import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { atom, useAtom, Provider as Provider$3 } from 'jotai';
import _styled, { css as css$1, keyframes as keyframes$1, useTheme as useTheme$1, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import * as React from 'react';
import React__default, { useContext, createContext, useMemo, useEffect, useRef, useState, useCallback, forwardRef, Children, StrictMode, useLayoutEffect, useImperativeHandle, memo } from 'react';
import { JsonRpcProvider } from '@ethersproject/providers';
import { initializeConnector } from '@web3-react/core';
import { EIP1193 } from '@web3-react/eip1193';
import { EMPTY } from '@web3-react/empty';
import { Url } from '@web3-react/url';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { Connector } from '@web3-react/types';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime.js';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import tokensList from '@brydge-network/token-list';
import { useAtomValue, useUpdateAtom, atomWithReset, useResetAtom } from 'jotai/utils';
import { atomWithImmer, withImmer } from 'jotai/immer';
import invariant from 'tiny-invariant';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import { Token, WETH9, NativeCurrency, Ether, CurrencyAmount, Percent, TradeType, Price as Price$1, Fraction } from '@uniswap/sdk-core';
import { FACTORY_ADDRESS, Pair, computePairAddress, Trade as Trade$1, Route as Route$1, Router } from '@uniswap/v2-sdk';
import { FACTORY_ADDRESS as FACTORY_ADDRESS$1, computePoolAddress, Pool, FeeAmount, Route, SwapQuoter, Trade as Trade$3, SwapRouter } from '@uniswap/v3-sdk';
import { parseUnits } from '@ethersproject/units';
import JSBI from 'jsbi';
import { USDC_MAINNET as USDC_MAINNET$1, nativeOnChain as nativeOnChain$1, WETH_POLYGON as WETH_POLYGON$1 } from '@uniswap/smart-order-router';
import { getAddress } from '@ethersproject/address';
import { AddressZero, MaxUint256 } from '@ethersproject/constants';
import { Contract } from '@ethersproject/contracts';
import { Interface } from '@ethersproject/abi';
import { createMulticall, NEVER_RELOAD } from '@uniswap/redux-multicall';
import { combineReducers, createStore } from 'redux';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Trade as Trade$2, Protocol, SwapRouter as SwapRouter$1 } from '@uniswap/router-sdk';
import 'setimmediate';
import { arrayify, hexStripZeros, splitSignature } from '@ethersproject/bytes';
import { parseBytes32String } from '@ethersproject/strings';
import { namehash } from '@ethersproject/hash';
import CID from 'cids';
import { getNameFromData, rmPrefix } from 'multicodec';
import { decode, toB58String } from 'multihashes';
import { af, ar, ca, cs, da, de, el, en, es, fi, fr, he, hu, id, it, ja, ko, nl, no, pl, pt, ro, ru, sr, sv, sw, tr, uk, vi, zh } from 'make-plural/plurals';
import { transparentize, readableColor, opacify, darken, lighten, mix } from 'polished';
import { hex } from 'wcag-contrast';
import { Text } from 'rebass';
import { Provider as Provider$2 } from 'react-redux';
import 'wicg-inert';
import { ArrowDown, ArrowRight as ArrowRight$1, ArrowUp, ArrowUpCircle, CheckCircle, BarChart2, ChevronDown as ChevronDown$1, Clock, HelpCircle as HelpCircle$1, Info as Info$1, ExternalLink as ExternalLink$1, Settings as Settings$2, Slash, Trash2, X as X$1, XOctagon as XOctagon$1, AlertTriangle as AlertTriangle$1 } from 'react-feather';
import { createPortal } from 'react-dom';
import { BigNumber } from '@ethersproject/bignumber';
import _typeof from '@babel/runtime/helpers/typeof';
import maxSize from 'popper-max-size-modifier';
import { usePopper } from 'react-popper';
import Vibrant from 'node-vibrant/lib/bundle.js';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList, areEqual } from 'react-window';
import { useColorModeValue, Link as Link$1 } from '@chakra-ui/react';
import _get from '@babel/runtime/helpers/get';
import { utils, Contract as Contract$1, ContractFactory } from 'ethers';
var EthereumLogo = "data:image/png;base64,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";
var arbitrumLogoUrl = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%20470.287%20514.251%22%20enable-background%3D%22new%200%200%20470.287%20514.251%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%20id%3D%22Background%22%3E%3C%2Fg%3E%3Cg%20id%3D%22Logos_and_symbols%22%3E%20%3Cg%20id%3D%22SYMBOL_VER_3%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_3_3_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_4%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_4_1_%22%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_4_3_%22%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_5_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22off_2_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22VER_3_1_%22%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_2_1_%22%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22VER_3%22%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_2%22%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22off_2%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_5%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1_3_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1_2_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1_1_%22%3E%20%20%3Cg%20id%3D%22_x31_-3%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_14_%22%3E%20%20%20%3Cpath%20fill%3D%22%232D374B%22%20d%3D%22M291.134%2C237.469l35.654-60.5l96.103%2C149.684l0.046%2C28.727l-0.313-197.672%20%20%20%20c-0.228-4.832-2.794-9.252-6.887-11.859L242.715%2C46.324c-4.045-1.99-9.18-1.967-13.22%2C0.063c-0.546%2C0.272-1.06%2C0.57-1.548%2C0.895%20%20%20%20l-0.604%2C0.379L59.399%2C144.983l-0.651%2C0.296c-0.838%2C0.385-1.686%2C0.875-2.48%2C1.444c-3.185%2C2.283-5.299%2C5.66-5.983%2C9.448%20%20%20%20c-0.103%2C0.574-0.179%2C1.158-0.214%2C1.749l0.264%2C161.083l89.515-138.745c11.271-18.397%2C35.825-24.323%2C58.62-24.001l26.753%2C0.706%20%20%20%20L67.588%2C409.765l18.582%2C10.697L245.692%2C157.22l70.51-0.256L157.091%2C426.849l66.306%2C38.138l7.922%2C4.556%20%20%20%20c3.351%2C1.362%2C7.302%2C1.431%2C10.681%2C0.21l175.453-101.678l-33.544%2C19.438L291.134%2C237.469z%20M304.736%2C433.395l-66.969-105.108%20%20%20%20l40.881-69.371l87.952%2C138.628L304.736%2C433.395z%22%2F%3E%20%20%20%3Cpolygon%20fill%3D%22%2328A0F0%22%20points%3D%22237.768%2C328.286%20304.736%2C433.395%20366.601%2C397.543%20278.648%2C258.915%20%20%20%20%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%2328A0F0%22%20d%3D%22M422.937%2C355.379l-0.046-28.727l-96.103-149.684l-35.654%2C60.5l92.774%2C150.043l33.544-19.438%20%20%20%20c3.29-2.673%2C5.281-6.594%2C5.49-10.825L422.937%2C355.379z%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M20.219%2C382.469l47.369%2C27.296l157.634-252.801l-26.753-0.706c-22.795-0.322-47.35%2C5.604-58.62%2C24.001%20%20%20%20L50.334%2C319.004l-30.115%2C46.271V382.469z%22%2F%3E%20%20%20%3Cpolygon%20fill%3D%22%23FFFFFF%22%20points%3D%22316.202%2C156.964%20245.692%2C157.22%2086.17%2C420.462%20141.928%2C452.565%20157.091%2C426.849%20%20%20%20%22%2F%3E%20%20%20%3Cpath%20fill%3D%22%2396BEDC%22%20d%3D%22M452.65%2C156.601c-0.59-14.746-8.574-28.245-21.08-36.104L256.28%2C19.692%20%20%20%20c-12.371-6.229-27.825-6.237-40.218-0.004c-1.465%2C0.739-170.465%2C98.752-170.465%2C98.752c-2.339%2C1.122-4.592%2C2.458-6.711%2C3.975%20%20%20%20c-11.164%2C8.001-17.969%2C20.435-18.668%2C34.095v208.765l30.115-46.271L50.07%2C157.921c0.035-0.589%2C0.109-1.169%2C0.214-1.741%20%20%20%20c0.681-3.79%2C2.797-7.171%2C5.983-9.456c0.795-0.569%2C172.682-100.064%2C173.228-100.337c4.04-2.029%2C9.175-2.053%2C13.22-0.063%20%20%20%20l173.022%2C99.523c4.093%2C2.607%2C6.659%2C7.027%2C6.887%2C11.859v199.542c-0.209%2C4.231-1.882%2C8.152-5.172%2C10.825l-33.544%2C19.438%20%20%20%20l-17.308%2C10.031l-61.864%2C35.852l-62.737%2C36.357c-3.379%2C1.221-7.33%2C1.152-10.681-0.21l-74.228-42.693l-15.163%2C25.717%20%20%20%20l66.706%2C38.406c2.206%2C1.255%2C4.171%2C2.367%2C5.784%2C3.272c2.497%2C1.4%2C4.199%2C2.337%2C4.8%2C2.629c4.741%2C2.303%2C11.563%2C3.643%2C17.71%2C3.643%20%20%20%20c5.636%2C0%2C11.132-1.035%2C16.332-3.072l182.225-105.531c10.459-8.104%2C16.612-20.325%2C17.166-33.564V156.601z%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_13_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_6_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_4_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22One_color_version_-_White_3_%22%3E%20%20%20%3Cg%20id%3D%22Symbol_-_Original_15_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22One_color_version_-_White%22%3E%20%20%20%3Cg%20id%3D%22Symbol_-_Original%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Monochromatic_3_%22%3E%20%20%20%3Cg%20id%3D%22_x33__7_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Monochromatic%22%3E%20%20%20%3Cg%20id%3D%22_x33__3_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22_x33__2_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22_x33__1_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22_x33_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_10_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_1_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_2_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22_x34__1_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Monochromatic_2_%22%3E%20%20%20%3Cg%20id%3D%22_x33__6_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22One_color_version_-_White_2_%22%3E%20%20%20%3Cg%20id%3D%22Symbol_-_Original_11_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Symbol_-_Original_5_%22%3E%20%20%20%3Cg%20id%3D%22Symbol_-_Original_12_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22One_color_version_-_White_1_%22%3E%20%20%20%3Cg%20id%3D%22Symbol_-_Original_9_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1_2_%22%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_2_4_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_2-1-1_1_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_2-2-1_1_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22SYMBOL_VER_2-3-1_4_%22%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22New_Symbol_1_%22%3E%20%20%20%3Cg%20id%3D%22SYMBOL_VER_2-3-1_3_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22New_Symbol%22%3E%20%20%20%3Cg%20id%3D%22SYMBOL_VER_2-3-1_1_%22%3E%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_2_2_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_4_2_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_3_2_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_3_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1-1_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1-1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1-1_2_2_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1-1_2%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_1-1-1_2_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22Symbol_-_Original_7_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22Symbol_-_Original_8_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_2-1-1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_2-2-1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_2-3-1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_5-1_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_5-1%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_5-2_1_%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22SYMBOL_VER_5-2%22%3E%20%3C%2Fg%3E%20%3Cg%20id%3D%22Symbol_-_Monochromatic_1_%22%3E%20%20%3Cg%20id%3D%22_x33__4_%22%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";
var avalancheLogo = "data:image/svg+xml,%3Csvg%20width%3D%221503%22%20height%3D%221504%22%20viewBox%3D%220%200%201503%201504%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%22287%22%20y%3D%22258%22%20width%3D%22928%22%20height%3D%22844%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M1502.5%20752C1502.5%201166.77%201166.27%201503%20751.5%201503C336.734%201503%200.5%201166.77%200.5%20752C0.5%20337.234%20336.734%201%20751.5%201C1166.27%201%201502.5%20337.234%201502.5%20752ZM538.688%201050.86H392.94C362.314%201050.86%20347.186%201050.86%20337.962%201044.96C327.999%201038.5%20321.911%201027.8%20321.173%201015.99C320.619%201005.11%20328.184%20991.822%20343.312%20965.255L703.182%20330.935C718.495%20303.999%20726.243%20290.531%20736.021%20285.55C746.537%20280.2%20759.083%20280.2%20769.599%20285.55C779.377%20290.531%20787.126%20303.999%20802.438%20330.935L876.42%20460.079L876.797%20460.738C893.336%20489.635%20901.723%20504.289%20905.385%20519.669C909.443%20536.458%20909.443%20554.169%20905.385%20570.958C901.695%20586.455%20893.393%20601.215%20876.604%20630.549L687.573%20964.702L687.084%20965.558C670.436%20994.693%20661.999%201009.46%20650.306%201020.6C637.576%201032.78%20622.263%201041.63%20605.474%201046.62C590.161%201050.86%20573.004%201050.86%20538.688%201050.86ZM906.75%201050.86H1115.59C1146.4%201050.86%201161.9%201050.86%201171.13%201044.78C1181.09%201038.32%201187.36%201027.43%201187.92%201015.63C1188.45%201005.1%201181.05%20992.33%201166.55%20967.307C1166.05%20966.455%201165.55%20965.588%201165.04%20964.706L1060.43%20785.75L1059.24%20783.735C1044.54%20758.877%201037.12%20746.324%201027.59%20741.472C1017.08%20736.121%201004.71%20736.121%20994.199%20741.472C984.605%20746.453%20976.857%20759.552%20961.544%20785.934L857.306%20964.891L856.949%20965.507C841.69%20991.847%20834.064%201005.01%20834.614%201015.81C835.352%201027.62%20841.44%201038.5%20851.402%201044.96C860.443%201050.86%20875.94%201050.86%20906.75%201050.86Z%22%20fill%3D%22%23E84142%22%2F%3E%3C%2Fsvg%3E";
var optimismLogoUrl = "data:image/svg+xml,%3Csvg%20width%3D%22500%22%20height%3D%22500%22%20viewBox%3D%220%200%20500%20500%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%22250%22%20cy%3D%22250%22%20r%3D%22250%22%20fill%3D%22%23FF0420%22%2F%3E%3Cpath%20d%3D%22M177.133%20316.446C162.247%20316.446%20150.051%20312.943%20140.544%20305.938C131.162%20298.808%20126.471%20288.676%20126.471%20275.541C126.471%20272.789%20126.784%20269.411%20127.409%20265.408C129.036%20256.402%20131.35%20245.581%20134.352%20232.947C142.858%20198.547%20164.812%20181.347%20200.213%20181.347C209.845%20181.347%20218.476%20182.973%20226.107%20186.225C233.738%20189.352%20239.742%20194.106%20244.12%20200.486C248.498%20206.74%20250.688%20214.246%20250.688%20223.002C250.688%20225.629%20250.375%20228.944%20249.749%20232.947C247.873%20244.08%20245.621%20254.901%20242.994%20265.408C238.616%20282.546%20231.048%20295.368%20220.29%20303.874C209.532%20312.255%20195.147%20316.446%20177.133%20316.446ZM179.76%20289.426C186.766%20289.426%20192.707%20287.362%20197.586%20283.234C202.59%20279.106%20206.155%20272.789%20208.281%20264.283C211.158%20252.524%20213.348%20242.266%20214.849%20233.51C215.349%20230.883%20215.599%20228.194%20215.599%20225.441C215.599%20214.058%20209.657%20208.366%20197.774%20208.366C190.768%20208.366%20184.764%20210.43%20179.76%20214.558C174.882%20218.687%20171.379%20225.004%20169.253%20233.51C167.001%20241.891%20164.749%20252.149%20162.498%20264.283C161.997%20266.784%20161.747%20269.411%20161.747%20272.163C161.747%20283.672%20167.752%20289.426%20179.76%20289.426Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M259.303%20314.57C257.927%20314.57%20256.863%20314.132%20256.113%20313.256C255.487%20312.255%20255.3%20311.13%20255.55%20309.879L281.444%20187.914C281.694%20186.538%20282.382%20185.412%20283.508%20184.536C284.634%20183.661%20285.822%20183.223%20287.073%20183.223H336.985C350.87%20183.223%20362.003%20186.1%20370.384%20191.854C378.891%20197.609%20383.144%20205.927%20383.144%20216.81C383.144%20219.937%20382.769%20223.19%20382.018%20226.567C378.891%20240.953%20372.574%20251.586%20363.067%20258.466C353.685%20265.346%20340.8%20268.786%20324.413%20268.786H299.082L290.451%20309.879C290.2%20311.255%20289.512%20312.38%20288.387%20313.256C287.261%20314.132%20286.072%20314.57%20284.822%20314.57H259.303ZM325.727%20242.892C330.98%20242.892%20335.546%20241.453%20339.424%20238.576C343.427%20235.699%20346.054%20231.571%20347.305%20226.192C347.68%20224.065%20347.868%20222.189%20347.868%20220.563C347.868%20216.935%20346.805%20214.183%20344.678%20212.307C342.551%20210.305%20338.924%20209.305%20333.795%20209.305H311.278L304.148%20242.892H325.727Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";
var polygonMaticLogo = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%2038.4%2033.5%22%20style%3D%22enable-background%3Anew%200%200%2038.4%2033.5%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%238247E5%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M29%2C10.2c-0.7-0.4-1.6-0.4-2.4%2C0L21%2C13.5l-3.8%2C2.1l-5.5%2C3.3c-0.7%2C0.4-1.6%2C0.4-2.4%2C0L5%2C16.3%20%20c-0.7-0.4-1.2-1.2-1.2-2.1v-5c0-0.8%2C0.4-1.6%2C1.2-2.1l4.3-2.5c0.7-0.4%2C1.6-0.4%2C2.4%2C0L16%2C7.2c0.7%2C0.4%2C1.2%2C1.2%2C1.2%2C2.1v3.3l3.8-2.2V7%20%20c0-0.8-0.4-1.6-1.2-2.1l-8-4.7c-0.7-0.4-1.6-0.4-2.4%2C0L1.2%2C5C0.4%2C5.4%2C0%2C6.2%2C0%2C7v9.4c0%2C0.8%2C0.4%2C1.6%2C1.2%2C2.1l8.1%2C4.7%20%20c0.7%2C0.4%2C1.6%2C0.4%2C2.4%2C0l5.5-3.2l3.8-2.2l5.5-3.2c0.7-0.4%2C1.6-0.4%2C2.4%2C0l4.3%2C2.5c0.7%2C0.4%2C1.2%2C1.2%2C1.2%2C2.1v5c0%2C0.8-0.4%2C1.6-1.2%2C2.1%20%20L29%2C28.8c-0.7%2C0.4-1.6%2C0.4-2.4%2C0l-4.3-2.5c-0.7-0.4-1.2-1.2-1.2-2.1V21l-3.8%2C2.2v3.3c0%2C0.8%2C0.4%2C1.6%2C1.2%2C2.1l8.1%2C4.7%20%20c0.7%2C0.4%2C1.6%2C0.4%2C2.4%2C0l8.1-4.7c0.7-0.4%2C1.2-1.2%2C1.2-2.1V17c0-0.8-0.4-1.6-1.2-2.1L29%2C10.2z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
var solanaLogo = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20397.7%20311.7%22%20style%3D%22enable-background%3Anew%200%200%20397.7%20311.7%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3Aurl%28%23SVGID_1_%29%3B%7D%20.st1%7Bfill%3Aurl%28%23SVGID_2_%29%3B%7D%20.st2%7Bfill%3Aurl%28%23SVGID_3_%29%3B%7D%3C%2Fstyle%3E%3ClinearGradient%20id%3D%22SVGID_1_%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22360.8791%22%20y1%3D%22351.4553%22%20x2%3D%22141.213%22%20y2%3D%22-69.2936%22%20gradientTransform%3D%22matrix%281%200%200%20-1%200%20314%29%22%3E%20%3Cstop%20%20offset%3D%220%22%20style%3D%22stop-color%3A%2300FFA3%22%2F%3E%20%3Cstop%20%20offset%3D%221%22%20style%3D%22stop-color%3A%23DC1FFF%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M64.6%2C237.9c2.4-2.4%2C5.7-3.8%2C9.2-3.8h317.4c5.8%2C0%2C8.7%2C7%2C4.6%2C11.1l-62.7%2C62.7c-2.4%2C2.4-5.7%2C3.8-9.2%2C3.8H6.5%20c-5.8%2C0-8.7-7-4.6-11.1L64.6%2C237.9z%22%2F%3E%3ClinearGradient%20id%3D%22SVGID_2_%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22264.8291%22%20y1%3D%22401.6014%22%20x2%3D%2245.163%22%20y2%3D%22-19.1475%22%20gradientTransform%3D%22matrix%281%200%200%20-1%200%20314%29%22%3E%20%3Cstop%20%20offset%3D%220%22%20style%3D%22stop-color%3A%2300FFA3%22%2F%3E%20%3Cstop%20%20offset%3D%221%22%20style%3D%22stop-color%3A%23DC1FFF%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M64.6%2C3.8C67.1%2C1.4%2C70.4%2C0%2C73.8%2C0h317.4c5.8%2C0%2C8.7%2C7%2C4.6%2C11.1l-62.7%2C62.7c-2.4%2C2.4-5.7%2C3.8-9.2%2C3.8H6.5%20c-5.8%2C0-8.7-7-4.6-11.1L64.6%2C3.8z%22%2F%3E%3ClinearGradient%20id%3D%22SVGID_3_%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22312.5484%22%20y1%3D%22376.688%22%20x2%3D%2292.8822%22%20y2%3D%22-44.061%22%20gradientTransform%3D%22matrix%281%200%200%20-1%200%20314%29%22%3E%20%3Cstop%20%20offset%3D%220%22%20style%3D%22stop-color%3A%2300FFA3%22%2F%3E%20%3Cstop%20%20offset%3D%221%22%20style%3D%22stop-color%3A%23DC1FFF%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20class%3D%22st2%22%20d%3D%22M333.1%2C120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8%2C0-8.7%2C7-4.6%2C11.1l62.7%2C62.7c2.4%2C2.4%2C5.7%2C3.8%2C9.2%2C3.8h317.4%20c5.8%2C0%2C8.7-7%2C4.6-11.1L333.1%2C120.1z%22%2F%3E%3C%2Fsvg%3E";

var _CHAIN_IDS_TO_NAMES;
/**
 * List of all the networks supported by the Uniswap Interface
 */


var SupportedChainId;

(function (SupportedChainId) {
  SupportedChainId[SupportedChainId["MAINNET"] = 1] = "MAINNET";
  SupportedChainId[SupportedChainId["ROPSTEN"] = 3] = "ROPSTEN";
  SupportedChainId[SupportedChainId["RINKEBY"] = 4] = "RINKEBY";
  SupportedChainId[SupportedChainId["GOERLI"] = 5] = "GOERLI";
  SupportedChainId[SupportedChainId["KOVAN"] = 42] = "KOVAN";
  SupportedChainId[SupportedChainId["ARBITRUM_ONE"] = 42161] = "ARBITRUM_ONE";
  SupportedChainId[SupportedChainId["ARBITRUM_RINKEBY"] = 421611] = "ARBITRUM_RINKEBY";
  SupportedChainId[SupportedChainId["OPTIMISM"] = 10] = "OPTIMISM";
  SupportedChainId[SupportedChainId["OPTIMISTIC_KOVAN"] = 69] = "OPTIMISTIC_KOVAN";
  SupportedChainId[SupportedChainId["POLYGON"] = 137] = "POLYGON";
  SupportedChainId[SupportedChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
  SupportedChainId[SupportedChainId["AVALANCHE"] = 43114] = "AVALANCHE";
  SupportedChainId[SupportedChainId["SOLANA"] = 12345] = "SOLANA";
})(SupportedChainId || (SupportedChainId = {}));

_CHAIN_IDS_TO_NAMES = {}, _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.MAINNET, 'mainnet'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ROPSTEN, 'ropsten'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.RINKEBY, 'rinkeby'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.GOERLI, 'goerli'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.KOVAN, 'kovan'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.POLYGON, 'polygon'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.POLYGON_MUMBAI, 'polygon_mumbai'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ARBITRUM_ONE, 'arbitrum'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ARBITRUM_RINKEBY, 'arbitrum_rinkeby'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.OPTIMISM, 'optimism'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.OPTIMISTIC_KOVAN, 'optimistic_kovan'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.AVALANCHE, 'avalanche'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.SOLANA, 'solana'), _CHAIN_IDS_TO_NAMES;
/**
 * Array of all the supported chain IDs
 */

var ALL_SUPPORTED_CHAIN_IDS = Object.values(SupportedChainId).filter(function (id) {
  return typeof id === 'number';
});
[SupportedChainId.MAINNET, SupportedChainId.POLYGON, SupportedChainId.OPTIMISM, SupportedChainId.ARBITRUM_ONE];
/**
 * All the chain IDs that are running the Ethereum protocol.
 */

[SupportedChainId.MAINNET, SupportedChainId.ROPSTEN, SupportedChainId.RINKEBY, SupportedChainId.GOERLI, SupportedChainId.KOVAN, SupportedChainId.POLYGON, SupportedChainId.POLYGON_MUMBAI];
/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */

var L2_CHAIN_IDS = [SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN];
var ARBITRUM_LIST = 'https://bridge.arbitrum.io/token-list-42161.json';
var OPTIMISM_LIST = 'https://static.optimism.io/optimism.tokenlist.json';

var _CHAIN_INFO;

var NetworkType;

(function (NetworkType) {
  NetworkType[NetworkType["L1"] = 0] = "L1";
  NetworkType[NetworkType["L2"] = 1] = "L2";
})(NetworkType || (NetworkType = {}));

var CHAIN_INFO = (_CHAIN_INFO = {}, _defineProperty(_CHAIN_INFO, SupportedChainId.MAINNET, {
  networkType: NetworkType.L1,
  docs: 'https://docs.uniswap.org/',
  explorer: 'https://etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/',
  label: 'Ethereum',
  logoUrl: EthereumLogo,
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18
  },
  brydgeSupportedNetwork: true
}), _defineProperty(_CHAIN_INFO, SupportedChainId.RINKEBY, {
  networkType: NetworkType.L1,
  docs: 'https://docs.uniswap.org/',
  explorer: 'https://rinkeby.etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/',
  label: 'Rinkeby',
  logoUrl: EthereumLogo,
  nativeCurrency: {
    name: 'Rinkeby Ether',
    symbol: 'rETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.ROPSTEN, {
  networkType: NetworkType.L1,
  docs: 'https://docs.uniswap.org/',
  explorer: 'https://ropsten.etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/',
  label: 'Ropsten',
  logoUrl: EthereumLogo,
  nativeCurrency: {
    name: 'Ropsten Ether',
    symbol: 'ropETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.KOVAN, {
  networkType: NetworkType.L1,
  docs: 'https://docs.uniswap.org/',
  explorer: 'https://kovan.etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/',
  label: 'Kovan',
  logoUrl: EthereumLogo,
  nativeCurrency: {
    name: 'Kovan Ether',
    symbol: 'kovETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.GOERLI, {
  networkType: NetworkType.L1,
  docs: 'https://docs.uniswap.org/',
  explorer: 'https://goerli.etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/',
  label: 'Görli',
  logoUrl: EthereumLogo,
  nativeCurrency: {
    name: 'Görli Ether',
    symbol: 'görETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.OPTIMISM, {
  networkType: NetworkType.L2,
  blockWaitMsBeforeWarning: 1500000,
  bridge: 'https://app.optimism.io/bridge',
  defaultListUrl: OPTIMISM_LIST,
  docs: 'https://optimism.io/',
  explorer: 'https://optimistic.etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/optimism/',
  label: 'Optimism',
  logoUrl: optimismLogoUrl,
  statusPage: 'https://optimism.io/status',
  helpCenterUrl: 'https://help.uniswap.org/en/collections/3137778-uniswap-on-optimistic-ethereum-oξ',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.OPTIMISTIC_KOVAN, {
  networkType: NetworkType.L2,
  blockWaitMsBeforeWarning: 1500000,
  bridge: 'https://app.optimism.io/bridge',
  defaultListUrl: OPTIMISM_LIST,
  docs: 'https://optimism.io/',
  explorer: 'https://optimistic.etherscan.io/',
  infoLink: 'https://info.uniswap.org/#/optimism/',
  label: 'Optimistic Kovan',
  logoUrl: optimismLogoUrl,
  statusPage: 'https://optimism.io/status',
  helpCenterUrl: 'https://help.uniswap.org/en/collections/3137778-uniswap-on-optimistic-ethereum-oξ',
  nativeCurrency: {
    name: 'Optimistic Kovan Ether',
    symbol: 'kovOpETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.ARBITRUM_ONE, {
  networkType: NetworkType.L2,
  blockWaitMsBeforeWarning: 600000,
  bridge: 'https://bridge.arbitrum.io/',
  docs: 'https://offchainlabs.com/',
  explorer: 'https://arbiscan.io/',
  infoLink: 'https://info.uniswap.org/#/arbitrum',
  label: 'Arbitrum',
  logoUrl: arbitrumLogoUrl,
  defaultListUrl: ARBITRUM_LIST,
  helpCenterUrl: 'https://help.uniswap.org/en/collections/3137787-uniswap-on-arbitrum',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.ARBITRUM_RINKEBY, {
  networkType: NetworkType.L2,
  blockWaitMsBeforeWarning: 600000,
  bridge: 'https://bridge.arbitrum.io/',
  docs: 'https://offchainlabs.com/',
  explorer: 'https://rinkeby-explorer.arbitrum.io/',
  infoLink: 'https://info.uniswap.org/#/arbitrum/',
  label: 'Arbitrum Rinkeby',
  logoUrl: arbitrumLogoUrl,
  defaultListUrl: ARBITRUM_LIST,
  helpCenterUrl: 'https://help.uniswap.org/en/collections/3137787-uniswap-on-arbitrum',
  nativeCurrency: {
    name: 'Rinkeby Arbitrum Ether',
    symbol: 'rinkArbETH',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.POLYGON, {
  networkType: NetworkType.L1,
  blockWaitMsBeforeWarning: 600000,
  bridge: 'https://wallet.polygon.technology/bridge',
  docs: 'https://polygon.io/',
  explorer: 'https://polygonscan.com/',
  infoLink: 'https://info.uniswap.org/#/polygon/',
  label: 'Polygon',
  logoUrl: polygonMaticLogo,
  nativeCurrency: {
    name: 'Polygon Matic',
    symbol: 'MATIC',
    decimals: 18
  },
  brydgeSupportedNetwork: true
}), _defineProperty(_CHAIN_INFO, SupportedChainId.POLYGON_MUMBAI, {
  networkType: NetworkType.L1,
  blockWaitMsBeforeWarning: 600000,
  bridge: 'https://wallet.polygon.technology/bridge',
  docs: 'https://polygon.io/',
  explorer: 'https://mumbai.polygonscan.com/',
  infoLink: 'https://info.uniswap.org/#/polygon/',
  label: 'Polygon Mumbai',
  logoUrl: polygonMaticLogo,
  nativeCurrency: {
    name: 'Polygon Mumbai Matic',
    symbol: 'mMATIC',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.AVALANCHE, {
  networkType: NetworkType.L1,
  blockWaitMsBeforeWarning: 600000,
  bridge: '',
  docs: '',
  explorer: '',
  infoLink: '',
  label: 'Avalanche',
  logoUrl: avalancheLogo,
  nativeCurrency: {
    name: 'Avalanche',
    symbol: 'AVAX',
    decimals: 18
  }
}), _defineProperty(_CHAIN_INFO, SupportedChainId.SOLANA, {
  networkType: NetworkType.L1,
  blockWaitMsBeforeWarning: 600000,
  bridge: '',
  docs: '',
  explorer: '',
  infoLink: '',
  label: 'Solana',
  logoUrl: solanaLogo,
  nativeCurrency: {
    name: 'Solana',
    symbol: 'SOL',
    decimals: 18
  }
}), _CHAIN_INFO);

function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$b() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function parseChainId(chainId) {
  return Number.parseInt(chainId, 16);
}

var JsonRpcConnector = /*#__PURE__*/function (_Connector) {
  _inherits(JsonRpcConnector, _Connector);

  var _super = _createSuper$b(JsonRpcConnector);

  function JsonRpcConnector(actions, customProvider) {
    var _this;

    _classCallCheck(this, JsonRpcConnector);

    _this = _super.call(this, actions);
    _this.customProvider = customProvider;
    customProvider.on('connect', function (_ref) {
      var chainId = _ref.chainId;

      _this.actions.update({
        chainId: parseChainId(chainId)
      });
    }).on('disconnect', function (error) {
      _this.actions.reportError(error);
    }).on('chainChanged', function (chainId) {
      _this.actions.update({
        chainId: parseChainId(chainId)
      });
    }).on('accountsChanged', function (accounts) {
      _this.actions.update({
        accounts: accounts
      });
    });
    return _this;
  }

  _createClass(JsonRpcConnector, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, chainId, accounts;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.actions.startActivation();
                _context.prev = 1;
                _context.next = 4;
                return Promise.all([this.customProvider.getNetwork(), this.customProvider.listAccounts()]);

              case 4:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                chainId = _yield$Promise$all2[0].chainId;
                accounts = _yield$Promise$all2[1];
                this.actions.update({
                  chainId: chainId,
                  accounts: accounts
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                this.actions.reportError(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function activate() {
        return _activate.apply(this, arguments);
      }

      return activate;
    }()
  }]);

  return JsonRpcConnector;
}(Connector);

var EMPTY_CONNECTOR$1 = initializeConnector(function () {
  return EMPTY;
});
var EMPTY_CONTEXT$1 = {
  connector: EMPTY
};
var jsonRpcConnectorAtom$1 = atom(EMPTY_CONNECTOR$1);
var injectedConnectorAtom = atom(EMPTY_CONNECTOR$1);
var Web3Context$1 = /*#__PURE__*/createContext(EMPTY_CONTEXT$1);

function useActiveWeb3React$1() {
  return useContext(Web3Context$1);
}

function useConnector$1(connectorAtom, Connector, initializer) {
  var _useAtom = useAtom(connectorAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      connector = _useAtom2[0],
      setConnector = _useAtom2[1];

  useEffect(function () {
    if (initializer) {
      var _initializeConnector = initializeConnector(function (actions) {
        return new Connector(actions, initializer);
      }),
          _initializeConnector2 = _slicedToArray(_initializeConnector, 3),
          _connector = _initializeConnector2[0],
          hooks = _initializeConnector2[1],
          store = _initializeConnector2[2];

      _connector.activate();

      setConnector([_connector, hooks, store]);
    } else {
      setConnector(EMPTY_CONNECTOR$1);
    }
  }, [Connector, initializer, setConnector]);
  return connector;
}

function ActiveWeb3Provider(_ref) {
  var provider = _ref.provider,
      jsonRpcEndpoints = _ref.jsonRpcEndpoints,
      children = _ref.children,
      destinationChainId = _ref.destinationChainId;
  var Injected = useMemo(function () {
    if (provider) {
      if (JsonRpcProvider.isProvider(provider)) return JsonRpcConnector;

      if (JsonRpcProvider.isProvider(provider.provider)) {
        throw new Error('Eip1193Bridge is experimental: pass your ethers Provider directly');
      }
    }

    return EIP1193;
  }, [provider]);
  var jsonRpcEndpoint = jsonRpcEndpoints[destinationChainId];
  var injectedConnector = useConnector$1(injectedConnectorAtom, Injected, provider);
  var JsonRpc = useMemo(function () {
    if (JsonRpcProvider.isProvider(jsonRpcEndpoint)) return JsonRpcConnector;
    return Url;
  }, [jsonRpcEndpoint]);
  var jsonRpcConnector = useConnector$1(jsonRpcConnectorAtom$1, JsonRpc, jsonRpcEndpoint);

  var _ref2 = injectedConnector[1].useIsActive() ? injectedConnector : jsonRpcConnector !== null && jsonRpcConnector !== void 0 ? jsonRpcConnector : EMPTY_CONNECTOR$1,
      _ref3 = _slicedToArray(_ref2, 2),
      connector = _ref3[0],
      hooks = _ref3[1];

  var library = hooks.useProvider();
  var accounts = hooks.useAccounts();
  var account = hooks.useAccount();
  var activating = hooks.useIsActivating();
  var active = hooks.useIsActive();
  var chainId = hooks.useChainId();
  var ensNames = hooks.useENSNames();
  var ensName = hooks.useENSName();
  var error = hooks.useError();
  var web3 = useMemo(function () {
    if (connector === EMPTY || !(active || activating)) {
      return EMPTY_CONTEXT$1;
    }

    return {
      connector: connector,
      library: library,
      chainId: chainId,
      accounts: accounts,
      account: account,
      active: active,
      activating: activating,
      error: error,
      ensNames: ensNames,
      ensName: ensName
    };
  }, [account, accounts, activating, active, chainId, connector, ensName, ensNames, error, library]); // Log web3 errors to facilitate debugging.

  useEffect(function () {
    if (error) {
      console.error('web3 error:', error);
    }
  }, [error]);
  return /*#__PURE__*/jsx(Web3Context$1.Provider, {
    value: web3,
    children: children
  });
}

function useActiveWeb3React() {
  return useActiveWeb3React$1();
}

function useOnClickOutside(node, handler) {
  var handlerRef = useRef(handler);
  useEffect(function () {
    handlerRef.current = handler;
  }, [handler]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(e) {
      var _node$current$contain, _node$current;

      if ((_node$current$contain = (_node$current = node.current) === null || _node$current === void 0 ? void 0 : _node$current.contains(e.target)) !== null && _node$current$contain !== void 0 ? _node$current$contain : false) {
        return;
      }

      if (handlerRef.current) handlerRef.current();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [node]);
}

function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
}

var SUPPORTED_LOCALES = [// order as they appear in the language dropdown
'en-US', 'af-ZA', 'ar-SA', 'ca-ES', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fi-FI', 'fr-FR', 'he-IL', 'hu-HU', 'id-ID', 'it-IT', 'ja-JP', 'ko-KR', 'nl-NL', 'no-NO', 'pl-PL', 'pt-BR', 'pt-PT', 'ro-RO', 'ru-RU', 'sr-SP', 'sv-SE', 'sw-TZ', 'tr-TR', 'uk-UA', 'vi-VN', 'zh-CN', 'zh-TW'];
var DEFAULT_LOCALE = 'en-US';
var TransactionType;

(function (TransactionType) {
  TransactionType[TransactionType["APPROVAL"] = 0] = "APPROVAL";
  TransactionType[TransactionType["SWAP"] = 1] = "SWAP";
  TransactionType[TransactionType["WRAP"] = 2] = "WRAP";
})(TransactionType || (TransactionType = {}));

var transactionsAtom = atomWithImmer({});

function isVisibilityStateSupported() {
  return 'visibilityState' in document;
}

function isWindowVisible() {
  return !isVisibilityStateSupported() || document.visibilityState !== 'hidden';
}
/**
 * Returns whether the window is currently visible to the user.
 */


function useIsWindowVisible() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var listener = useCallback(function () {
    setFocused(isWindowVisible());
  }, [setFocused]);
  useEffect(function () {
    if (!isVisibilityStateSupported()) return undefined;
    setFocused(function (focused) {
      return isWindowVisible();
    });
    document.addEventListener('visibilitychange', listener);
    return function () {
      document.removeEventListener('visibilitychange', listener);
    };
  }, [listener]);
  return focused;
}

var MISSING_PROVIDER$1 = Symbol();
var BlockNumberContext = /*#__PURE__*/createContext(MISSING_PROVIDER$1);

function useBlockNumberContext() {
  var blockNumber = useContext(BlockNumberContext);

  if (blockNumber === MISSING_PROVIDER$1) {
    throw new Error('BlockNumber hooks must be wrapped in a <BlockNumberProvider>');
  }

  return blockNumber;
}
/** Requires that BlockUpdater be installed in the DOM tree. */


function useBlockNumber() {
  return useBlockNumberContext().value;
}

function useFastForwardBlockNumber() {
  return useBlockNumberContext().fastForward;
}

function BlockNumberProvider(_ref) {
  var children = _ref.children;

  var _useActiveWeb3React = useActiveWeb3React(),
      activeChainId = _useActiveWeb3React.chainId,
      library = _useActiveWeb3React.library;

  var _useState = useState({
    chainId: activeChainId
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      chainId = _useState2$.chainId,
      block = _useState2$.block,
      setChainBlock = _useState2[1];

  var onBlock = useCallback(function (block) {
    setChainBlock(function (chainBlock) {
      if (chainBlock.chainId === activeChainId) {
        if (!chainBlock.block || chainBlock.block < block) {
          return {
            chainId: activeChainId,
            block: block
          };
        }
      }

      return chainBlock;
    });
  }, [activeChainId, setChainBlock]);
  var windowVisible = useIsWindowVisible();
  useEffect(function () {
    if (library && activeChainId && windowVisible) {
      // If chainId hasn't changed, don't clear the block. This prevents re-fetching still valid data.
      setChainBlock(function (chainBlock) {
        return chainBlock.chainId === activeChainId ? chainBlock : {
          chainId: activeChainId
        };
      });
      library.getBlockNumber().then(onBlock).catch(function (error) {
        console.error("Failed to get block number for chainId ".concat(activeChainId), error);
      });
      library.on('block', onBlock);
      return function () {
        library.removeListener('block', onBlock);
      };
    }

    return undefined;
  }, [activeChainId, library, onBlock, setChainBlock, windowVisible]);
  var value = useMemo(function () {
    return {
      value: chainId === activeChainId ? block : undefined,
      fastForward: function fastForward(block) {
        return setChainBlock({
          chainId: activeChainId,
          block: block
        });
      }
    };
  }, [activeChainId, block, chainId]);
  return /*#__PURE__*/jsx(BlockNumberContext.Provider, {
    value: value,
    children: children
  });
}

function _createSuper$a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$a() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

function waitRandom(min, max) {
  return wait(min + Math.round(Math.random() * Math.max(0, max - min)));
}
/**
 * This error is thrown if the function is cancelled before completing
 */


var CancelledError = /*#__PURE__*/function (_Error) {
  _inherits(CancelledError, _Error);

  var _super = _createSuper$a(CancelledError);

  function CancelledError() {
    var _this;

    _classCallCheck(this, CancelledError);

    _this = _super.call(this, 'Cancelled');

    _defineProperty(_assertThisInitialized(_this), "isCancelledError", true);

    return _this;
  }

  return _createClass(CancelledError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Throw this error if the function should retry
 */


var RetryableError = /*#__PURE__*/function (_Error2) {
  _inherits(RetryableError, _Error2);

  var _super2 = _createSuper$a(RetryableError);

  function RetryableError() {
    var _this2;

    _classCallCheck(this, RetryableError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "isRetryableError", true);

    return _this2;
  }

  return _createClass(RetryableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Retries the function that returns the promise until the promise successfully resolves up to n retries
 * @param fn function to retry
 * @param n how many times to retry
 * @param minWait min wait between retries in ms
 * @param maxWait max wait between retries in ms
 */


function retry(fn, _ref) {
  var n = _ref.n,
      minWait = _ref.minWait,
      maxWait = _ref.maxWait;
  var completed = false;
  var rejectCancelled;
  var promise = new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              rejectCancelled = reject;

            case 1:
              result = void 0;
              _context.prev = 3;
              _context.next = 6;
              return fn();

            case 6:
              result = _context.sent;

              if (!completed) {
                resolve(result);
                completed = true;
              }

              return _context.abrupt("break", 24);

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);

              if (!completed) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("break", 24);

            case 15:
              if (!(n <= 0 || !_context.t0.isRetryableError)) {
                _context.next = 19;
                break;
              }

              reject(_context.t0);
              completed = true;
              return _context.abrupt("break", 24);

            case 19:
              n--;

            case 20:
              _context.next = 22;
              return waitRandom(minWait, maxWait);

            case 22:
              _context.next = 1;
              break;

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
  return {
    promise: promise,
    cancel: function cancel() {
      if (completed) return;
      completed = true;
      rejectCancelled(new CancelledError());
    }
  };
}

var _RETRY_OPTIONS_BY_CHA;

function shouldCheck(lastBlockNumber, tx) {
  if (tx.receipt) return false;
  if (!tx.lastCheckedBlockNumber) return true;
  var blocksSinceCheck = lastBlockNumber - tx.lastCheckedBlockNumber;
  if (blocksSinceCheck < 1) return false;
  var minutesPending = (new Date().getTime() - tx.addedTime) / 60000;

  if (minutesPending > 60) {
    // every 10 blocks if pending longer than an hour
    return blocksSinceCheck > 9;
  } else if (minutesPending > 5) {
    // every 3 blocks if pending longer than 5 minutes
    return blocksSinceCheck > 2;
  } else {
    // otherwise every block
    return true;
  }
}

var RETRY_OPTIONS_BY_CHAIN_ID = (_RETRY_OPTIONS_BY_CHA = {}, _defineProperty(_RETRY_OPTIONS_BY_CHA, SupportedChainId.ARBITRUM_ONE, {
  n: 10,
  minWait: 250,
  maxWait: 1000
}), _defineProperty(_RETRY_OPTIONS_BY_CHA, SupportedChainId.ARBITRUM_RINKEBY, {
  n: 10,
  minWait: 250,
  maxWait: 1000
}), _defineProperty(_RETRY_OPTIONS_BY_CHA, SupportedChainId.OPTIMISTIC_KOVAN, {
  n: 10,
  minWait: 250,
  maxWait: 1000
}), _defineProperty(_RETRY_OPTIONS_BY_CHA, SupportedChainId.OPTIMISM, {
  n: 10,
  minWait: 250,
  maxWait: 1000
}), _RETRY_OPTIONS_BY_CHA);
var DEFAULT_RETRY_OPTIONS = {
  n: 1,
  minWait: 0,
  maxWait: 0
};

function Updater(_ref) {
  var pendingTransactions = _ref.pendingTransactions,
      onCheck = _ref.onCheck,
      onReceipt = _ref.onReceipt;

  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId,
      library = _useActiveWeb3React.library;

  var lastBlockNumber = useBlockNumber();
  var fastForwardBlockNumber = useFastForwardBlockNumber();
  var getReceipt = useCallback(function (hash) {
    var _RETRY_OPTIONS_BY_CHA2;

    if (!library || !chainId) throw new Error('No library or chainId');
    var retryOptions = (_RETRY_OPTIONS_BY_CHA2 = RETRY_OPTIONS_BY_CHAIN_ID[chainId]) !== null && _RETRY_OPTIONS_BY_CHA2 !== void 0 ? _RETRY_OPTIONS_BY_CHA2 : DEFAULT_RETRY_OPTIONS;
    return retry(function () {
      return library.getTransactionReceipt(hash).then(function (receipt) {
        if (receipt === null) {
          console.debug("Retrying tranasaction receipt for ".concat(hash));
          throw new RetryableError();
        }

        return receipt;
      });
    }, retryOptions);
  }, [chainId, library]);
  useEffect(function () {
    if (!chainId || !library || !lastBlockNumber) return;
    var cancels = Object.keys(pendingTransactions).filter(function (hash) {
      return shouldCheck(lastBlockNumber, pendingTransactions[hash]);
    }).map(function (hash) {
      var _getReceipt = getReceipt(hash),
          promise = _getReceipt.promise,
          cancel = _getReceipt.cancel;

      promise.then(function (receipt) {
        if (receipt) {
          onReceipt({
            chainId: chainId,
            hash: hash,
            receipt: receipt
          });
        } else {
          onCheck({
            chainId: chainId,
            hash: hash,
            blockNumber: lastBlockNumber
          });
        }
      }).catch(function (error) {
        if (!error.isCancelledError) {
          console.warn("Failed to get transaction receipt for ".concat(hash), error);
        }
      });
      return cancel;
    });
    return function () {
      cancels.forEach(function (cancel) {
        return cancel();
      });
    };
  }, [chainId, library, lastBlockNumber, getReceipt, fastForwardBlockNumber, onReceipt, onCheck, pendingTransactions]);
  return null;
}

function isTransactionRecent(transaction) {
  return Date.now() - transaction.addedTime < 86400000;
}

function usePendingTransactions() {
  var _ref;

  var _useActiveWeb3React = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React.chainId;

  var txs = useAtomValue(transactionsAtom);
  return (_ref = chainId ? txs[chainId] : null) !== null && _ref !== void 0 ? _ref : {};
}

function useAddTransaction() {
  var _useActiveWeb3React2 = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React2.chainId;

  var blockNumber = useBlockNumber();
  var updateTxs = useUpdateAtom(transactionsAtom);
  return useCallback(function (info) {
    invariant(chainId);
    var txChainId = chainId;
    var hash = info.response.hash;
    updateTxs(function (chainTxs) {
      var txs = chainTxs[txChainId] || {};
      txs[hash] = {
        addedTime: new Date().getTime(),
        lastCheckedBlockNumber: blockNumber,
        info: info
      };
      chainTxs[chainId] = txs;
    });
  }, [blockNumber, chainId, updateTxs]);
}
/** Returns the hash of a pending approval transaction, if it exists. */


function usePendingApproval(token, spender) {
  var _Object$values$find;

  var _useActiveWeb3React3 = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React3.chainId;

  var txs = useAtomValue(transactionsAtom);
  if (!chainId || !token || !spender) return undefined;
  var chainTxs = txs[chainId];
  if (!chainTxs) return undefined;
  return (_Object$values$find = Object.values(chainTxs).find(function (tx) {
    return tx && tx.receipt === undefined && tx.info.type === TransactionType.APPROVAL && tx.info.tokenAddress === token.address && tx.info.spenderAddress === spender && isTransactionRecent(tx);
  })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.info.response.hash;
}

function TransactionsUpdater() {
  var pendingTransactions = usePendingTransactions();
  var updateTxs = useUpdateAtom(transactionsAtom);
  var onCheck = useCallback(function (_ref2) {
    var chainId = _ref2.chainId,
        hash = _ref2.hash,
        blockNumber = _ref2.blockNumber;
    updateTxs(function (txs) {
      var _txs$chainId;

      var tx = (_txs$chainId = txs[chainId]) === null || _txs$chainId === void 0 ? void 0 : _txs$chainId[hash];

      if (tx) {
        tx.lastCheckedBlockNumber = tx.lastCheckedBlockNumber ? Math.max(tx.lastCheckedBlockNumber, blockNumber) : blockNumber;
      }
    });
  }, [updateTxs]);
  var onReceipt = useCallback(function (_ref3) {
    var chainId = _ref3.chainId,
        hash = _ref3.hash,
        receipt = _ref3.receipt;
    updateTxs(function (txs) {
      var _txs$chainId2;

      var tx = (_txs$chainId2 = txs[chainId]) === null || _txs$chainId2 === void 0 ? void 0 : _txs$chainId2[hash];

      if (tx) {
        tx.receipt = receipt;
      }
    });
  }, [updateTxs]);
  return /*#__PURE__*/jsx(Updater, {
    pendingTransactions: pendingTransactions,
    onCheck: onCheck,
    onReceipt: onReceipt
  });
}
/* eslint-disable @typescript-eslint/ban-types */

/**
 * Creates a derived atom whose value is the picked object property.
 * By default, the setter acts as a primitive atom's, changing the original atom.
 * A custom setter may also be passed, which uses an Immer Draft so that it may be mutated directly.
 */


function pickAtom(anAtom, key) {
  var setter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (draft, update) {
    return update;
  };
  return atom(function (get) {
    return get(anAtom)[key];
  }, function (get, set, update) {
    return set(withImmer(anAtom), function (value) {
      var derived = setter(value[key], update);
      value[key] = derived;
    });
  });
}
/** Sets a togglable atom to invert its state at the next render. */


function setTogglable(draft) {
  return !draft;
}

var DEFAULT_NETWORKS = [SupportedChainId.MAINNET, SupportedChainId.ROPSTEN, SupportedChainId.RINKEBY, SupportedChainId.GOERLI, SupportedChainId.KOVAN];

function constructSameAddressMap(address) {
  var additionalNetworks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return DEFAULT_NETWORKS.concat(additionalNetworks).reduce(function (memo, chainId) {
    memo[chainId] = address;
    return memo;
  }, {});
}

var BRYDGE_FEE_COEFFICIENT = 5;
var ETHEREUM_PORTAL_ADDRESS = '0x1b89898d33841ee860ab087e696ba14c4986385b';
var POLYGON_PORTAL_ADDRESS = '0x5c27EcDce6Cba482a3a3892F960720DFFD3D7275';
var POLYGON_ROUTER_ADDRESS = '0xaa8A044fFbcd6c4E84fAd3452c5615AE20C76879';
var ATK_ADDRESS = '0xf868939ee81f04f463010bc52eab91c0839ef08c';
var PORTAL_MAP = {
  1: ETHEREUM_PORTAL_ADDRESS,
  137: POLYGON_ROUTER_ADDRESS
}; //TODO: @zachrosen, update below hardcoded values when we have ethPortal and polygonPortal gas limit calculated

var PORTAL_GAS_LIMIT = {
  1: {
    NATIVE: 187500,
    ERC20: 212500
  },
  137: {
    NATIVE: 800000,
    ERC20: 1000000
  }
};
var COMPLETION_TIMES = {
  1: '~10 min',
  137: '<1 min'
};

var _objectSpread2$2, _objectSpread3, _objectSpread4, _ENS_REGISTRAR_ADDRES;

function ownKeys$n(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$n(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var UNI_ADDRESS = constructSameAddressMap('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984');
var ROUTER_ARGS_WRAP = '0x00000000000000000000000d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270';
var ROUTER_ARGS_UNWRAP = '0x00000000000000000000000000000000000000000000000000000000001010'; // const QUICKSWAP_MULTICALL_ADDRESS: AddressMap = constructSameAddressMap('0x02817C1e3543c2d908a590F5dB6bc97f933dB4BD')

var QUICKSWAP_FACTORY_ADDRESS = '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32';
var QUICKSWAP_ROUTER_ADDRESS = '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff';

var V2_FACTORY_ADDRESSES = _objectSpread$n(_objectSpread$n({}, constructSameAddressMap(FACTORY_ADDRESS)), {}, (_objectSpread2$2 = {}, _defineProperty(_objectSpread2$2, SupportedChainId.POLYGON, QUICKSWAP_FACTORY_ADDRESS), _defineProperty(_objectSpread2$2, SupportedChainId.MAINNET, QUICKSWAP_FACTORY_ADDRESS), _objectSpread2$2));

var QUICKSWAP_ONLY_TOKEN_LIST = [ATK_ADDRESS];

var V2_ROUTER_ADDRESS = _objectSpread$n(_objectSpread$n({}, constructSameAddressMap('0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D')), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, SupportedChainId.POLYGON, QUICKSWAP_ROUTER_ADDRESS), _defineProperty(_objectSpread3, SupportedChainId.MAINNET, QUICKSWAP_ROUTER_ADDRESS), _objectSpread3));

var MULTICALL_ADDRESS = _objectSpread$n(_objectSpread$n({}, constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984', [SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.OPTIMISM, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON])), {}, (_objectSpread4 = {}, _defineProperty(_objectSpread4, SupportedChainId.ARBITRUM_ONE, '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB'), _defineProperty(_objectSpread4, SupportedChainId.ARBITRUM_RINKEBY, '0xa501c031958F579dB7676fF1CE78AD305794d579'), _objectSpread4));

var V3_ROUTER_ADDRESS = constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.POLYGON, SupportedChainId.POLYGON_MUMBAI]);
var SWAP_ROUTER_ADDRESSES = constructSameAddressMap('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.POLYGON, SupportedChainId.POLYGON_MUMBAI]);
var V3_CORE_FACTORY_ADDRESSES = constructSameAddressMap(FACTORY_ADDRESS$1, [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
var QUOTER_ADDRESSES = constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
constructSameAddressMap('0xC36442b4a4522E871399CD717aBDD847Ab11FE88', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
var ENS_REGISTRAR_ADDRESSES = (_ENS_REGISTRAR_ADDRES = {}, _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.MAINNET, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.ROPSTEN, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.GOERLI, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.RINKEBY, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _ENS_REGISTRAR_ADDRES);

var ROOT_CHAIN_MANAGER_PROXY_ADDRESSES = _defineProperty({}, SupportedChainId.MAINNET, '0xA0c68C638235ee32657e8f720a23ceC1bFc77C77');

var _USDC, _UNI, _objectSpread2$1, _USDC2;

function _createSuper$9(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$9();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$9() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function ownKeys$m(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$m(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var MATIC_NATIVE_ADDRESS = '0x0000000000000000000000000000000000001010';
var USDC_MAINNET = new Token(SupportedChainId.MAINNET, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USD//C');
var USDC_ROPSTEN = new Token(SupportedChainId.ROPSTEN, '0x07865c6e87b9f70255377e024ace6630c1eaa37f', 6, 'USDC', 'USD//C');
var USDC_RINKEBY = new Token(SupportedChainId.RINKEBY, '0x4DBCdF9B62e891a7cec5A2568C3F4FAF9E8Abe2b', 6, 'tUSDC', 'test USD//C');
var USDC_GOERLI = new Token(SupportedChainId.GOERLI, '0x07865c6e87b9f70255377e024ace6630c1eaa37f', 6, 'USDC', 'USD//C');
var USDC_KOVAN = new Token(SupportedChainId.KOVAN, '0x31eeb2d0f9b6fd8642914ab10f4dd473677d80df', 6, 'USDC', 'USD//C');
var USDC_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x7F5c764cBc14f9669B88837ca1490cCa17c31607', 6, 'USDC', 'USD//C');
var USDC_OPTIMISTIC_KOVAN = new Token(SupportedChainId.OPTIMISTIC_KOVAN, '0x3b8e53b3ab8e01fb57d0c9e893bc4d655aa67d84', 6, 'USDC', 'USD//C');
var USDC_ARBITRUM = new Token(SupportedChainId.ARBITRUM_ONE, '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', 6, 'USDC', 'USD//C');
var USDC_ARBITRUM_RINKEBY = new Token(SupportedChainId.ARBITRUM_RINKEBY, '0x09b98f8b2395d076514037ff7d39a091a536206c', 6, 'USDC', 'USD//C');
var USDC_POLYGON = new Token(SupportedChainId.POLYGON, '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', 6, 'USDC', 'USD//C');
var USDC_POLYGON_MUMBAI = new Token(SupportedChainId.POLYGON_MUMBAI, '0xe11a86849d99f524cac3e7a0ec1241828e332c62', 6, 'USDC', 'USD//C');
var AMPL = new Token(SupportedChainId.MAINNET, '0xD46bA6D942050d489DBd938a2C909A5d5039A161', 9, 'AMPL', 'Ampleforth');
var DAI = new Token(SupportedChainId.MAINNET, '0x6B175474E89094C44Da98b954EedeAC495271d0F', 18, 'DAI', 'Dai Stablecoin');
var DAI_ARBITRUM_ONE = new Token(SupportedChainId.ARBITRUM_ONE, '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', 18, 'DAI', 'Dai stable coin');
var DAI_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', 18, 'DAI', 'Dai stable coin');
_USDC = {}, _defineProperty(_USDC, SupportedChainId.MAINNET, USDC_MAINNET), _defineProperty(_USDC, SupportedChainId.ARBITRUM_ONE, USDC_ARBITRUM), _defineProperty(_USDC, SupportedChainId.OPTIMISM, USDC_OPTIMISM), _defineProperty(_USDC, SupportedChainId.ARBITRUM_RINKEBY, USDC_ARBITRUM_RINKEBY), _defineProperty(_USDC, SupportedChainId.OPTIMISTIC_KOVAN, USDC_OPTIMISTIC_KOVAN), _defineProperty(_USDC, SupportedChainId.POLYGON, USDC_POLYGON), _defineProperty(_USDC, SupportedChainId.POLYGON_MUMBAI, USDC_POLYGON_MUMBAI), _defineProperty(_USDC, SupportedChainId.GOERLI, USDC_GOERLI), _defineProperty(_USDC, SupportedChainId.RINKEBY, USDC_RINKEBY), _defineProperty(_USDC, SupportedChainId.KOVAN, USDC_KOVAN), _defineProperty(_USDC, SupportedChainId.ROPSTEN, USDC_ROPSTEN), _USDC;
var DAI_POLYGON = new Token(SupportedChainId.POLYGON, '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', 18, 'DAI', 'Dai Stablecoin');
var USDT_POLYGON = new Token(SupportedChainId.POLYGON, '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', 6, 'USDT', 'Tether USD');
var WBTC_POLYGON = new Token(SupportedChainId.POLYGON, '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6', 8, 'WBTC', 'Wrapped BTC');
var USDT = new Token(SupportedChainId.MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD');
var USDT_ARBITRUM_ONE = new Token(SupportedChainId.ARBITRUM_ONE, '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', 6, 'USDT', 'Tether USD');
var USDT_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58', 6, 'USDT', 'Tether USD');
var WBTC = new Token(SupportedChainId.MAINNET, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC');
var WBTC_ARBITRUM_ONE = new Token(SupportedChainId.ARBITRUM_ONE, '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f', 8, 'WBTC', 'Wrapped BTC');
var WBTC_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x68f180fcCe6836688e9084f035309E29Bf0A2095', 8, 'WBTC', 'Wrapped BTC');
var FEI = new Token(SupportedChainId.MAINNET, '0x956F47F50A910163D8BF957Cf5846D573E7f87CA', 18, 'FEI', 'Fei USD');
var TRIBE = new Token(SupportedChainId.MAINNET, '0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B', 18, 'TRIBE', 'Tribe');
var FRAX = new Token(SupportedChainId.MAINNET, '0x853d955aCEf822Db058eb8505911ED77F175b99e', 18, 'FRAX', 'Frax');
var FXS = new Token(SupportedChainId.MAINNET, '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0', 18, 'FXS', 'Frax Share');
var renBTC = new Token(SupportedChainId.MAINNET, '0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D', 8, 'renBTC', 'renBTC');
var ETH2X_FLI = new Token(SupportedChainId.MAINNET, '0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD', 18, 'ETH2x-FLI', 'ETH 2x Flexible Leverage Index');
var sETH2 = new Token(SupportedChainId.MAINNET, '0xFe2e637202056d30016725477c5da089Ab0A043A', 18, 'sETH2', 'StakeWise Staked ETH2');
var rETH2 = new Token(SupportedChainId.MAINNET, '0x20BC832ca081b91433ff6c17f85701B6e92486c5', 18, 'rETH2', 'StakeWise Reward ETH2');
var SWISE = new Token(SupportedChainId.MAINNET, '0x48C3399719B582dD63eB5AADf12A40B4C3f52FA2', 18, 'SWISE', 'StakeWise');
var WETH_POLYGON_MUMBAI = new Token(SupportedChainId.POLYGON_MUMBAI, '0xa6fa4fb5f76172d178d61b04b0ecd319c5d1c0aa', 18, 'WETH', 'Wrapped Ether');
var WETH_POLYGON = new Token(SupportedChainId.POLYGON, '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619', 18, 'WETH', 'Wrapped Ether');
var UNI = (_UNI = {}, _defineProperty(_UNI, SupportedChainId.MAINNET, new Token(SupportedChainId.MAINNET, UNI_ADDRESS[1], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.RINKEBY, new Token(SupportedChainId.RINKEBY, UNI_ADDRESS[4], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.ROPSTEN, new Token(SupportedChainId.ROPSTEN, UNI_ADDRESS[3], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.GOERLI, new Token(SupportedChainId.GOERLI, UNI_ADDRESS[5], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.KOVAN, new Token(SupportedChainId.KOVAN, UNI_ADDRESS[42], 18, 'UNI', 'Uniswap')), _UNI);

var WRAPPED_NATIVE_CURRENCY = _objectSpread$m(_objectSpread$m({}, WETH9), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, SupportedChainId.OPTIMISM, new Token(SupportedChainId.OPTIMISM, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2$1, SupportedChainId.OPTIMISTIC_KOVAN, new Token(SupportedChainId.OPTIMISTIC_KOVAN, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2$1, SupportedChainId.ARBITRUM_ONE, new Token(SupportedChainId.ARBITRUM_ONE, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2$1, SupportedChainId.ARBITRUM_RINKEBY, new Token(SupportedChainId.ARBITRUM_RINKEBY, '0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2$1, SupportedChainId.POLYGON, new Token(SupportedChainId.POLYGON, '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', 18, 'WMATIC', 'Wrapped MATIC')), _defineProperty(_objectSpread2$1, SupportedChainId.POLYGON_MUMBAI, new Token(SupportedChainId.POLYGON_MUMBAI, '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889', 18, 'WMATIC', 'Wrapped MATIC')), _objectSpread2$1));

function isMatic(chainId) {
  return chainId === SupportedChainId.POLYGON_MUMBAI || chainId === SupportedChainId.POLYGON;
}

var MaticNativeCurrency = /*#__PURE__*/function (_NativeCurrency) {
  _inherits(MaticNativeCurrency, _NativeCurrency);

  var _super = _createSuper$9(MaticNativeCurrency);

  function MaticNativeCurrency(chainId) {
    _classCallCheck(this, MaticNativeCurrency);

    if (!isMatic(chainId)) throw new Error('Not matic');
    return _super.call(this, chainId, 18, 'MATIC', 'Polygon Matic');
  }

  _createClass(MaticNativeCurrency, [{
    key: "equals",
    value: function equals(other) {
      return other.isNative && other.chainId === this.chainId;
    }
  }, {
    key: "wrapped",
    get: function get() {
      if (!isMatic(this.chainId)) throw new Error('Not matic');
      var wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId];
      invariant(wrapped instanceof Token);
      return wrapped;
    }
  }]);

  return MaticNativeCurrency;
}(NativeCurrency);

var ExtendedEther = /*#__PURE__*/function (_Ether) {
  _inherits(ExtendedEther, _Ether);

  var _super2 = _createSuper$9(ExtendedEther);

  function ExtendedEther() {
    _classCallCheck(this, ExtendedEther);

    return _super2.apply(this, arguments);
  }

  _createClass(ExtendedEther, [{
    key: "wrapped",
    get: function get() {
      var wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId];
      if (wrapped) return wrapped;
      throw new Error('Unsupported chain ID');
    }
  }], [{
    key: "onChain",
    value: function onChain(chainId) {
      var _this$_cachedExtended;

      return (_this$_cachedExtended = this._cachedExtendedEther[chainId]) !== null && _this$_cachedExtended !== void 0 ? _this$_cachedExtended : this._cachedExtendedEther[chainId] = new ExtendedEther(chainId);
    }
  }]);

  return ExtendedEther;
}(Ether);

_defineProperty(ExtendedEther, "_cachedExtendedEther", {});

var cachedNativeCurrency = {};

function nativeOnChain(chainId) {
  var _cachedNativeCurrency;

  return (_cachedNativeCurrency = cachedNativeCurrency[chainId]) !== null && _cachedNativeCurrency !== void 0 ? _cachedNativeCurrency : cachedNativeCurrency[chainId] = isMatic(chainId) ? new MaticNativeCurrency(chainId) : ExtendedEther.onChain(chainId);
}

function isNativeAddress(address, chainId) {
  if (address === 'NATIVE') return true;
  if (chainId === SupportedChainId.POLYGON && address === MATIC_NATIVE_ADDRESS) return true; // add more chain/native currency address checks here

  return false;
}

var TOKEN_SHORTHANDS = {
  USDC: (_USDC2 = {}, _defineProperty(_USDC2, SupportedChainId.MAINNET, USDC_MAINNET.address), _defineProperty(_USDC2, SupportedChainId.ARBITRUM_ONE, USDC_ARBITRUM.address), _defineProperty(_USDC2, SupportedChainId.OPTIMISM, USDC_OPTIMISM.address), _defineProperty(_USDC2, SupportedChainId.ARBITRUM_RINKEBY, USDC_ARBITRUM_RINKEBY.address), _defineProperty(_USDC2, SupportedChainId.OPTIMISTIC_KOVAN, USDC_OPTIMISTIC_KOVAN.address), _defineProperty(_USDC2, SupportedChainId.POLYGON, USDC_POLYGON.address), _defineProperty(_USDC2, SupportedChainId.POLYGON_MUMBAI, USDC_POLYGON_MUMBAI.address), _defineProperty(_USDC2, SupportedChainId.GOERLI, USDC_GOERLI.address), _defineProperty(_USDC2, SupportedChainId.RINKEBY, USDC_RINKEBY.address), _defineProperty(_USDC2, SupportedChainId.KOVAN, USDC_KOVAN.address), _defineProperty(_USDC2, SupportedChainId.ROPSTEN, USDC_ROPSTEN.address), _USDC2)
};
var Field$1;

(function (Field) {
  Field["INPUT"] = "INPUT";
  Field["OUTPUT"] = "OUTPUT";
})(Field$1 || (Field$1 = {}));

var swapAtom = atomWithImmer(_defineProperty({
  independentField: Field$1.INPUT,
  amount: ''
}, Field$1.INPUT, nativeOnChain(SupportedChainId.MAINNET))); // If set to a transaction hash, that transaction will display in a status dialog.

var displayTxHashAtom = atom(undefined);
var feeOptionsAtom = atom(undefined);
/**
 * Parses a CurrencyAmount from the passed string.
 * Returns the CurrencyAmount, or undefined if parsing fails.
 */

function tryParseCurrencyAmount(value, currency) {
  if (!value || !currency) {
    return undefined;
  }

  try {
    var typedValueParsed = parseUnits(value, currency.decimals).toString();

    if (typedValueParsed !== '0') {
      return CurrencyAmount.fromRawAmount(currency, JSBI.BigInt(typedValueParsed));
    }
  } catch (error) {
    // fails if the user specifies too many decimal places of precision (or maybe exceed max uint?)
    console.debug("Failed to parse input amount: \"".concat(value, "\""), error);
  }

  return undefined;
}

var abi$4 = [{
  inputs: [],
  name: "WETH",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenA",
    type: "address"
  }, {
    internalType: "address",
    name: "tokenB",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountADesired",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountBDesired",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountAMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountBMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "addLiquidity",
  outputs: [{
    internalType: "uint256",
    name: "amountA",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountB",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountTokenDesired",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountTokenMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETHMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "addLiquidityETH",
  outputs: [{
    internalType: "uint256",
    name: "amountToken",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETH",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "factory",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reserveIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reserveOut",
    type: "uint256"
  }],
  name: "getAmountIn",
  outputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reserveIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reserveOut",
    type: "uint256"
  }],
  name: "getAmountOut",
  outputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }],
  name: "getAmountsIn",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }],
  name: "getAmountsOut",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountA",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reserveA",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reserveB",
    type: "uint256"
  }],
  name: "quote",
  outputs: [{
    internalType: "uint256",
    name: "amountB",
    type: "uint256"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenA",
    type: "address"
  }, {
    internalType: "address",
    name: "tokenB",
    type: "address"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountAMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountBMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "removeLiquidity",
  outputs: [{
    internalType: "uint256",
    name: "amountA",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountB",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountTokenMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETHMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "removeLiquidityETH",
  outputs: [{
    internalType: "uint256",
    name: "amountToken",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETH",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountTokenMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETHMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "removeLiquidityETHSupportingFeeOnTransferTokens",
  outputs: [{
    internalType: "uint256",
    name: "amountETH",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountTokenMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETHMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }, {
    internalType: "bool",
    name: "approveMax",
    type: "bool"
  }, {
    internalType: "uint8",
    name: "v",
    type: "uint8"
  }, {
    internalType: "bytes32",
    name: "r",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "s",
    type: "bytes32"
  }],
  name: "removeLiquidityETHWithPermit",
  outputs: [{
    internalType: "uint256",
    name: "amountToken",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETH",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountTokenMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountETHMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }, {
    internalType: "bool",
    name: "approveMax",
    type: "bool"
  }, {
    internalType: "uint8",
    name: "v",
    type: "uint8"
  }, {
    internalType: "bytes32",
    name: "r",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "s",
    type: "bytes32"
  }],
  name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
  outputs: [{
    internalType: "uint256",
    name: "amountETH",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenA",
    type: "address"
  }, {
    internalType: "address",
    name: "tokenB",
    type: "address"
  }, {
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountAMin",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountBMin",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }, {
    internalType: "bool",
    name: "approveMax",
    type: "bool"
  }, {
    internalType: "uint8",
    name: "v",
    type: "uint8"
  }, {
    internalType: "bytes32",
    name: "r",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "s",
    type: "bytes32"
  }],
  name: "removeLiquidityWithPermit",
  outputs: [{
    internalType: "uint256",
    name: "amountA",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountB",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapETHForExactTokens",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOutMin",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapExactETHForTokens",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOutMin",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountOutMin",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapExactTokensForETH",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountOutMin",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountOutMin",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapExactTokensForTokens",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountOutMin",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountInMax",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapTokensForExactETH",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amountInMax",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "path",
    type: "address[]"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }],
  name: "swapTokensForExactTokens",
  outputs: [{
    internalType: "uint256[]",
    name: "amounts",
    type: "uint256[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];
var evm = {
  bytecode: {
    linkReferences: {},
    object: "",
    opcodes: "",
    sourceMap: ""
  },
  deployedBytecode: {
    immutableReferences: {},
    linkReferences: {},
    object: "",
    opcodes: "",
    sourceMap: ""
  }
};
var bytecode$2 = "";
var IUniswapV2Router02Json = {
  abi: abi$4,
  evm: evm,
  "interface": [{
    inputs: [],
    name: "WETH",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "tokenA",
      type: "address"
    }, {
      internalType: "address",
      name: "tokenB",
      type: "address"
    }, {
      internalType: "uint256",
      name: "amountADesired",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountBDesired",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountAMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountBMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "addLiquidity",
    outputs: [{
      internalType: "uint256",
      name: "amountA",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountB",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "uint256",
      name: "amountTokenDesired",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountTokenMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETHMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "addLiquidityETH",
    outputs: [{
      internalType: "uint256",
      name: "amountToken",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETH",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [],
    name: "factory",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOut",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "reserveIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "reserveOut",
      type: "uint256"
    }],
    name: "getAmountIn",
    outputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "reserveIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "reserveOut",
      type: "uint256"
    }],
    name: "getAmountOut",
    outputs: [{
      internalType: "uint256",
      name: "amountOut",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOut",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }],
    name: "getAmountsIn",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }],
    name: "getAmountsOut",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "view",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountA",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "reserveA",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "reserveB",
      type: "uint256"
    }],
    name: "quote",
    outputs: [{
      internalType: "uint256",
      name: "amountB",
      type: "uint256"
    }],
    stateMutability: "pure",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "tokenA",
      type: "address"
    }, {
      internalType: "address",
      name: "tokenB",
      type: "address"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountAMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountBMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "removeLiquidity",
    outputs: [{
      internalType: "uint256",
      name: "amountA",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountB",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountTokenMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETHMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "removeLiquidityETH",
    outputs: [{
      internalType: "uint256",
      name: "amountToken",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETH",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountTokenMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETHMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [{
      internalType: "uint256",
      name: "amountETH",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountTokenMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETHMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "bool",
      name: "approveMax",
      type: "bool"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }, {
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }],
    name: "removeLiquidityETHWithPermit",
    outputs: [{
      internalType: "uint256",
      name: "amountToken",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETH",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountTokenMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountETHMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "bool",
      name: "approveMax",
      type: "bool"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }, {
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [{
      internalType: "uint256",
      name: "amountETH",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "address",
      name: "tokenA",
      type: "address"
    }, {
      internalType: "address",
      name: "tokenB",
      type: "address"
    }, {
      internalType: "uint256",
      name: "liquidity",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountAMin",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountBMin",
      type: "uint256"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "bool",
      name: "approveMax",
      type: "bool"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }, {
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }],
    name: "removeLiquidityWithPermit",
    outputs: [{
      internalType: "uint256",
      name: "amountA",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountB",
      type: "uint256"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOut",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapETHForExactTokens",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOutMin",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapExactETHForTokens",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOutMin",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountOutMin",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapExactTokensForETH",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountOutMin",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountOutMin",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapExactTokensForTokens",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountIn",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountOutMin",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOut",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountInMax",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapTokensForExactETH",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }, {
    inputs: [{
      internalType: "uint256",
      name: "amountOut",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "amountInMax",
      type: "uint256"
    }, {
      internalType: "address[]",
      name: "path",
      type: "address[]"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    name: "swapTokensForExactTokens",
    outputs: [{
      internalType: "uint256[]",
      name: "amounts",
      type: "uint256[]"
    }],
    stateMutability: "nonpayable",
    type: "function"
  }],
  bytecode: bytecode$2
};
var _format$1 = "hh-sol-artifact-1";
var contractName$1 = "Quoter";
var sourceName$1 = "contracts/lens/Quoter.sol";
var abi$3 = [{
  inputs: [{
    internalType: "address",
    name: "_factory",
    type: "address"
  }, {
    internalType: "address",
    name: "_WETH9",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "WETH9",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "factory",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "path",
    type: "bytes"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }],
  name: "quoteExactInput",
  outputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "address",
    name: "tokenOut",
    type: "address"
  }, {
    internalType: "uint24",
    name: "fee",
    type: "uint24"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "uint160",
    name: "sqrtPriceLimitX96",
    type: "uint160"
  }],
  name: "quoteExactInputSingle",
  outputs: [{
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "path",
    type: "bytes"
  }, {
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }],
  name: "quoteExactOutput",
  outputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "address",
    name: "tokenOut",
    type: "address"
  }, {
    internalType: "uint24",
    name: "fee",
    type: "uint24"
  }, {
    internalType: "uint256",
    name: "amountOut",
    type: "uint256"
  }, {
    internalType: "uint160",
    name: "sqrtPriceLimitX96",
    type: "uint160"
  }],
  name: "quoteExactOutputSingle",
  outputs: [{
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "int256",
    name: "amount0Delta",
    type: "int256"
  }, {
    internalType: "int256",
    name: "amount1Delta",
    type: "int256"
  }, {
    internalType: "bytes",
    name: "path",
    type: "bytes"
  }],
  name: "uniswapV3SwapCallback",
  outputs: [],
  stateMutability: "view",
  type: "function"
}];
var bytecode$1 = "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";
var deployedBytecode$1 = "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";
var linkReferences$1 = {};
var deployedLinkReferences$1 = {};
var QuoterJson = {
  _format: _format$1,
  contractName: contractName$1,
  sourceName: sourceName$1,
  abi: abi$3,
  bytecode: bytecode$1,
  deployedBytecode: deployedBytecode$1,
  linkReferences: linkReferences$1,
  deployedLinkReferences: deployedLinkReferences$1
};
var _format = "hh-sol-artifact-1";
var contractName = "UniswapInterfaceMulticall";
var sourceName = "contracts/lens/UniswapInterfaceMulticall.sol";
var abi$2 = [{
  inputs: [],
  name: "getCurrentBlockTimestamp",
  outputs: [{
    internalType: "uint256",
    name: "timestamp",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "addr",
    type: "address"
  }],
  name: "getEthBalance",
  outputs: [{
    internalType: "uint256",
    name: "balance",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "target",
      type: "address"
    }, {
      internalType: "uint256",
      name: "gasLimit",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "callData",
      type: "bytes"
    }],
    internalType: "struct UniswapInterfaceMulticall.Call[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "multicall",
  outputs: [{
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }, {
    components: [{
      internalType: "bool",
      name: "success",
      type: "bool"
    }, {
      internalType: "uint256",
      name: "gasUsed",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "returnData",
      type: "bytes"
    }],
    internalType: "struct UniswapInterfaceMulticall.Result[]",
    name: "returnData",
    type: "tuple[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];
var bytecode = "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";
var deployedBytecode = "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";
var linkReferences = {};
var deployedLinkReferences = {};
var UniswapInterfaceMulticallJson = {
  _format: _format,
  contractName: contractName,
  sourceName: sourceName,
  abi: abi$2,
  bytecode: bytecode,
  deployedBytecode: deployedBytecode,
  linkReferences: linkReferences,
  deployedLinkReferences: deployedLinkReferences
};
var EIP_2612 = [{
  constant: true,
  inputs: [{
    name: "owner",
    type: "address"
  }],
  name: "nonces",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var ENS_PUBLIC_RESOLVER_ABI = [{
  inputs: [{
    internalType: "contract ENS",
    name: "_ens",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "contentType",
    type: "uint256"
  }],
  name: "ABIChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "address",
    name: "a",
    type: "address"
  }],
  name: "AddrChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "coinType",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "newAddress",
    type: "bytes"
  }],
  name: "AddressChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "target",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "isAuthorised",
    type: "bool"
  }],
  name: "AuthorisationChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "hash",
    type: "bytes"
  }],
  name: "ContenthashChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "name",
    type: "bytes"
  }, {
    indexed: false,
    internalType: "uint16",
    name: "resource",
    type: "uint16"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "record",
    type: "bytes"
  }],
  name: "DNSRecordChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "name",
    type: "bytes"
  }, {
    indexed: false,
    internalType: "uint16",
    name: "resource",
    type: "uint16"
  }],
  name: "DNSRecordDeleted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "DNSZoneCleared",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes4",
    name: "interfaceID",
    type: "bytes4"
  }, {
    indexed: false,
    internalType: "address",
    name: "implementer",
    type: "address"
  }],
  name: "InterfaceChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "string",
    name: "name",
    type: "string"
  }],
  name: "NameChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bytes32",
    name: "x",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "bytes32",
    name: "y",
    type: "bytes32"
  }],
  name: "PubkeyChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "string",
    name: "indexedKey",
    type: "string"
  }, {
    indexed: false,
    internalType: "string",
    name: "key",
    type: "string"
  }],
  name: "TextChanged",
  type: "event"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "contentTypes",
    type: "uint256"
  }],
  name: "ABI",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "addr",
  outputs: [{
    internalType: "address payable",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "authorisations",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "clearDNSZone",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "contenthash",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "name",
    type: "bytes32"
  }, {
    internalType: "uint16",
    name: "resource",
    type: "uint16"
  }],
  name: "dnsRecord",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "name",
    type: "bytes32"
  }],
  name: "hasDNSRecords",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes4",
    name: "interfaceID",
    type: "bytes4"
  }],
  name: "interfaceImplementer",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "pubkey",
  outputs: [{
    internalType: "bytes32",
    name: "x",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "y",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "contentType",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "setABI",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "coinType",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "a",
    type: "bytes"
  }],
  name: "setAddr",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "a",
    type: "address"
  }],
  name: "setAddr",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "target",
    type: "address"
  }, {
    internalType: "bool",
    name: "isAuthorised",
    type: "bool"
  }],
  name: "setAuthorisation",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes",
    name: "hash",
    type: "bytes"
  }],
  name: "setContenthash",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "setDNSRecords",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes4",
    name: "interfaceID",
    type: "bytes4"
  }, {
    internalType: "address",
    name: "implementer",
    type: "address"
  }],
  name: "setInterface",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "string",
    name: "name",
    type: "string"
  }],
  name: "setName",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "x",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "y",
    type: "bytes32"
  }],
  name: "setPubkey",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "string",
    name: "key",
    type: "string"
  }, {
    internalType: "string",
    name: "value",
    type: "string"
  }],
  name: "setText",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes4",
    name: "interfaceID",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "string",
    name: "key",
    type: "string"
  }],
  name: "text",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var ENS_ABI = [{
  inputs: [{
    internalType: "contract ENS",
    name: "_old",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "ApprovalForAll",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "label",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "NewOwner",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "address",
    name: "resolver",
    type: "address"
  }],
  name: "NewResolver",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "NewTTL",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "Transfer",
  type: "event"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "operator",
    type: "address"
  }],
  name: "isApprovedForAll",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "old",
  outputs: [{
    internalType: "contract ENS",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "recordExists",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "resolver",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setApprovalForAll",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "setOwner",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "resolver",
    type: "address"
  }, {
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "setRecord",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "resolver",
    type: "address"
  }],
  name: "setResolver",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "label",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "setSubnodeOwner",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "label",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "resolver",
    type: "address"
  }, {
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "setSubnodeRecord",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }, {
    internalType: "uint64",
    name: "ttl",
    type: "uint64"
  }],
  name: "setTTL",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes32",
    name: "node",
    type: "bytes32"
  }],
  name: "ttl",
  outputs: [{
    internalType: "uint64",
    name: "",
    type: "uint64"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var ERC20ABI = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "_value",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_from",
    type: "address"
  }, {
    name: "_to",
    type: "address"
  }, {
    name: "_value",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "balance",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_to",
    type: "address"
  }, {
    name: "_value",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address"
  }, {
    name: "_spender",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  payable: true,
  stateMutability: "payable",
  type: "fallback"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    name: "spender",
    type: "address"
  }, {
    indexed: false,
    name: "value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "value",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}];
var ERC20_BYTES32_ABI = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var ROOT_CHAIN_MANAGER_ABI = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "userAddress",
    type: "address"
  }, {
    indexed: false,
    internalType: "address payable",
    name: "relayerAddress",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "functionSignature",
    type: "bytes"
  }],
  name: "MetaTransactionExecuted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "tokenType",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "predicateAddress",
    type: "address"
  }],
  name: "PredicateRegistered",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "rootToken",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "childToken",
    type: "address"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "tokenType",
    type: "bytes32"
  }],
  name: "TokenMapped",
  type: "event"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DEPOSIT",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ERC712_VERSION",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ETHER_ADDRESS",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MAPPER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MAP_TOKEN",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "checkpointManagerAddress",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "childChainManagerAddress",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "childToRootToken",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "rootToken",
    type: "address"
  }, {
    internalType: "address",
    name: "childToken",
    type: "address"
  }],
  name: "cleanMapToken",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "user",
    type: "address"
  }],
  name: "depositEtherFor",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    internalType: "address",
    name: "rootToken",
    type: "address"
  }, {
    internalType: "bytes",
    name: "depositData",
    type: "bytes"
  }],
  name: "depositFor",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "userAddress",
    type: "address"
  }, {
    internalType: "bytes",
    name: "functionSignature",
    type: "bytes"
  }, {
    internalType: "bytes32",
    name: "sigR",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "sigS",
    type: "bytes32"
  }, {
    internalType: "uint8",
    name: "sigV",
    type: "uint8"
  }],
  name: "executeMetaTransaction",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "inputData",
    type: "bytes"
  }],
  name: "exit",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "getChainId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [],
  name: "getDomainSeperator",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "user",
    type: "address"
  }],
  name: "getNonce",
  outputs: [{
    internalType: "uint256",
    name: "nonce",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "index",
    type: "uint256"
  }],
  name: "getRoleMember",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleMemberCount",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "initializeEIP712",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "rootToken",
    type: "address"
  }, {
    internalType: "address",
    name: "childToken",
    type: "address"
  }, {
    internalType: "bytes32",
    name: "tokenType",
    type: "bytes32"
  }],
  name: "mapToken",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "processedExits",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "tokenType",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "predicateAddress",
    type: "address"
  }],
  name: "registerPredicate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "rootToken",
    type: "address"
  }, {
    internalType: "address",
    name: "childToken",
    type: "address"
  }, {
    internalType: "bytes32",
    name: "tokenType",
    type: "bytes32"
  }],
  name: "remapToken",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "rootToChildToken",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newCheckpointManager",
    type: "address"
  }],
  name: "setCheckpointManager",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newChildChainManager",
    type: "address"
  }],
  name: "setChildChainManagerAddress",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newStateSender",
    type: "address"
  }],
  name: "setStateSender",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "setupContractId",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "stateSenderAddress",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "tokenToType",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "typeToPredicate",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  stateMutability: "payable",
  type: "receive"
}];
var WETH_ABI = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "guy",
    type: "address"
  }, {
    name: "wad",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "src",
    type: "address"
  }, {
    name: "dst",
    type: "address"
  }, {
    name: "wad",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "wad",
    type: "uint256"
  }],
  name: "withdraw",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "dst",
    type: "address"
  }, {
    name: "wad",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [],
  name: "deposit",
  outputs: [],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  payable: true,
  stateMutability: "payable",
  type: "fallback"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "src",
    type: "address"
  }, {
    indexed: true,
    name: "guy",
    type: "address"
  }, {
    indexed: false,
    name: "wad",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "src",
    type: "address"
  }, {
    indexed: true,
    name: "dst",
    type: "address"
  }, {
    indexed: false,
    name: "wad",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "dst",
    type: "address"
  }, {
    indexed: false,
    name: "wad",
    type: "uint256"
  }],
  name: "Deposit",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "src",
    type: "address"
  }, {
    indexed: false,
    name: "wad",
    type: "uint256"
  }],
  name: "Withdrawal",
  type: "event"
}]; // returns the checksummed address if the address is valid, otherwise returns false

function isAddress(value) {
  try {
    return getAddress(value);
  } catch (_unused) {
    return false;
  }
} // shorten the checksummed version of the input address to have 0x + 4 characters at start and end


function getSigner(library, account) {
  return library.getSigner(account).connectUnchecked();
} // account is optional


function getProviderOrSigner(library, account) {
  return account ? getSigner(library, account) : library;
} // account is optional


function getContract(address, ABI, library, account) {
  if (!isAddress(address) || address === AddressZero) {
    throw Error("Invalid 'address' parameter '".concat(address, "'."));
  }

  return new Contract(address, ABI, getProviderOrSigner(library, account));
}

var IUniswapV2Router02ABI = IUniswapV2Router02Json.abi;
var QuoterABI = QuoterJson.abi;
var MulticallABI = UniswapInterfaceMulticallJson.abi; // returns null on errors

function useContract(addressOrAddressMap, ABI) {
  var withSignerIfPossible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useActiveWeb3React = useActiveWeb3React(),
      library = _useActiveWeb3React.library,
      account = _useActiveWeb3React.account,
      chainId = _useActiveWeb3React.chainId;

  return useMemo(function () {
    if (!addressOrAddressMap || !ABI || !library || !chainId) return null;
    var address;
    if (typeof addressOrAddressMap === 'string') address = addressOrAddressMap;else address = addressOrAddressMap[chainId];
    if (!address) return null;

    try {
      return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined);
    } catch (error) {
      console.error('Failed to get contract', error);
      return null;
    }
  }, [addressOrAddressMap, ABI, library, chainId, withSignerIfPossible, account]);
}

function useTokenContract(tokenAddress, withSignerIfPossible) {
  return useContract(tokenAddress, ERC20ABI, withSignerIfPossible);
}

function useWETHContract(withSignerIfPossible) {
  var _WRAPPED_NATIVE_CURRE;

  var _useActiveWeb3React2 = useActiveWeb3React(),
      chainId = _useActiveWeb3React2.chainId;

  return useContract(chainId ? (_WRAPPED_NATIVE_CURRE = WRAPPED_NATIVE_CURRENCY[chainId]) === null || _WRAPPED_NATIVE_CURRE === void 0 ? void 0 : _WRAPPED_NATIVE_CURRE.address : undefined, WETH_ABI, withSignerIfPossible);
}

function useENSRegistrarContractWithChainId(chainId, withSignerIfPossible) {
  return useContractWithChainId(chainId, ENS_REGISTRAR_ADDRESSES, ENS_ABI, withSignerIfPossible);
}

function useENSResolverContractWithChainId(chainId, address, withSignerIfPossible) {
  return useContractWithChainId(chainId, address, ENS_PUBLIC_RESOLVER_ABI, withSignerIfPossible);
}

function useBytes32TokenContract(tokenAddress, withSignerIfPossible) {
  return useContract(tokenAddress, ERC20_BYTES32_ABI, withSignerIfPossible);
}

function useEIP2612Contract(tokenAddress) {
  return useContract(tokenAddress, EIP_2612, false);
}

function useV2RouterContract() {
  return useContract(V2_ROUTER_ADDRESS, IUniswapV2Router02ABI, true);
}

function useInterfaceMulticallWithChainId(chainId) {
  return useContractWithChainId(chainId, MULTICALL_ADDRESS, MulticallABI, false);
}

function useV3QuoterWithChainId(chainId) {
  return useContractWithChainId(chainId, QUOTER_ADDRESSES, QuoterABI);
}

function useRootChainManagerProxyContract() {
  var _useActiveWeb3React3 = useActiveWeb3React(),
      chainId = _useActiveWeb3React3.chainId;

  var address = chainId ? ROOT_CHAIN_MANAGER_PROXY_ADDRESSES[chainId] : undefined;
  return useContract(address, ROOT_CHAIN_MANAGER_ABI, false);
}

function useContractWithChainId(chainId, addressOrAddressMap, ABI) {
  var withSignerIfPossible = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var _useActiveWeb3React4 = useActiveWeb3React(),
      library = _useActiveWeb3React4.library,
      account = _useActiveWeb3React4.account;

  return useMemo(function () {
    if (!addressOrAddressMap || !ABI || !library || !chainId) return null;
    var address;
    if (typeof addressOrAddressMap === 'string') address = addressOrAddressMap;else address = addressOrAddressMap[chainId];
    if (!address) return null;

    try {
      return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined);
    } catch (error) {
      console.error('Failed to get contract', error);
      return null;
    }
  }, [addressOrAddressMap, ABI, library, chainId, withSignerIfPossible, account]);
}

var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
var ZERO_ADDRESS_ENC = '0x0000000000000000000000000000000000000000000000000000000000000000';
var DEFAULT_DEADLINE_FROM_NOW = 60 * 30;
var L2_DEADLINE_FROM_NOW = 60 * 5;
var ONE_HOUR_IN_MS = 60 * 60 * 1000; // transaction popup dismisal amounts

JSBI.BigInt(60 * 60 * 24 * 7);
JSBI.BigInt(0); // one basis JSBI.BigInt

var BIPS_BASE = JSBI.BigInt(10000);
new Percent(JSBI.BigInt(1), BIPS_BASE); // used for warning states

new Percent(JSBI.BigInt(100), BIPS_BASE); // 1%

var ALLOWED_PRICE_IMPACT_MEDIUM = new Percent(JSBI.BigInt(300), BIPS_BASE); // 3%

var ALLOWED_PRICE_IMPACT_HIGH = new Percent(JSBI.BigInt(500), BIPS_BASE); // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute

new Percent(JSBI.BigInt(1000), BIPS_BASE); // 10%
// for non expert mode disable swaps above this

new Percent(JSBI.BigInt(1500), BIPS_BASE); // 15%

var BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), BIPS_BASE);
var ZERO_PERCENT = new Percent('0');
new Percent(JSBI.BigInt(200), BIPS_BASE);
var ONE_HUNDRED_PERCENT = new Percent('1'); // only used by v2 hooks

function isTradeBetter(tradeA, tradeB) {
  var minimumDelta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ZERO_PERCENT;
  if (tradeA && !tradeB) return false;
  if (tradeB && !tradeA) return true;
  if (!tradeA || !tradeB) return undefined;

  if (tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency)) {
    throw new Error('Comparing incomparable trades');
  }

  if (minimumDelta.equalTo(ZERO_PERCENT)) {
    return tradeA.executionPrice.lessThan(tradeB.executionPrice);
  } else {
    return tradeA.executionPrice.asFraction.multiply(minimumDelta.add(ONE_HUNDRED_PERCENT)).lessThan(tradeB.executionPrice);
  }
}

var _objectSpread2, _SupportedChainId$MAI, _COMMON_BASES;

function ownKeys$l(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$l(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var WRAPPED_NATIVE_CURRENCIES_ONLY = Object.fromEntries(Object.entries(WRAPPED_NATIVE_CURRENCY).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return [key, [value]];
}).filter(Boolean)); // used to construct intermediary pairs for trading

var BASES_TO_CHECK_TRADES_AGAINST = _objectSpread$l(_objectSpread$l({}, WRAPPED_NATIVE_CURRENCIES_ONLY), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, SupportedChainId.MAINNET, [].concat(_toConsumableArray(WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.MAINNET]), [DAI, USDC_MAINNET, USDT, WBTC])), _defineProperty(_objectSpread2, SupportedChainId.OPTIMISM, [].concat(_toConsumableArray(WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.OPTIMISM]), [DAI_OPTIMISM, USDT_OPTIMISM, WBTC_OPTIMISM])), _defineProperty(_objectSpread2, SupportedChainId.ARBITRUM_ONE, [].concat(_toConsumableArray(WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.ARBITRUM_ONE]), [DAI_ARBITRUM_ONE, USDT_ARBITRUM_ONE, WBTC_ARBITRUM_ONE])), _defineProperty(_objectSpread2, SupportedChainId.POLYGON, [].concat(_toConsumableArray(WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.POLYGON]), [DAI_POLYGON, USDC_POLYGON, USDT_POLYGON, WETH_POLYGON])), _objectSpread2));

var ADDITIONAL_BASES = _defineProperty({}, SupportedChainId.MAINNET, (_SupportedChainId$MAI = {
  '0xF16E4d813f4DcfDe4c5b44f305c908742De84eF0': [ETH2X_FLI]
}, _defineProperty(_SupportedChainId$MAI, rETH2.address, [sETH2]), _defineProperty(_SupportedChainId$MAI, SWISE.address, [sETH2]), _defineProperty(_SupportedChainId$MAI, FEI.address, [TRIBE]), _defineProperty(_SupportedChainId$MAI, TRIBE.address, [FEI]), _defineProperty(_SupportedChainId$MAI, FRAX.address, [FXS]), _defineProperty(_SupportedChainId$MAI, FXS.address, [FRAX]), _defineProperty(_SupportedChainId$MAI, WBTC.address, [renBTC]), _defineProperty(_SupportedChainId$MAI, renBTC.address, [WBTC]), _SupportedChainId$MAI));
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */


var CUSTOM_BASES = _defineProperty({}, SupportedChainId.MAINNET, _defineProperty({}, AMPL.address, [DAI, WRAPPED_NATIVE_CURRENCY[SupportedChainId.MAINNET]]));
/**
 * Shows up in the currency select for swap and add liquidity
 */


_COMMON_BASES = {}, _defineProperty(_COMMON_BASES, SupportedChainId.MAINNET, [nativeOnChain(SupportedChainId.MAINNET), DAI, USDC_MAINNET, USDT, WBTC, WRAPPED_NATIVE_CURRENCY[SupportedChainId.MAINNET]]), _defineProperty(_COMMON_BASES, SupportedChainId.ROPSTEN, [nativeOnChain(SupportedChainId.ROPSTEN), WRAPPED_NATIVE_CURRENCY[SupportedChainId.ROPSTEN]]), _defineProperty(_COMMON_BASES, SupportedChainId.RINKEBY, [nativeOnChain(SupportedChainId.RINKEBY), WRAPPED_NATIVE_CURRENCY[SupportedChainId.RINKEBY]]), _defineProperty(_COMMON_BASES, SupportedChainId.GOERLI, [nativeOnChain(SupportedChainId.GOERLI), WRAPPED_NATIVE_CURRENCY[SupportedChainId.GOERLI]]), _defineProperty(_COMMON_BASES, SupportedChainId.KOVAN, [nativeOnChain(SupportedChainId.KOVAN), WRAPPED_NATIVE_CURRENCY[SupportedChainId.KOVAN]]), _defineProperty(_COMMON_BASES, SupportedChainId.ARBITRUM_ONE, [nativeOnChain(SupportedChainId.ARBITRUM_ONE), DAI_ARBITRUM_ONE, USDC_ARBITRUM, USDT_ARBITRUM_ONE, WBTC_ARBITRUM_ONE, WRAPPED_NATIVE_CURRENCY[SupportedChainId.ARBITRUM_ONE]]), _defineProperty(_COMMON_BASES, SupportedChainId.ARBITRUM_RINKEBY, [nativeOnChain(SupportedChainId.ARBITRUM_RINKEBY), WRAPPED_NATIVE_CURRENCY[SupportedChainId.ARBITRUM_RINKEBY]]), _defineProperty(_COMMON_BASES, SupportedChainId.OPTIMISM, [nativeOnChain(SupportedChainId.OPTIMISM), DAI_OPTIMISM, USDC_OPTIMISM, USDT_OPTIMISM, WBTC_OPTIMISM]), _defineProperty(_COMMON_BASES, SupportedChainId.OPTIMISTIC_KOVAN, [nativeOnChain(SupportedChainId.OPTIMISTIC_KOVAN)]), _defineProperty(_COMMON_BASES, SupportedChainId.POLYGON, [nativeOnChain(SupportedChainId.POLYGON), WETH_POLYGON, USDC_POLYGON, DAI_POLYGON, USDT_POLYGON, WBTC_POLYGON]), _defineProperty(_COMMON_BASES, SupportedChainId.POLYGON_MUMBAI, [nativeOnChain(SupportedChainId.POLYGON_MUMBAI), WRAPPED_NATIVE_CURRENCY[SupportedChainId.POLYGON_MUMBAI], WETH_POLYGON_MUMBAI]), _COMMON_BASES; // used to construct the list of all pairs we consider by default in the frontend

_objectSpread$l(_objectSpread$l({}, WRAPPED_NATIVE_CURRENCIES_ONLY), {}, _defineProperty({}, SupportedChainId.MAINNET, [].concat(_toConsumableArray(WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.MAINNET]), [DAI, USDC_MAINNET, USDT, WBTC])));

_defineProperty({}, SupportedChainId.MAINNET, [[new Token(SupportedChainId.MAINNET, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643', 8, 'cDAI', 'Compound Dai'), new Token(SupportedChainId.MAINNET, '0x39AA39c021dfbaE8faC545936693aC917d5E7563', 8, 'cUSDC', 'Compound USD Coin')], [USDC_MAINNET, USDT], [DAI, USDT]]);

function useAllCurrencyCombinations(currencyA, currencyB) {
  var chainId = currencyA === null || currencyA === void 0 ? void 0 : currencyA.chainId;

  var _ref = chainId ? [currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped, currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped] : [undefined, undefined],
      _ref2 = _slicedToArray(_ref, 2),
      tokenA = _ref2[0],
      tokenB = _ref2[1];

  var bases = useMemo(function () {
    var _BASES_TO_CHECK_TRADE, _ADDITIONAL_BASES$cha, _ADDITIONAL_BASES$cha2, _ADDITIONAL_BASES$cha3, _ADDITIONAL_BASES$cha4;

    if (!chainId || chainId !== (tokenB === null || tokenB === void 0 ? void 0 : tokenB.chainId)) return [];
    var common = (_BASES_TO_CHECK_TRADE = BASES_TO_CHECK_TRADES_AGAINST[chainId]) !== null && _BASES_TO_CHECK_TRADE !== void 0 ? _BASES_TO_CHECK_TRADE : [];
    var additionalA = tokenA ? (_ADDITIONAL_BASES$cha = (_ADDITIONAL_BASES$cha2 = ADDITIONAL_BASES[chainId]) === null || _ADDITIONAL_BASES$cha2 === void 0 ? void 0 : _ADDITIONAL_BASES$cha2[tokenA.address]) !== null && _ADDITIONAL_BASES$cha !== void 0 ? _ADDITIONAL_BASES$cha : [] : [];
    var additionalB = tokenB ? (_ADDITIONAL_BASES$cha3 = (_ADDITIONAL_BASES$cha4 = ADDITIONAL_BASES[chainId]) === null || _ADDITIONAL_BASES$cha4 === void 0 ? void 0 : _ADDITIONAL_BASES$cha4[tokenB.address]) !== null && _ADDITIONAL_BASES$cha3 !== void 0 ? _ADDITIONAL_BASES$cha3 : [] : [];
    return [].concat(_toConsumableArray(common), _toConsumableArray(additionalA), _toConsumableArray(additionalB));
  }, [chainId, tokenA, tokenB]);
  var basePairs = useMemo(function () {
    return bases.flatMap(function (base) {
      return bases.map(function (otherBase) {
        return [base, otherBase];
      });
    }) // though redundant with the first filter below, that expression runs more often, so this is probably worthwhile
    .filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          t0 = _ref4[0],
          t1 = _ref4[1];

      return !t0.equals(t1);
    });
  }, [bases]);
  return useMemo(function () {
    return tokenA && tokenB ? [// the direct pair
    [tokenA, tokenB]].concat(_toConsumableArray(bases.map(function (base) {
      return [tokenA, base];
    })), _toConsumableArray(bases.map(function (base) {
      return [tokenB, base];
    })), _toConsumableArray(basePairs)) // filter out invalid pairs comprised of the same asset (e.g. WETH<>WETH)
    .filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          t0 = _ref6[0],
          t1 = _ref6[1];

      return !t0.equals(t1);
    }) // filter out duplicate pairs
    .filter(function (_ref7, i, otherPairs) {
      var _ref8 = _slicedToArray(_ref7, 2),
          t0 = _ref8[0],
          t1 = _ref8[1]; // find the first index in the array at which there are the same 2 tokens as the current


      var firstIndexInOtherPairs = otherPairs.findIndex(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            t0Other = _ref10[0],
            t1Other = _ref10[1];

        return t0.equals(t0Other) && t1.equals(t1Other) || t0.equals(t1Other) && t1.equals(t0Other);
      }); // only accept the first occurrence of the same 2 tokens

      return firstIndexInOtherPairs === i;
    }) // optionally filter out some pairs for tokens with custom bases defined
    .filter(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          tokenA = _ref12[0],
          tokenB = _ref12[1];

      if (!chainId) return true;
      var customBases = CUSTOM_BASES[chainId];
      var customBasesA = customBases === null || customBases === void 0 ? void 0 : customBases[tokenA.address];
      var customBasesB = customBases === null || customBases === void 0 ? void 0 : customBases[tokenB.address];
      if (!customBasesA && !customBasesB) return true;
      if (customBasesA && !customBasesA.find(function (base) {
        return tokenB.equals(base);
      })) return false;
      if (customBasesB && !customBasesB.find(function (base) {
        return tokenA.equals(base);
      })) return false;
      return true;
    }) : [];
  }, [tokenA, tokenB, bases, basePairs, chainId]);
}

var abi$1 = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount0",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount1",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }],
  name: "Burn",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount0",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount1",
    type: "uint256"
  }],
  name: "Mint",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount0In",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount1In",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount0Out",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount1Out",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }],
  name: "Swap",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint112",
    name: "reserve0",
    type: "uint112"
  }, {
    indexed: false,
    internalType: "uint112",
    name: "reserve1",
    type: "uint112"
  }],
  name: "Sync",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  constant: true,
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "MINIMUM_LIQUIDITY",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "PERMIT_TYPEHASH",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "spender",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }],
  name: "burn",
  outputs: [{
    internalType: "uint256",
    name: "amount0",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amount1",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    internalType: "uint8",
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "factory",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getReserves",
  outputs: [{
    internalType: "uint112",
    name: "reserve0",
    type: "uint112"
  }, {
    internalType: "uint112",
    name: "reserve1",
    type: "uint112"
  }, {
    internalType: "uint32",
    name: "blockTimestampLast",
    type: "uint32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "initialize",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "kLast",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }],
  name: "mint",
  outputs: [{
    internalType: "uint256",
    name: "liquidity",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "nonces",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "deadline",
    type: "uint256"
  }, {
    internalType: "uint8",
    name: "v",
    type: "uint8"
  }, {
    internalType: "bytes32",
    name: "r",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "s",
    type: "bytes32"
  }],
  name: "permit",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "price0CumulativeLast",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "price1CumulativeLast",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }],
  name: "skim",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "uint256",
    name: "amount0Out",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amount1Out",
    type: "uint256"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "swap",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: false,
  inputs: [],
  name: "sync",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "token0",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "token1",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}];
var multicall = createMulticall();
var reducer = combineReducers(_defineProperty({}, multicall.reducerPath, multicall.reducer));
var store = createStore(reducer);

function MulticallUpdater() {
  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var latestBlockNumber = useBlockNumber();
  var contract = useInterfaceMulticallWithChainId(chainId);
  return /*#__PURE__*/jsx(multicall.Updater, {
    chainId: chainId,
    latestBlockNumber: latestBlockNumber,
    contract: contract
  });
} // Create wrappers for hooks so consumers don't need to get latest block themselves


function useMultipleContractSingleData() {
  var _multicall$hooks;

  var _useCallContext = useCallContext(),
      latestBlock = _useCallContext.latestBlock,
      chainId = _useCallContext.chainId;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (_multicall$hooks = multicall.hooks).useMultipleContractSingleData.apply(_multicall$hooks, [chainId, latestBlock].concat(args));
}

function useMultipleContractSingleDataWithChainId(_chainId) {
  var _multicall$hooks2;

  var _useCallContext2 = useCallContext(),
      latestBlock = _useCallContext2.latestBlock;

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_multicall$hooks2 = multicall.hooks).useMultipleContractSingleData.apply(_multicall$hooks2, [_chainId, latestBlock].concat(args));
}

function useSingleCallResultWithChainId(_chainId) {
  var _multicall$hooks3;

  var _useCallContext3 = useCallContext(),
      latestBlock = _useCallContext3.latestBlock; //


  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return (_multicall$hooks3 = multicall.hooks).useSingleCallResult.apply(_multicall$hooks3, [_chainId, latestBlock].concat(args));
}

function useSingleContractMultipleData() {
  var _multicall$hooks5;

  var _useCallContext5 = useCallContext(),
      chainId = _useCallContext5.chainId,
      latestBlock = _useCallContext5.latestBlock;

  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return (_multicall$hooks5 = multicall.hooks).useSingleContractMultipleData.apply(_multicall$hooks5, [chainId, latestBlock].concat(args));
}

function useSingleContractWithCallDataWithChainId(chainId) {
  var _multicall$hooks7;

  for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  return (_multicall$hooks7 = multicall.hooks).useSingleContractWithCallData.apply(_multicall$hooks7, [chainId, undefined].concat(args));
}

function useCallContext() {
  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var latestBlock = useBlockNumber();
  return {
    chainId: chainId,
    latestBlock: latestBlock
  };
}

var PAIR_INTERFACE = new Interface(abi$1);
var PairState;

(function (PairState) {
  PairState[PairState["LOADING"] = 0] = "LOADING";
  PairState[PairState["NOT_EXISTS"] = 1] = "NOT_EXISTS";
  PairState[PairState["EXISTS"] = 2] = "EXISTS";
  PairState[PairState["INVALID"] = 3] = "INVALID";
})(PairState || (PairState = {}));

function useV2Pairs(currencies) {
  var tokens = useMemo(function () {
    return currencies.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          currencyA = _ref2[0],
          currencyB = _ref2[1];

      return [currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped, currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped];
    });
  }, [currencies]);
  var pairAddresses = useMemo(function () {
    return tokens.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          tokenA = _ref4[0],
          tokenB = _ref4[1];

      return tokenA && tokenB && tokenA.chainId === tokenB.chainId && !tokenA.equals(tokenB) && V2_FACTORY_ADDRESSES[tokenA.chainId] ? computePairAddress({
        factoryAddress: V2_FACTORY_ADDRESSES[tokenA.chainId],
        tokenA: tokenA,
        tokenB: tokenB
      }) : undefined;
    });
  }, [tokens]);
  var results = useMultipleContractSingleDataWithChainId(137, pairAddresses, PAIR_INTERFACE, 'getReserves');
  return useMemo(function () {
    return results.map(function (result, i) {
      var reserves = result.result,
          loading = result.loading;
      var tokenA = tokens[i][0];
      var tokenB = tokens[i][1];
      if (loading) return [PairState.LOADING, null];
      if (!tokenA || !tokenB || tokenA.equals(tokenB)) return [PairState.INVALID, null];
      if (!reserves) return [PairState.NOT_EXISTS, null];
      var reserve0 = reserves.reserve0,
          reserve1 = reserves.reserve1;

      var _ref5 = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA],
          _ref6 = _slicedToArray(_ref5, 2),
          token0 = _ref6[0],
          token1 = _ref6[1];

      return [PairState.EXISTS, new Pair(CurrencyAmount.fromRawAmount(token0, reserve0.toString()), CurrencyAmount.fromRawAmount(token1, reserve1.toString()))];
    });
  }, [results, tokens]);
}

function useAllCommonPairs(currencyA, currencyB) {
  var allCurrencyCombinations = useAllCurrencyCombinations(currencyA, currencyB);
  var allPairs = useV2Pairs(allCurrencyCombinations);
  return useMemo(function () {
    return Object.values(allPairs // filter out invalid pairs
    .filter(function (result) {
      return Boolean(result[0] === PairState.EXISTS && result[1]);
    }).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          pair = _ref2[1];

      return pair;
    }));
  }, [allPairs]);
}

var MAX_HOPS = 3;
/**
 * Returns the best v2 trade for a desired swap
 * @param tradeType whether the swap is an exact in/out
 * @param amountSpecified the exact amount to swap in/out
 * @param otherCurrency the desired output/payment currency
 */

function useBestV2Trade(tradeType, amountSpecified, otherCurrency) {
  var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref3$maxHops = _ref3.maxHops,
      maxHops = _ref3$maxHops === void 0 ? MAX_HOPS : _ref3$maxHops;

  var _useMemo = useMemo(function () {
    return tradeType === TradeType.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency];
  }, [tradeType, amountSpecified, otherCurrency]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      currencyIn = _useMemo2[0],
      currencyOut = _useMemo2[1];

  var allowedPairs = useAllCommonPairs(currencyIn, currencyOut);
  return useMemo(function () {
    if (amountSpecified && currencyIn && currencyOut && allowedPairs.length > 0) {
      if (maxHops === 1) {
        var options = {
          maxHops: 1,
          maxNumResults: 1
        };

        if (tradeType === TradeType.EXACT_INPUT) {
          var _Trade$bestTradeExact;

          var amountIn = amountSpecified;
          return (_Trade$bestTradeExact = Trade$1.bestTradeExactIn(allowedPairs, amountIn, currencyOut, options)[0]) !== null && _Trade$bestTradeExact !== void 0 ? _Trade$bestTradeExact : null;
        } else {
          var _Trade$bestTradeExact2;

          var amountOut = amountSpecified;
          return (_Trade$bestTradeExact2 = Trade$1.bestTradeExactOut(allowedPairs, currencyIn, amountOut, options)[0]) !== null && _Trade$bestTradeExact2 !== void 0 ? _Trade$bestTradeExact2 : null;
        }
      } // search through trades with varying hops, find best trade out of them


      var bestTradeSoFar = null;

      for (var i = 1; i <= maxHops; i++) {
        var _options = {
          maxHops: i,
          maxNumResults: 1
        };
        var currentTrade = void 0;

        if (tradeType === TradeType.EXACT_INPUT) {
          var _Trade$bestTradeExact3;

          var _amountIn = amountSpecified;
          currentTrade = (_Trade$bestTradeExact3 = Trade$1.bestTradeExactIn(allowedPairs, _amountIn, currencyOut, _options)[0]) !== null && _Trade$bestTradeExact3 !== void 0 ? _Trade$bestTradeExact3 : null;
        } else {
          var _Trade$bestTradeExact4;

          var _amountOut = amountSpecified;
          currentTrade = (_Trade$bestTradeExact4 = Trade$1.bestTradeExactOut(allowedPairs, currencyIn, _amountOut, _options)[0]) !== null && _Trade$bestTradeExact4 !== void 0 ? _Trade$bestTradeExact4 : null;
        } // if current trade is best yet, save it


        if (isTradeBetter(bestTradeSoFar, currentTrade, BETTER_TRADE_LESS_HOPS_THRESHOLD)) {
          bestTradeSoFar = currentTrade;
        }
      }

      return bestTradeSoFar;
    }

    return null;
  }, [tradeType, amountSpecified, currencyIn, currencyOut, allowedPairs, maxHops]);
}

var _excluded$4 = ["gasUseEstimateUSD"];

function _createSuper$8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$8();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$8() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var TradeState; // from https://github.com/Uniswap/routing-api/blob/main/lib/handlers/schema.ts

(function (TradeState) {
  TradeState[TradeState["LOADING"] = 0] = "LOADING";
  TradeState[TradeState["INVALID"] = 1] = "INVALID";
  TradeState[TradeState["NO_ROUTE_FOUND"] = 2] = "NO_ROUTE_FOUND";
  TradeState[TradeState["VALID"] = 3] = "VALID";
  TradeState[TradeState["SYNCING"] = 4] = "SYNCING";
})(TradeState || (TradeState = {}));

var InterfaceTrade = /*#__PURE__*/function (_Trade) {
  _inherits(InterfaceTrade, _Trade);

  var _super = _createSuper$8(InterfaceTrade);

  function InterfaceTrade(_ref) {
    var _this;

    var gasUseEstimateUSD = _ref.gasUseEstimateUSD,
        routes = _objectWithoutProperties(_ref, _excluded$4);

    _classCallCheck(this, InterfaceTrade);

    _this = _super.call(this, routes);
    _this.gasUseEstimateUSD = gasUseEstimateUSD;
    return _this;
  }

  return _createClass(InterfaceTrade);
}(Trade$2);

var abi = [{
  inputs: [],
  name: "feeGrowthGlobal0X128",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "feeGrowthGlobal1X128",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "liquidity",
  outputs: [{
    internalType: "uint128",
    name: "",
    type: "uint128"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "index",
    type: "uint256"
  }],
  name: "observations",
  outputs: [{
    internalType: "uint32",
    name: "blockTimestamp",
    type: "uint32"
  }, {
    internalType: "int56",
    name: "tickCumulative",
    type: "int56"
  }, {
    internalType: "uint160",
    name: "secondsPerLiquidityCumulativeX128",
    type: "uint160"
  }, {
    internalType: "bool",
    name: "initialized",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "key",
    type: "bytes32"
  }],
  name: "positions",
  outputs: [{
    internalType: "uint128",
    name: "_liquidity",
    type: "uint128"
  }, {
    internalType: "uint256",
    name: "feeGrowthInside0LastX128",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "feeGrowthInside1LastX128",
    type: "uint256"
  }, {
    internalType: "uint128",
    name: "tokensOwed0",
    type: "uint128"
  }, {
    internalType: "uint128",
    name: "tokensOwed1",
    type: "uint128"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "protocolFees",
  outputs: [{
    internalType: "uint128",
    name: "token0",
    type: "uint128"
  }, {
    internalType: "uint128",
    name: "token1",
    type: "uint128"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "slot0",
  outputs: [{
    internalType: "uint160",
    name: "sqrtPriceX96",
    type: "uint160"
  }, {
    internalType: "int24",
    name: "tick",
    type: "int24"
  }, {
    internalType: "uint16",
    name: "observationIndex",
    type: "uint16"
  }, {
    internalType: "uint16",
    name: "observationCardinality",
    type: "uint16"
  }, {
    internalType: "uint16",
    name: "observationCardinalityNext",
    type: "uint16"
  }, {
    internalType: "uint8",
    name: "feeProtocol",
    type: "uint8"
  }, {
    internalType: "bool",
    name: "unlocked",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "int16",
    name: "wordPosition",
    type: "int16"
  }],
  name: "tickBitmap",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "int24",
    name: "tick",
    type: "int24"
  }],
  name: "ticks",
  outputs: [{
    internalType: "uint128",
    name: "liquidityGross",
    type: "uint128"
  }, {
    internalType: "int128",
    name: "liquidityNet",
    type: "int128"
  }, {
    internalType: "uint256",
    name: "feeGrowthOutside0X128",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "feeGrowthOutside1X128",
    type: "uint256"
  }, {
    internalType: "int56",
    name: "tickCumulativeOutside",
    type: "int56"
  }, {
    internalType: "uint160",
    name: "secondsPerLiquidityOutsideX128",
    type: "uint160"
  }, {
    internalType: "uint32",
    name: "secondsOutside",
    type: "uint32"
  }, {
    internalType: "bool",
    name: "initialized",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
var POOL_STATE_INTERFACE = new Interface(abi); // Classes are expensive to instantiate, so this caches the recently instantiated pools.
// This avoids re-instantiating pools as the other pools in the same request are loaded.

var PoolCache = /*#__PURE__*/function () {
  function PoolCache() {
    _classCallCheck(this, PoolCache);
  }

  _createClass(PoolCache, null, [{
    key: "getPoolAddress",
    value: // Evict after 128 entries. Empirically, a swap uses 64 entries.
    // These are FIFOs, using unshift/pop. This makes recent entries faster to find.
    function getPoolAddress(factoryAddress, tokenA, tokenB, fee) {
      if (this.addresses.length > this.MAX_ENTRIES) {
        this.addresses = this.addresses.slice(0, this.MAX_ENTRIES / 2);
      }

      var addressA = tokenA.address;
      var addressB = tokenB.address;
      var key = "".concat(factoryAddress, ":").concat(addressA, ":").concat(addressB, ":").concat(fee.toString());
      var found = this.addresses.find(function (address) {
        return address.key === key;
      });
      if (found) return found.address;
      var address = {
        key: key,
        address: computePoolAddress({
          factoryAddress: factoryAddress,
          tokenA: tokenA,
          tokenB: tokenB,
          fee: fee
        })
      };
      this.addresses.unshift(address);
      return address.address;
    }
  }, {
    key: "getPool",
    value: function getPool(tokenA, tokenB, fee, sqrtPriceX96, liquidity, tick) {
      if (this.pools.length > this.MAX_ENTRIES) {
        this.pools = this.pools.slice(0, this.MAX_ENTRIES / 2);
      }

      var found = this.pools.find(function (pool) {
        return pool.token0 === tokenA && pool.token1 === tokenB && pool.fee === fee && JSBI.EQ(pool.sqrtRatioX96, sqrtPriceX96) && JSBI.EQ(pool.liquidity, liquidity) && pool.tickCurrent === tick;
      });
      if (found) return found;
      var pool = new Pool(tokenA, tokenB, fee, sqrtPriceX96, liquidity, tick);
      this.pools.unshift(pool);
      return pool;
    }
  }]);

  return PoolCache;
}();

_defineProperty(PoolCache, "MAX_ENTRIES", 128);

_defineProperty(PoolCache, "pools", []);

_defineProperty(PoolCache, "addresses", []);

var PoolState;

(function (PoolState) {
  PoolState[PoolState["LOADING"] = 0] = "LOADING";
  PoolState[PoolState["NOT_EXISTS"] = 1] = "NOT_EXISTS";
  PoolState[PoolState["EXISTS"] = 2] = "EXISTS";
  PoolState[PoolState["INVALID"] = 3] = "INVALID";
})(PoolState || (PoolState = {}));

function usePools(poolKeys) {
  // const { chainId } = useActiveWeb3React()
  var _useJsonRPCWeb3React = useJsonRPCWeb3React(),
      chainId = _useJsonRPCWeb3React.chainId;

  var poolTokens = useMemo(function () {
    if (!chainId) return new Array(poolKeys.length);
    return poolKeys.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          currencyA = _ref2[0],
          currencyB = _ref2[1],
          feeAmount = _ref2[2];

      if (currencyA && currencyB && feeAmount) {
        var tokenA = currencyA.wrapped;
        var tokenB = currencyB.wrapped;
        if (tokenA.equals(tokenB)) return undefined;
        if (tokenA.symbol === tokenB.symbol) return undefined; // TODO: less sus way to allow Ether to token on polygon

        return tokenA.sortsBefore(tokenB) ? [tokenA, tokenB, feeAmount] : [tokenB, tokenA, feeAmount];
      }

      return undefined;
    });
  }, [chainId, poolKeys]);
  var poolAddresses = useMemo(function () {
    var v3CoreFactoryAddress = chainId && V3_CORE_FACTORY_ADDRESSES[chainId];
    if (!v3CoreFactoryAddress) return new Array(poolTokens.length);
    return poolTokens.map(function (value) {
      return value && PoolCache.getPoolAddress.apply(PoolCache, [v3CoreFactoryAddress].concat(_toConsumableArray(value)));
    });
  }, [chainId, poolTokens]);
  var slot0s = useMultipleContractSingleData(poolAddresses, POOL_STATE_INTERFACE, 'slot0');
  var liquidities = useMultipleContractSingleData(poolAddresses, POOL_STATE_INTERFACE, 'liquidity');
  return useMemo(function () {
    return poolKeys.map(function (_key, index) {
      var tokens = poolTokens[index];
      if (!tokens) return [PoolState.INVALID, null];

      var _tokens = _slicedToArray(tokens, 3),
          token0 = _tokens[0],
          token1 = _tokens[1],
          fee = _tokens[2];

      if (!slot0s[index]) return [PoolState.INVALID, null];
      var _slot0s$index = slot0s[index],
          slot0 = _slot0s$index.result,
          slot0Loading = _slot0s$index.loading,
          slot0Valid = _slot0s$index.valid;
      if (!liquidities[index]) return [PoolState.INVALID, null];
      var _liquidities$index = liquidities[index],
          liquidity = _liquidities$index.result,
          liquidityLoading = _liquidities$index.loading,
          liquidityValid = _liquidities$index.valid;
      if (!tokens || !slot0Valid || !liquidityValid) return [PoolState.INVALID, null];
      if (slot0Loading || liquidityLoading) return [PoolState.LOADING, null];
      if (!slot0 || !liquidity) return [PoolState.NOT_EXISTS, null];
      if (!slot0.sqrtPriceX96 || slot0.sqrtPriceX96.eq(0)) return [PoolState.NOT_EXISTS, null];

      try {
        var pool = PoolCache.getPool(token0, token1, fee, slot0.sqrtPriceX96, liquidity[0], slot0.tick);
        return [PoolState.EXISTS, pool];
      } catch (error) {
        console.error('Error when constructing the pool', error);
        return [PoolState.NOT_EXISTS, null];
      }
    });
  }, [liquidities, poolKeys, slot0s, poolTokens]);
}
/**
 * Returns all the existing pools that should be considered for swapping between an input currency and an output currency
 * @param currencyIn the input currency
 * @param currencyOut the output currency
 */


function useV3SwapPools(currencyIn, currencyOut) {
  var _useJsonRPCWeb3React = useJsonRPCWeb3React(),
      chainId = _useJsonRPCWeb3React.chainId;

  var allCurrencyCombinations = useAllCurrencyCombinations(currencyIn, currencyOut);
  var allCurrencyCombinationsWithAllFees = useMemo(function () {
    return allCurrencyCombinations.reduce(function (list, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          tokenA = _ref2[0],
          tokenB = _ref2[1];

      return chainId === SupportedChainId.MAINNET ? list.concat([[tokenA, tokenB, FeeAmount.LOW], [tokenA, tokenB, FeeAmount.MEDIUM], [tokenA, tokenB, FeeAmount.HIGH]]) : list.concat([[tokenA, tokenB, FeeAmount.LOWEST], [tokenA, tokenB, FeeAmount.LOW], [tokenA, tokenB, FeeAmount.MEDIUM], [tokenA, tokenB, FeeAmount.HIGH]]);
    }, []);
  }, [allCurrencyCombinations, chainId]);
  var pools = usePools(allCurrencyCombinationsWithAllFees);
  return useMemo(function () {
    return {
      pools: pools.filter(function (tuple) {
        return tuple[0] === PoolState.EXISTS && tuple[1] !== null;
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            pool = _ref4[1];

        return pool;
      }),
      loading: pools.some(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            state = _ref6[0];

        return state === PoolState.LOADING;
      })
    };
  }, [pools]);
}

function _createForOfIteratorHelper$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}

function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Returns true if poolA is equivalent to poolB
 * @param poolA one of the two pools
 * @param poolB the other pool
 */


function poolEquals(poolA, poolB) {
  return poolA === poolB || poolA.token0.equals(poolB.token0) && poolA.token1.equals(poolB.token1) && poolA.fee === poolB.fee;
}

function computeAllRoutes(currencyIn, currencyOut, pools, chainId) {
  var currentPath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var allPaths = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var startCurrencyIn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : currencyIn;
  var maxHops = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 2;
  var tokenIn = currencyIn === null || currencyIn === void 0 ? void 0 : currencyIn.wrapped;
  var tokenOut = currencyOut === null || currencyOut === void 0 ? void 0 : currencyOut.wrapped;
  if (!tokenIn || !tokenOut) throw new Error('Missing tokenIn/tokenOut');

  var _iterator = _createForOfIteratorHelper$3(pools),
      _step;

  try {
    var _loop = function _loop() {
      var pool = _step.value;
      if (!pool.involvesToken(tokenIn) || currentPath.find(function (pathPool) {
        return poolEquals(pool, pathPool);
      })) return "continue";
      var outputToken = pool.token0.equals(tokenIn) ? pool.token1 : pool.token0;

      if (outputToken.equals(tokenOut)) {
        allPaths.push(new Route([].concat(_toConsumableArray(currentPath), [pool]), startCurrencyIn, currencyOut));
      } else if (maxHops > 1) {
        computeAllRoutes(outputToken, currencyOut, pools, chainId, [].concat(_toConsumableArray(currentPath), [pool]), allPaths, startCurrencyIn, maxHops - 1);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return allPaths;
}
/**
 * Returns all the routes from an input currency to an output currency
 * @param currencyIn the input currency
 * @param currencyOut the output currency
 */


function useAllV3Routes(currencyIn, currencyOut) {
  // const { chainId } = useActiveWeb3React()
  var _useJsonRPCWeb3React = useJsonRPCWeb3React(),
      chainId = _useJsonRPCWeb3React.chainId;

  var _useV3SwapPools = useV3SwapPools(currencyIn, currencyOut),
      pools = _useV3SwapPools.pools,
      poolsLoading = _useV3SwapPools.loading;

  return useMemo(function () {
    if (poolsLoading || !chainId || !pools || !currencyIn || !currencyOut) return {
      loading: true,
      routes: []
    };
    var routes = computeAllRoutes(currencyIn, currencyOut, pools, chainId, [], [], currencyIn, 2);
    return {
      loading: false,
      routes: routes
    };
  }, [chainId, currencyIn, currencyOut, pools, poolsLoading]);
}

var _QUOTE_GAS_OVERRIDES;

var QUOTE_GAS_OVERRIDES = (_QUOTE_GAS_OVERRIDES = {}, _defineProperty(_QUOTE_GAS_OVERRIDES, SupportedChainId.ARBITRUM_ONE, 25000000), _defineProperty(_QUOTE_GAS_OVERRIDES, SupportedChainId.ARBITRUM_RINKEBY, 25000000), _QUOTE_GAS_OVERRIDES);
var DEFAULT_GAS_QUOTE = 2000000;
/**
 * Returns the best v3 trade for a desired swap
 * @param tradeType whether the swap is an exact in/out
 * @param amountSpecified the exact amount to swap in/out
 * @param otherCurrency the desired output/payment currency
 */

function useClientSideV3Trade(tradeType, amountSpecified, otherCurrency) {
  var _ref3, _otherCurrency$chainI, _QUOTE_GAS_OVERRIDES$;

  var _ref = tradeType === TradeType.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency],
      _ref2 = _slicedToArray(_ref, 2),
      currencyIn = _ref2[0],
      currencyOut = _ref2[1];

  var _useAllV3Routes = useAllV3Routes(currencyIn, currencyOut),
      routes = _useAllV3Routes.routes,
      routesLoading = _useAllV3Routes.loading;

  var chainId = (_ref3 = (_otherCurrency$chainI = otherCurrency === null || otherCurrency === void 0 ? void 0 : otherCurrency.chainId) !== null && _otherCurrency$chainI !== void 0 ? _otherCurrency$chainI : currencyIn === null || currencyIn === void 0 ? void 0 : currencyIn.chainId) !== null && _ref3 !== void 0 ? _ref3 : 137;
  var quoter = useV3QuoterWithChainId(chainId);
  var callData = useMemo(function () {
    return amountSpecified ? routes.map(function (route) {
      return SwapQuoter.quoteCallParameters(route, amountSpecified, tradeType).calldata;
    }) : [];
  }, [amountSpecified, routes, tradeType]);
  var quotesResults = useSingleContractWithCallDataWithChainId(chainId, quoter, callData, {
    gasRequired: chainId ? (_QUOTE_GAS_OVERRIDES$ = QUOTE_GAS_OVERRIDES[chainId]) !== null && _QUOTE_GAS_OVERRIDES$ !== void 0 ? _QUOTE_GAS_OVERRIDES$ : DEFAULT_GAS_QUOTE : undefined
  });
  return useMemo(function () {
    if (!amountSpecified || !currencyIn || !currencyOut || quotesResults.some(function (_ref4) {
      var valid = _ref4.valid;
      return !valid;
    }) || ( // skip when tokens are the same
    tradeType === TradeType.EXACT_INPUT ? amountSpecified.currency.equals(currencyOut) : amountSpecified.currency.equals(currencyIn))) {
      return {
        state: TradeState.INVALID,
        trade: undefined
      };
    }

    if (routesLoading || quotesResults.some(function (_ref5) {
      var loading = _ref5.loading;
      return loading;
    })) {
      return {
        state: TradeState.LOADING,
        trade: undefined
      };
    }

    var _quotesResults$reduce = quotesResults.reduce(function (currentBest, _ref6, i) {
      var result = _ref6.result;
      if (!result) return currentBest; // overwrite the current best if it's not defined or if this route is better

      if (tradeType === TradeType.EXACT_INPUT) {
        var _amountOut = CurrencyAmount.fromRawAmount(currencyOut, result.amountOut.toString());

        if (currentBest.amountOut === null || JSBI.lessThan(currentBest.amountOut.quotient, _amountOut.quotient)) {
          return {
            bestRoute: routes[i],
            amountIn: amountSpecified,
            amountOut: _amountOut
          };
        }
      } else {
        var _amountIn = CurrencyAmount.fromRawAmount(currencyIn, result.amountIn.toString());

        if (currentBest.amountIn === null || JSBI.greaterThan(currentBest.amountIn.quotient, _amountIn.quotient)) {
          return {
            bestRoute: routes[i],
            amountIn: _amountIn,
            amountOut: amountSpecified
          };
        }
      }

      return currentBest;
    }, {
      bestRoute: null,
      amountIn: null,
      amountOut: null
    }),
        bestRoute = _quotesResults$reduce.bestRoute,
        amountIn = _quotesResults$reduce.amountIn,
        amountOut = _quotesResults$reduce.amountOut;

    if (!bestRoute || !amountIn || !amountOut) {
      return {
        state: TradeState.NO_ROUTE_FOUND,
        trade: undefined
      };
    }

    return {
      state: TradeState.VALID,
      trade: new InterfaceTrade({
        v2Routes: [],
        v3Routes: [{
          routev3: bestRoute,
          inputAmount: amountIn,
          outputAmount: amountOut
        }],
        tradeType: tradeType
      })
    };
  }, [amountSpecified, currencyIn, currencyOut, quotesResults, routes, routesLoading, tradeType]);
}
/**
 * Returns the last value of type T that passes a filter function
 * @param value changing value
 * @param filterFn function that determines whether a given value should be considered for the last value
 */


function useLast(value, filterFn) {
  var _useState = useState(filterFn && filterFn(value) ? value : undefined),
      _useState2 = _slicedToArray(_useState, 2),
      last = _useState2[0],
      setLast = _useState2[1];

  useEffect(function () {
    setLast(function (last) {
      var shouldUse = filterFn ? filterFn(value) : true;
      if (shouldUse) return value;
      return last;
    });
  }, [filterFn, value]);
  return last;
}
/**
 * @param currencyA Currency
 * @param currencyB Currency
 * @returns boolean Returns boolean representing if the Currency A is the same as Currency B
 * If Currency A or B is a Native token check for strict equality since Currency type does not have an address
 */


function isSameToken(currencyA, currencyB) {
  if (currencyA && currencyB) {
    if (!currencyA.isNative && !currencyB.isNative) {
      return currencyA.address === currencyB.address;
    }

    return currencyA === currencyB;
  }

  return false;
}
/**
 * @param trade AnyTrade
 * @returns boolean Returns boolean representing if the trade needs to be done involves a currency
 * that needs to be done on Quickswap V2 router
 */


function isQuickswapTrade(trade) {
  var quickswapTokenFound = false;
  QUICKSWAP_ONLY_TOKEN_LIST.forEach(function (token) {
    if (!quickswapTokenFound && trade.inputAmount.wrapped.currency.address.toLowerCase() === token || trade.inputAmount.currency.wrapped.address.toLowerCase() === token || trade.outputAmount.wrapped.currency.address.toLowerCase() === token || trade.outputAmount.currency.wrapped.address.toLowerCase() === token) {
      quickswapTokenFound = true;
    }
  });
  return quickswapTokenFound;
}
/**
 * Debounces updates to a value.
 * Non-primitives *must* wrap the value in useMemo, or the value will be updated due to referential inequality.
 */
// modified from https://usehooks.com/useDebounce/


function useDebounce(value, delay) {
  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  useEffect(function () {
    // Update debounced value after delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.

    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}
/**
 * Transforms a Routing API quote into an array of routes that can be used to create
 * a `Trade`.
 */


function computeRoutes(currencyIn, currencyOut, tradeType, quoteResult) {
  if (!quoteResult || !quoteResult.route || !currencyIn || !currencyOut) return undefined;
  if (quoteResult.route.length === 0) return [];
  var parsedTokenIn = parseToken(quoteResult.route[0][0].tokenIn);
  var parsedTokenOut = parseToken(quoteResult.route[0][quoteResult.route[0].length - 1].tokenOut);
  if (parsedTokenIn.address !== currencyIn.wrapped.address) return undefined;
  if (parsedTokenOut.address !== currencyOut.wrapped.address) return undefined;
  var parsedCurrencyIn = currencyIn.isNative ? nativeOnChain(currencyIn.chainId) : parsedTokenIn;
  var parsedCurrencyOut = currencyOut.isNative ? nativeOnChain(currencyOut.chainId) : parsedTokenOut;

  try {
    return quoteResult.route.map(function (route) {
      if (route.length === 0) {
        throw new Error('Expected route to have at least one pair or pool');
      }

      var rawAmountIn = route[0].amountIn;
      var rawAmountOut = route[route.length - 1].amountOut;

      if (!rawAmountIn || !rawAmountOut) {
        throw new Error('Expected both amountIn and amountOut to be present');
      }

      return {
        routev3: isV3Route(route) ? new Route(route.map(parsePool), parsedCurrencyIn, parsedCurrencyOut) : null,
        routev2: !isV3Route(route) ? new Route$1(route.map(parsePair), parsedCurrencyIn, parsedCurrencyOut) : null,
        inputAmount: CurrencyAmount.fromRawAmount(parsedCurrencyIn, rawAmountIn),
        outputAmount: CurrencyAmount.fromRawAmount(parsedCurrencyOut, rawAmountOut)
      };
    });
  } catch (e) {
    // `Route` constructor may throw if inputs/outputs are temporarily out of sync
    // (RTK-Query always returns the latest data which may not be the right inputs/outputs)
    // This is not fatal and will fix itself in future render cycles
    console.error(e);
    return undefined;
  }
}

function transformRoutesToTrade(route, tradeType, gasUseEstimateUSD) {
  var _route$filter$map, _route$filter$map2;

  return new InterfaceTrade({
    v2Routes: (_route$filter$map = route === null || route === void 0 ? void 0 : route.filter(function (r) {
      return r.routev2 !== null;
    }).map(function (_ref) {
      var routev2 = _ref.routev2,
          inputAmount = _ref.inputAmount,
          outputAmount = _ref.outputAmount;
      return {
        routev2: routev2,
        inputAmount: inputAmount,
        outputAmount: outputAmount
      };
    })) !== null && _route$filter$map !== void 0 ? _route$filter$map : [],
    v3Routes: (_route$filter$map2 = route === null || route === void 0 ? void 0 : route.filter(function (r) {
      return r.routev3 !== null;
    }).map(function (_ref2) {
      var routev3 = _ref2.routev3,
          inputAmount = _ref2.inputAmount,
          outputAmount = _ref2.outputAmount;
      return {
        routev3: routev3,
        inputAmount: inputAmount,
        outputAmount: outputAmount
      };
    })) !== null && _route$filter$map2 !== void 0 ? _route$filter$map2 : [],
    tradeType: tradeType,
    gasUseEstimateUSD: gasUseEstimateUSD
  });
}

var parseToken = function parseToken(_ref3) {
  var address = _ref3.address,
      chainId = _ref3.chainId,
      decimals = _ref3.decimals,
      symbol = _ref3.symbol;
  return new Token(chainId, address, parseInt(decimals.toString()), symbol);
};

var parsePool = function parsePool(_ref4) {
  var fee = _ref4.fee,
      sqrtRatioX96 = _ref4.sqrtRatioX96,
      liquidity = _ref4.liquidity,
      tickCurrent = _ref4.tickCurrent,
      tokenIn = _ref4.tokenIn,
      tokenOut = _ref4.tokenOut;
  return new Pool(parseToken(tokenIn), parseToken(tokenOut), parseInt(fee), sqrtRatioX96, liquidity, parseInt(tickCurrent));
};

var parsePair = function parsePair(_ref5) {
  var reserve0 = _ref5.reserve0,
      reserve1 = _ref5.reserve1;
  return new Pair(CurrencyAmount.fromRawAmount(parseToken(reserve0.token), reserve0.quotient), CurrencyAmount.fromRawAmount(parseToken(reserve1.token), reserve1.quotient));
};

function isV3Route(route) {
  return route[0].type === 'v3-pool';
}
/**
 * Returns a map of the given addresses to their eventually consistent ETH balances.
 */


function useNativeCurrencyBalances(uncheckedAddresses) {
  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var multicallContract = useInterfaceMulticallWithChainId(chainId);
  var validAddressInputs = useMemo(function () {
    return uncheckedAddresses ? uncheckedAddresses.map(isAddress).filter(function (a) {
      return a !== false;
    }).sort().map(function (addr) {
      return [addr];
    }) : [];
  }, [uncheckedAddresses]);
  var results = useSingleContractMultipleData(multicallContract, 'getEthBalance', validAddressInputs);
  return useMemo(function () {
    return validAddressInputs.reduce(function (memo, _ref, i) {
      var _results$i, _results$i$result;

      var _ref2 = _slicedToArray(_ref, 1),
          address = _ref2[0];

      var value = results === null || results === void 0 ? void 0 : (_results$i = results[i]) === null || _results$i === void 0 ? void 0 : (_results$i$result = _results$i.result) === null || _results$i$result === void 0 ? void 0 : _results$i$result[0];
      if (value && chainId) memo[address] = CurrencyAmount.fromRawAmount(nativeOnChain(chainId), JSBI.BigInt(value.toString()));
      return memo;
    }, {});
  }, [validAddressInputs, chainId, results]);
}

var ERC20Interface = new Interface(ERC20ABI);
var tokenBalancesGasRequirement = {
  gasRequired: 185000
};
/**
 * Returns a map of token addresses to their eventually consistent token balances for a single account.
 */

function useTokenBalancesWithLoadingIndicator(address, tokens) {
  var validatedTokens = useMemo(function () {
    var _tokens$filter;

    return (_tokens$filter = tokens === null || tokens === void 0 ? void 0 : tokens.filter(function (t) {
      return isAddress(t === null || t === void 0 ? void 0 : t.address) !== false;
    })) !== null && _tokens$filter !== void 0 ? _tokens$filter : [];
  }, [tokens]);
  var validatedTokenAddresses = useMemo(function () {
    return validatedTokens.map(function (vt) {
      return vt.address;
    });
  }, [validatedTokens]);
  var balances = useMultipleContractSingleData(validatedTokenAddresses, ERC20Interface, 'balanceOf', useMemo(function () {
    return [address];
  }, [address]), tokenBalancesGasRequirement);
  var anyLoading = useMemo(function () {
    return balances.some(function (callState) {
      return callState.loading;
    });
  }, [balances]);
  return useMemo(function () {
    return [address && validatedTokens.length > 0 ? validatedTokens.reduce(function (memo, token, i) {
      var _balances$i, _balances$i$result;

      var value = balances === null || balances === void 0 ? void 0 : (_balances$i = balances[i]) === null || _balances$i === void 0 ? void 0 : (_balances$i$result = _balances$i.result) === null || _balances$i$result === void 0 ? void 0 : _balances$i$result[0];
      var amount = value ? JSBI.BigInt(value.toString()) : undefined;

      if (amount) {
        memo[token.address] = CurrencyAmount.fromRawAmount(token, amount);
      }

      return memo;
    }, {}) : {}, anyLoading];
  }, [address, validatedTokens, anyLoading, balances]);
}

function useTokenBalances(address, tokens) {
  return useTokenBalancesWithLoadingIndicator(address, tokens)[0];
} // get the balance for a single token/account combo


function useCurrencyBalances(account, currencies) {
  var tokens = useMemo(function () {
    var _currencies$filter;

    return (_currencies$filter = currencies === null || currencies === void 0 ? void 0 : currencies.filter(function (currency) {
      var _currency$isToken;

      return (_currency$isToken = currency === null || currency === void 0 ? void 0 : currency.isToken) !== null && _currency$isToken !== void 0 ? _currency$isToken : false;
    })) !== null && _currencies$filter !== void 0 ? _currencies$filter : [];
  }, [currencies]);
  var tokenBalances = useTokenBalances(account, tokens);
  var containsETH = useMemo(function () {
    var _currencies$some;

    return (_currencies$some = currencies === null || currencies === void 0 ? void 0 : currencies.some(function (currency) {
      return currency === null || currency === void 0 ? void 0 : currency.isNative;
    })) !== null && _currencies$some !== void 0 ? _currencies$some : false;
  }, [currencies]);
  var ethBalance = useNativeCurrencyBalances(useMemo(function () {
    return containsETH ? [account] : [];
  }, [containsETH, account]));
  return useMemo(function () {
    var _currencies$map;

    return (_currencies$map = currencies === null || currencies === void 0 ? void 0 : currencies.map(function (currency) {
      if (!account || !currency) return undefined;
      if (currency.isToken) return tokenBalances[currency.address];
      if (currency.isNative) return ethBalance[account];
      return undefined;
    })) !== null && _currencies$map !== void 0 ? _currencies$map : [];
  }, [account, currencies, ethBalance, tokenBalances]);
}

function useCurrencyBalance(account, currency) {
  return useCurrencyBalances(account, useMemo(function () {
    return [currency];
  }, [currency]))[0];
}

var WrapType;

(function (WrapType) {
  WrapType[WrapType["NONE"] = 0] = "NONE";
  WrapType[WrapType["WRAP"] = 1] = "WRAP";
  WrapType[WrapType["UNWRAP"] = 2] = "UNWRAP";
})(WrapType || (WrapType = {}));

function useWrapCallback() {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      account = _useActiveWeb3React.account,
      chainId = _useActiveWeb3React.chainId;

  var wrappedNativeCurrencyContract = useWETHContract();

  var _useAtomValue = useAtomValue(swapAtom),
      amount = _useAtomValue.amount,
      inputCurrency = _useAtomValue[Field$1.INPUT],
      outputCurrency = _useAtomValue[Field$1.OUTPUT];

  var wrapType = useMemo(function () {
    if (chainId && inputCurrency && outputCurrency) {
      var _WRAPPED_NATIVE_CURRE, _WRAPPED_NATIVE_CURRE2;

      if (inputCurrency.isNative && (_WRAPPED_NATIVE_CURRE = WRAPPED_NATIVE_CURRENCY[chainId]) !== null && _WRAPPED_NATIVE_CURRE !== void 0 && _WRAPPED_NATIVE_CURRE.equals(outputCurrency)) {
        return WrapType.WRAP;
      }

      if (outputCurrency.isNative && (_WRAPPED_NATIVE_CURRE2 = WRAPPED_NATIVE_CURRENCY[chainId]) !== null && _WRAPPED_NATIVE_CURRE2 !== void 0 && _WRAPPED_NATIVE_CURRE2.equals(inputCurrency)) {
        return WrapType.UNWRAP;
      }
    }

    return WrapType.NONE;
  }, [chainId, inputCurrency, outputCurrency]);
  var parsedAmountIn = useMemo(function () {
    return tryParseCurrencyAmount(amount, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
  }, [inputCurrency, amount]);
  var balanceIn = useCurrencyBalance(account, inputCurrency);
  var callback = useMemo(function () {
    if (wrapType === WrapType.NONE || !parsedAmountIn || !balanceIn || balanceIn.lessThan(parsedAmountIn) || !wrappedNativeCurrencyContract) {
      return;
    }

    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", wrapType === WrapType.WRAP ? wrappedNativeCurrencyContract.deposit({
                value: "0x".concat(parsedAmountIn.quotient.toString(16))
              }) : wrappedNativeCurrencyContract.withdraw("0x".concat(parsedAmountIn.quotient.toString(16))));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [wrapType, parsedAmountIn, balanceIn, wrappedNativeCurrencyContract]);
  return useMemo(function () {
    return {
      callback: callback,
      type: wrapType
    };
  }, [callback, wrapType]);
}

var oldestBlockMapAtom = atomWithImmer({});
var DEFAULT_MAX_BLOCK_AGE = 10;

function useGetIsValidBlock() {
  var maxBlockAge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_MAX_BLOCK_AGE;

  var _useActiveWeb3React2 = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React2.chainId;

  var currentBlock = useBlockNumber();
  var oldestBlockMap = useAtomValue(oldestBlockMapAtom);
  var oldestBlock = chainId ? oldestBlockMap[chainId] : 0;
  return useCallback(function (block) {
    if (!currentBlock) return false;
    if (currentBlock - block > maxBlockAge) return false;
    if (currentBlock < oldestBlock) return false;
    return true;
  }, [currentBlock, maxBlockAge, oldestBlock]);
}

function ownKeys$k(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$k(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var DEFAULT_POLLING_INTERVAL = 15000;
var DEFAULT_KEEP_UNUSED_DATA_FOR = 10000;

function usePoll(fetch) {
  var _cache$get;

  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var _ref = arguments.length > 2 ? arguments[2] : undefined,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? false : _ref$debounce,
      isStale = _ref.isStale,
      _ref$pollingInterval = _ref.pollingInterval,
      pollingInterval = _ref$pollingInterval === void 0 ? DEFAULT_POLLING_INTERVAL : _ref$pollingInterval,
      _ref$keepUnusedDataFo = _ref.keepUnusedDataFor,
      keepUnusedDataFor = _ref$keepUnusedDataFo === void 0 ? DEFAULT_KEEP_UNUSED_DATA_FOR : _ref$keepUnusedDataFo;

  var cache = useMemo(function () {
    return new Map();
  }, []);

  var _useState = useState({
    key: key
  }),
      _useState2 = _slicedToArray(_useState, 2),
      setData = _useState2[1];

  useEffect(function () {
    if (debounce) return;
    var timeout;
    var entry = cache.get(key);

    if (entry) {
      // If there is not a pending fetch (and there should be), queue one.
      if (entry.ttl) {
        if (isStale && (entry === null || entry === void 0 ? void 0 : entry.result) !== undefined ? isStale(entry.result) : false) {
          poll(); // stale results should be refetched immediately
        } else if (entry.ttl && entry.ttl + keepUnusedDataFor > Date.now()) {
          timeout = setTimeout(poll, Math.max(0, entry.ttl - Date.now()));
        }
      }
    } else {
      // If there is no cached entry, trigger a poll immediately.
      poll();
    }

    setData({
      key: key,
      result: entry === null || entry === void 0 ? void 0 : entry.result
    });
    return function () {
      clearTimeout(timeout);
      timeout = 0;
    };

    function poll() {
      return _poll.apply(this, arguments);
    }

    function _poll() {
      _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var ttl,
            result,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ttl = _args.length > 0 && _args[0] !== undefined ? _args[0] : Date.now() + pollingInterval;
                timeout = setTimeout(poll, pollingInterval); // queue the next poll

                cache.set(key, _objectSpread$k({
                  ttl: null
                }, cache.get(key))); // mark the entry as a pending fetch
                // Always set the result in the cache, but only set it as data if the key is still being queried.

                _context.next = 5;
                return fetch();

              case 5:
                result = _context.sent;
                cache.set(key, {
                  ttl: ttl,
                  result: result
                });
                if (timeout) setData(function (data) {
                  return data.key === key ? {
                    key: key,
                    result: result
                  } : data;
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _poll.apply(this, arguments);
    }
  }, [cache, debounce, fetch, isStale, keepUnusedDataFor, key, pollingInterval]);
  useEffect(function () {
    var now = Date.now();
    cache.forEach(function (_ref2, key) {
      var ttl = _ref2.ttl;

      if (ttl && ttl + keepUnusedDataFor <= now) {
        cache.delete(key);
      }
    });
  }, [cache, keepUnusedDataFor, key]); // Use data.result to force a re-render, but actually retrieve the data from the cache.
  // This gives the _first_ render access to a new result, avoiding lag introduced by React.

  return (_cache$get = cache.get(key)) === null || _cache$get === void 0 ? void 0 : _cache$get.result;
}
/**
 * Returns query arguments for the Routing API query or undefined if the
 * query should be skipped. Input arguments do not need to be memoized, as they will
 * be destructured.
 */


function useRoutingAPIArguments(_ref) {
  var tokenIn = _ref.tokenIn,
      tokenOut = _ref.tokenOut,
      amount = _ref.amount,
      tradeType = _ref.tradeType,
      useClientSideRouter = _ref.useClientSideRouter;
  return useMemo(function () {
    return !tokenIn || !tokenOut || !amount || tokenIn.equals(tokenOut) ? undefined : {
      amount: amount.quotient.toString(),
      tokenInAddress: tokenIn.wrapped.address,
      tokenInChainId: tokenIn.wrapped.chainId,
      tokenInDecimals: tokenIn.wrapped.decimals,
      tokenInSymbol: tokenIn.wrapped.symbol,
      tokenOutAddress: tokenOut.wrapped.address,
      tokenOutChainId: tokenOut.wrapped.chainId,
      tokenOutDecimals: tokenOut.wrapped.decimals,
      tokenOutSymbol: tokenOut.wrapped.symbol,
      useClientSideRouter: useClientSideRouter,
      type: tradeType === TradeType.EXACT_INPUT ? 'exactIn' : 'exactOut'
    };
  }, [amount, tokenIn, tokenOut, tradeType, useClientSideRouter]);
}

var _DistributionPercents;
/**
 * Reduces client-side latency by increasing the minimum percentage of the input token to use for each route in a split route while SOR is used client-side.
 * Defaults are defined in https://github.com/Uniswap/smart-order-router/blob/309e6f6603984d3b5aef0733b0cfaf129c29f602/src/routers/alpha-router/config.ts#L83.
 */


var DistributionPercents = (_DistributionPercents = {}, _defineProperty(_DistributionPercents, SupportedChainId.MAINNET, 10), _defineProperty(_DistributionPercents, SupportedChainId.OPTIMISM, 10), _defineProperty(_DistributionPercents, SupportedChainId.OPTIMISTIC_KOVAN, 10), _defineProperty(_DistributionPercents, SupportedChainId.ARBITRUM_ONE, 25), _defineProperty(_DistributionPercents, SupportedChainId.ARBITRUM_RINKEBY, 25), _DistributionPercents);
var DEFAULT_DISTRIBUTION_PERCENT = 10;

function getConfig(chainId) {
  var _ref;

  return {
    // Limit to only V2 and V3.
    protocols: [Protocol.V2, Protocol.V3],
    distributionPercent: (_ref = chainId && DistributionPercents[chainId]) !== null && _ref !== void 0 ? _ref : DEFAULT_DISTRIBUTION_PERCENT
  };
}

function useClientSideSmartOrderRouterTrade(tradeType, amountSpecified, otherCurrency) {
  var _usePoll, _useStablecoinAmountF;

  var amount = useMemo(function () {
    return amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.asFraction;
  }, [amountSpecified]);

  var _ref2 = tradeType === TradeType.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency],
      _ref3 = _slicedToArray(_ref2, 2),
      currencyIn = _ref3[0],
      currencyOut = _ref3[1]; // Debounce is used to prevent excessive requests to SOR, as it is data intensive.
  // Fast user actions (ie updating the input) should be debounced, but currency changes should not.


  var _useDebounce = useDebounce(useMemo(function () {
    return [amount, currencyIn, currencyOut];
  }, [amount, currencyIn, currencyOut]), 200),
      _useDebounce2 = _slicedToArray(_useDebounce, 3),
      debouncedAmount = _useDebounce2[0],
      debouncedCurrencyIn = _useDebounce2[1],
      debouncedCurrencyOut = _useDebounce2[2];

  var isDebouncing = amount !== debouncedAmount && currencyIn === debouncedCurrencyIn && currencyOut === debouncedCurrencyOut;
  var queryArgs = useRoutingAPIArguments({
    tokenIn: currencyIn,
    tokenOut: currencyOut,
    amount: amountSpecified,
    tradeType: tradeType,
    useClientSideRouter: true
  });
  var chainId = amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency.chainId;

  var _useJsonRPCWeb3React = useJsonRPCWeb3React(),
      library = _useJsonRPCWeb3React.library;

  var params = useMemo(function () {
    return chainId && library && {
      chainId: chainId,
      provider: library
    };
  }, [chainId, library]);
  var config = useMemo(function () {
    return getConfig(chainId);
  }, [chainId]);

  var _useWrapCallback = useWrapCallback(),
      wrapType = _useWrapCallback.type;

  var getQuoteResult = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _quoteResult;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(wrapType !== WrapType.NONE)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", {
              error: undefined
            });

          case 2:
            if (!(!queryArgs || !params)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              error: undefined
            });

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return import('./clientSideSmartOrderRouter-5f69632a.js');

          case 7:
            _context.next = 9;
            return _context.sent.getClientSideQuote(queryArgs, params, config);

          case 9:
            _quoteResult = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve) {
              return setImmediate(function () {
                return resolve(_quoteResult);
              });
            }));

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", {
              error: true
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 13]]);
  })), [config, params, queryArgs, wrapType]);
  var getIsValidBlock = useGetIsValidBlock();

  var _ref5 = (_usePoll = usePoll(getQuoteResult, JSON.stringify(queryArgs), {
    debounce: isDebouncing,
    isStale: useCallback(function (_ref6) {
      var data = _ref6.data;
      return !getIsValidBlock(Number(data === null || data === void 0 ? void 0 : data.blockNumber) || 0);
    }, [getIsValidBlock])
  })) !== null && _usePoll !== void 0 ? _usePoll : {
    error: undefined
  },
      quoteResult = _ref5.data,
      error = _ref5.error;

  var isValid = getIsValidBlock(Number(quoteResult === null || quoteResult === void 0 ? void 0 : quoteResult.blockNumber) || 0);
  var route = useMemo(function () {
    return computeRoutes(currencyIn, currencyOut, tradeType, quoteResult);
  }, [currencyIn, currencyOut, quoteResult, tradeType]);
  var gasUseEstimateUSD = (_useStablecoinAmountF = useStablecoinAmountFromFiatValue(quoteResult === null || quoteResult === void 0 ? void 0 : quoteResult.gasUseEstimateUSD)) !== null && _useStablecoinAmountF !== void 0 ? _useStablecoinAmountF : null;
  var trade = useMemo(function () {
    if (route) {
      try {
        return route && transformRoutesToTrade(route, tradeType, gasUseEstimateUSD);
      } catch (e) {
        console.debug('transformRoutesToTrade failed: ', e);
      }
    }

    return;
  }, [gasUseEstimateUSD, route, tradeType]);
  return useMemo(function () {
    if (!currencyIn || !currencyOut) {
      return {
        state: TradeState.INVALID,
        trade: undefined
      };
    }

    if (!trade && !error) {
      if (isDebouncing) {
        return {
          state: TradeState.SYNCING,
          trade: undefined
        };
      } else if (!isValid) {
        return {
          state: TradeState.LOADING,
          trade: undefined
        };
      }
    }

    var otherAmount = undefined;

    if (quoteResult) {
      switch (tradeType) {
        case TradeType.EXACT_INPUT:
          otherAmount = CurrencyAmount.fromRawAmount(currencyOut, quoteResult.quote);
          break;

        case TradeType.EXACT_OUTPUT:
          otherAmount = CurrencyAmount.fromRawAmount(currencyIn, quoteResult.quote);
          break;
      }
    }

    if (error || !otherAmount || !route || route.length === 0) {
      return {
        state: TradeState.NO_ROUTE_FOUND,
        trade: undefined
      };
    }

    if (trade) {
      return {
        state: TradeState.VALID,
        trade: trade
      };
    }

    return {
      state: TradeState.INVALID,
      trade: undefined
    };
  }, [currencyIn, currencyOut, trade, error, isValid, quoteResult, route, isDebouncing, tradeType]);
}

function useNativeCurrency(_chainId) {
  var _useActiveWeb3React = useActiveWeb3React(),
      activeChainId = _useActiveWeb3React.chainId;

  var chainId = _chainId || activeChainId;
  return useMemo(function () {
    return chainId ? nativeOnChain(chainId) : // display mainnet when not connected
    nativeOnChain(SupportedChainId.MAINNET);
  }, [chainId]);
}
/**
 * Returns the input chain ID if chain is supported. If not, return undefined
 * @param chainId a chain ID, which will be returned if it is a supported chain ID
 */


function supportedChainId(chainId) {
  if (typeof chainId === 'number' && chainId in SupportedChainId) {
    return chainId;
  }

  return undefined;
}

var REGISTRAR_ABI = [{
  constant: true,
  inputs: [{
    name: 'node',
    type: 'bytes32'
  }],
  name: 'resolver',
  outputs: [{
    name: 'resolverAddress',
    type: 'address'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}];
var REGISTRAR_ADDRESS = '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e';
var RESOLVER_ABI = [{
  constant: true,
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'contenthash',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}]; // cache the resolver contracts since most of them are the public resolver

function resolverContract(resolverAddress, provider) {
  return new Contract(resolverAddress, RESOLVER_ABI, provider);
}
/**
 * Fetches and decodes the result of an ENS contenthash lookup on mainnet to a URI
 * @param ensName to resolve
 * @param provider provider to use to fetch the data
 */


function resolveENSContentHash(_x, _x2) {
  return _resolveENSContentHash.apply(this, arguments);
}

function _resolveENSContentHash() {
  _resolveENSContentHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ensName, provider) {
    var ensRegistrarContract, hash, resolverAddress;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ensRegistrarContract = new Contract(REGISTRAR_ADDRESS, REGISTRAR_ABI, provider);
            hash = namehash(ensName);
            _context.next = 4;
            return ensRegistrarContract.resolver(hash);

          case 4:
            resolverAddress = _context.sent;
            return _context.abrupt("return", resolverContract(resolverAddress, provider).contenthash(hash));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveENSContentHash.apply(this, arguments);
}

function hexToUint8Array(hex) {
  hex = hex.startsWith('0x') ? hex.substr(2) : hex;
  if (hex.length % 2 !== 0) throw new Error('hex must have length that is multiple of 2');
  var arr = new Uint8Array(hex.length / 2);

  for (var i = 0; i < arr.length; i++) {
    arr[i] = parseInt(hex.substr(i * 2, 2), 16);
  }

  return arr;
}

var UTF_8_DECODER = new TextDecoder('utf-8');
/**
 * Returns the URI representation of the content hash for supported codecs
 * @param contenthash to decode
 */

function contenthashToUri(contenthash) {
  var data = hexToUint8Array(contenthash);
  var codec = getNameFromData(data);

  switch (codec) {
    case 'ipfs-ns':
      {
        var unprefixedData = rmPrefix(data);
        var cid = new CID(unprefixedData);
        return "ipfs://".concat(toB58String(cid.multihash));
      }

    case 'ipns-ns':
      {
        var _unprefixedData = rmPrefix(data);

        var _cid = new CID(_unprefixedData);

        var multihash = decode(_cid.multihash);

        if (multihash.name === 'identity') {
          return "ipns://".concat(UTF_8_DECODER.decode(multihash.digest).trim());
        } else {
          return "ipns://".concat(toB58String(_cid.multihash));
        }
      }

    default:
      throw new Error("Unrecognized codec: ".concat(codec));
  }
}

var ENS_NAME_REGEX = /^(([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+)eth(\/.*)?$/;

function parseENSAddress(ensAddress) {
  var match = ensAddress.match(ENS_NAME_REGEX);
  if (!match) return undefined;
  return {
    ensName: "".concat(match[1].toLowerCase(), "eth"),
    ensPath: match[4]
  };
}
/**
 * Given a URI that may be ipfs, ipns, http, https, ar, or data protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */


function uriToHttp(uri) {
  var _uri$match, _uri$match2, _uri$match3;

  var protocol = uri.split(':')[0].toLowerCase();

  switch (protocol) {
    case 'data':
      return [uri];

    case 'https':
      return [uri];

    case 'http':
      return ['https' + uri.substr(4), uri];

    case 'ipfs':
      var hash = (_uri$match = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || _uri$match === void 0 ? void 0 : _uri$match[2];
      return ["https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"), "https://ipfs.io/ipfs/".concat(hash, "/")];

    case 'ipns':
      var name = (_uri$match2 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || _uri$match2 === void 0 ? void 0 : _uri$match2[2];
      return ["https://cloudflare-ipfs.com/ipns/".concat(name, "/"), "https://ipfs.io/ipns/".concat(name, "/")];

    case 'ar':
      var tx = (_uri$match3 = uri.match(/^ar:(\/\/)?(.*)$/i)) === null || _uri$match3 === void 0 ? void 0 : _uri$match3[2];
      return ["https://arweave.net/".concat(tx)];

    default:
      return [];
  }
}

function ownKeys$j(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$j(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ValidationSchema;

(function (ValidationSchema) {
  ValidationSchema["LIST"] = "list";
  ValidationSchema["TOKENS"] = "tokens";
})(ValidationSchema || (ValidationSchema = {}));

var validator = new Promise( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
    var _yield$Promise$all, _yield$Promise$all2, ajv, schema, validator;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([import('ajv'), import('./tokenlist.schema-4c1da21e.js')]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            ajv = _yield$Promise$all2[0];
            schema = _yield$Promise$all2[1];
            validator = new ajv.default({
              allErrors: true
            }).addSchema(schema, ValidationSchema.LIST) // Adds a meta scheme of Pick<TokenList, 'tokens'>
            .addSchema(_objectSpread$j(_objectSpread$j({}, schema), {}, {
              $id: schema.$id + '#tokens',
              required: ['tokens']
            }), ValidationSchema.TOKENS);
            resolve(validator);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

function getValidationErrors(validate) {
  var _validate$errors$map$, _validate$errors;

  return (_validate$errors$map$ = validate === null || validate === void 0 ? void 0 : (_validate$errors = validate.errors) === null || _validate$errors === void 0 ? void 0 : _validate$errors.map(function (error) {
    return [error.dataPath, error.message].filter(Boolean).join(' ');
  }).join('; ')) !== null && _validate$errors$map$ !== void 0 ? _validate$errors$map$ : 'unknown error';
}
/**
 * Validates an array of tokens.
 * @param json the TokenInfo[] to validate
 */


function validateTokens(_x2) {
  return _validateTokens.apply(this, arguments);
}
/**
 * Validates a token list.
 * @param json the TokenList to validate
 */


function _validateTokens() {
  _validateTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(json) {
    var validate;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return validator;

          case 2:
            validate = _context2.sent.getSchema(ValidationSchema.TOKENS);

            if (!(validate !== null && validate !== void 0 && validate({
              tokens: json
            }))) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", json);

          case 5:
            throw new Error("Token list failed validation: ".concat(getValidationErrors(validate)));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _validateTokens.apply(this, arguments);
}

function validateTokenList(_x3) {
  return _validateTokenList.apply(this, arguments);
}

function _validateTokenList() {
  _validateTokenList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(json) {
    var validate;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return validator;

          case 2:
            validate = _context3.sent.getSchema(ValidationSchema.LIST);

            if (!(validate !== null && validate !== void 0 && validate(json))) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", json);

          case 5:
            throw new Error("Token list failed validation: ".concat(getValidationErrors(validate)));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _validateTokenList.apply(this, arguments);
}

var listCache = new Map();
/** Fetches and validates a token list. */

function fetchTokenList(_x, _x2) {
  return _fetchTokenList.apply(this, arguments);
}

function _fetchTokenList() {
  _fetchTokenList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(listUrl, resolveENSContentHash) {
    var cached, urls, parsedENS, _parsedENS$ensPath, contentHashUri, message, translatedUri, _message, i, url, isLast, response, _message2, _message3, json, list;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cached = listCache === null || listCache === void 0 ? void 0 : listCache.get(listUrl); // avoid spurious re-fetches

            if (!cached) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", cached);

          case 3:
            parsedENS = parseENSAddress(listUrl);

            if (!parsedENS) {
              _context.next = 28;
              break;
            }

            _context.prev = 5;
            _context.next = 8;
            return resolveENSContentHash(parsedENS.ensName);

          case 8:
            contentHashUri = _context.sent;
            _context.next = 16;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            message = "failed to resolve ENS name: ".concat(parsedENS.ensName);
            console.debug(message, _context.t0);
            throw new Error(message);

          case 16:
            _context.prev = 16;
            translatedUri = contenthashToUri(contentHashUri);
            _context.next = 25;
            break;

          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](16);
            _message = "failed to translate contenthash to URI: ".concat(contentHashUri);
            console.debug(_message, _context.t1);
            throw new Error(_message);

          case 25:
            urls = uriToHttp("".concat(translatedUri).concat((_parsedENS$ensPath = parsedENS.ensPath) !== null && _parsedENS$ensPath !== void 0 ? _parsedENS$ensPath : ''));
            _context.next = 29;
            break;

          case 28:
            urls = uriToHttp(listUrl);

          case 29:
            i = 0;

          case 30:
            if (!(i < urls.length)) {
              _context.next = 64;
              break;
            }

            url = urls[i];
            isLast = i === urls.length - 1;
            response = void 0;
            _context.prev = 34;
            _context.next = 37;
            return fetch(url, {
              credentials: 'omit'
            });

          case 37:
            response = _context.sent;
            _context.next = 47;
            break;

          case 40:
            _context.prev = 40;
            _context.t2 = _context["catch"](34);
            _message2 = "failed to fetch list: ".concat(listUrl);
            console.debug(_message2, _context.t2);

            if (!isLast) {
              _context.next = 46;
              break;
            }

            throw new Error(_message2);

          case 46:
            return _context.abrupt("continue", 61);

          case 47:
            if (response.ok) {
              _context.next = 53;
              break;
            }

            _message3 = "failed to fetch list: ".concat(listUrl);
            console.debug(_message3, response.statusText);

            if (!isLast) {
              _context.next = 52;
              break;
            }

            throw new Error(_message3);

          case 52:
            return _context.abrupt("continue", 61);

          case 53:
            _context.next = 55;
            return response.json();

          case 55:
            json = _context.sent;
            _context.next = 58;
            return validateTokenList(json);

          case 58:
            list = _context.sent;
            listCache === null || listCache === void 0 ? void 0 : listCache.set(listUrl, list);
            return _context.abrupt("return", list);

          case 61:
            i++;
            _context.next = 30;
            break;

          case 64:
            throw new Error('Unrecognized list URL protocol.');

          case 65:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11], [16, 20], [34, 40]]);
  }));
  return _fetchTokenList.apply(this, arguments);
}

var alwaysTrue = function alwaysTrue() {
  return true;
};
/** Creates a filter function that filters tokens that do not match the query. */


function getTokenFilter(query) {
  var searchingAddress = isAddress(query);

  if (searchingAddress) {
    var address = searchingAddress.toLowerCase();
    return function (t) {
      return 'address' in t && address === t.address.toLowerCase();
    };
  }

  var queryParts = query.toLowerCase().split(/\s+/).filter(function (s) {
    return s.length > 0;
  });
  if (queryParts.length === 0) return alwaysTrue;

  var match = function match(s) {
    var parts = s.toLowerCase().split(/\s+/).filter(function (s) {
      return s.length > 0;
    });
    return queryParts.every(function (p) {
      return p.length === 0 || parts.some(function (sp) {
        return sp.startsWith(p) || sp.endsWith(p);
      });
    });
  };

  return function (_ref) {
    var name = _ref.name,
        symbol = _ref.symbol;
    return Boolean(symbol && match(symbol) || name && match(name));
  };
}
/** Sorts currency amounts (descending). */


function balanceComparator(a, b) {
  if (a && b) {
    return a.greaterThan(b) ? -1 : a.equalTo(b) ? 0 : 1;
  } else if (a !== null && a !== void 0 && a.greaterThan('0')) {
    return -1;
  } else if (b !== null && b !== void 0 && b.greaterThan('0')) {
    return 1;
  }

  return 0;
}
/** Sorts tokens by currency amount (descending), then symbol (ascending). */


function tokenComparator(balances, a, b) {
  // Sorts by balances
  var balanceComparison = balanceComparator(balances[a.address], balances[b.address]);
  if (balanceComparison !== 0) return balanceComparison; // Sorts by symbol

  if (a.symbol && b.symbol) {
    return a.symbol.toLowerCase() < b.symbol.toLowerCase() ? -1 : 1;
  }

  return -1;
}
/** Sorts tokens by query, giving precedence to exact matches and partial matches. */


function useSortTokensByQuery(query, tokens) {
  return useMemo(function () {
    if (!tokens) {
      return [];
    }

    var matches = query.toLowerCase().split(/\s+/).filter(function (s) {
      return s.length > 0;
    });

    if (matches.length > 1) {
      return tokens;
    }

    var exactMatches = [];
    var symbolSubtrings = [];
    var rest = []; // sort tokens by exact match -> subtring on symbol match -> rest

    tokens.map(function (token) {
      var _token$symbol, _token$symbol2;

      if (((_token$symbol = token.symbol) === null || _token$symbol === void 0 ? void 0 : _token$symbol.toLowerCase()) === matches[0]) {
        return exactMatches.push(token);
      } else if ((_token$symbol2 = token.symbol) !== null && _token$symbol2 !== void 0 && _token$symbol2.toLowerCase().startsWith(query.toLowerCase().trim())) {
        return symbolSubtrings.push(token);
      } else {
        return rest.push(token);
      }
    });
    return [].concat(exactMatches, symbolSubtrings, rest);
  }, [tokens, query]);
}

function useQueryTokens(query, tokens, _chainId) {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      activeChainId = _useActiveWeb3React.chainId,
      account = _useActiveWeb3React.account;

  var chainId = _chainId !== null && _chainId !== void 0 ? _chainId : activeChainId;
  var balances = useTokenBalances(account, tokens);
  var sortedTokens = useMemo( // Create a new array because sort is in-place and returns a referentially equivalent array.
  function () {
    return Array.from(tokens).sort(tokenComparator.bind(null, balances));
  }, [balances, tokens]);
  var debouncedQuery = useDebounce(query, 200);
  var filter = useMemo(function () {
    return getTokenFilter(debouncedQuery);
  }, [debouncedQuery]);
  var filteredTokens = useMemo(function () {
    return sortedTokens.filter(filter);
  }, [filter, sortedTokens]);
  var queriedTokens = useSortTokensByQuery(debouncedQuery, filteredTokens);
  var native = useMemo(function () {
    return chainId && nativeOnChain(chainId);
  }, [chainId]);
  return useMemo(function () {
    if (native && filter(native)) {
      return [native].concat(_toConsumableArray(queriedTokens));
    }

    return queriedTokens;
  }, [filter, native, queriedTokens]);
}

var unsupportedTokenList = [[1, '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0'] // Matic ERC20 on Ethereum Mainnet
];

function tokenSupported(chainId, address) {
  return unsupportedTokenList.find(function (token) {
    return token[0] === chainId && token[1] === address;
  }) === undefined;
}

function ownKeys$i(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$i(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/**
 * Token instances created from token info on a token list.
 */


var WrappedTokenInfo = /*#__PURE__*/function () {
  function WrappedTokenInfo(tokenInfo, list) {
    _classCallCheck(this, WrappedTokenInfo);

    _defineProperty(this, "isNative", false);

    _defineProperty(this, "isToken", true);

    _defineProperty(this, "_checksummedAddress", null);

    _defineProperty(this, "_tags", null);

    this.tokenInfo = tokenInfo;
    this.list = list;
  }

  _createClass(WrappedTokenInfo, [{
    key: "address",
    get: function get() {
      if (this._checksummedAddress) return this._checksummedAddress;
      var checksummedAddress = isAddress(this.tokenInfo.address);
      if (!checksummedAddress) throw new Error("Invalid token address: ".concat(this.tokenInfo.address));
      return this._checksummedAddress = checksummedAddress;
    }
  }, {
    key: "chainId",
    get: function get() {
      return this.tokenInfo.chainId;
    }
  }, {
    key: "decimals",
    get: function get() {
      return this.tokenInfo.decimals;
    }
  }, {
    key: "name",
    get: function get() {
      return this.tokenInfo.name;
    }
  }, {
    key: "symbol",
    get: function get() {
      return this.tokenInfo.symbol;
    }
  }, {
    key: "logoURI",
    get: function get() {
      return this.tokenInfo.logoURI;
    }
  }, {
    key: "tags",
    get: function get() {
      var _this$list;

      if (this._tags !== null) return this._tags;
      if (!this.tokenInfo.tags) return this._tags = [];
      var listTags = (_this$list = this.list) === null || _this$list === void 0 ? void 0 : _this$list.tags;
      if (!listTags) return this._tags = [];
      return this._tags = this.tokenInfo.tags.map(function (tagId) {
        return _objectSpread$i(_objectSpread$i({}, listTags[tagId]), {}, {
          id: tagId
        });
      });
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return other.chainId === this.chainId && other.isToken && other.address.toLowerCase() === this.address.toLowerCase();
    }
  }, {
    key: "sortsBefore",
    value: function sortsBefore(other) {
      if (this.equals(other)) throw new Error('Addresses should not be equal');
      return this.address.toLowerCase() < other.address.toLowerCase();
    }
  }, {
    key: "wrapped",
    get: function get() {
      return this;
    }
  }]);

  return WrappedTokenInfo;
}();

var mapCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

function tokensToChainTokenMap(tokens) {
  var cached = mapCache === null || mapCache === void 0 ? void 0 : mapCache.get(tokens);
  if (cached) return cached;

  var _ref = Array.isArray(tokens) ? [undefined, tokens] : [tokens, tokens.tokens],
      _ref2 = _slicedToArray(_ref, 2),
      list = _ref2[0],
      infos = _ref2[1];

  var map = infos.reduce(function (map, info) {
    var _map$token$chainId;

    var token = new WrappedTokenInfo(info, list);

    if (((_map$token$chainId = map[token.chainId]) === null || _map$token$chainId === void 0 ? void 0 : _map$token$chainId[token.address]) !== undefined) {
      console.warn("Duplicate token skipped: ".concat(token.address));
      return map;
    }

    if (!map[token.chainId]) {
      map[token.chainId] = {};
    }

    map[token.chainId][token.address] = {
      token: token,
      list: list
    };
    return map;
  }, {});
  mapCache === null || mapCache === void 0 ? void 0 : mapCache.set(tokens, map);
  return map;
}

var DEFAULT_TOKEN_LIST = 'https://raw.githubusercontent.com/brydge-network/brydge-tokens/main/brydge-tokens.json';

function useTokenMap(_chainId) {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      activeChainId = _useActiveWeb3React.chainId;

  var chainId = _chainId !== null && _chainId !== void 0 ? _chainId : activeChainId;
  var chainTokenMap = useChainTokenMapContext();
  var tokenMap = chainId && (chainTokenMap === null || chainTokenMap === void 0 ? void 0 : chainTokenMap[chainId]);
  return useMemo(function () {
    if (!tokenMap) return {};
    return Object.entries(tokenMap).reduce(function (map, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          address = _ref2[0],
          token = _ref2[1].token;

      map[address] = token;
      return map;
    }, {});
  }, [tokenMap]);
}

function useQueryCurrencies() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _chainId = arguments.length > 1 ? arguments[1] : undefined;

  return useQueryTokens(query, useTokenList(_chainId), _chainId);
}

var MISSING_PROVIDER = Symbol();
var ChainTokenMapContext = /*#__PURE__*/createContext(MISSING_PROVIDER);

function useChainTokenMapContext() {
  var chainTokenMap = useContext(ChainTokenMapContext);

  if (chainTokenMap === MISSING_PROVIDER) {
    throw new Error('TokenList hooks must be wrapped in a <TokenListProvider>');
  }

  return chainTokenMap;
}

function useIsTokenListLoaded() {
  return Boolean(useChainTokenMapContext());
}

function useTokenList(_chainId) {
  var _useActiveWeb3React2 = useActiveWeb3React$1(),
      activeChainId = _useActiveWeb3React2.chainId;

  var chainId = _chainId !== null && _chainId !== void 0 ? _chainId : activeChainId;
  var chainTokenMap = useChainTokenMapContext();
  var tokenMap = chainId && (chainTokenMap === null || chainTokenMap === void 0 ? void 0 : chainTokenMap[chainId]);
  return useMemo(function () {
    if (!tokenMap) return [];
    return Object.values(tokenMap).filter(function (_ref3) {
      var token = _ref3.token;
      return tokenSupported(token.chainId, token.address) ? token : undefined;
    }).map(function (_ref4) {
      var token = _ref4.token;
      return token;
    });
  }, [tokenMap]);
}

function TokenListProvider(_ref5) {
  var _ref5$list = _ref5.list,
      list = _ref5$list === void 0 ? DEFAULT_TOKEN_LIST : _ref5$list,
      children = _ref5.children; // Error boundaries will not catch (non-rendering) async errors, but it should still be shown

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  if (error) throw error;

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      chainTokenMap = _useState4[0],
      setChainTokenMap = _useState4[1];

  useEffect(function () {
    return setChainTokenMap(undefined);
  }, [list]);

  var _useActiveWeb3React3 = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React3.chainId,
      library = _useActiveWeb3React3.library;

  var resolver = useCallback(function (ensName) {
    if (library && chainId === 1) {
      return resolveENSContentHash(ensName, library);
    }

    throw new Error('Could not construct mainnet ENS resolver');
  }, [chainId, library]);
  useEffect(function () {
    // If the list was already loaded, don't reload it.
    if (chainTokenMap) return;
    var stale = false;
    activateList(list);
    return function () {
      stale = true;
    };

    function activateList(_x) {
      return _activateList.apply(this, arguments);
    }

    function _activateList() {
      _activateList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(list) {
        var tokens, map;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(typeof list === 'string')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return fetchTokenList(list, resolver);

              case 4:
                tokens = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.next = 9;
                return validateTokens(list);

              case 9:
                tokens = _context.sent;

              case 10:
                // tokensToChainTokenMap also caches the fetched tokens, so it must be invoked even if stale.
                map = tokensToChainTokenMap(tokens);

                if (!stale) {
                  setChainTokenMap(map);
                  setError(undefined);
                }

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);

                if (!stale) {
                  // Do not update the token map, in case the map was already resolved without error on mainnet.
                  setError(_context.t0);
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14]]);
      }));
      return _activateList.apply(this, arguments);
    }
  }, [chainTokenMap, list, resolver]);
  return /*#__PURE__*/jsx(ChainTokenMapContext.Provider, {
    value: chainTokenMap,
    children: children
  });
}

var BYTES32_REGEX = /^0x[a-fA-F0-9]{64}$/;

function parseStringOrBytes32(str, bytes32, defaultValue) {
  return str && str.length > 0 ? str : // need to check for proper bytes string and valid terminator
  bytes32 && BYTES32_REGEX.test(bytes32) && arrayify(bytes32)[31] === 0 ? parseBytes32String(bytes32) : defaultValue;
}
/**
 * Returns a Token from the tokenAddress.
 * Returns null if token is loading or null was passed.
 * Returns undefined if tokenAddress is invalid or token does not exist.
 */


function useTokenFromNetwork(tokenAddress, _chainId) {
  var _useActiveWeb3React = useActiveWeb3React(),
      activeChainId = _useActiveWeb3React.chainId;

  var chainId = _chainId || activeChainId;
  var formattedAddress = isAddress(tokenAddress);
  var tokenContract = useTokenContract(formattedAddress ? formattedAddress : undefined, false);
  var tokenContractBytes32 = useBytes32TokenContract(formattedAddress ? formattedAddress : undefined, false);
  var tokenName = useSingleCallResultWithChainId(chainId, tokenContract, 'name', undefined, NEVER_RELOAD);
  var tokenNameBytes32 = useSingleCallResultWithChainId(chainId, tokenContractBytes32, 'name', undefined, NEVER_RELOAD);
  var symbol = useSingleCallResultWithChainId(chainId, tokenContract, 'symbol', undefined, NEVER_RELOAD);
  var symbolBytes32 = useSingleCallResultWithChainId(chainId, tokenContractBytes32, 'symbol', undefined, NEVER_RELOAD);
  var decimals = useSingleCallResultWithChainId(chainId, tokenContract, 'decimals', undefined, NEVER_RELOAD);
  return useMemo(function () {
    if (typeof tokenAddress !== 'string' || !chainId || !formattedAddress) return undefined;
    if (decimals.loading || symbol.loading || tokenName.loading) return null;

    if (decimals.result) {
      var _symbol$result, _symbolBytes32$result, _tokenName$result, _tokenNameBytes32$res;

      return new Token(chainId, formattedAddress, decimals.result[0], parseStringOrBytes32((_symbol$result = symbol.result) === null || _symbol$result === void 0 ? void 0 : _symbol$result[0], (_symbolBytes32$result = symbolBytes32.result) === null || _symbolBytes32$result === void 0 ? void 0 : _symbolBytes32$result[0], 'UNKNOWN'), parseStringOrBytes32((_tokenName$result = tokenName.result) === null || _tokenName$result === void 0 ? void 0 : _tokenName$result[0], (_tokenNameBytes32$res = tokenNameBytes32.result) === null || _tokenNameBytes32$res === void 0 ? void 0 : _tokenNameBytes32$res[0], 'Unknown Token'));
    }

    return undefined;
  }, [formattedAddress, chainId, decimals.loading, decimals.result, symbol.loading, symbol.result, symbolBytes32.result, tokenAddress, tokenName.loading, tokenName.result, tokenNameBytes32.result]);
}
/**
 * Returns a Token from the tokenAddress.
 * Returns null if token is loading or null was passed.
 * Returns undefined if tokenAddress is invalid or token does not exist.
 */


function useTokenFromMapOrNetwork(tokens, tokenAddress, _chainId) {
  var address = isAddress(tokenAddress);
  var token = address ? tokens[address] : undefined;
  var tokenFromNetwork = useTokenFromNetwork(token ? undefined : address || undefined, _chainId);
  return tokenFromNetwork !== null && tokenFromNetwork !== void 0 ? tokenFromNetwork : token;
}
/**
 * Returns a Token from the tokenAddress.
 * Returns null if token is loading or null was passed.
 * Returns undefined if tokenAddress is invalid or token does not exist.
 */


function useToken(tokenAddress, _chainId) {
  var tokens = useTokenMap(_chainId);
  return useTokenFromMapOrNetwork(tokens, tokenAddress, _chainId);
}
/**
 * Returns a Currency from the currencyId.
 * Returns null if currency is loading or null was passed.
 * Returns undefined if currencyId is invalid or token does not exist.
 */


function useCurrencyFromMap(tokens, currencyId, _chainId) {
  var _wrappedNative$addres;

  var nativeCurrency = useNativeCurrency(_chainId);

  var _useActiveWeb3React2 = useActiveWeb3React(),
      activeChainId = _useActiveWeb3React2.chainId;

  var chainId = _chainId || activeChainId;
  var isNative = Boolean(nativeCurrency && (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toUpperCase()) === 'ETH');
  var shorthandMatchAddress = useMemo(function () {
    var _TOKEN_SHORTHANDS$cur;

    var chain = supportedChainId(chainId);
    return chain && currencyId ? (_TOKEN_SHORTHANDS$cur = TOKEN_SHORTHANDS[currencyId.toUpperCase()]) === null || _TOKEN_SHORTHANDS$cur === void 0 ? void 0 : _TOKEN_SHORTHANDS$cur[chain] : undefined;
  }, [chainId, currencyId]);
  var token = useTokenFromMapOrNetwork(tokens, isNative ? undefined : shorthandMatchAddress !== null && shorthandMatchAddress !== void 0 ? shorthandMatchAddress : currencyId, chainId);
  if (currencyId === null || currencyId === undefined) return currencyId; // this case so we use our builtin wrapped token instead of wrapped tokens on token lists

  var wrappedNative = nativeCurrency === null || nativeCurrency === void 0 ? void 0 : nativeCurrency.wrapped;
  if ((wrappedNative === null || wrappedNative === void 0 ? void 0 : (_wrappedNative$addres = wrappedNative.address) === null || _wrappedNative$addres === void 0 ? void 0 : _wrappedNative$addres.toUpperCase()) === (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toUpperCase())) return wrappedNative;
  return isNative ? nativeCurrency : token;
}
/**
 * Returns a Currency from the currencyId.
 * Returns null if currency is loading or null was passed.
 * Returns undefined if currencyId is invalid or token does not exist.
 */


function useCurrency(currencyId, _chainId) {
  var tokens = useTokenMap(_chainId);
  return useCurrencyFromMap(tokens, currencyId, _chainId);
}

var INVALID_TRADE = {
  state: TradeState.INVALID,
  trade: undefined
};
/**
 * Returns the best v2+v3 trade for a desired swap.
 * @param tradeType whether the swap is an exact in/out
 * @param amountSpecified the exact amount to swap in/out
 * @param otherCurrency the desired output/payment currency
 */

function useBestTrade(tradeType, amountSpecified, otherCurrency, isSameTokenTrade) {
  var _useLast;

  var daiCurrency = useCurrency('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', 137);
  var usdcCurrency = useCurrency('0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174', 137);

  if (isSameTokenTrade) {
    if (((amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency) === daiCurrency || otherCurrency === daiCurrency) && usdcCurrency) {
      otherCurrency = usdcCurrency;
    } else if (daiCurrency) {
      otherCurrency = daiCurrency;
    }
  }

  var tradeV2 = useBestV2Trade(TradeType.EXACT_OUTPUT, amountSpecified ? amountSpecified : undefined, otherCurrency ? otherCurrency : undefined);
  var clientSORTradeObject = useClientSideSmartOrderRouterTrade(tradeType, amountSpecified, otherCurrency); // Use a simple client side logic as backup if SOR is not available.

  var useFallback = clientSORTradeObject.state === TradeState.NO_ROUTE_FOUND || clientSORTradeObject.state === TradeState.INVALID;
  var fallbackTradeObject = useClientSideV3Trade(tradeType, useFallback ? amountSpecified : undefined, useFallback ? otherCurrency : undefined);
  var tradeObject = useFallback ? fallbackTradeObject : clientSORTradeObject;
  var lastTrade = (_useLast = useLast(tradeObject.trade, Boolean)) !== null && _useLast !== void 0 ? _useLast : undefined; // Return the last trade while syncing/loading to avoid jank from clearing the last trade while loading.
  // If the trade is unsettled and not stale, return the last trade as a placeholder during settling.

  return useMemo(function () {
    var _lastTrade$inputAmoun, _lastTrade$outputAmou;

    if (!tradeObject.trade && tradeV2 && isQuickswapTrade(tradeV2)) {
      tradeObject.trade = new InterfaceTrade({
        v2Routes: [{
          routev2: tradeV2.route,
          inputAmount: tradeV2.inputAmount,
          outputAmount: tradeV2.outputAmount
        }],
        v3Routes: [],
        tradeType: TradeType.EXACT_OUTPUT
      });
      tradeObject.state = TradeState.VALID;
    } // If the trade is in a settled state, return it.


    if (tradeObject.state === TradeState.INVALID && !tradeV2) return INVALID_TRADE;

    if (tradeObject.state !== TradeState.LOADING && tradeObject.state !== TradeState.SYNCING || tradeObject.trade) {
      return {
        state: tradeObject.state,
        trade: tradeObject.trade
      };
    }

    var _ref = tradeType === TradeType.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency],
        _ref2 = _slicedToArray(_ref, 2),
        currencyIn = _ref2[0],
        currencyOut = _ref2[1]; // If the trade currencies have switched, consider it stale - do not return the last trade.


    var isStale = currencyIn && !(lastTrade !== null && lastTrade !== void 0 && (_lastTrade$inputAmoun = lastTrade.inputAmount) !== null && _lastTrade$inputAmoun !== void 0 && _lastTrade$inputAmoun.currency.equals(currencyIn)) || currencyOut && !(lastTrade !== null && lastTrade !== void 0 && (_lastTrade$outputAmou = lastTrade.outputAmount) !== null && _lastTrade$outputAmou !== void 0 && _lastTrade$outputAmou.currency.equals(currencyOut));
    if (isStale) return tradeObject;
    return {
      state: tradeObject.state,
      trade: lastTrade
    };
  }, [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, isSameTokenTrade, lastTrade, otherCurrency, tradeObject, tradeType, tradeV2]);
}

var _STABLECOIN_AMOUNT_OU; // The amount is large enough to filter low liquidity pairs.


var STABLECOIN_AMOUNT_OUT = (_STABLECOIN_AMOUNT_OU = {}, _defineProperty(_STABLECOIN_AMOUNT_OU, SupportedChainId.MAINNET, CurrencyAmount.fromRawAmount(USDC_MAINNET$1, 100000e6)), _defineProperty(_STABLECOIN_AMOUNT_OU, SupportedChainId.ARBITRUM_ONE, CurrencyAmount.fromRawAmount(USDC_ARBITRUM, 10000e6)), _defineProperty(_STABLECOIN_AMOUNT_OU, SupportedChainId.OPTIMISM, CurrencyAmount.fromRawAmount(DAI_OPTIMISM, 10000e18)), _defineProperty(_STABLECOIN_AMOUNT_OU, SupportedChainId.POLYGON, CurrencyAmount.fromRawAmount(USDC_POLYGON, 10000e6)), _STABLECOIN_AMOUNT_OU);
/**
 * Returns the price in USDC of the input currency
 * @param currency currency to compute the USDC price of
 */

function useUSDCPrice(currency) {
  var chainId = currency === null || currency === void 0 ? void 0 : currency.chainId;
  var amountOut = chainId ? STABLECOIN_AMOUNT_OUT[chainId] : undefined;
  var stablecoin = amountOut === null || amountOut === void 0 ? void 0 : amountOut.currency; // TODO(#2808): remove dependency on useBestV2Trade

  var v2USDCTrade = useBestV2Trade(TradeType.EXACT_OUTPUT, amountOut, currency, {
    maxHops: 2
  });
  var bestTradeTrade = useBestTrade(TradeType.EXACT_OUTPUT, amountOut, currency);
  var price = useMemo(function () {
    if (!currency || !stablecoin) {
      return undefined;
    } // handle usdc


    if (currency !== null && currency !== void 0 && currency.wrapped.equals(stablecoin)) {
      return new Price$1(stablecoin, stablecoin, '1', '1');
    } // use v2 price if available, use useBestTrade as fallback


    if (bestTradeTrade !== null && bestTradeTrade !== void 0 && bestTradeTrade.trade) {
      var _bestTradeTrade$trade = bestTradeTrade === null || bestTradeTrade === void 0 ? void 0 : bestTradeTrade.trade.routes[0].midPrice,
          numerator = _bestTradeTrade$trade.numerator,
          denominator = _bestTradeTrade$trade.denominator;

      return new Price$1(currency, stablecoin, denominator, numerator);
    } else {
      if (v2USDCTrade) {
        var _v2USDCTrade$route$mi = v2USDCTrade.route.midPrice,
            _numerator = _v2USDCTrade$route$mi.numerator,
            _denominator = _v2USDCTrade$route$mi.denominator;
        return new Price$1(currency, stablecoin, _denominator, _numerator);
      }
    }

    return undefined;
  }, [currency, stablecoin, bestTradeTrade === null || bestTradeTrade === void 0 ? void 0 : bestTradeTrade.trade, v2USDCTrade]);
  var lastPrice = useRef(price);

  if (!price || !lastPrice.current || !price.equalTo(lastPrice.current) || !price.baseCurrency.equals(lastPrice.current.baseCurrency)) {
    lastPrice.current = price;
  }

  return lastPrice.current;
}

function useUSDCPriceWithChainId(currency, chainId) {
  var amountOut = chainId ? STABLECOIN_AMOUNT_OUT[chainId] : undefined;
  var stablecoin = amountOut === null || amountOut === void 0 ? void 0 : amountOut.currency; // TODO(#2808): remove dependency on useBestV2Trade
  // const v2USDCTrade = useBestV2Trade(TradeType.EXACT_OUTPUT, amountOut, currency, {
  //   maxHops: 2,
  // })
  // const mappedCurrency = useEthToPolyMappedCurrency(currency)
  // if (chainId !== 137) {
  //   currency = mappedCurrency
  // }

  var mappedCurrency = useEthToPolyMappedCurrency(currency);
  var bestTradeTrade = useBestTrade(TradeType.EXACT_OUTPUT, amountOut, mappedCurrency);
  var price = useMemo(function () {
    if (!mappedCurrency || !stablecoin) {
      return undefined;
    } // handle usdc


    if (mappedCurrency !== null && mappedCurrency !== void 0 && mappedCurrency.wrapped.equals(stablecoin)) {
      return new Price$1(stablecoin, stablecoin, '1', '1');
    } // use v2 price if available, use useBestTrade as fallback


    if (bestTradeTrade !== null && bestTradeTrade !== void 0 && bestTradeTrade.trade) {
      var _bestTradeTrade$trade2 = bestTradeTrade === null || bestTradeTrade === void 0 ? void 0 : bestTradeTrade.trade.routes[0].midPrice,
          numerator = _bestTradeTrade$trade2.numerator,
          denominator = _bestTradeTrade$trade2.denominator;

      if (currency) {
        return new Price$1(currency, stablecoin, denominator, numerator);
      }
    }

    return undefined;
  }, [mappedCurrency, stablecoin, bestTradeTrade === null || bestTradeTrade === void 0 ? void 0 : bestTradeTrade.trade, currency]);
  var lastPrice = useRef(price);

  if (!price || !lastPrice.current || !price.equalTo(lastPrice.current)) {
    lastPrice.current = price;
  }

  return lastPrice.current;
}

function useUSDCValue(currencyAmount) {
  var price = useUSDCPrice(currencyAmount === null || currencyAmount === void 0 ? void 0 : currencyAmount.currency);
  return useMemo(function () {
    if (!price || !currencyAmount) return null;

    try {
      return price.quote(currencyAmount);
    } catch (error) {
      console.error(error);
      return null;
    }
  }, [currencyAmount, price]);
}
/**
 *
 * @param fiatValue string representation of a USD amount
 * @returns CurrencyAmount where currency is stablecoin on active chain
 */


function useStablecoinAmountFromFiatValue(fiatValue) {
  var _STABLECOIN_AMOUNT_OU2;

  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var stablecoin = chainId ? (_STABLECOIN_AMOUNT_OU2 = STABLECOIN_AMOUNT_OUT[chainId]) === null || _STABLECOIN_AMOUNT_OU2 === void 0 ? void 0 : _STABLECOIN_AMOUNT_OU2.currency : undefined;
  return useMemo(function () {
    if (fiatValue === null || fiatValue === undefined || !chainId || !stablecoin) {
      return undefined;
    } // trim for decimal precision when parsing


    var parsedForDecimals = parseFloat(fiatValue).toFixed(stablecoin.decimals).toString();

    try {
      // parse USD string into CurrencyAmount based on stablecoin decimals
      return tryParseCurrencyAmount(parsedForDecimals, stablecoin);
    } catch (error) {
      return undefined;
    }
  }, [chainId, fiatValue, stablecoin]);
}
/**
 * Returns the price in USDC of the input currency
 * @param currency currency to compute the USDC price of
 */
// export default function useUSDCPrice(currency?: Currency): Price<Currency, Token> | undefined {
// const chainId = currency?.chainId
// const amountOut = chainId ? STABLECOIN_AMOUNT_OUT[chainId] : undefined
// const stablecoin = amountOut?.currency
// // TODO(#2808): remove dependency on useBestV2Trade
// const v2USDCTrade = useBestV2Trade(TradeType.EXACT_OUTPUT, amountOut, currency, {
//   maxHops: 2,
// })
// const v3USDCTrade = useClientSideV3Trade(TradeType.EXACT_OUTPUT, amountOut, currency)
// const price = useMemo(() => {
//   if (!currency || !stablecoin) {
//     return undefined
//   }
//   // handle usdc
//   if (currency?.wrapped.equals(stablecoin)) {
//     return new Price(stablecoin, stablecoin, '1', '1')
//   }
//   // use v2 price if available, v3 as fallback
//   if (v2USDCTrade) {
//     const { numerator, denominator } = v2USDCTrade.route.midPrice
//     return new Price(currency, stablecoin, denominator, numerator)
//   } else if (v3USDCTrade.trade) {
//     const { numerator, denominator } = v3USDCTrade.trade.routes[0].midPrice
//     return new Price(currency, stablecoin, denominator, numerator)
//   }
//   return undefined
// }, [currency, stablecoin, v2USDCTrade, v3USDCTrade.trade])
// const lastPrice = useRef(price)
// if (!price || !lastPrice.current || !price.equalTo(lastPrice.current)) {
//   lastPrice.current = price
// }
// return lastPrice.current
// }


var V3_SWAP_DEFAULT_SLIPPAGE = new Percent(50, 10000); // .50%

var ETH_DEFAULT_SLIPPAGE = new Percent(500, 10000);
var ONE_TENTHS_PERCENT = new Percent(10, 10000); // .10%

var DEFAULT_AUTO_SLIPPAGE = ONE_TENTHS_PERCENT;
/**
 * Return a guess of the gas cost used in computing slippage tolerance for a given trade
 * @param trade the trade for which to _guess_ the amount of gas it would cost to execute
 */
// function guesstimateGas(trade: Trade<Currency, Currency, TradeType> | undefined): number | undefined {
//   if (!!trade) {
//     return 100_000 + trade.swaps.reduce((memo, swap) => swap.route.pools.length + memo, 0) * 30_000
//   }
//   return undefined
// }

/**
 * Returns slippage tolerance based on values from current trade, gas estimates from api, and active network.
 */

function useAutoSlippageTolerance(trade) {
  // const { chainId } = useJsonRPCWeb3React()
  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var onL2nonPoly = chainId && L2_CHAIN_IDS.includes(chainId);
  var onL2 = chainId && chainId === 137 ? true : onL2nonPoly;
  return useMemo(function () {
    if (!trade || onL2) return DEFAULT_AUTO_SLIPPAGE;
    return chainId && chainId === 1 ? ETH_DEFAULT_SLIPPAGE : V3_SWAP_DEFAULT_SLIPPAGE; // }, [trade, onL2, nativeGasPrice, gasEstimate, nativeCurrency, nativeCurrencyPrice, chainId, outputDollarValue])
  }, [trade, onL2, chainId]);
}

var initialSettings = {
  autoSlippage: true,
  maxSlippage: undefined,
  transactionTtl: undefined,
  mockTogglable: true,
  clientSideRouter: false
};
var settingsAtom = atomWithReset(initialSettings);
var autoSlippageAtom = pickAtom(settingsAtom, 'autoSlippage');
var maxSlippageAtom = pickAtom(settingsAtom, 'maxSlippage');
var transactionTtlAtom = pickAtom(settingsAtom, 'transactionTtl');
pickAtom(settingsAtom, 'mockTogglable', setTogglable);
pickAtom(settingsAtom, 'clientSideRouter');

function toPercent(maxSlippage) {
  if (!maxSlippage) return undefined;
  var numerator = Math.floor(maxSlippage * 100);
  return new Percent(numerator, 10000);
}

var DEFAULT_SLIPPAGE = {
  auto: true,
  allowed: DEFAULT_AUTO_SLIPPAGE
};
/** Returns the allowed slippage, and whether it is auto-slippage. */

function useSlippage(trade) {
  var shouldUseAutoSlippage = useAtomValue(autoSlippageAtom);
  var autoSlippage = useAutoSlippageTolerance(shouldUseAutoSlippage ? trade : undefined);
  var maxSlippageValue = useAtomValue(maxSlippageAtom);
  var maxSlippage = useMemo(function () {
    return toPercent(maxSlippageValue);
  }, [maxSlippageValue]);
  return useMemo(function () {
    var auto = shouldUseAutoSlippage || !maxSlippage;
    var allowed = shouldUseAutoSlippage ? autoSlippage : maxSlippage !== null && maxSlippage !== void 0 ? maxSlippage : autoSlippage;
    var warning = auto ? undefined : getSlippageWarning(allowed);

    if (auto && allowed === DEFAULT_AUTO_SLIPPAGE) {
      return DEFAULT_SLIPPAGE;
    }

    return {
      auto: auto,
      allowed: allowed,
      warning: warning
    };
  }, [autoSlippage, maxSlippage, shouldUseAutoSlippage]);
}

var MAX_VALID_SLIPPAGE = new Percent(1, 2);
var MIN_HIGH_SLIPPAGE = new Percent(1, 100);

function getSlippageWarning(slippage) {
  if (slippage !== null && slippage !== void 0 && slippage.greaterThan(MAX_VALID_SLIPPAGE)) return 'error';
  if (slippage !== null && slippage !== void 0 && slippage.greaterThan(MIN_HIGH_SLIPPAGE)) return 'warning';
  return;
}

function computeFiatValuePriceImpact(fiatValueInput, fiatValueOutput) {
  if (!fiatValueOutput || !fiatValueInput) return undefined;
  if (!fiatValueInput.currency.equals(fiatValueOutput.currency)) return undefined;
  if (JSBI.equal(fiatValueInput.quotient, JSBI.BigInt(0))) return undefined;
  var pct = ONE_HUNDRED_PERCENT.subtract(fiatValueOutput.divide(fiatValueInput));
  return new Percent(pct.numerator, pct.denominator);
}

function _createForOfIteratorHelper$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var THIRTY_BIPS_FEE = new Percent(JSBI.BigInt(30), JSBI.BigInt(10000));
var INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(THIRTY_BIPS_FEE);

function getPriceImpactWarning(priceImpact) {
  if (priceImpact !== null && priceImpact !== void 0 && priceImpact.greaterThan(ALLOWED_PRICE_IMPACT_HIGH)) return 'error';
  if (priceImpact !== null && priceImpact !== void 0 && priceImpact.greaterThan(ALLOWED_PRICE_IMPACT_MEDIUM)) return 'warning';
  return;
} // computes realized lp fee as a percent


function computeRealizedLPFeePercent(trade) {
  var percent; // Since routes are either all v2 or all v3 right now, calculate separately

  if (trade.swaps[0].route.pools instanceof Pair) {
    // for each hop in our trade, take away the x*y=k price impact from 0.3% fees
    // e.g. for 3 tokens/2 hops: 1 - ((1 - .03) * (1-.03))
    percent = ONE_HUNDRED_PERCENT.subtract(trade.swaps.reduce(function (currentFee) {
      return currentFee.multiply(INPUT_FRACTION_AFTER_FEE);
    }, ONE_HUNDRED_PERCENT));
  } else {
    percent = ZERO_PERCENT;

    var _iterator = _createForOfIteratorHelper$2(trade.swaps),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var swap = _step.value;

        var _swap$inputAmount$div = swap.inputAmount.divide(trade.inputAmount),
            numerator = _swap$inputAmount$div.numerator,
            denominator = _swap$inputAmount$div.denominator;

        var overallPercent = new Percent(numerator, denominator);
        var routeRealizedLPFeePercent = overallPercent.multiply(ONE_HUNDRED_PERCENT.subtract(swap.route.pools.reduce(function (currentFee, pool) {
          var fee = pool instanceof Pair ? // not currently possible given protocol check above, but not fatal
          FeeAmount.MEDIUM : pool.fee;
          return currentFee.multiply(ONE_HUNDRED_PERCENT.subtract(new Fraction(fee, 1000000)));
        }, ONE_HUNDRED_PERCENT)));
        percent = percent.add(routeRealizedLPFeePercent);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return new Percent(percent.numerator, percent.denominator);
} // computes price breakdown for the trade


function computeRealizedLPFeeAmount(trade) {
  if (trade) {
    var realizedLPFee = computeRealizedLPFeePercent(trade); // the amount of the input that accrues to LPs

    return CurrencyAmount.fromRawAmount(trade.inputAmount.currency, trade.inputAmount.multiply(realizedLPFee).quotient);
  }

  return undefined;
}
/**
 * Computes input/output USDC equivalents and the price impact.
 * Returns the price impact as a human readable string.
 */


function useUSDCPriceImpact(inputAmount, outputAmount) {
  var _useUSDCValue, _useUSDCValue2;

  var inputUSDC = (_useUSDCValue = useUSDCValue(inputAmount)) !== null && _useUSDCValue !== void 0 ? _useUSDCValue : undefined;
  var outputUSDC = (_useUSDCValue2 = useUSDCValue(outputAmount)) !== null && _useUSDCValue2 !== void 0 ? _useUSDCValue2 : undefined;
  return useMemo(function () {
    var priceImpact = computeFiatValuePriceImpact(inputUSDC, outputUSDC);
    var impact = priceImpact ? {
      percent: priceImpact,
      warning: getPriceImpactWarning(priceImpact),
      toString: function toString() {
        return toHumanReadablePriceImpact(priceImpact);
      }
    } : undefined;
    return {
      inputUSDC: inputUSDC,
      outputUSDC: outputUSDC,
      impact: impact
    };
  }, [inputUSDC, outputUSDC]);
}

function toHumanReadablePriceImpact(priceImpact) {
  var _priceImpact$multiply;

  var sign = priceImpact.lessThan(0) ? '+' : '';
  var number = parseFloat((_priceImpact$multiply = priceImpact.multiply(-1)) === null || _priceImpact$multiply === void 0 ? void 0 : _priceImpact$multiply.toSignificant(3));
  return "".concat(sign).concat(number, "%");
}

var _DEFAULT_SWAP_INFO;

function useEthToPolyMappedCurrency(currency, chainId) {
  var rootChainManager = useRootChainManagerProxyContract();
  var wethAddress = '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619'; // WETH_POLYGON ? i put this here to hard code the native case

  var _useState = useState(wethAddress),
      _useState2 = _slicedToArray(_useState, 2),
      address = _useState2[0],
      setAddress = _useState2[1]; // this is used in conjunction w/ useEffect to store state between renders


  var other = useToken(address, chainId); // this is a common pattern to fetch async data in react.
  // with react, there's no concept of async / await, everything is just 'current', i.e. when a change occurs,
  // react re-renders in an instant (from its perspective, it exists in one execution that occurrs instantly).
  // useEffect basically tells react to perform some action right now and to expect a side effect to occurr later
  // to this hook triggers fetchData instantly on page load (notice it does not await fetchData)

  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(currency !== null && currency !== void 0 && currency.isToken)) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return rootChainManager === null || rootChainManager === void 0 ? void 0 : rootChainManager.rootToChildToken(currency.address);

              case 4:
                result = _context.sent;
                setAddress(result);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                setAddress(undefined);

              case 11:
                _context.next = 14;
                break;

              case 13:
                if (currency !== null && currency !== void 0 && currency.isNative) {
                  setAddress(wethAddress);
                } else {
                  setAddress(undefined);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData(); // these are dependencies. they let react know that if any of these are to change, then it should rerun this effect
  }, [currency, chainId, rootChainManager]);
  if (!currency) return undefined;

  if ((currency === null || currency === void 0 ? void 0 : currency.chainId) === chainId) {
    return currency;
  }

  if (currency !== null && currency !== void 0 && currency.isNative || currency !== null && currency !== void 0 && currency.isToken && currency.chainId === 1 && currency.address.toLowerCase() === '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2') {
    return WETH_POLYGON$1;
  }

  if (currency.symbol === 'MATIC') {
    return nativeOnChain$1(137);
  }

  return other !== null && other !== void 0 ? other : undefined;
}

function usePolyToEthMappedCurrency(currency, chainId) {
  var rootChainManager = useRootChainManagerProxyContract(); // use weth on eth

  var wethAddress = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'; // there's some constant i dont remember where it is though

  var _useState3 = useState(wethAddress),
      _useState4 = _slicedToArray(_useState3, 2),
      address = _useState4[0],
      setAddress = _useState4[1];

  var other = useToken(address, chainId);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(currency !== null && currency !== void 0 && currency.isToken)) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return rootChainManager === null || rootChainManager === void 0 ? void 0 : rootChainManager.childToRootToken(currency.address);

              case 4:
                result = _context2.sent;
                setAddress(result);
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                setAddress(undefined);

              case 11:
                _context2.next = 14;
                break;

              case 13:
                if (currency !== null && currency !== void 0 && currency.isNative) {
                  setAddress(wethAddress);
                } else {
                  setAddress(undefined);
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [currency, chainId, rootChainManager]);
  if (!currency) return undefined;

  if ((currency === null || currency === void 0 ? void 0 : currency.chainId) === chainId) {
    return currency;
  } // change WETH to ETH


  if (currency.symbol === 'WETH') {
    return nativeOnChain$1(1);
  }

  return other !== null && other !== void 0 ? other : undefined;
}

function useCurrencyToMappedCurrency(sourceCurrency, chainId) {
  var rootChainManager = useRootChainManagerProxyContract();
  var wethAddress = '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619';

  var _useState5 = useState(wethAddress),
      _useState6 = _slicedToArray(_useState5, 2),
      address = _useState6[0],
      setAddress = _useState6[1];

  var other = useToken(address, chainId);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(sourceCurrency !== null && sourceCurrency !== void 0 && sourceCurrency.isToken)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return rootChainManager === null || rootChainManager === void 0 ? void 0 : rootChainManager.rootToChildToken(sourceCurrency.address);

              case 3:
                result = _context3.sent;
                setAddress(result);
                _context3.next = 8;
                break;

              case 7:
                if (sourceCurrency !== null && sourceCurrency !== void 0 && sourceCurrency.isNative) {
                  setAddress(wethAddress);
                } else {
                  setAddress(undefined);
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [sourceCurrency, chainId, rootChainManager]);
  if (!sourceCurrency) return undefined;

  if ((sourceCurrency === null || sourceCurrency === void 0 ? void 0 : sourceCurrency.chainId) === chainId) {
    return sourceCurrency;
  }

  if (sourceCurrency !== null && sourceCurrency !== void 0 && sourceCurrency.isNative || sourceCurrency !== null && sourceCurrency !== void 0 && sourceCurrency.isToken && sourceCurrency.chainId === 1 && sourceCurrency.address.toLowerCase() === '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2') {
    return WETH_POLYGON$1;
  }

  if (sourceCurrency.symbol === 'MATIC') {
    return nativeOnChain$1(137);
  }

  return other !== null && other !== void 0 ? other : undefined;
} // from the current swap inputs, compute the best trade and return it.


function useComputeSwapInfo() {
  var _amountIn$numerator, _amountIn$denominator, _trade$trade4, _trade$trade5, _trade$trade6;

  var _useWrapCallback = useWrapCallback(),
      wrapType = _useWrapCallback.type;

  var _useAtomValue = useAtomValue(swapAtom),
      independentField = _useAtomValue.independentField,
      amount = _useAtomValue.amount,
      activeCurrencyIn = _useAtomValue[Field$1.INPUT],
      currencyOut = _useAtomValue[Field$1.OUTPUT];

  var mappedInputCurrency = useCurrencyToMappedCurrency(activeCurrencyIn, currencyOut === null || currencyOut === void 0 ? void 0 : currencyOut.chainId);
  var isSameTokenTrade = isSameToken(mappedInputCurrency, currencyOut);
  var isWrapping = isSameTokenTrade ? true : wrapType === WrapType.WRAP || wrapType === WrapType.UNWRAP;
  var isExactIn = independentField === Field$1.INPUT;
  var parsedAmount = useMemo(function () {
    var _ref4;

    return tryParseCurrencyAmount(amount, (_ref4 = isExactIn ? mappedInputCurrency : currencyOut) !== null && _ref4 !== void 0 ? _ref4 : undefined);
  }, [amount, isExactIn, mappedInputCurrency, currencyOut]);
  var hasAmounts = activeCurrencyIn && currencyOut && parsedAmount;
  var passInAmounts = hasAmounts && !isWrapping || isSameTokenTrade;
  var trade = useBestTrade(isExactIn ? TradeType.EXACT_INPUT : TradeType.EXACT_OUTPUT, passInAmounts ? parsedAmount : undefined, passInAmounts ? isExactIn ? currencyOut : mappedInputCurrency : undefined, isSameTokenTrade);
  var amountIn = useMemo(function () {
    var _trade$trade, _trade$trade2;

    return isWrapping || isExactIn ? parsedAmount : activeCurrencyIn && (trade === null || trade === void 0 ? void 0 : trade.trade) && CurrencyAmount.fromFractionalAmount(activeCurrencyIn, trade === null || trade === void 0 ? void 0 : (_trade$trade = trade.trade) === null || _trade$trade === void 0 ? void 0 : _trade$trade.inputAmount.numerator, trade === null || trade === void 0 ? void 0 : (_trade$trade2 = trade.trade) === null || _trade$trade2 === void 0 ? void 0 : _trade$trade2.inputAmount.denominator);
  }, [activeCurrencyIn, isExactIn, isWrapping, parsedAmount, trade === null || trade === void 0 ? void 0 : trade.trade]);
  var mappedInputCurrencyAmount = mappedInputCurrency && CurrencyAmount.fromFractionalAmount(mappedInputCurrency, (_amountIn$numerator = amountIn === null || amountIn === void 0 ? void 0 : amountIn.numerator) !== null && _amountIn$numerator !== void 0 ? _amountIn$numerator : 0, (_amountIn$denominator = amountIn === null || amountIn === void 0 ? void 0 : amountIn.denominator) !== null && _amountIn$denominator !== void 0 ? _amountIn$denominator : 1); // Calculate Brydge Fee, LP Fee, and total amountIn here

  var brydgeFee = mappedInputCurrencyAmount ? mappedInputCurrencyAmount === null || mappedInputCurrencyAmount === void 0 ? void 0 : mappedInputCurrencyAmount.multiply(BRYDGE_FEE_COEFFICIENT).divide(1000 - BRYDGE_FEE_COEFFICIENT) : mappedInputCurrency && CurrencyAmount.fromRawAmount(mappedInputCurrency, 0);
  var lpFeeRaw = !isSameTokenTrade && trade.trade ? computeRealizedLPFeeAmount(trade.trade) : mappedInputCurrency && CurrencyAmount.fromRawAmount(mappedInputCurrency, 0);
  var lpFee = lpFeeRaw && mappedInputCurrency ? CurrencyAmount.fromFractionalAmount(mappedInputCurrency, lpFeeRaw.numerator, lpFeeRaw.denominator) : mappedInputCurrency && CurrencyAmount.fromRawAmount(mappedInputCurrency, 0);
  var totalAmountIn = mappedInputCurrencyAmount && brydgeFee ? mappedInputCurrencyAmount.add(brydgeFee) : undefined;
  var amountOut = useMemo(function () {
    var _trade$trade3;

    return isWrapping || !isExactIn ? parsedAmount : (_trade$trade3 = trade.trade) === null || _trade$trade3 === void 0 ? void 0 : _trade$trade3.outputAmount;
  }, [isExactIn, isWrapping, parsedAmount, (_trade$trade4 = trade.trade) === null || _trade$trade4 === void 0 ? void 0 : _trade$trade4.outputAmount]);

  var _useActiveWeb3React = useActiveWeb3React$1(),
      account = _useActiveWeb3React.account;

  var _useCurrencyBalances = useCurrencyBalances(account, useMemo(function () {
    return [activeCurrencyIn, currencyOut];
  }, [activeCurrencyIn, currencyOut])),
      _useCurrencyBalances2 = _slicedToArray(_useCurrencyBalances, 2),
      balanceIn = _useCurrencyBalances2[0],
      balanceOut = _useCurrencyBalances2[1]; // Compute slippage and impact off of the trade so that it refreshes with the trade.
  // (Using amountIn/amountOut would show (incorrect) intermediate values.)


  var slippage = useSlippage(trade.trade);

  var _useUSDCPriceImpact = useUSDCPriceImpact((_trade$trade5 = trade.trade) === null || _trade$trade5 === void 0 ? void 0 : _trade$trade5.inputAmount, trade.trade ? (_trade$trade6 = trade.trade) === null || _trade$trade6 === void 0 ? void 0 : _trade$trade6.outputAmount : amountOut),
      inputUSDC = _useUSDCPriceImpact.inputUSDC,
      outputUSDC = _useUSDCPriceImpact.outputUSDC,
      impact = _useUSDCPriceImpact.impact;

  var brydgeFeeUSDC = useUSDCValue(brydgeFee);
  var lpFeeUSDC = useUSDCValue(lpFee);
  var totalAmountInUSDC = useUSDCValue(totalAmountIn);
  var swapInfo = useMemo(function () {
    var _ref5;

    return _ref5 = {}, _defineProperty(_ref5, Field$1.INPUT, {
      currency: activeCurrencyIn,
      amount: amountIn,
      balance: balanceIn,
      usdc: inputUSDC,
      mappedCurrency: mappedInputCurrency,
      mappedCurrencyAmount: mappedInputCurrencyAmount,
      brydgeFee: brydgeFee,
      brydgeFeeUSDC: brydgeFeeUSDC ? brydgeFeeUSDC : undefined,
      lpFee: lpFee,
      lpFeeUSDC: lpFeeUSDC ? lpFeeUSDC : undefined,
      totalAmount: totalAmountIn,
      totalAmountInUSDC: totalAmountInUSDC ? totalAmountInUSDC : outputUSDC
    }), _defineProperty(_ref5, Field$1.OUTPUT, {
      currency: currencyOut,
      amount: amountOut,
      balance: balanceOut,
      usdc: outputUSDC
    }), _defineProperty(_ref5, "trade", trade), _defineProperty(_ref5, "slippage", slippage), _defineProperty(_ref5, "impact", impact), _defineProperty(_ref5, "isSameTokenTrade", isSameTokenTrade), _ref5;
  }, [activeCurrencyIn, amountIn, amountOut, balanceIn, balanceOut, currencyOut, impact, inputUSDC, isSameTokenTrade, mappedInputCurrency, mappedInputCurrencyAmount, outputUSDC, slippage, trade, brydgeFee, brydgeFeeUSDC, lpFee, lpFeeUSDC, totalAmountIn, totalAmountInUSDC]);
  return swapInfo;
}

var DEFAULT_SWAP_INFO = (_DEFAULT_SWAP_INFO = {}, _defineProperty(_DEFAULT_SWAP_INFO, Field$1.INPUT, {}), _defineProperty(_DEFAULT_SWAP_INFO, Field$1.OUTPUT, {}), _defineProperty(_DEFAULT_SWAP_INFO, "trade", INVALID_TRADE), _defineProperty(_DEFAULT_SWAP_INFO, "slippage", {
  auto: true,
  allowed: new Percent(10, 10000)
}), _defineProperty(_DEFAULT_SWAP_INFO, "isSameTokenTrade", false), _DEFAULT_SWAP_INFO);
var SwapInfoContext = /*#__PURE__*/createContext(DEFAULT_SWAP_INFO);

function SwapInfoProvider(_ref6) {
  var children = _ref6.children,
      disabled = _ref6.disabled;
  var swapInfo = useComputeSwapInfo();

  if (disabled) {
    return /*#__PURE__*/jsx(SwapInfoContext.Provider, {
      value: DEFAULT_SWAP_INFO,
      children: children
    });
  }

  return /*#__PURE__*/jsx(SwapInfoContext.Provider, {
    value: swapInfo,
    children: children
  });
}
/** Requires that SwapInfoUpdater be installed in the DOM tree. **/


function useSwapInfo() {
  return useContext(SwapInfoContext);
}

function useSwapCurrency(field) {
  var atom = useMemo(function () {
    return pickAtom(swapAtom, field);
  }, [field]); // const otherAtom = useMemo(() => pickAtom(swapAtom, otherField(field)), [field])

  var _useAtom = useAtom(atom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      currency = _useAtom2[0],
      setCurrency = _useAtom2[1]; // const otherCurrency = useAtomValue(otherAtom)
  // const switchSwapCurrencies = useSwitchSwapCurrencies()


  var setOrSwitchCurrency = useCallback(function (currency) {
    // if (currency === otherCurrency) {
    //   switchSwapCurrencies()
    // } else {
    //   setCurrency(currency)
    // }
    setCurrency(currency);
  }, [setCurrency]);
  return [currency, setOrSwitchCurrency];
}

var independentFieldAtom = pickAtom(swapAtom, 'independentField');

function useIsSwapFieldIndependent(field) {
  var independentField = useAtomValue(independentFieldAtom);
  return independentField === field;
}

var amountAtom = pickAtom(swapAtom, 'amount'); // check if any amount has been entered by user

function useIsAmountPopulated() {
  return Boolean(useAtomValue(amountAtom));
}

function useSwapAmount(field) {
  var amount = useAtomValue(amountAtom);
  var isFieldIndependent = useIsSwapFieldIndependent(field);
  var value = isFieldIndependent ? amount : undefined;
  var updateSwap = useUpdateAtom(swapAtom);
  var updateAmount = useCallback(function (amount) {
    return updateSwap(function (swap) {
      swap.independentField = field;
      swap.amount = amount;
    });
  }, [field, updateSwap]);
  return [value, updateAmount];
}

function useSwapCurrencyAmount(field) {
  var isFieldIndependent = useIsSwapFieldIndependent(field);
  var isAmountPopulated = useIsAmountPopulated();

  var _useSwapAmount = useSwapAmount(field),
      _useSwapAmount2 = _slicedToArray(_useSwapAmount, 1),
      swapAmount = _useSwapAmount2[0];

  var _useSwapCurrency = useSwapCurrency(field),
      _useSwapCurrency2 = _slicedToArray(_useSwapCurrency, 1),
      swapCurrency = _useSwapCurrency2[0];

  var currencyAmount = useMemo(function () {
    return tryParseCurrencyAmount(swapAmount, swapCurrency);
  }, [swapAmount, swapCurrency]);

  if (isFieldIndependent && isAmountPopulated) {
    return currencyAmount;
  }

  return;
}

function useSwapChainId() {
  var _swapCurrency$chainId;

  var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Field$1.OUTPUT;

  var _useSwapCurrency3 = useSwapCurrency(field),
      _useSwapCurrency4 = _slicedToArray(_useSwapCurrency3, 1),
      swapCurrency = _useSwapCurrency4[0];

  return (_swapCurrency$chainId = swapCurrency === null || swapCurrency === void 0 ? void 0 : swapCurrency.chainId) !== null && _swapCurrency$chainId !== void 0 ? _swapCurrency$chainId : SupportedChainId.POLYGON;
}

var Field;

(function (Field) {
  Field["INPUT"] = "INPUT";
  Field["OUTPUT"] = "OUTPUT";
})(Field || (Field = {}));

var EMPTY_CONNECTOR = initializeConnector(function () {
  return EMPTY;
});
var EMPTY_CONTEXT = {
  connector: EMPTY
};
var jsonRpcConnectorAtom = atom(EMPTY_CONNECTOR);
var Web3Context = /*#__PURE__*/createContext(EMPTY_CONTEXT);

function useJsonRPCWeb3React() {
  return useContext(Web3Context);
}

function useConnector(connectorAtom, Connector, initializer) {
  var _useAtom = useAtom(connectorAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      connector = _useAtom2[0],
      setConnector = _useAtom2[1];

  useEffect(function () {
    if (initializer) {
      var _initializeConnector = initializeConnector(function (actions) {
        return new Connector(actions, initializer);
      }),
          _initializeConnector2 = _slicedToArray(_initializeConnector, 3),
          _connector = _initializeConnector2[0],
          hooks = _initializeConnector2[1],
          store = _initializeConnector2[2];

      _connector.activate();

      setConnector([_connector, hooks, store]);
    } else {
      setConnector(EMPTY_CONNECTOR);
    }
  }, [Connector, initializer, setConnector]);
  return connector;
}

function JsonRPCWeb3ReactProvider(_ref) {
  var jsonRpcEndpoints = _ref.jsonRpcEndpoints,
      children = _ref.children;
  var destinationChainId = useSwapChainId(Field.OUTPUT);
  var jsonRpcEndpoint = jsonRpcEndpoints[destinationChainId];

  if (!jsonRpcEndpoint) {
    throw new Error('No JSON-RPC endpoint found for chainId: ' + destinationChainId);
  }

  var JsonRpc = useMemo(function () {
    if (JsonRpcProvider.isProvider(jsonRpcEndpoint)) return JsonRpcConnector;
    return Url;
  }, [jsonRpcEndpoint]);
  var jsonRpcConnector = useConnector(jsonRpcConnectorAtom, JsonRpc, jsonRpcEndpoint);

  var _ref2 = jsonRpcConnector !== null && jsonRpcConnector !== void 0 ? jsonRpcConnector : EMPTY_CONNECTOR,
      _ref3 = _slicedToArray(_ref2, 2),
      connector = _ref3[0],
      hooks = _ref3[1];

  var library = hooks.useProvider(); // const accounts = hooks.useAccounts()
  // const account = hooks.useAccount()

  var activating = hooks.useIsActivating();
  var active = hooks.useIsActive();
  var chainId = hooks.useChainId(); // const ensNames = hooks.useENSNames()
  // const ensName = hooks.useENSName()

  var error = hooks.useError();
  var web3 = useMemo(function () {
    if (connector === EMPTY || !(active || activating)) {
      return EMPTY_CONTEXT;
    }

    return {
      connector: connector,
      library: library,
      chainId: chainId,
      // accounts,
      // account,
      active: active,
      activating: activating,
      error: error // ensNames,
      // ensName,

    };
  }, [// account, accounts,
  activating, active, chainId, connector, // ensName, ensNames,
  error, library]); // Log web3 errors to facilitate debugging.

  useEffect(function () {
    if (error) {
      console.error('jsonWeb3 (not active) error:', error);
    }
  }, [error]);
  return /*#__PURE__*/jsx(Web3Context.Provider, {
    value: web3,
    children: children
  });
}

var i$1 = function i(e) {
  return "string" == typeof e;
},
    s$1 = function s(e) {
  return "function" == typeof e;
},
    u$1 = new Map(),
    c$1 = new Map();

function f$1(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
  return function (r) {
    if (i$1(r) && (r = new Date(r)), n) {
      var a = v$1(e, t),
          o = c$1.get(a);
      if (o) return o.format(r);
      var l = new Intl.DateTimeFormat(e, t);
      return c$1.set(a, l), l.format(r);
    }

    var s = new Intl.DateTimeFormat(e, t);
    return s.format(r);
  };
}

function h(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
  return function (r) {
    if (n) {
      var a = v$1(e, t),
          o = u$1.get(a);
      if (o) return o.format(r);
      var l = new Intl.NumberFormat(e, t);
      return u$1.set(a, l), l.format(r);
    }

    var i = new Intl.NumberFormat(e, t);
    return i.format(r);
  };
}

function v$1(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = Array.isArray(e) ? e.sort().join("-") : e;
  return "".concat(n, "-").concat(JSON.stringify(t));
}

var m$1 = Object.freeze({
  __proto__: null,
  date: f$1,
  number: h
}),
    g = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;

function _$1(e) {
  var t = e.locale,
      n = e.locales,
      r = e.values,
      a = e.formats,
      o = e.localeData,
      u = function (e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
      plurals: void 0
    },
        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    t = t || e;

    var a = n.plurals,
        o = function o(e) {
      return i$1(e) ? r[e] || {
        style: e
      } : e;
    },
        u = function u(e, n) {
      return function (r) {
        var a = s$1(n) ? n(r) : n,
            o = Array.isArray(a) ? a : [a],
            l = h(t)(e);
        return o.map(function (e) {
          return i$1(e) ? e.replace("#", l) : e;
        });
      };
    };

    return a || console.error("Plurals for locale ".concat(e, " aren't loaded. Use i18n.loadLocaleData method to load plurals for specific locale. Using other plural rule as a fallback.")), {
      plural: function plural(e, t) {
        var n = t.offset,
            r = void 0 === n ? 0 : n,
            o = _objectWithoutProperties(t, ["offset"]),
            i = o[e] || o[null == a ? void 0 : a(e - r)] || o.other;

        return u(e - r, i);
      },
      selectordinal: function selectordinal(e, t) {
        var n = t.offset,
            r = void 0 === n ? 0 : n,
            o = _objectWithoutProperties(t, ["offset"]),
            i = o[e] || o[null == a ? void 0 : a(e - r, !0)] || o.other;

        return u(e - r, i);
      },
      select: function select(e, t) {
        return t[e] || t.other;
      },
      number: function number(e, n) {
        return h(t, o(n))(e);
      },
      date: function date(e, n) {
        return f$1(t, o(n))(e);
      },
      undefined: function undefined$1(e) {
        return e;
      }
    };
  }(t, n, o, a);

  return function e(t, n, a) {
    var o = r[t],
        l = u[n](o, a),
        i = s$1(l) ? l(e) : l;
    return Array.isArray(i) ? i.join("") : i;
  };
}

function d$1(e, t, n, r) {
  return function (a) {
    var l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        s = _$1({
      locale: t,
      locales: n,
      localeData: r,
      formats: l,
      values: a
    }),
        u = function e(t) {
      return Array.isArray(t) ? t.reduce(function (t, n) {
        if (i$1(n)) return t + n;

        var r = _slicedToArray(n, 3),
            a = r[0],
            l = r[1],
            u = r[2],
            c = {};

        null == u || i$1(u) ? c = u : Object.keys(u).forEach(function (t) {
          c[t] = e(u[t]);
        });
        var f = s(a, l, c);
        return null == f ? t : t + f;
      }, "") : t;
    },
        c = u(e);

    return i$1(c) && g.test(c) ? JSON.parse('"'.concat(c.trim(), '"')) : i$1(c) ? c.trim() : c;
  };
}

var p$1 = function () {
  function n() {
    _classCallCheck(this, n), this._events = {};
  }

  return _createClass(n, [{
    key: "on",
    value: function value(e, t) {
      var n = this;
      return this._hasEvent(e) || (this._events[e] = []), this._events[e].push(t), function () {
        return n.removeListener(e, t);
      };
    }
  }, {
    key: "removeListener",
    value: function value(e, t) {
      if (this._hasEvent(e)) {
        var n = this._events[e].indexOf(t);

        ~n && this._events[e].splice(n, 1);
      }
    }
  }, {
    key: "emit",
    value: function value(e) {
      for (var t = this, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) {
        r[a - 1] = arguments[a];
      }

      this._hasEvent(e) && this._events[e].map(function (e) {
        return e.apply(t, r);
      });
    }
  }, {
    key: "_hasEvent",
    value: function value(e) {
      return Array.isArray(this._events[e]);
    }
  }]), n;
}();

function y$1(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        o = _getPrototypeOf(e);

    if (t) {
      var l = _getPrototypeOf(this).constructor;

      n = Reflect.construct(o, arguments, l);
    } else n = o.apply(this, arguments);

    return _possibleConstructorReturn(this, n);
  };
}

var b = function (r) {
  _inherits(o, r);

  var a = y$1(o);

  function o(t) {
    var n;
    return _classCallCheck(this, o), n = a.call(this), n._messages = {}, n._localeData = {}, null != t.missing && (n._missing = t.missing), null != t.messages && n.load(t.messages), null != t.localeData && n.loadLocaleData(t.localeData), null == t.locale && null == t.locales || n.activate(t.locale, t.locales), n;
  }

  return _createClass(o, [{
    key: "_loadLocaleData",
    value: function value(e, t) {
      null == this._localeData[e] ? this._localeData[e] = t : Object.assign(this._localeData[e], t);
    }
  }, {
    key: "loadLocaleData",
    value: function value(e, t) {
      var n = this;
      null != t ? this._loadLocaleData(e, t) : Object.keys(e).forEach(function (t) {
        return n._loadLocaleData(t, e[t]);
      }), this.emit("change");
    }
  }, {
    key: "_load",
    value: function value(e, t) {
      null == this._messages[e] ? this._messages[e] = t : Object.assign(this._messages[e], t);
    }
  }, {
    key: "load",
    value: function value(e, t) {
      var n = this;
      null != t ? this._load(e, t) : Object.keys(e).forEach(function (t) {
        return n._load(t, e[t]);
      }), this.emit("change");
    }
  }, {
    key: "activate",
    value: function value(e, t) {
      this._locale = e, this._locales = t, this.emit("change");
    }
  }, {
    key: "_",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = n.message,
          a = n.formats,
          o = n.context;
      i$1(e) || (t = e.values || t, r = e.message, o = e.context, e = e.id);
      var l,
          u = !o && !this.messages[e],
          c = o && !this.messages[o][e],
          f = c || u,
          h = this._missing;
      return h && f ? s$1(h) ? h(this._locale, e, o) : h : (f && this.emit("missing", {
        id: e,
        context: o,
        locale: this._locale
      }), l = o && !c ? this.messages[o][e] || r || e : this.messages[e] || r || e, i$1(l) && g.test(l) ? JSON.parse('"'.concat(l, '"')) : i$1(l) ? l : d$1(l, this._locale, this._locales, this.localeData)(t, a));
    }
  }, {
    key: "date",
    value: function value(e, t) {
      return f$1(this._locales || this._locale, t)(e);
    }
  }, {
    key: "number",
    value: function value(e, t) {
      return h(this._locales || this._locale, t)(e);
    }
  }, {
    key: "locale",
    get: function get() {
      return this._locale;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._locales;
    }
  }, {
    key: "messages",
    get: function get() {
      var e;
      return null !== (e = this._messages[this._locale]) && void 0 !== e ? e : {};
    }
  }, {
    key: "localeData",
    get: function get() {
      var e;
      return null !== (e = this._localeData[this._locale]) && void 0 !== e ? e : {};
    }
  }]), o;
}(p$1);

function D() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return new b(e);
}

var k = D();
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

function peg$subclass(child, parent) {
  function ctor() {
    this.constructor = child;
  }

  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function literal(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },
    "class": function _class(expectation) {
      var escapedParts = "",
          i;

      for (i = 0; i < expectation.parts.length; i++) {
        escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
      }

      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },
    any: function any(expectation) {
      return "any character";
    },
    end: function end(expectation) {
      return "end of input";
    },
    other: function other(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function classEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i,
        j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }

      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},
      peg$startRuleFunctions = {
    start: peg$parsestart
  },
      peg$startRuleFunction = peg$parsestart,
      peg$c0 = "#",
      peg$c1 = peg$literalExpectation("#", false),
      peg$c2 = function peg$c2() {
    return inPlural[0];
  },
      peg$c3 = function peg$c3() {
    return {
      type: 'octothorpe'
    };
  },
      peg$c4 = function peg$c4(str) {
    return str.join('');
  },
      peg$c5 = "{",
      peg$c6 = peg$literalExpectation("{", false),
      peg$c7 = "}",
      peg$c8 = peg$literalExpectation("}", false),
      peg$c9 = function peg$c9(arg) {
    return {
      type: 'argument',
      arg: arg
    };
  },
      peg$c10 = ",",
      peg$c11 = peg$literalExpectation(",", false),
      peg$c12 = "select",
      peg$c13 = peg$literalExpectation("select", false),
      peg$c14 = function peg$c14(arg, m) {
    if (options.strict) {
      inPlural.unshift(false);
    }

    return m;
  },
      peg$c15 = function peg$c15(arg, cases) {
    if (options.strict) inPlural.shift();
    return {
      type: 'select',
      arg: arg,
      cases: cases
    };
  },
      peg$c16 = "plural",
      peg$c17 = peg$literalExpectation("plural", false),
      peg$c18 = "selectordinal",
      peg$c19 = peg$literalExpectation("selectordinal", false),
      peg$c20 = function peg$c20(arg, m) {
    inPlural.unshift(true);
    return m;
  },
      peg$c21 = function peg$c21(arg, type, offset, cases) {
    var ls = (type === 'selectordinal' ? options.ordinal : options.cardinal) || ['zero', 'one', 'two', 'few', 'many', 'other'];
    if (ls && ls.length) cases.forEach(function (c) {
      if (isNaN(c.key) && ls.indexOf(c.key) < 0) throw new Error('Invalid key `' + c.key + '` for argument `' + arg + '`.' + ' Valid ' + type + ' keys for this locale are `' + ls.join('`, `') + '`, and explicit keys like `=0`.');
    });
    inPlural.shift();
    return {
      type: type,
      arg: arg,
      offset: offset || 0,
      cases: cases
    };
  },
      peg$c22 = function peg$c22(arg, key, param) {
    return {
      type: 'function',
      arg: arg,
      key: key,
      param: param
    };
  },
      peg$c23 = peg$otherExpectation("identifier"),
      peg$c24 = /^[^\t-\r \x85\u200E\u200F\u2028\u2029!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/,
      peg$c25 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\u200E", "\u200F", "\u2028", "\u2029", ["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], true, false),
      peg$c26 = function peg$c26(key, tokens) {
    return {
      key: key,
      tokens: tokens
    };
  },
      peg$c27 = function peg$c27(tokens) {
    return tokens;
  },
      peg$c28 = peg$otherExpectation("plural offset"),
      peg$c29 = "offset",
      peg$c30 = peg$literalExpectation("offset", false),
      peg$c31 = ":",
      peg$c32 = peg$literalExpectation(":", false),
      peg$c33 = function peg$c33(d) {
    return d;
  },
      peg$c34 = "=",
      peg$c35 = peg$literalExpectation("=", false),
      peg$c36 = "number",
      peg$c37 = peg$literalExpectation("number", false),
      peg$c38 = "date",
      peg$c39 = peg$literalExpectation("date", false),
      peg$c40 = "time",
      peg$c41 = peg$literalExpectation("time", false),
      peg$c42 = "spellout",
      peg$c43 = peg$literalExpectation("spellout", false),
      peg$c44 = "ordinal",
      peg$c45 = peg$literalExpectation("ordinal", false),
      peg$c46 = "duration",
      peg$c47 = peg$literalExpectation("duration", false),
      peg$c48 = function peg$c48(key) {
    if (options.strict || /^\d/.test(key)) return false;

    switch (key.toLowerCase()) {
      case 'select':
      case 'plural':
      case 'selectordinal':
        return false;

      default:
        return true;
    }
  },
      peg$c49 = function peg$c49(key) {
    return key;
  },
      peg$c50 = function peg$c50(tokens) {
    return !options.strict;
  },
      peg$c51 = function peg$c51(tokens) {
    return {
      tokens: tokens
    };
  },
      peg$c52 = function peg$c52(parts) {
    return {
      tokens: [parts.join('')]
    };
  },
      peg$c53 = peg$otherExpectation("a valid (strict) function parameter"),
      peg$c54 = /^[^'{}]/,
      peg$c55 = peg$classExpectation(["'", "{", "}"], true, false),
      peg$c56 = function peg$c56(p) {
    return p.join('');
  },
      peg$c57 = "'",
      peg$c58 = peg$literalExpectation("'", false),
      peg$c59 = function peg$c59(quoted) {
    return quoted;
  },
      peg$c60 = function peg$c60(p) {
    return '{' + p.join('') + '}';
  },
      peg$c61 = peg$otherExpectation("doubled apostrophe"),
      peg$c62 = "''",
      peg$c63 = peg$literalExpectation("''", false),
      peg$c64 = function peg$c64() {
    return "'";
  },
      peg$c65 = /^[^']/,
      peg$c66 = peg$classExpectation(["'"], true, false),
      peg$c67 = "'{",
      peg$c68 = peg$literalExpectation("'{", false),
      peg$c69 = function peg$c69(str) {
    return "{" + str.join('');
  },
      peg$c70 = "'}",
      peg$c71 = peg$literalExpectation("'}", false),
      peg$c72 = function peg$c72(str) {
    return "}" + str.join('');
  },
      peg$c73 = peg$otherExpectation("escaped string"),
      peg$c74 = "'#",
      peg$c75 = peg$literalExpectation("'#", false),
      peg$c76 = function peg$c76(str) {
    return "#" + str.join('');
  },
      peg$c77 = function peg$c77(quotedOcto) {
    return quotedOcto[0];
  },
      peg$c78 = peg$otherExpectation("plain char"),
      peg$c79 = /^[^{}#\0-\x08\x0E-\x1F\x7F]/,
      peg$c80 = peg$classExpectation(["{", "}", "#", ["\0", "\b"], ["\x0E", "\x1F"], "\x7F"], true, false),
      peg$c81 = function peg$c81(octo) {
    return !inPlural[0];
  },
      peg$c82 = function peg$c82(octo) {
    return octo;
  },
      peg$c83 = peg$otherExpectation("integer"),
      peg$c84 = /^[0-9]/,
      peg$c85 = peg$classExpectation([["0", "9"]], false, false),
      peg$c86 = peg$otherExpectation("white space"),
      peg$c87 = /^[\t-\r \x85\u200E\u200F\u2028\u2029]/,
      peg$c88 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\u200E", "\u200F", "\u2028", "\u2029"], false, false),
      peg$currPos = 0,
      peg$posDetailsCache = [{
    line: 1,
    column: 1
  }],
      peg$maxFailPos = 0,
      peg$maxFailExpected = [],
      peg$silentFails = 0,
      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function peg$literalExpectation(text, ignoreCase) {
    return {
      type: "literal",
      text: text,
      ignoreCase: ignoreCase
    };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: "class",
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }

  function peg$endExpectation() {
    return {
      type: "end"
    };
  }

  function peg$otherExpectation(description) {
    return {
      type: "other",
      description: description
    };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos],
        p;

    if (details) {
      return details;
    } else {
      p = pos - 1;

      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
  }

  function peg$parsestart() {
    var s0, s1;
    s0 = [];
    s1 = peg$parsetoken();

    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parsetoken();
    }

    return s0;
  }

  function peg$parsetoken() {
    var s0, s1, s2;
    s0 = peg$parseargument();

    if (s0 === peg$FAILED) {
      s0 = peg$parseselect();

      if (s0 === peg$FAILED) {
        s0 = peg$parseplural();

        if (s0 === peg$FAILED) {
          s0 = peg$parsefunction();

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;

            if (input.charCodeAt(peg$currPos) === 35) {
              s1 = peg$c0;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c1);
              }
            }

            if (s1 !== peg$FAILED) {
              s2 = peg$c2();

              if (s2) {
                s2 = void 0;
              } else {
                s2 = peg$FAILED;
              }

              if (s2 !== peg$FAILED) {
                s1 = peg$c3();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }

            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = [];
              s2 = peg$parsechar();

              if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                  s1.push(s2);
                  s2 = peg$parsechar();
                }
              } else {
                s1 = peg$FAILED;
              }

              if (s1 !== peg$FAILED) {
                s1 = peg$c4(s1);
              }

              s0 = s1;
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseargument() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c6);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c7;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c8);
              }
            }

            if (s5 !== peg$FAILED) {
              s1 = peg$c9(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseselect() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c6);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c10;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c11);
              }
            }

            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;

                if (input.substr(peg$currPos, 6) === peg$c12) {
                  s8 = peg$c12;
                  peg$currPos += 6;
                } else {
                  s8 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c13);
                  }
                }

                if (s8 !== peg$FAILED) {
                  s8 = peg$c14(s3, s8);
                }

                s7 = s8;

                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();

                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c10;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c11);
                      }
                    }

                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();

                      if (s10 !== peg$FAILED) {
                        s11 = [];
                        s12 = peg$parseselectCase();

                        if (s12 !== peg$FAILED) {
                          while (s12 !== peg$FAILED) {
                            s11.push(s12);
                            s12 = peg$parseselectCase();
                          }
                        } else {
                          s11 = peg$FAILED;
                        }

                        if (s11 !== peg$FAILED) {
                          s12 = peg$parse_();

                          if (s12 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 125) {
                              s13 = peg$c7;
                              peg$currPos++;
                            } else {
                              s13 = peg$FAILED;

                              if (peg$silentFails === 0) {
                                peg$fail(peg$c8);
                              }
                            }

                            if (s13 !== peg$FAILED) {
                              s1 = peg$c15(s3, s11);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseplural() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c6);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c10;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c11);
              }
            }

            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;

                if (input.substr(peg$currPos, 6) === peg$c16) {
                  s8 = peg$c16;
                  peg$currPos += 6;
                } else {
                  s8 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c17);
                  }
                }

                if (s8 === peg$FAILED) {
                  if (input.substr(peg$currPos, 13) === peg$c18) {
                    s8 = peg$c18;
                    peg$currPos += 13;
                  } else {
                    s8 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c19);
                    }
                  }
                }

                if (s8 !== peg$FAILED) {
                  s8 = peg$c20(s3, s8);
                }

                s7 = s8;

                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();

                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c10;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c11);
                      }
                    }

                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();

                      if (s10 !== peg$FAILED) {
                        s11 = peg$parseoffset();

                        if (s11 === peg$FAILED) {
                          s11 = null;
                        }

                        if (s11 !== peg$FAILED) {
                          s12 = [];
                          s13 = peg$parsepluralCase();

                          if (s13 !== peg$FAILED) {
                            while (s13 !== peg$FAILED) {
                              s12.push(s13);
                              s13 = peg$parsepluralCase();
                            }
                          } else {
                            s12 = peg$FAILED;
                          }

                          if (s12 !== peg$FAILED) {
                            s13 = peg$parse_();

                            if (s13 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 125) {
                                s14 = peg$c7;
                                peg$currPos++;
                              } else {
                                s14 = peg$FAILED;

                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c8);
                                }
                              }

                              if (s14 !== peg$FAILED) {
                                s1 = peg$c21(s3, s7, s11, s12);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunction() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c6);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c10;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c11);
              }
            }

            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$parsefunctionKey();

                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();

                  if (s8 !== peg$FAILED) {
                    s9 = peg$parsefunctionParam();

                    if (s9 === peg$FAILED) {
                      s9 = null;
                    }

                    if (s9 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 125) {
                        s10 = peg$c7;
                        peg$currPos++;
                      } else {
                        s10 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c8);
                        }
                      }

                      if (s10 !== peg$FAILED) {
                        s1 = peg$c22(s3, s7, s9);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseid() {
    var s0, s1, s2;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = [];

    if (peg$c24.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c25);
      }
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c24.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c25);
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c23);
      }
    }

    return s0;
  }

  function peg$parseselectCase() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parse_();

    if (s1 !== peg$FAILED) {
      s2 = peg$parseid();

      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();

          if (s4 !== peg$FAILED) {
            s1 = peg$c26(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralCase() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parse_();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsepluralKey();

      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();

          if (s4 !== peg$FAILED) {
            s1 = peg$c26(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsecaseTokens() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c6);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse_();

      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;
        peg$silentFails++;

        if (input.charCodeAt(peg$currPos) === 123) {
          s5 = peg$c5;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c6);
          }
        }

        peg$silentFails--;

        if (s5 !== peg$FAILED) {
          peg$currPos = s4;
          s4 = void 0;
        } else {
          s4 = peg$FAILED;
        }

        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parsetoken();

        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsetoken();
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c7;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c8);
              }
            }

            if (s5 !== peg$FAILED) {
              s1 = peg$c27(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseoffset() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$parse_();

    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c29) {
        s2 = peg$c29;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c30);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();

        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 58) {
            s4 = peg$c31;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c32);
            }
          }

          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();

            if (s5 !== peg$FAILED) {
              s6 = peg$parsedigits();

              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();

                if (s7 !== peg$FAILED) {
                  s1 = peg$c33(s6);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c28);
      }
    }

    return s0;
  }

  function peg$parsepluralKey() {
    var s0, s1, s2;
    s0 = peg$parseid();

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 61) {
        s1 = peg$c34;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c35);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parsedigits();

        if (s2 !== peg$FAILED) {
          s1 = peg$c33(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionKey() {
    var s0, s1, s2, s3, s4, s5;

    if (input.substr(peg$currPos, 6) === peg$c36) {
      s0 = peg$c36;
      peg$currPos += 6;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c37);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c38) {
        s0 = peg$c38;
        peg$currPos += 4;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c39);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c40) {
          s0 = peg$c40;
          peg$currPos += 4;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c41);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 8) === peg$c42) {
            s0 = peg$c42;
            peg$currPos += 8;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c43);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 7) === peg$c44) {
              s0 = peg$c44;
              peg$currPos += 7;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c45);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 8) === peg$c46) {
                s0 = peg$c46;
                peg$currPos += 8;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c47);
                }
              }

              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$currPos;
                peg$silentFails++;

                if (input.substr(peg$currPos, 6) === peg$c12) {
                  s2 = peg$c12;
                  peg$currPos += 6;
                } else {
                  s2 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c13);
                  }
                }

                peg$silentFails--;

                if (s2 === peg$FAILED) {
                  s1 = void 0;
                } else {
                  peg$currPos = s1;
                  s1 = peg$FAILED;
                }

                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  peg$silentFails++;

                  if (input.substr(peg$currPos, 6) === peg$c16) {
                    s3 = peg$c16;
                    peg$currPos += 6;
                  } else {
                    s3 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c17);
                    }
                  }

                  peg$silentFails--;

                  if (s3 === peg$FAILED) {
                    s2 = void 0;
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }

                  if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    peg$silentFails++;

                    if (input.substr(peg$currPos, 13) === peg$c18) {
                      s4 = peg$c18;
                      peg$currPos += 13;
                    } else {
                      s4 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c19);
                      }
                    }

                    peg$silentFails--;

                    if (s4 === peg$FAILED) {
                      s3 = void 0;
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }

                    if (s3 !== peg$FAILED) {
                      s4 = peg$parseid();

                      if (s4 !== peg$FAILED) {
                        s5 = peg$c48(s4);

                        if (s5) {
                          s5 = void 0;
                        } else {
                          s5 = peg$FAILED;
                        }

                        if (s5 !== peg$FAILED) {
                          s1 = peg$c49(s4);
                          s0 = s1;
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parsefunctionParam() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;
    s1 = peg$parse_();

    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c10;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c11);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parsetoken();

        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsetoken();
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$c50();

          if (s4) {
            s4 = void 0;
          } else {
            s4 = peg$FAILED;
          }

          if (s4 !== peg$FAILED) {
            s1 = peg$c51(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 44) {
          s2 = peg$c10;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c11);
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parsestrictFunctionParamPart();

          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$parsestrictFunctionParamPart();
          }

          if (s3 !== peg$FAILED) {
            s1 = peg$c52(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsestrictFunctionParamPart() {
    var s0, s1, s2, s3;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = [];

    if (peg$c54.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c55);
      }
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c54.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c55);
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c56(s1);
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$parsedoubleapos();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 39) {
          s1 = peg$c57;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c58);
          }
        }

        if (s1 !== peg$FAILED) {
          s2 = peg$parseinapos();

          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 39) {
              s3 = peg$c57;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c58);
              }
            }

            if (s3 !== peg$FAILED) {
              s1 = peg$c59(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;

          if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c5;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c6);
            }
          }

          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsestrictFunctionParamPart();

            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsestrictFunctionParamPart();
            }

            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 125) {
                s3 = peg$c7;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c8);
                }
              }

              if (s3 !== peg$FAILED) {
                s1 = peg$c60(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c53);
      }
    }

    return s0;
  }

  function peg$parsedoubleapos() {
    var s0, s1;
    peg$silentFails++;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c62) {
      s1 = peg$c62;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c63);
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c64();
    }

    s0 = s1;
    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c61);
      }
    }

    return s0;
  }

  function peg$parseinapos() {
    var s0, s1, s2;
    s0 = peg$parsedoubleapos();

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];

      if (peg$c65.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c66);
        }
      }

      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);

          if (peg$c65.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c66);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        s1 = peg$c4(s1);
      }

      s0 = s1;
    }

    return s0;
  }

  function peg$parsequotedCurly() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c67) {
      s1 = peg$c67;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c68);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseinapos();

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseinapos();
      }

      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s3 = peg$c57;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c58);
          }
        }

        if (s3 !== peg$FAILED) {
          s1 = peg$c69(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c70) {
        s1 = peg$c70;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c71);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseinapos();

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseinapos();
        }

        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s3 = peg$c57;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }

          if (s3 !== peg$FAILED) {
            s1 = peg$c72(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsequoted() {
    var s0, s1, s2, s3, s4, s5;
    peg$silentFails++;
    s0 = peg$parsequotedCurly();

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      s2 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c74) {
        s3 = peg$c74;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c75);
        }
      }

      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$parseinapos();

        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseinapos();
        }

        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s5 = peg$c57;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }

          if (s5 !== peg$FAILED) {
            s3 = peg$c76(s4);
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$c2();

        if (s3) {
          s3 = void 0;
        } else {
          s3 = peg$FAILED;
        }

        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        s1 = peg$c77(s1);
      }

      s0 = s1;

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s0 = peg$c57;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c58);
          }
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c73);
      }
    }

    return s0;
  }

  function peg$parseplainChar() {
    var s0;
    peg$silentFails++;

    if (peg$c79.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c80);
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      if (peg$silentFails === 0) {
        peg$fail(peg$c78);
      }
    }

    return s0;
  }

  function peg$parsechar() {
    var s0, s1, s2;
    s0 = peg$parsedoubleapos();

    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 35) {
          s1 = peg$c0;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c1);
          }
        }

        if (s1 !== peg$FAILED) {
          s2 = peg$c81();

          if (s2) {
            s2 = void 0;
          } else {
            s2 = peg$FAILED;
          }

          if (s2 !== peg$FAILED) {
            s1 = peg$c82(s1);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }

        if (s0 === peg$FAILED) {
          s0 = peg$parseplainChar();
        }
      }
    }

    return s0;
  }

  function peg$parsedigits() {
    var s0, s1, s2;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = [];

    if (peg$c84.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c85);
      }
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c84.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c85);
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c83);
      }
    }

    return s0;
  }

  function peg$parse_() {
    var s0, s1, s2;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = [];

    if (peg$c87.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c88);
      }
    }

    while (s2 !== peg$FAILED) {
      s1.push(s2);

      if (peg$c87.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c88);
        }
      }
    }

    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c86);
      }
    }

    return s0;
  }

  var inPlural = [false];
  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
  }
}

var parser = {
  SyntaxError: peg$SyntaxError,
  parse: peg$parse
};

var isString = function isString(s) {
  return typeof s === "string";
};

var isFunction = function isFunction(f) {
  return typeof f === "function";
};
/** Memoized cache */


var numberFormats = new Map();
var dateFormats = new Map();

function date(locales) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var memoize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (value) {
    if (isString(value)) value = new Date(value);

    if (memoize) {
      var key = cacheKey(locales, format);
      var cachedFormatter = dateFormats.get(key);

      if (cachedFormatter) {
        return cachedFormatter.format(value);
      }

      var _formatter = new Intl.DateTimeFormat(locales, format);

      dateFormats.set(key, _formatter);
      return _formatter.format(value);
    }

    var formatter = new Intl.DateTimeFormat(locales, format);
    return formatter.format(value);
  };
}

function number(locales) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var memoize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (value) {
    if (memoize) {
      var key = cacheKey(locales, format);
      var cachedFormatter = numberFormats.get(key);

      if (cachedFormatter) {
        return cachedFormatter.format(value);
      }

      var _formatter2 = new Intl.NumberFormat(locales, format);

      numberFormats.set(key, _formatter2);
      return _formatter2.format(value);
    }

    var formatter = new Intl.NumberFormat(locales, format);
    return formatter.format(value);
  };
}
/** Memoize helpers */


function cacheKey(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localeKey = Array.isArray(locales) ? locales.sort().join('-') : locales;
  return "".concat(localeKey, "-").concat(JSON.stringify(options));
}

var formats = /*#__PURE__*/Object.freeze({
  __proto__: null,
  date: date,
  number: number
});
var UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;

var defaultFormats = function defaultFormats(locale, locales) {
  var localeData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    plurals: undefined
  };
  var formats = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  locales = locales || locale;
  var plurals = localeData.plurals;

  var style = function style(format) {
    return isString(format) ? formats[format] || {
      style: format
    } : format;
  };

  var replaceOctothorpe = function replaceOctothorpe(value, message) {
    return function (ctx) {
      var msg = isFunction(message) ? message(ctx) : message;
      var norm = Array.isArray(msg) ? msg : [msg];
      var valueStr = number(locales)(value);
      return norm.map(function (m) {
        return isString(m) ? m.replace("#", valueStr) : m;
      });
    };
  };

  if (!plurals) {
    console.error("Plurals for locale ".concat(locale, " aren't loaded. Use i18n.loadLocaleData method to load plurals for specific locale. Using other plural rule as a fallback."));
  }

  return {
    plural: function plural(value, _ref) {
      var _ref$offset = _ref.offset,
          offset = _ref$offset === void 0 ? 0 : _ref$offset,
          rules = _objectWithoutProperties(_ref, ["offset"]);

      var message = rules[value] || rules[plurals === null || plurals === void 0 ? void 0 : plurals(value - offset)] || rules.other;
      return replaceOctothorpe(value - offset, message);
    },
    selectordinal: function selectordinal(value, _ref2) {
      var _ref2$offset = _ref2.offset,
          offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
          rules = _objectWithoutProperties(_ref2, ["offset"]);

      var message = rules[value] || rules[plurals === null || plurals === void 0 ? void 0 : plurals(value - offset, true)] || rules.other;
      return replaceOctothorpe(value - offset, message);
    },
    select: function select(value, rules) {
      return rules[value] || rules.other;
    },
    number: function number$1(value, format) {
      return number(locales, style(format))(value);
    },
    date: function date$1(value, format) {
      return date(locales, style(format))(value);
    },
    undefined: function undefined$1(value) {
      return value;
    }
  };
}; // Params -> CTX

/**
 * Creates a context object, which formats ICU MessageFormat arguments based on
 * argument type.
 *
 * @param locale     - Locale of message
 * @param locales      - Locales to be used when formatting the numbers or dates
 * @param values       - Parameters for variable interpolation
 * @param localeData - Locale data (e.g: plurals)
 * @param formats - Custom format styles
 * @returns {function(string, string, any)}
 */


function context(_ref3) {
  var locale = _ref3.locale,
      locales = _ref3.locales,
      values = _ref3.values,
      formats = _ref3.formats,
      localeData = _ref3.localeData;
  var formatters = defaultFormats(locale, locales, localeData, formats);

  var ctx = function ctx(name, type, format) {
    var value = values[name];
    var formatted = formatters[type](value, format);
    var message = isFunction(formatted) ? formatted(ctx) : formatted;
    return Array.isArray(message) ? message.join("") : message;
  };

  return ctx;
}

function interpolate(translation, locale, locales, localeData) {
  return function (values) {
    var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ctx = context({
      locale: locale,
      locales: locales,
      localeData: localeData,
      formats: formats,
      values: values
    });

    var formatMessage = function formatMessage(message) {
      if (!Array.isArray(message)) return message;
      return message.reduce(function (message, token) {
        if (isString(token)) return message + token;

        var _token = _slicedToArray(token, 3),
            name = _token[0],
            type = _token[1],
            format = _token[2];

        var interpolatedFormat = {};

        if (format != null && !isString(format)) {
          Object.keys(format).forEach(function (key) {
            interpolatedFormat[key] = formatMessage(format[key]);
          });
        } else {
          interpolatedFormat = format;
        }

        var value = ctx(name, type, interpolatedFormat);
        if (value == null) return message;
        return message + value;
      }, "");
    };

    var result = formatMessage(translation);
    if (isString(result) && UNICODE_REGEX.test(result)) return JSON.parse("\"".concat(result.trim(), "\""));
    if (isString(result)) return result.trim();
    return result;
  };
}

function ownKeys$h(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$h(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$h(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$h(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function processTokens(tokens) {
  if (!tokens.filter(function (token) {
    return !isString(token);
  }).length) {
    return tokens.join("");
  }

  return tokens.map(function (token) {
    if (isString(token)) {
      return token; // # in plural case
    } else if (token.type === "octothorpe") {
      return "#"; // simple argument
    } else if (token.type === "argument") {
      return [token.arg]; // argument with custom format (date, number)
    } else if (token.type === "function") {
      var _param = token.param && token.param.tokens[0];

      var param = typeof _param === "string" ? _param.trim() : _param;
      return [token.arg, token.key, param].filter(Boolean);
    }

    var offset = token.offset ? parseInt(token.offset) : undefined; // complex argument with cases

    var formatProps = {};
    token.cases.forEach(function (item) {
      formatProps[item.key] = processTokens(item.tokens);
    });
    return [token.arg, token.type, _objectSpread$h({
      offset: offset
    }, formatProps)];
  });
} // Message -> (Params -> String)


function compile(message) {
  try {
    return processTokens(parser.parse(message));
  } catch (e) {
    console.error("Message cannot be parsed due to syntax errors: ".concat(message));
    return message;
  }
}

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this._events = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, listener) {
      var _this = this;

      if (!this._hasEvent(event)) this._events[event] = [];

      this._events[event].push(listener);

      return function () {
        return _this.removeListener(event, listener);
      };
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      if (!this._hasEvent(event)) return;

      var index = this._events[event].indexOf(listener);

      if (~index) this._events[event].splice(index, 1);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!this._hasEvent(event)) return;

      this._events[event].map(function (listener) {
        return listener.apply(_this2, args);
      });
    }
  }, {
    key: "_hasEvent",
    value: function _hasEvent(event) {
      return Array.isArray(this._events[event]);
    }
  }]);

  return EventEmitter;
}();

function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$7() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var I18n = /*#__PURE__*/function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  var _super = _createSuper$7(I18n);

  function I18n(params) {
    var _this;

    _classCallCheck(this, I18n);

    _this = _super.call(this);
    _this._messages = {};
    _this._localeData = {};
    if (params.missing != null) _this._missing = params.missing;
    if (params.messages != null) _this.load(params.messages);
    if (params.localeData != null) _this.loadLocaleData(params.localeData);

    if (params.locale != null || params.locales != null) {
      _this.activate(params.locale, params.locales);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "_loadLocaleData",
    value: function _loadLocaleData(locale, localeData) {
      if (this._localeData[locale] == null) {
        this._localeData[locale] = localeData;
      } else {
        Object.assign(this._localeData[locale], localeData);
      }
    }
  }, {
    key: "loadLocaleData",
    value: function loadLocaleData(localeOrAllData, localeData) {
      var _this2 = this;

      if (localeData != null) {
        // loadLocaleData('en', enLocaleData)
        // Loading locale data for a single locale.
        this._loadLocaleData(localeOrAllData, localeData);
      } else {
        // loadLocaleData(allLocaleData)
        // Loading all locale data at once.
        Object.keys(localeOrAllData).forEach(function (locale) {
          return _this2._loadLocaleData(locale, localeOrAllData[locale]);
        });
      }

      this.emit("change");
    }
  }, {
    key: "_load",
    value: function _load(locale, messages) {
      if (this._messages[locale] == null) {
        this._messages[locale] = messages;
      } else {
        Object.assign(this._messages[locale], messages);
      }
    }
  }, {
    key: "load",
    value: function load(localeOrMessages, messages) {
      var _this3 = this;

      if (messages != null) {
        // load('en', catalog)
        // Loading a catalog for a single locale.
        this._load(localeOrMessages, messages);
      } else {
        // load(catalogs)
        // Loading several locales at once.
        Object.keys(localeOrMessages).forEach(function (locale) {
          return _this3._load(locale, localeOrMessages[locale]);
        });
      }

      this.emit("change");
    }
  }, {
    key: "activate",
    value: function activate(locale, locales) {
      {
        if (!this._messages[locale]) {
          console.warn("Messages for locale \"".concat(locale, "\" not loaded."));
        }

        if (!this._localeData[locale]) {
          console.warn("Locale data for locale \"".concat(locale, "\" not loaded. Plurals won't work correctly."));
        }
      }
      this._locale = locale;
      this._locales = locales;
      this.emit("change");
    } // method for translation and formatting

  }, {
    key: "_",
    value: function _(id) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          message = _ref.message,
          formats = _ref.formats,
          context = _ref.context;

      if (!isString(id)) {
        values = id.values || values;
        message = id.message;
        context = id.context;
        id = id.id;
      }

      var messageMissing = !context && !this.messages[id];
      var contextualMessageMissing = context && !this.messages[context][id];
      var messageUnreachable = contextualMessageMissing || messageMissing; // replace missing messages with custom message for debugging

      var missing = this._missing;

      if (missing && messageUnreachable) {
        return isFunction(missing) ? missing(this._locale, id, context) : missing;
      }

      if (messageUnreachable) {
        this.emit("missing", {
          id: id,
          context: context,
          locale: this._locale
        });
      }

      var translation;

      if (context && !contextualMessageMissing) {
        // context is like a subdirectory of other keys
        translation = this.messages[context][id] || message || id;
      } else {
        translation = this.messages[id] || message || id;
      }

      {
        translation = isString(translation) ? compile(translation) : translation;
      } // hack for parsing unicode values inside a string to get parsed in react native environments

      if (isString(translation) && UNICODE_REGEX.test(translation)) return JSON.parse("\"".concat(translation, "\""));
      if (isString(translation)) return translation;
      return interpolate(translation, this._locale, this._locales, this.localeData)(values, formats);
    }
  }, {
    key: "date",
    value: function date$1(value, format) {
      return date(this._locales || this._locale, format)(value);
    }
  }, {
    key: "number",
    value: function number$1(value, format) {
      return number(this._locales || this._locale, format)(value);
    }
  }, {
    key: "locale",
    get: function get() {
      return this._locale;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._locales;
    }
  }, {
    key: "messages",
    get: function get() {
      var _this$_messages$this$;

      return (_this$_messages$this$ = this._messages[this._locale]) !== null && _this$_messages$this$ !== void 0 ? _this$_messages$this$ : {};
    }
  }, {
    key: "localeData",
    get: function get() {
      var _this$_localeData$thi;

      return (_this$_localeData$thi = this._localeData[this._locale]) !== null && _this$_localeData$thi !== void 0 ? _this$_localeData$thi : {};
    }
  }]);

  return I18n;
}(EventEmitter);

function setupI18n() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new I18n(params);
}

var i18n$1 = setupI18n();
var i18n = process.env.NODE_ENV === 'production' ? k : i18n$1;
process.env.NODE_ENV === 'production' ? D : setupI18n;
process.env.NODE_ENV === 'production' ? m$1 : formats;
process.env.NODE_ENV === 'production' ? b : I18n;
var LinguiContext = /*#__PURE__*/React__default.createContext(null);

function useLingui$1() {
  var context = React__default.useContext(LinguiContext);
  {
    if (context == null) {
      throw new Error("useLingui hook was used without I18nProvider.");
    }
  }
  return context;
}

function withI18n(o) {
  return function (WrappedComponent) {
    return function (props) {
      {
        if (typeof o === "function" || /*#__PURE__*/React__default.isValidElement(o)) {
          throw new Error("withI18n([options]) takes options as a first argument, " + "but received React component itself. Without options, the Component " + "should be wrapped as withI18n()(Component), not withI18n(Component).");
        }
      }

      var _useLingui = useLingui$1(),
          i18n = _useLingui.i18n;

      return /*#__PURE__*/React__default.createElement(WrappedComponent, Object.assign({}, props, {
        i18n: i18n
      }));
    };
  };
}

var I18nProvider$1 = function I18nProvider(_ref) {
  var i18n = _ref.i18n,
      defaultComponent = _ref.defaultComponent,
      _ref$forceRenderOnLoc = _ref.forceRenderOnLocaleChange,
      forceRenderOnLocaleChange = _ref$forceRenderOnLoc === void 0 ? true : _ref$forceRenderOnLoc,
      children = _ref.children;
  /**
   * We can't pass `i18n` object directly through context, because even when locale
   * or messages are changed, i18n object is still the same. Context provider compares
   * reference identity and suggested workaround is create a wrapper object every time
   * we need to trigger re-render. See https://reactjs.org/docs/context.html#caveats.
   *
   * Due to this effect we also pass `defaultComponent` in the same context, instead
   * of creating a separate Provider/Consumer pair.
   *
   * We can't use useMemo hook either, because we want to recalculate value manually.
   */

  var makeContext = function makeContext() {
    return {
      i18n: i18n,
      defaultComponent: defaultComponent
    };
  };

  var getRenderKey = function getRenderKey() {
    return forceRenderOnLocaleChange ? i18n.locale || 'default' : 'default';
  };

  var _React$useState = React__default.useState(makeContext()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      context = _React$useState2[0],
      setContext = _React$useState2[1],
      _React$useState3 = React__default.useState(getRenderKey()),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      renderKey = _React$useState4[0],
      setRenderKey = _React$useState4[1];
  /**
   * Subscribe for locale/message changes
   *
   * I18n object from `@lingui/core` is the single source of truth for all i18n related
   * data (active locale, catalogs). When new messages are loaded or locale is changed
   * we need to trigger re-rendering of LinguiContext.Consumers.
   *
   * We call `setContext(makeContext())` after adding the observer in case the `change`
   * event would already have fired between the inital renderKey calculation and the
   * `useEffect` hook being called. This can happen if locales are loaded/activated
   * async.
   */


  React__default.useEffect(function () {
    var unsubscribe = i18n.on("change", function () {
      setContext(makeContext());
      setRenderKey(getRenderKey());
    });

    if (renderKey === 'default') {
      setRenderKey(getRenderKey());
    }

    if (forceRenderOnLocaleChange && renderKey === 'default') {
      console.log("I18nProvider did not render. A call to i18n.activate still needs to happen or forceRenderOnLocaleChange must be set to false.");
    }

    return function () {
      return unsubscribe();
    };
  }, []);
  if (forceRenderOnLocaleChange && renderKey === 'default') return null;
  return /*#__PURE__*/React__default.createElement(LinguiContext.Provider, {
    value: context,
    key: renderKey
  }, children);
};

function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var tagRe = /<(\d+)>(.*?)<\/\1>|<(\d+)\/>/;
var nlRe = /(?:\r\n|\r|\n)/g; // For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var voidElementTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
};
/**
 * `formatElements` - parse string and return tree of react elements
 *
 * `value` is string to be formatted with <0>Paired<0/> or <0/> (unpaired)
 * placeholders. `elements` is a array of react elements which indexes
 * correspond to element indexes in formatted string
 */

function formatElements(value) {
  var elements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var uniqueId = makeCounter(0, '$lingui$');
  var parts = value.replace(nlRe, "").split(tagRe); // no inline elements, return

  if (parts.length === 1) return value;
  var tree = [];
  var before = parts.shift();
  if (before) tree.push(before);

  var _iterator = _createForOfIteratorHelper$1(getElements(parts)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 3),
          index = _step$value[0],
          children = _step$value[1],
          after = _step$value[2];

      var element = elements[index];

      if (!element || voidElementTags[element.type] && children) {
        if (!element) {
          console.error("Can use element at index '".concat(index, "' as it is not declared in the original translation"));
        } else {
          console.error("".concat(element.type, " is a void element tag therefore it must have no children"));
        } // ignore problematic element but push its children and elements after it


        element = /*#__PURE__*/React__default.createElement(React__default.Fragment);
      }

      tree.push( /*#__PURE__*/React__default.cloneElement(element, {
        key: uniqueId()
      }, // format children for pair tags
      // unpaired tags might have children if it's a component passed as a variable
      children ? formatElements(children, elements) : element.props.children));
      if (after) tree.push(after);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return tree;
}
/*
 * `getElements` - return array of element indexes and element childrens
 *
 * `parts` is array of [pairedIndex, children, unpairedIndex, textAfter, ...]
 * where:
 * - `pairedIndex` is index of paired element (undef for unpaired)
 * - `children` are children of paired element (undef for unpaired)
 * - `unpairedIndex` is index of unpaired element (undef for paired)
 * - `textAfter` is string after all elements (empty string, if there's nothing)
 *
 * `parts` length is always multiply of 4
 *
 * Returns: Array<[elementIndex, children, after]>
 */


function getElements(parts) {
  if (!parts.length) return [];

  var _parts$slice = parts.slice(0, 4),
      _parts$slice2 = _slicedToArray(_parts$slice, 4),
      paired = _parts$slice2[0],
      children = _parts$slice2[1],
      unpaired = _parts$slice2[2],
      after = _parts$slice2[3];

  return [[parseInt(paired || unpaired), children || "", after]].concat(getElements(parts.slice(4, parts.length)));
}

var makeCounter = function makeCounter() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function () {
    return "".concat(prefix, "_").concat(count++);
  };
};

function ownKeys$g(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$g(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$g(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$g(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function Trans$1(props) {
  var _useLingui = useLingui$1(),
      i18n = _useLingui.i18n,
      defaultComponent = _useLingui.defaultComponent;

  var render = props.render,
      component = props.component,
      id = props.id,
      message = props.message,
      formats = props.formats;

  var values = _objectSpread$g({}, props.values);

  var components = _objectSpread$g({}, props.components);

  if (values) {
    /*
      Related discussion: https://github.com/lingui/js-lingui/issues/183
           Values *might* contain React elements with static content.
      They're replaced with <INDEX /> placeholders and added to `components`.
           Example:
      Translation: Hello {name}
      Values: { name: <strong>Jane</strong> }
           It'll become "Hello <0 />" with components=[<strong>Jane</strong>]
      */
    Object.keys(values).forEach(function (key) {
      var value = values[key];
      if (! /*#__PURE__*/React__default.isValidElement(value)) return;
      var index = Object.keys(components).length;
      components[index] = value;
      values[key] = "<".concat(index, "/>");
    });
  }

  var _translation = i18n && typeof i18n._ === "function" ? i18n._(id, values, {
    message: message,
    formats: formats
  }) : id; // i18n provider isn't loaded at all


  var translation = _translation ? formatElements(_translation, components) : null;

  if (render === null || component === null) {
    // Although `string` is a valid react element, types only allow `Element`
    // Upstream issue: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return translation;
  }

  var FallbackComponent = defaultComponent || React__default.Fragment; // Validation of `render` and `component` props

  if (render && component) {
    console.error("You can't use both `component` and `render` prop at the same time. `component` is ignored.");
  } else if (render && typeof render !== "function") {
    console.error("Invalid value supplied to prop `render`. It must be a function, provided ".concat(render));
  } else if (component && typeof component !== "function") {
    // Apparently, both function components and class components are functions
    // See https://stackoverflow.com/a/41658173/1535540
    console.error("Invalid value supplied to prop `component`. It must be a React component, provided ".concat(component));
    return /*#__PURE__*/React__default.createElement(FallbackComponent, null, translation);
  } // Rendering using a render prop


  if (typeof render === "function") {
    // Component: render={(props) => <a title={props.translation}>x</a>}
    return render({
      id: id,
      translation: translation,
      message: message
    });
  } // `component` prop has a higher precedence over `defaultComponent`


  var Component = component || FallbackComponent;
  return /*#__PURE__*/React__default.createElement(Component, null, translation);
}

Trans$1.defaultProps = {
  values: {},
  components: {}
};
var r = /*#__PURE__*/React__default.createContext(null);

function o() {
  var e = React__default.useContext(r);
  return e;
}

function a(e) {
  return function (e) {
    return function (t) {
      var r = o(),
          a = r.i18n;
      return /*#__PURE__*/React__default.createElement(e, Object.assign({}, t, {
        i18n: a
      }));
    };
  };
}

var i = function i(t) {
  var o = t.i18n,
      a = t.defaultComponent,
      i = t.forceRenderOnLocaleChange,
      c = void 0 === i || i,
      u = t.children,
      l = function l() {
    return {
      i18n: o,
      defaultComponent: a
    };
  },
      f = function f() {
    return c && o.locale || "default";
  },
      s = React__default.useState(l()),
      p = _slicedToArray(s, 2),
      m = p[0],
      d = p[1],
      v = React__default.useState(f()),
      y = _slicedToArray(v, 2),
      h = y[0],
      b = y[1];

  return React__default.useEffect(function () {
    var e = o.on("change", function () {
      d(l()), b(f());
    });
    return "default" === h && b(f()), c && "default" === h && console.log("I18nProvider did not render. A call to i18n.activate still needs to happen or forceRenderOnLocaleChange must be set to false."), function () {
      return e();
    };
  }, []), c && "default" === h ? null : /*#__PURE__*/React__default.createElement(r.Provider, {
    value: m,
    key: h
  }, u);
};

function c(e, n) {
  var t;

  if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
    if (Array.isArray(e) || (t = function (e, n) {
      if (!e) return;
      if ("string" == typeof e) return u(e, n);
      var t = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === t && e.constructor && (t = e.constructor.name);
      if ("Map" === t || "Set" === t) return Array.from(e);
      if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return u(e, n);
    }(e)) || n && e && "number" == typeof e.length) {
      t && (e = t);

      var r = 0,
          o = function o() {};

      return {
        s: o,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: o
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var a,
      i = !0,
      c = !1;
  return {
    s: function s() {
      t = e[Symbol.iterator]();
    },
    n: function n() {
      var e = t.next();
      return i = e.done, e;
    },
    e: function e(_e2) {
      c = !0, a = _e2;
    },
    f: function f() {
      try {
        i || null == t.return || t.return();
      } finally {
        if (c) throw a;
      }
    }
  };
}

function u(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var t = 0, r = new Array(n); t < n; t++) {
    r[t] = e[t];
  }

  return r;
}

var l = /<(\d+)>(.*?)<\/\1>|<(\d+)\/>/,
    f = /(?:\r\n|\r|\n)/g,
    s = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0,
  menuitem: !0
};

function p(n) {
  if (!n.length) return [];

  var t = n.slice(0, 4),
      r = _slicedToArray(t, 4),
      o = r[0],
      a = r[1],
      i = r[2],
      c = r[3];

  return [[parseInt(o || i), a || "", c]].concat(p(n.slice(4, n.length)));
}

var m = function m() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  return function () {
    return "".concat(n, "_").concat(e++);
  };
};

function d(e, n) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function v(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? d(Object(r), !0).forEach(function (n) {
      _defineProperty(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return e;
}

function y(t) {
  var r = o(),
      a = r.i18n,
      i = r.defaultComponent,
      u = t.render,
      d = t.component,
      y = t.id,
      h = t.message,
      b = t.formats,
      g = v({}, t.values),
      O = v({}, t.components);
  g && Object.keys(g).forEach(function (e) {
    var t = g[e];

    if ( /*#__PURE__*/React__default.isValidElement(t)) {
      var r = Object.keys(O).length;
      O[r] = t, g[e] = "<".concat(r, "/>");
    }
  });
  var j = a && "function" == typeof a._ ? a._(y, g, {
    message: h,
    formats: b
  }) : y,
      w = j ? function t(r) {
    var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        a = m(0, "$lingui$"),
        i = r.replace(f, "").split(l);
    if (1 === i.length) return r;
    var u = [],
        d = i.shift();
    d && u.push(d);
    var v,
        y = c(p(i));

    try {
      for (y.s(); !(v = y.n()).done;) {
        var h = _slicedToArray(v.value, 3),
            b = h[0],
            g = h[1],
            O = h[2],
            j = o[b];

        (!j || s[j.type] && g) && (j ? console.error("".concat(j.type, " is a void element tag therefore it must have no children")) : console.error("Can use element at index '".concat(b, "' as it is not declared in the original translation")), j = /*#__PURE__*/React__default.createElement(React__default.Fragment)), u.push( /*#__PURE__*/React__default.cloneElement(j, {
          key: a()
        }, g ? t(g, o) : j.props.children)), O && u.push(O);
      }
    } catch (e) {
      y.e(e);
    } finally {
      y.f();
    }

    return u;
  }(j, O) : null;
  if (null === u || null === d) return w;
  var E = i || React__default.Fragment;
  if (u && d) console.error("You can't use both `component` and `render` prop at the same time. `component` is ignored.");else if (u && "function" != typeof u) console.error("Invalid value supplied to prop `render`. It must be a function, provided ".concat(u));else if (d && "function" != typeof d) return console.error("Invalid value supplied to prop `component`. It must be a React component, provided ".concat(d)), /*#__PURE__*/React__default.createElement(E, null, w);
  if ("function" == typeof u) return u({
    id: y,
    translation: w,
    message: h
  });
  var P = d || E;
  return /*#__PURE__*/React__default.createElement(P, null, w);
}

y.defaultProps = {
  values: {},
  components: {}
};
var I18nProvider = process.env.NODE_ENV === "production" ? i : I18nProvider$1;
var Trans = process.env.NODE_ENV === "production" ? y : Trans$1;
var useLingui = process.env.NODE_ENV === "production" ? o : useLingui$1;
process.env.NODE_ENV === "production" ? a : withI18n;
var _plurals = {
  'af-ZA': af,
  'ar-SA': ar,
  'ca-ES': ca,
  'cs-CZ': cs,
  'da-DK': da,
  'de-DE': de,
  'el-GR': el,
  'en-US': en,
  'es-ES': es,
  'fi-FI': fi,
  'fr-FR': fr,
  'he-IL': he,
  'hu-HU': hu,
  'id-ID': id,
  'it-IT': it,
  'ja-JP': ja,
  'ko-KR': ko,
  'nl-NL': nl,
  'no-NO': no,
  'pl-PL': pl,
  'pt-BR': pt,
  'pt-PT': pt,
  'ro-RO': ro,
  'ru-RU': ru,
  'sr-SP': sr,
  'sv-SE': sv,
  'sw-TZ': sw,
  'tr-TR': tr,
  'uk-UA': uk,
  'vi-VN': vi,
  'zh-CN': zh,
  'zh-TW': zh,
  pseudo: en
};

function dynamicActivate(_x) {
  return _dynamicActivate.apply(this, arguments);
}

function _dynamicActivate() {
  _dynamicActivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var catalog;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i18n.loadLocaleData(locale, {
              plurals: function plurals() {
                return _plurals[locale];
              }
            });
            _context.prev = 1;
            _context.next = 4;
            return import("./locales".concat("/", locale, ".js"));

          case 4:
            catalog = _context.sent; // Bundlers will either export it as default or as a named export named default.

            i18n.load(locale, catalog.messages || catalog.default.messages);
            _context.next = 10;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);

          case 10:
            i18n.activate(locale);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _dynamicActivate.apply(this, arguments);
}

function Provider$1(_ref) {
  var locale = _ref.locale,
      _ref$forceRenderAfter = _ref.forceRenderAfterLocaleChange,
      forceRenderAfterLocaleChange = _ref$forceRenderAfter === void 0 ? true : _ref$forceRenderAfter,
      onActivate = _ref.onActivate,
      children = _ref.children;
  useEffect(function () {
    dynamicActivate(locale).then(function () {
      return onActivate === null || onActivate === void 0 ? void 0 : onActivate(locale);
    }).catch(function (error) {
      console.error('Failed to activate locale', locale, error);
    });
  }, [locale, onActivate]); // Initialize the locale immediately if it is DEFAULT_LOCALE, so that keys are shown while the translation messages load.
  // This renders the translation _keys_, not the translation _messages_, which is only acceptable while loading the DEFAULT_LOCALE,
  // as [there are no "default" messages](https://github.com/lingui/js-lingui/issues/388#issuecomment-497779030).
  // See https://github.com/lingui/js-lingui/issues/1194#issuecomment-1068488619.

  if (i18n.locale === undefined && locale === DEFAULT_LOCALE) {
    i18n.loadLocaleData(DEFAULT_LOCALE, {
      plurals: function plurals() {
        return _plurals[DEFAULT_LOCALE];
      }
    });
    i18n.load(DEFAULT_LOCALE, {});
    i18n.activate(DEFAULT_LOCALE);
  }

  return /*#__PURE__*/jsx(I18nProvider, {
    forceRenderOnLocaleChange: forceRenderAfterLocaleChange,
    i18n: i18n,
    children: children
  });
}

var css = css$1;
var keyframes = keyframes$1;
var useTheme = useTheme$1;
var ThemedProvider = ThemeProvider$1; // nextjs imports all of styled-components/macro instead of its default. Check for and resolve this at runtime.

var styled = _styled instanceof Function ? _styled : _styled.default;

function ownKeys$f(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$f(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var black$1 = 'hsl(0, 0%, 0%)';
var white$1 = 'hsl(0, 0%, 100%)';
var light = {
  // surface
  interactive: transparentize(1 - 0.54, black$1),
  outline: transparentize(1 - 0.24, black$1),
  // text
  primary: black$1,
  secondary: transparentize(1 - 0.64, black$1),
  onInteractive: white$1
};
var dark = {
  // surface
  interactive: transparentize(1 - 0.48, white$1),
  outline: transparentize(1 - 0.12, white$1),
  // text
  primary: white$1,
  secondary: transparentize(1 - 0.6, white$1),
  onInteractive: black$1
};

function getDynamicTheme(theme, color) {
  var colors = {
    light: light,
    dark: dark
  }[readableColor(color, 'light', 'dark', false)];
  return _objectSpread$f(_objectSpread$f(_objectSpread$f({}, theme), colors), {}, {
    module: color,
    onHover: function onHover(color) {
      return color === colors.primary ? transparentize(0.4, colors.primary) : opacify(0.25, color);
    }
  });
}

function getAccessibleColor(theme, color) {
  var dynamic = getDynamicTheme(theme, color);
  var primary = dynamic.primary;
  var AAscore = hex(color, primary);
  var contrastify = hex(color, '#000') > hex(color, '#fff') ? darken : lighten;

  while (AAscore < 3) {
    color = contrastify(0.005, color);
    primary = getDynamicTheme(theme, color).primary;
    AAscore = hex(color, primary);
  }

  return color;
}

function DynamicThemeProvider(_ref) {
  var color = _ref.color,
      children = _ref.children;
  var theme = useTheme();
  var value = useMemo(function () {
    if (!color) {
      return theme;
    }

    var accessibleColor = getAccessibleColor(theme, color);
    return getDynamicTheme(theme, accessibleColor);
  }, [theme, color]);
  return /*#__PURE__*/jsx(ThemedProvider, {
    theme: value,
    children: /*#__PURE__*/jsx("div", {
      style: {
        color: value.primary
      },
      children: children
    })
  });
}

var Layer;

(function (Layer) {
  Layer[Layer["UNDERLAYER"] = -1] = "UNDERLAYER";
  Layer[Layer["OVERLAY"] = 100] = "OVERLAY";
  Layer[Layer["DIALOG"] = 1000] = "DIALOG";
  Layer[Layer["TOOLTIP"] = 2000] = "TOOLTIP";
})(Layer || (Layer = {}));

var _templateObject$y, _templateObject2$i;

function ownKeys$e(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TextWrapper = styled(Text)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  color: ", ";\n  // Avoid the need for placeholders by setting min-height to line-height.\n  min-height: ", ";\n  // user-select is set to 'none' at the root element (Widget), but is desired for displayed data.\n  // user-select must be configured through styled-components for cross-browser compat (eg to auto-generate prefixed properties).\n  user-select: ", ";\n  white-space: ", ";\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      theme = _ref.theme;
  return theme[color];
}, function (_ref2) {
  var lineHeight = _ref2.lineHeight;
  return lineHeight;
}, function (_ref3) {
  var userSelect = _ref3.userSelect;
  return userSelect && 'text';
}, function (_ref4) {
  var noWrap = _ref4.noWrap;
  return noWrap && 'nowrap';
});
var TransitionTextWrapper = styled(TextWrapper)(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n  transition: font-size 0.25s ease-out, line-height 0.25s ease-out;\n"])));

function H2(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "headline headline-2",
    fontSize: 32,
    fontWeight: 400,
    lineHeight: "32px",
    noWrap: true
  }, props));
}

function Subhead1(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "subhead subhead-1",
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "16px",
    noWrap: true
  }, props));
}

function Subhead2(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "subhead subhead-2",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "14px",
    noWrap: true
  }, props));
}

function Body1(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "body body-1",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px"
  }, props));
}

function Body2(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "body body-2",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "20px"
  }, props));
}

function Caption$1(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "caption",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px"
  }, props));
}

function ButtonLarge(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    fontSize: 20,
    fontWeight: 500,
    lineHeight: "20px",
    noWrap: true
  }, props));
}

function ButtonMedium(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "16px",
    noWrap: true
  }, props));
}

function ButtonSmall(props) {
  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "14px",
    noWrap: true
  }, props));
}

function TransitionButton(props) {
  var fontSize = {
    small: 14,
    medium: 16,
    large: 20
  }[props.buttonSize];
  var lineHeight = "".concat(fontSize, "px");
  return /*#__PURE__*/jsx(TransitionTextWrapper, _objectSpread$e({
    fontSize: fontSize,
    fontWeight: 500,
    lineHeight: lineHeight,
    noWrap: true
  }, props));
}

function Code(props) {
  var _useTheme = useTheme(),
      fontFamilyCode = _useTheme.fontFamilyCode;

  return /*#__PURE__*/jsx(TextWrapper, _objectSpread$e({
    className: "code",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px",
    fontFamily: fontFamilyCode
  }, props));
}

function ownKeys$d(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var white = 'hsl(0, 0%, 100%)';
var black = 'hsl(0, 0%, 0%)';
var brydge = 'hsl(43, 63%, 43%)';
var brandLight = 'hsl(331.3, 100%, 50%)'; // const brandDark = 'hsl(215, 79%, 51.4%)'

var brand = brandLight;
var stateColors = {
  active: 'hsl(215, 79%, 51.4%)',
  success: 'hsl(145, 63.4%, 41.8%)',
  warning: 'hsl(43, 89.9%, 53.5%)',
  error: 'hsl(0, 98%, 62.2%)'
};

var lightTheme = _objectSpread$d(_objectSpread$d({
  // surface
  accent: brydge,
  container: 'rgb(255,255,255)',
  module: 'rgb(247, 248, 250)',
  interactive: 'hsl(224, 10%, 28%)',
  outline: brydge,
  dialog: 'rgb(247, 248, 250)',
  // text
  onAccent: white,
  primary: black,
  secondary: 'hsl(224, 8.7%, 57.1%)',
  hint: brydge,
  onInteractive: white
}, stateColors), {}, {
  currentColor: 'currentColor',
  borderColor: '#ffd360',
  bgBoardColor: 'rgb(247, 248, 250)',
  bgBoardColor2: 'rgb(247, 248, 250)',
  gradientBG: 'rgb(247, 248, 250)',
  blurSize: '3px',
  borderRadius: '1em',
  cardTransparency1: 'rgb(255,255,255)',
  cardTransparency2: 'rgb(255,255,255)',
  networkSelector: '#bdbdbd'
});

var darkTheme = _objectSpread$d(_objectSpread$d({
  // surface
  accent: brydge,
  container: '#181A1F',
  module: '#232323',
  interactive: 'hsl(224, 10%, 28%)',
  outline: 'hsl(227, 10%, 37.5%)',
  dialog: black,
  // text
  onAccent: white,
  primary: white,
  secondary: 'hsl(224, 8.7%, 57.1%)',
  hint: 'hsl(225, 10%, 47.1%)',
  onInteractive: white
}, stateColors), {}, {
  currentColor: 'currentColor',
  borderColor: '#ffd360',
  bgBoardColor: '#232323',
  bgBoardColor2: '#232323',
  blurSize: '3px',
  borderRadius: '1em',
  gradientBG: 'linear-gradient(40.7deg,#23232333,#232323,#232323)',
  cardTransparency1: 'rgba(0,0,0,0.5)',
  cardTransparency2: 'rgba(0,0,0,0.2)',
  networkSelector: '#444444'
});

var defaultTheme = _objectSpread$d(_objectSpread$d({
  fontFamily: {
    font: '"Inter", sans-serif',
    variable: '"InterVariable", sans-serif'
  },
  fontFamilyCode: 'IBM Plex Mono',
  tokenColorExtraction: false
}, lightTheme), {}, {
  borderRadius: '1'
});

var ThemeContext = /*#__PURE__*/createContext(toComputedTheme(defaultTheme));

function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var contextTheme = useContext(ThemeContext);
  var value = useMemo(function () {
    return toComputedTheme(_objectSpread$d(_objectSpread$d({}, contextTheme), theme));
  }, [contextTheme, theme]);
  return /*#__PURE__*/jsx(ThemeContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsx(ThemedProvider, {
      theme: value,
      children: children
    })
  });
}

function toComputedTheme(theme) {
  return _objectSpread$d(_objectSpread$d({}, theme), {}, {
    borderRadius: clamp(Number.isFinite(theme.borderRadius) ? theme.borderRadius : theme.borderRadius ? 1 : 0),
    onHover: function onHover(color) {
      return color === theme.primary ? transparentize(0.4, theme.primary) : mix(0.16, theme.primary, color);
    }
  });

  function clamp(value) {
    return Math.min(Math.max(value, 0), 1);
  }
}

function isAnimating(node) {
  var _node$getAnimations$l;

  return ((_node$getAnimations$l = node.getAnimations().length) !== null && _node$getAnimations$l !== void 0 ? _node$getAnimations$l : 0) > 0;
}

var UNMOUNTING = 'unmounting';
/**
 * Delays a node's unmounting until any animations on that node are finished, so that an unmounting
 * animation may be applied. If there is no animation, this is a no-op.
 *
 * CSS should target the UNMOUNTING class to determine when to apply an unmounting animation.
 */

function delayUnmountForAnimation(node) {
  var current = node.current;
  var parent = current === null || current === void 0 ? void 0 : current.parentElement;
  var removeChild = parent === null || parent === void 0 ? void 0 : parent.removeChild;

  if (parent && removeChild) {
    parent.removeChild = function (child) {
      if (child === current) {
        current.classList.add(UNMOUNTING);

        if (isAnimating(current)) {
          current.addEventListener('animationend', function () {
            removeChild.call(parent, child);
          });
        } else {
          removeChild.call(parent, child);
        }

        return child;
      } else {
        return removeChild.call(parent, child);
      }
    };
  }
}

var MissingTokenIcon = "data:image/png;base64,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";

var _defs$1, _path$3;

function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$6.apply(this, arguments);
}

var SvgAutoRouter = function SvgAutoRouter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "rotate(95)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    offset: 0,
    stopColor: "#2274E2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    offset: 0.5,
    stopColor: "#2274E2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    offset: 1,
    stopColor: "#3FB672"
  })))), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C10 16 9 10 5 10M16 16C16 17.6569 17.3431 19 19 19C20.6569 19 22 17.6569 22 16C22 14.3431 20.6569 13 19 13C17.3431 13 16 14.3431 16 16ZM5 10C9 10 10 4 16 4M5 10H1.5M16 4C16 5.65685 17.3431 7 19 7C20.6569 7 22 5.65685 22 4C22 2.34315 20.6569 1 19 1C17.3431 1 16 2.34315 16 4Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "url(#gradient)"
  })));
};

var _defs, _circle$3, _path$2, _path2$1;

function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$5.apply(this, arguments);
}

var SvgBrydgeLogoNew = function SvgBrydgeLogoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    viewBox: "6.475 60.183 301.862 297.099",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42_665",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.764706 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_309_945",
    x: 0.969635,
    y: 0.320221,
    width: 1029.75,
    height: 1079.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120.045
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_309_945"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_309_945",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_945",
    x1: 779.97,
    y1: 590.162,
    x2: 549.77,
    y2: 518.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#CE9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_309_945",
    x1: 251.715,
    y1: 590.162,
    x2: 481.915,
    y2: 518.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#CE9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42_665)",
    transform: "matrix(4.573663, 0, 0, 4.501493, -48.408611, 6.164735)",
    style: {}
  }, _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 33,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_309_945)",
    transform: "matrix(0.360286, 0, 0, 0.370488, -27.76285, 6.647435)",
    style: {}
  }, _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M653.899 317.937L678.449 240.411L761.914 376.727L790.624 539.425L776.953 553.097L790.624 555.832L735.937 620.091L735.937 643.334L752.343 655.638L730.467 695.288L707.223 723.999L667.571 700.756L649.798 713.061L647.063 749.976L603.312 816.969L558.188 839.579L558.195 491.573C587.969 491.478 606.248 497.027 627.069 513.448C662.528 502.561 671.486 486.637 685.345 442.353C692.847 377.798 684.822 351.467 653.899 317.937Z",
    fill: "url(#paint0_linear_309_945)"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M377.785 317.937L353.236 240.411L269.771 376.727L241.061 539.425L254.731 553.097L241.061 555.832L295.748 620.091L295.748 643.334L279.341 655.638L301.218 695.288L324.461 723.999L364.113 700.756L381.887 713.061L384.621 749.976L428.372 816.969L473.496 839.579L473.493 665.576L473.49 491.573C443.716 491.478 425.436 497.027 404.616 513.448C369.156 502.561 360.198 486.637 346.339 442.353C338.838 377.798 346.863 351.467 377.785 317.937Z",
    fill: "url(#paint1_linear_309_945)"
  }))));
};

var _circle$2, _path$1;

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$4.apply(this, arguments);
}

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  })), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7L8.5 12.5L6 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _polyline, _polyline2;

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

var SvgExpando = function SvgExpando(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 24 24",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "left",
    points: "18 15 12 9"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "right",
    points: "12 9 6 15"
  })));
};

var _mask$1, _circle$1, _circle2, _circle3;

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

var SvgInlineSpinner = function SvgInlineSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask$1 || (_mask$1 = /*#__PURE__*/React.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 12,
    r: 1,
    fill: "white",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 1,
    fill: "white",
    strokeWidth: 0
  }))), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "track",
    cx: 12,
    cy: 12,
    r: 10,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    mask: "url(#mask)"
  })));
};

var _mask, _circle;

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "black",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 12,
    r: 1,
    fill: "white",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 1,
    fill: "white",
    strokeWidth: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask)"
  })));
};

var _path, _path2, _path3;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V7Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H20C21.1046 19 22 18.1046 22 17V14C22 12.8954 21.1046 12 20 12H16C15.4477 12 14.9935 12.4624 14.7645 12.965C14.4438 13.6688 13.789 14.5 12 14.5C10.29 14.5 9.48213 13.7406 9.1936 13.0589C8.96576 12.5206 8.49905 12 7.91447 12H4C2.89543 12 2 12.8954 2 14V17C2 18.1046 2.89543 19 4 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13V11C22 9.89543 21.1034 9 19.9989 9C14.0294 9 9.97062 9 4.00115 9C2.89658 9 2 9.89543 2 11V13",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

var _templateObject$x, _templateObject2$h;

var loadingOpacity = 0.6;
var loadingCss = css(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  filter: grayscale(1);\n  opacity: ", ";\n"])), loadingOpacity); // need to use isLoading as `loading` is a reserved prop

var loadingTransitionCss = css(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: color 0.125s linear, opacity ", "s ease-in-out;\n"])), function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading && loadingOpacity;
}, function (_ref2) {
  var isLoading = _ref2.isLoading;
  return isLoading ? 0 : 0.25;
});

var _templateObject$w, _templateObject2$g, _templateObject3$b, _templateObject4$6, _templateObject5$2, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function ownKeys$c(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledImage = styled.img(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  height: 1em;\n  width: 1em;\n"])));

function icon(Icon) {
  return styled(Icon)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n    clip-path: stroke-box;\n    height: 1em;\n    stroke: ", ";\n    width: 1em;\n  "])), function (_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? 'currentColor' : _ref$color,
        theme = _ref.theme;
    return theme[color];
  });
}

var largeIconCss = css(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  display: flex;\n\n  svg {\n    align-self: center;\n    height: ", "em;\n    width: ", "em;\n  }\n"])), function (_ref2) {
  var iconSize = _ref2.iconSize;
  return iconSize;
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return iconSize;
});
var LargeWrapper = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  height: 1em;\n  width: ", "em;\n  ", "\n"])), function (_ref4) {
  var iconSize = _ref4.iconSize;
  return iconSize;
}, largeIconCss);

function LargeIcon(_ref5) {
  var Icon = _ref5.icon,
      color = _ref5.color,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 1.2 : _ref5$size,
      className = _ref5.className;
  return /*#__PURE__*/jsx(LargeWrapper, {
    color: color,
    iconSize: size,
    className: className,
    children: Icon && /*#__PURE__*/jsx(Icon, {
      color: color
    })
  });
}

var AlertTriangle = icon(AlertTriangle$1);
icon(ArrowDown);
var ArrowRight = icon(ArrowRight$1);
icon(ArrowUp);
icon(ArrowUpCircle);
icon(CheckCircle);
var BarChart = icon(BarChart2);
var ChevronDown = icon(ChevronDown$1);
icon(Clock);
var HelpCircle = icon(HelpCircle$1);
var Info = icon(Info$1);
var Link = icon(ExternalLink$1);
icon(SvgAutoRouter);
var Settings$1 = icon(Settings$2);
icon(Slash);
icon(Trash2);
var Wallet$1 = icon(SvgWallet);
var X = icon(X$1);
var XOctagon = icon(XOctagon$1);

var MissingToken = function MissingToken(props) {
  return /*#__PURE__*/jsx(StyledImage, _objectSpread$c({
    src: MissingTokenIcon,
    alt: "Missing token"
  }, props));
};

var Check = styled(icon(SvgCheck))(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  circle {\n    fill: ", ";\n    stroke: none;\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.active;
});
var Expando$1 = styled(icon(SvgExpando))(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  .left,\n  .right {\n    transition: transform 0.25s ease-in-out;\n    will-change: transform;\n  }\n\n  .left {\n    transform: ", ";\n  }\n\n  .right {\n    transform: ", ";\n  }\n"])), function (_ref7) {
  var open = _ref7.open;
  return open ? undefined : 'translateX(-25%)';
}, function (_ref8) {
  var open = _ref8.open;
  return open ? undefined : 'translateX(25%)';
});
var Logo$1 = styled(icon(SvgBrydgeLogoNew))(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  fill: ", ";\n  stroke: none;\n  border-radius: 100%;\n  background: ", ";\n  box-shadow: 0px 0px 5px ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.secondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.container;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderColor;
});
var rotate = keyframes(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner = styled(icon(SvgSpinner))(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  animation: 2s ", " linear infinite;\n  stroke: ", ";\n  stroke-linecap: round;\n  stroke-width: 2;\n"])), rotate, function (_ref12) {
  var _ref12$color = _ref12.color,
      color = _ref12$color === void 0 ? 'active' : _ref12$color,
      theme = _ref12.theme;
  return theme[color];
});
var InlineSpinner = styled(icon(SvgInlineSpinner))(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  animation: ", " 1s cubic-bezier(0.83, 0, 0.17, 1) infinite;\n  color: ", ";\n  fill: ", ";\n\n  #track {\n    stroke: ", ";\n    ", ";\n  }\n"])), rotate, function (_ref13) {
  var _ref13$color = _ref13.color,
      color = _ref13$color === void 0 ? 'active' : _ref13$color,
      theme = _ref13.theme;
  return theme[color];
}, function (_ref14) {
  var _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? 'active' : _ref14$color,
      theme = _ref14.theme;
  return theme[color];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.secondary;
}, loadingCss);
var _excluded$3 = ["icon", "iconProps"];

var _templateObject$v, _templateObject2$f, _templateObject3$a, _templateObject4$5;

function ownKeys$b(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var BaseButton = styled.button(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  border-radius: 0.5em;\n  color: currentColor;\n  cursor: pointer;\n  font-size: inherit;\n  font-weight: inherit;\n  height: inherit;\n  line-height: inherit;\n  margin: 0;\n  padding: 0;\n\n  :enabled {\n    transition: filter 0.125s linear;\n  }\n\n  :disabled {\n    cursor: initial;\n    filter: saturate(0) opacity(0.4);\n  }\n"])));
var transitionCss$1 = css(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  transition: background-color 0.125s linear, border-color 0.125s linear, filter 0.125s linear;\n"])));
var Button$1 = styled(BaseButton)(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  border: 1px solid transparent;\n  color: ", ";\n\n  :enabled {\n    background-color: ", ";\n    ", ";\n  }\n\n  :enabled:hover {\n    background-color: ", ";\n  }\n\n  :disabled {\n    border-color: ", ";\n    color: ", ";\n  }\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'interactive' : _ref$color,
      theme = _ref.theme;
  return color === 'interactive' && theme.onInteractive;
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'interactive' : _ref2$color,
      theme = _ref2.theme;
  return theme[color];
}, function (_ref3) {
  var _ref3$transition = _ref3.transition,
      transition = _ref3$transition === void 0 ? true : _ref3$transition;
  return transition && transitionCss$1;
}, function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? 'interactive' : _ref4$color,
      theme = _ref4.theme;
  return theme.onHover("".concat(theme[color]));
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.outline;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.secondary;
});

var transparentButton = function transparentButton(defaultColor) {
  return styled(BaseButton)(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  :enabled:hover {\n    color: ", ";\n  }\n"])), function (_ref7) {
    var _ref7$color = _ref7.color,
        color = _ref7$color === void 0 ? defaultColor : _ref7$color,
        theme = _ref7.theme;
    return theme[color];
  }, function (_ref8) {
    var _ref8$color = _ref8.color,
        color = _ref8$color === void 0 ? defaultColor : _ref8$color,
        theme = _ref8.theme;
    return theme.onHover("".concat(theme[color]));
  });
};

var TextButton = transparentButton('accent');
var SecondaryButton = transparentButton('secondary');
var IconButton = /*#__PURE__*/forwardRef(function IconButton(_ref9, ref) {
  var Icon = _ref9.icon,
      iconProps = _ref9.iconProps,
      props = _objectWithoutProperties(_ref9, _excluded$3);

  return /*#__PURE__*/jsx(SecondaryButton, _objectSpread$b(_objectSpread$b({}, props), {}, {
    ref: ref,
    children: /*#__PURE__*/jsx(Icon, _objectSpread$b({}, iconProps))
  }));
});

var _templateObject$u, _templateObject2$e, _templateObject3$9;

var Column = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  align-items: ", ";\n  color: ", ";\n  display: ", ";\n  flex-direction: column;\n  flex-grow: ", ";\n  gap: ", ";\n  grid-auto-flow: row;\n  grid-template-columns: 1fr;\n  justify-content: ", ";\n  padding: ", ";\n\n  ", "\n"])), function (_ref) {
  var align = _ref.align;
  return align !== null && align !== void 0 ? align : 'center';
}, function (_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;
  return color && theme[color];
}, function (_ref3) {
  var flex = _ref3.flex;
  return flex ? 'flex' : 'grid';
}, function (_ref4) {
  var grow = _ref4.grow;
  return grow && 1;
}, function (_ref5) {
  var gap = _ref5.gap;
  return gap && "".concat(gap, "em");
}, function (_ref6) {
  var justify = _ref6.justify;
  return justify !== null && justify !== void 0 ? justify : 'space-between';
}, function (_ref7) {
  var padded = _ref7.padded;
  return padded && '0.75em';
}, function (_ref8) {
  var css = _ref8.css;
  return css;
});
styled(Column)(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  width: 100%;\n  align-items: center;\n"])));
var AutoColumn = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: ", ";\n  justify-items: ", ";\n"])), function (_ref9) {
  var gap = _ref9.gap;
  return gap === 'sm' && '8px' || gap === 'md' && '12px' || gap === 'lg' && '24px' || gap;
}, function (_ref10) {
  var justify = _ref10.justify;
  return justify && justify;
});

var _templateObject$t;

var Row$1 = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  align-items: ", ";\n  color: ", ";\n  display: ", ";\n  flex-flow: wrap;\n  flex-grow: ", ";\n  gap: ", ";\n  grid-auto-flow: column;\n  grid-template-columns: ", ";\n  justify-content: ", ";\n  padding: ", ";\n"])), function (_ref) {
  var align = _ref.align;
  return align !== null && align !== void 0 ? align : 'center';
}, function (_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;
  return color && theme[color];
}, function (_ref3) {
  var flex = _ref3.flex;
  return flex ? 'flex' : 'grid';
}, function (_ref4) {
  var grow = _ref4.grow;
  return grow && 1;
}, function (_ref5) {
  var gap = _ref5.gap;
  return gap && "".concat(gap, "em");
}, function (_ref6) {
  var grow = _ref6.grow,
      children = _ref6.children;
  if (grow === 'first') return '1fr';
  if (grow === 'last') return "repeat(".concat(Children.count(children) - 1, ", auto) 1fr");
  if (grow) return "repeat(".concat(Children.count(children), ", 1fr)");
  return undefined;
}, function (_ref7) {
  var justify = _ref7.justify;
  return justify !== null && justify !== void 0 ? justify : 'space-between';
}, function (_ref8) {
  var pad = _ref8.pad;
  return pad && "0 ".concat(pad, "em");
});

var _templateObject$s;

var HeaderRow = styled(Row$1)(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  height: 1.75em;\n  margin: 0 0.75em 0.75em;\n  padding-top: 0.5em;\n  ", "\n"])), largeIconCss);

function Header$1(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/jsxs(HeaderRow, {
    iconSize: 1.2,
    children: [/*#__PURE__*/jsx(Row$1, {
      gap: 0.5,
      children: title && /*#__PURE__*/jsx(Subhead1, {
        children: /*#__PURE__*/jsx(Fragment, {
          children: title
        })
      })
    }), /*#__PURE__*/jsx(Row$1, {
      gap: 1,
      children: children
    })]
  });
}

var _templateObject$r;

var Rule = styled.hr(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  border: none;\n  border-bottom: 1px solid ", ";\n  margin: 0 ", ";\n  margin-bottom: ", "px;\n  margin-top: ", "px;\n\n  // Integrators will commonly modify hr width - this overrides any modifications within the widget.\n  max-width: auto;\n  width: auto;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.outline;
}, function (_ref2) {
  var padded = _ref2.padded;
  return padded ? '0.75em' : 0;
}, function (_ref3) {
  var scrollingEdge = _ref3.scrollingEdge;
  return scrollingEdge === 'bottom' ? -1 : 0;
}, function (_ref4) {
  var scrollingEdge = _ref4.scrollingEdge;
  return scrollingEdge !== 'bottom' ? -1 : 0;
});

var _templateObject$q;

var Context = /*#__PURE__*/createContext({
  element: null,
  active: false,
  setActive: function setActive(active) {
    return undefined;
  }
});

function Provider(_ref) {
  var value = _ref.value,
      children = _ref.children; // If a Dialog is active, mark the main content inert

  var ref = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var context = {
    element: value,
    active: active,
    setActive: setActive
  };
  useEffect(function () {
    if (ref.current) {
      ref.current.inert = active;
    }
  }, [active]);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    style: {
      isolation: 'isolate'
    } // creates a new stacking context, preventing the dialog from intercepting non-dialog clicks
    ,
    children: /*#__PURE__*/jsx(Context.Provider, {
      value: context,
      children: children
    })
  });
}

var OnCloseContext = /*#__PURE__*/createContext(function () {
  return void 0;
});

function Header(_ref2) {
  var title = _ref2.title,
      children = _ref2.children,
      ruled = _ref2.ruled;
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs(Column, {
      children: [/*#__PURE__*/jsxs(Header$1, {
        title: title,
        children: [children, /*#__PURE__*/jsx(IconButton, {
          color: "primary",
          onClick: useContext(OnCloseContext),
          icon: X
        })]
      }), ruled && /*#__PURE__*/jsx(Rule, {
        padded: true
      })]
    })
  });
}

var Modal = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", "em;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: ", ";\n"])), function (_ref3) {
  var color = _ref3.color,
      theme = _ref3.theme;
  return theme[color];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius * 0.75;
}, Layer.DIALOG);

function Dialog(_ref5) {
  var color = _ref5.color,
      children = _ref5.children,
      _ref5$onClose = _ref5.onClose,
      onClose = _ref5$onClose === void 0 ? function () {
    return void 0;
  } : _ref5$onClose;
  var context = useContext(Context);
  useEffect(function () {
    context.setActive(true);
    return function () {
      return context.setActive(false);
    };
  }, [context]);
  var modal = useRef(null);
  useEffect(function () {
    return delayUnmountForAnimation(modal);
  }, []);
  useEffect(function () {
    var close = function close(e) {
      return e.key === 'Escape' && (onClose === null || onClose === void 0 ? void 0 : onClose());
    };

    document.addEventListener('keydown', close, true);
    return function () {
      return document.removeEventListener('keydown', close, true);
    };
  }, [onClose]);
  return context.element && /*#__PURE__*/createPortal( /*#__PURE__*/jsx(ThemeProvider, {
    children: /*#__PURE__*/jsx(OnCloseContext.Provider, {
      value: onClose,
      children: /*#__PURE__*/jsx(Modal, {
        color: color,
        ref: modal,
        children: children
      })
    })
  }), context.element);
}

var _templateObject$p, _templateObject2$d, _templateObject3$8, _templateObject4$4;

var WidgetWrapper = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  border-radius: ", "em;\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  font-feature-settings: 'ss01' on, 'ss02' on, 'cv01' on, 'cv03' on;\n  font-size: 16px;\n  font-smooth: always;\n  font-variant: none;\n  min-height: 300px;\n  min-width: 300px;\n  padding: 0.25em;\n  position: relative;\n  user-select: none;\n  width: ", ";\n\n  * {\n    box-sizing: border-box;\n    font-family: ", ";\n\n    @supports (font-variation-settings: normal) {\n      font-family: ", ";\n    }\n  }\n\n\n\n\n    -webkit-backdrop-filter: blur(", ");\n    backdrop-filter: blur(20px);\n    border-radius: ", ";\n    background:\n    ", ";\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      zIndex: 10;\n      opacity: 1;\n      backdrop-filter: blur(10px);\n      background: ", ");\n      border-radius: inherit;\n      box-shadow: inset 0 0 0 1.5px ", ";\n      -webkit-mask-image:\n        radial-gradient(at -31%,at -58%,", " 34%,transparent 60%),linear-gradient(270deg,", " 0,transparent 13%),linear-gradient(hsl(0deg 0% 0%/5%),hsl(0deg 0% 0%/5%));\n      mask-image:\n        radial-gradient(at -31%,at -58%,", " 34%,transparent 60%),linear-gradient(270deg,", " 0,transparent 13%),linear-gradient(hsl(0deg 0% 0%/5%),hsl(0deg 0% 0%/5%));\n      -webkit-mask-image:\n        radial-gradient(at -31% -58%,", " 34%,transparent 60%),linear-gradient(270deg,", " 0,transparent 13%),linear-gradient(hsl(0deg 0% 0%/5%),hsl(0deg 0% 0%/5%));\n      mask-image:\n        radial-gradient(at -31% -58%,", " 34%,transparent 60%),linear-gradient(270deg,", " 0,transparent 13%),linear-gradient(hsl(0deg 0% 0%/5%),hsl(0deg 0% 0%/5%));\n    },\n\n\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.primary;
}, function (_ref3) {
  var width = _ref3.width;
  return width && (isNaN(Number(width)) ? width : "".concat(width, "px"));
}, function (_ref4) {
  var theme = _ref4.theme;
  return typeof theme.fontFamily === 'string' ? theme.fontFamily : theme.fontFamily.font;
}, function (_ref5) {
  var theme = _ref5.theme;
  return typeof theme.fontFamily === 'string' ? undefined : theme.fontFamily.variable;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.blurSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.gradientBG;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.bgBoardColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.cardTransparency1;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.cardTransparency2;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.cardTransparency1;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.cardTransparency2;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.cardTransparency1;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.cardTransparency2;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.cardTransparency1;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.cardTransparency2;
});
var slideIn = keyframes(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(calc(100% - 0.25em));\n  }\n"])));
var slideOut = keyframes(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  to {\n    transform: translateY(calc(100% - 0.25em));\n  }\n"])));
var DialogWrapper = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  border-radius: ", "em;\n  height: calc(100% - 0.5em);\n  left: 0;\n  margin: 0.25em;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: calc(100% - 0.5em);\n\n  @supports (overflow: clip) {\n    overflow: clip;\n  }\n\n  ", " {\n    animation: ", " 0.25s ease-in;\n\n    &.", " {\n      animation: ", " 0.25s ease-out;\n    }\n  }\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.borderRadius * 0.75;
}, Modal, slideIn, UNMOUNTING, slideOut);
var ChainContext = /*#__PURE__*/createContext(null);

function Widget(_ref20) {
  var children = _ref20.children,
      provider = _ref20.provider,
      userDialog = _ref20.dialog,
      className = _ref20.className;
  _ref20.onError;
  var jsonRpcEndpoints = _ref20.jsonRpcEndpoints,
      width = _ref20.width,
      locale = _ref20.locale,
      destinationChainId = _ref20.destinationChainId,
      darkMode = _ref20.darkMode; // const darkMode = true
  // const theme = { ...defaultTheme, ...(theme) }

  var widgetWidth = useMemo(function () {
    if (width && width < 300) {
      console.warn("Widget width must be at least 300px (you set it to ".concat(width, "). Falling back to 300px."));
      return 300;
    }

    return width !== null && width !== void 0 ? width : 360;
  }, [width]);
  var widgetLocale = useMemo(function () {
    if (locale && ![].concat(_toConsumableArray(SUPPORTED_LOCALES), ['pseudo']).includes(locale)) {
      console.warn("Unsupported locale: ".concat(locale, ". Falling back to ").concat(DEFAULT_LOCALE, "."));
      return DEFAULT_LOCALE;
    }

    return locale !== null && locale !== void 0 ? locale : DEFAULT_LOCALE;
  }, [locale]);
  var tokenList = tokensList.tokens;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialog = _useState2[0],
      setDialog = _useState2[1];

  var _useState3 = useState(destinationChainId),
      _useState4 = _slicedToArray(_useState3, 2),
      chainId = _useState4[0],
      setChainId = _useState4[1];

  var theme = darkMode ? darkTheme : lightTheme;
  return /*#__PURE__*/jsx(StrictMode, {
    children: /*#__PURE__*/jsx(ThemeProvider, {
      theme: theme,
      children: /*#__PURE__*/jsx(WidgetWrapper, {
        width: widgetWidth,
        className: className,
        children: /*#__PURE__*/jsxs(Provider$1, {
          locale: widgetLocale,
          children: [/*#__PURE__*/jsx(DialogWrapper, {
            ref: setDialog
          }), /*#__PURE__*/jsx(Provider, {
            value: userDialog || dialog,
            children: /*#__PURE__*/jsx(Provider$2, {
              store: store,
              children: /*#__PURE__*/jsx(Provider$3, {
                children: /*#__PURE__*/jsx(ActiveWeb3Provider, {
                  provider: provider,
                  jsonRpcEndpoints: jsonRpcEndpoints,
                  destinationChainId: chainId,
                  children: /*#__PURE__*/jsx(JsonRPCWeb3ReactProvider, {
                    jsonRpcEndpoints: jsonRpcEndpoints,
                    destinationChainId: chainId,
                    children: /*#__PURE__*/jsxs(BlockNumberProvider, {
                      children: [/*#__PURE__*/jsx(MulticallUpdater, {}), /*#__PURE__*/jsx(TransactionsUpdater, {}), /*#__PURE__*/jsx(TokenListProvider, {
                        list: tokenList,
                        children: /*#__PURE__*/jsx(ChainContext.Provider, {
                          value: setChainId,
                          children: children
                        })
                      })]
                    })
                  })
                })
              })
            })
          })]
        })
      })
    })
  });
}

var _process$env$REACT_AP, _INFURA_NETWORK_URLS;

var INFURA_KEY = (_process$env$REACT_AP = process.env.REACT_APP_INFURA_KEY) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : process.env.NEXT_PUBLIC_INFURA_KEY;

if (typeof INFURA_KEY === 'undefined') {
  console.warn("INFURA_KEY must be a defined environment variable (e.g. 'REACT_APP_INFURA_KEY' or 'NEXT_PUBLIC_INFURA_KEY')");
  console.warn("@dev note, this may not be required if json-rpc endpoints are provided");
}
/**
 * These are the network URLs used by the interface when there is not another available source of chain data
 */


var INFURA_NETWORK_URLS = (_INFURA_NETWORK_URLS = {}, _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.MAINNET, "https://mainnet.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.RINKEBY, "https://rinkeby.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.ROPSTEN, "https://ropsten.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.GOERLI, "https://goerli.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.KOVAN, "https://kovan.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.OPTIMISM, "https://optimism-mainnet.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.OPTIMISTIC_KOVAN, "https://optimism-kovan.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.ARBITRUM_ONE, "https://arbitrum-mainnet.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.ARBITRUM_RINKEBY, "https://arbitrum-rinkeby.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.POLYGON, "https://polygon-mainnet.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.POLYGON_MUMBAI, "https://polygon-mumbai.infura.io/v3/".concat(INFURA_KEY)), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.AVALANCHE, ""), _defineProperty(_INFURA_NETWORK_URLS, SupportedChainId.SOLANA, ""), _INFURA_NETWORK_URLS);

function getRpcUrls(chainId) {
  switch (chainId) {
    case SupportedChainId.MAINNET:
    case SupportedChainId.RINKEBY:
    case SupportedChainId.ROPSTEN:
    case SupportedChainId.KOVAN:
    case SupportedChainId.GOERLI:
      return [INFURA_NETWORK_URLS[chainId]];

    case SupportedChainId.OPTIMISM:
      return ['https://mainnet.optimism.io'];

    case SupportedChainId.OPTIMISTIC_KOVAN:
      return ['https://kovan.optimism.io'];

    case SupportedChainId.ARBITRUM_ONE:
      return ['https://arb1.arbitrum.io/rpc'];

    case SupportedChainId.ARBITRUM_RINKEBY:
      return ['https://rinkeby.arbitrum.io/rpc'];

    case SupportedChainId.POLYGON:
      return ['https://polygon-rpc.com/'];

    case SupportedChainId.POLYGON_MUMBAI:
      return ['https://rpc-endpoints.superfluid.dev/mumbai'];
  } // Our API-keyed URLs will fail security checks when used with external wallets.


  throw new Error('RPC URLs must use public endpoints');
} // provider.request returns Promise<any>, but wallet_switchEthereumChain must return null or throw
// see https://github.com/rekmarks/EIPs/blob/3326-create/EIPS/eip-3326.md for more info on wallet_switchEthereumChain


function switchToNetwork(_x) {
  return _switchToNetwork.apply(this, arguments);
}

function _switchToNetwork() {
  _switchToNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var provider, chainId, formattedChainId, info;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = _ref.provider, chainId = _ref.chainId;

            if (provider.request) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            formattedChainId = hexStripZeros(BigNumber.from(chainId).toHexString());
            _context.prev = 4;
            _context.next = 7;
            return provider.request({
              method: 'wallet_switchEthereumChain',
              params: [{
                chainId: formattedChainId
              }]
            });

          case 7:
            _context.next = 26;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](4);

            if (!(_context.t0.code === 4902)) {
              _context.next = 25;
              break;
            }

            info = CHAIN_INFO[chainId];
            _context.next = 15;
            return provider.request({
              method: 'wallet_addEthereumChain',
              params: [{
                chainId: formattedChainId,
                chainName: info.label,
                rpcUrls: getRpcUrls(chainId),
                nativeCurrency: info.nativeCurrency,
                blockExplorerUrls: [info.explorer]
              }]
            });

          case 15:
            _context.prev = 15;
            _context.next = 18;
            return provider.request({
              method: 'wallet_switchEthereumChain',
              params: [{
                chainId: formattedChainId
              }]
            });

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](15);
            console.debug('Added network but could not switch chains', _context.t1);

          case 23:
            _context.next = 26;
            break;

          case 25:
            throw _context.t0;

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 9], [15, 20]]);
  }));
  return _switchToNetwork.apply(this, arguments);
}

var MEDIA_WIDTHS = {
  upToExtraSmall: 500,
  upToSmall: 720,
  upToMedium: 960,
  upToLarge: 1280
};

var ActiveRowWrapper = _styled.div.withConfig({
  displayName: "NetworkSelector__ActiveRowWrapper",
  componentId: "sc-1wcp4ua-0"
})(["background-color:", ";border-radius:8px;cursor:pointer;padding:8px;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.bg1;
}); // const FlyoutHeader = styled.div`
//   color: ${({ theme }) => theme.text2};
//   font-weight: 400;
// `


var FlyoutMenu = _styled.div.withConfig({
  displayName: "NetworkSelector__FlyoutMenu",
  componentId: "sc-1wcp4ua-1"
})(["position:absolute;top:54px;width:100%;z-index:99;padding-top:10px;background:", ";border-radius:16px;@media screen and (min-width:", "px){top:40px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.container;
}, MEDIA_WIDTHS.upToSmall);

var FlyoutMenuContents = _styled.div.withConfig({
  displayName: "NetworkSelector__FlyoutMenuContents",
  componentId: "sc-1wcp4ua-2"
})(["align-items:flex-start;background-color:", ";box-shadow:0px 0px 1px rgba(0,0,0,0.01),0px 4px 8px rgba(0,0,0,0.04),0px 16px 24px rgba(0,0,0,0.04),0px 24px 32px rgba(0,0,0,0.01);border-radius:20px;display:flex;flex-direction:column;font-size:16px;overflow:auto;padding:16px;& > *:not(:last-child){margin-bottom:12px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.bg0;
}); // const FlyoutRow = styled.div<{ active: boolean, brydgeSupportedNetwork: boolean }>`
//   align-items: center;
//   background-color: ${({ active, theme }) => (active ? theme.bg1 : 'transparent')};
//   border-radius: 8px;
//   cursor: pointer;
//   display: flex;
//   font-weight: 500;
//   justify-content: space-between;
//   padding: 6px 8px;
//   text-align: left;
//   color: ${({ theme }) => theme.primary};
//   width: 100%;
//   &:hover {
//     background: ${({ theme }) => theme.networkSelector};
//   }
// `


var FlyoutRow = _styled.div.withConfig({
  displayName: "NetworkSelector__FlyoutRow",
  componentId: "sc-1wcp4ua-3"
})(["align-items:center;background-color:", ";border-radius:8px;cursor:", ";display:flex;font-weight:500;justify-content:space-between;padding:6px 8px;text-align:left;color:", ";width:100%;&:hover{background:", ";}"], function (_ref4) {
  var active = _ref4.active,
      theme = _ref4.theme;
  return active ? theme.bg1 : 'transparent';
}, function (_ref5) {
  var supported = _ref5.supported;
  return supported ? 'pointer' : 'cursor';
}, function (_ref6) {
  var supported = _ref6.supported,
      theme = _ref6.theme;
  return supported ? theme.primary : 'grey';
}, function (_ref7) {
  var supported = _ref7.supported,
      theme = _ref7.theme;
  return supported ? theme.networkSelector : 'transparent';
});

var FlyoutRowActiveIndicator = _styled.div.withConfig({
  displayName: "NetworkSelector__FlyoutRowActiveIndicator",
  componentId: "sc-1wcp4ua-4"
})(["background-color:", ";border-radius:50%;height:9px;width:9px;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.green1;
});

var Logo = _styled.img.withConfig({
  displayName: "NetworkSelector__Logo",
  componentId: "sc-1wcp4ua-5"
})(["height:20px;width:20px;margin-right:8px;"]);

var NetworkLabel = _styled.div.withConfig({
  displayName: "NetworkSelector__NetworkLabel",
  componentId: "sc-1wcp4ua-6"
})(["flex:1 1 auto;"]);

var SelectorLabel = _styled(NetworkLabel).withConfig({
  displayName: "NetworkSelector__SelectorLabel",
  componentId: "sc-1wcp4ua-7"
})(["display:none;@media screen{display:block;margin-right:8px;}color:white;"]);

var ShownNetwork = _styled.div.withConfig({
  displayName: "NetworkSelector__ShownNetwork",
  componentId: "sc-1wcp4ua-8"
})(["background-color:transparent;border:none;border-radius:0.5em;color:currentColor;cursor:pointer;font-size:inherit;font-weight:inherit;height:inherit;line-height:inherit;margin:0;padding:0;text-align:left;:enabled{transition:filter 0.125s linear;}:disabled{cursor:initial;filter:saturate(0) opacity(0.4);}"]); // eslint-disable-next-line prettier/prettier


var SelectorControls = _styled(ShownNetwork).withConfig({
  displayName: "NetworkSelector__SelectorControls",
  componentId: "sc-1wcp4ua-9"
})(["align-items:center;background-color:", ";border-radius:16px 16px 0px 0px;color:", ";cursor:", ";display:flex;font-weight:500;font-size:18px;justify-content:space-between;padding:6px 8px;:hover{background-color:", ";}"], function (_ref9) {
  var theme = _ref9.theme;
  return isFirstLoad ? 'hsl(43,63%,43%)' : theme['interactive'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.text1;
}, function (_ref11) {
  var interactive = _ref11.interactive;
  return interactive ? 'pointer' : 'auto';
}, function (_ref12) {
  var theme = _ref12.theme;
  return isFirstLoad ? theme.onHover("".concat(theme['accent'])) : theme.onHover("".concat(theme['interactive']));
}); // eslint-disable-next-line prettier/prettier


var SelectorLogo = _styled(Logo).withConfig({
  displayName: "NetworkSelector__SelectorLogo",
  componentId: "sc-1wcp4ua-10"
})(["margin-right:", "px;@media screen and (min-width:", "px){margin-right:8px;}"], function (_ref13) {
  var interactive = _ref13.interactive;
  return interactive ? 8 : 0;
}, MEDIA_WIDTHS.upToSmall);

var SelectorWrapper = _styled.div.withConfig({
  displayName: "NetworkSelector__SelectorWrapper",
  componentId: "sc-1wcp4ua-11"
})(["margin:0 0.75em 0;@media screen and (min-width:", "px){position:relative;}"], MEDIA_WIDTHS.upToSmall);

var isFirstLoad = true;

function Row(_ref14) {
  var targetChain = _ref14.targetChain,
      onSelectChain = _ref14.onSelectChain;

  var _useActiveWeb3React = useActiveWeb3React(),
      library = _useActiveWeb3React.library,
      chainId = _useActiveWeb3React.chainId;

  if (!library || !chainId) {
    return null;
  }

  var active = chainId === targetChain;
  var _CHAIN_INFO$targetCha = CHAIN_INFO[targetChain],
      label = _CHAIN_INFO$targetCha.label,
      logoUrl = _CHAIN_INFO$targetCha.logoUrl,
      brydgeSupportedNetwork = _CHAIN_INFO$targetCha.brydgeSupportedNetwork;
  var rowContent = /*#__PURE__*/jsxs(FlyoutRow, {
    onClick: function onClick() {
      return onSelectChain(targetChain);
    },
    active: active,
    supported: brydgeSupportedNetwork,
    children: [/*#__PURE__*/jsx(Logo, {
      src: logoUrl
    }), /*#__PURE__*/jsx(NetworkLabel, {
      children: label
    }), chainId === targetChain && /*#__PURE__*/jsx(FlyoutRowActiveIndicator, {})]
  });

  if (active) {
    return /*#__PURE__*/jsx(ActiveRowWrapper, {
      children: rowContent
    });
  }

  return rowContent;
}

function NetworkSelector() {
  var _useActiveWeb3React2 = useActiveWeb3React(),
      chainId = _useActiveWeb3React2.chainId,
      library = _useActiveWeb3React2.library;

  var setChainId = useContext(ChainContext);
  var setIsFirstLoad = useContext(FirstLoadContext);

  var _useState = useState(chainId),
      _useState2 = _slicedToArray(_useState, 1),
      requestedChainId // setRequestedChainId
  = _useState2[0];

  var prevChainId = usePrevious(chainId);
  var node = useRef();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1]; // eslint-disable-next-line react-hooks/exhaustive-deps


  var toggle = function toggle() {
    return setOpen(!open);
  };

  useOnClickOutside(node, open ? toggle : undefined);
  var info = chainId ? CHAIN_INFO[chainId] : undefined;
  var handleChainSwitch = useCallback(function (targetChain, skipToggle) {
    isFirstLoad = false;
    if (setIsFirstLoad) setIsFirstLoad(false);

    if (!(library !== null && library !== void 0 && library.provider)) {
      if (setChainId) setChainId(targetChain);
      return;
    }

    switchToNetwork({
      provider: library === null || library === void 0 ? void 0 : library.provider,
      chainId: targetChain
    }).then(function () {
      if (!skipToggle) {
        toggle();
      }
    }).catch(function (error) {
      console.error('Failed to switch networks', error);

      if (!skipToggle) {
        toggle();
      } // dispatch(addPopup({ content: { failedSwitchNetwork: targetChain }, key: `failed-network-switch` }))

    });
  }, [library === null || library === void 0 ? void 0 : library.provider, setChainId, setIsFirstLoad, toggle]);
  useEffect(function () {
    if (!chainId || !prevChainId) return;

    if (requestedChainId && requestedChainId !== chainId) {
      handleChainSwitch(requestedChainId, false);
    }
  }, [chainId, requestedChainId, prevChainId, handleChainSwitch]);

  if (!chainId || !info || !library) {
    return null;
  }

  return /*#__PURE__*/jsxs(SelectorWrapper, {
    ref: node,
    onClick: toggle,
    children: [isFirstLoad ? /*#__PURE__*/jsxs(SelectorControls, {
      interactive: true,
      isFirstLoad: true,
      children: [/*#__PURE__*/jsx(SelectorLabel, {
        children: "Select Chain to Pay From"
      }), /*#__PURE__*/jsx(ChevronDown, {
        strokeWidth: 3
      })]
    }) : /*#__PURE__*/jsxs(SelectorControls, {
      interactive: true,
      isFirstLoad: true,
      children: [/*#__PURE__*/jsx(SelectorLogo, {
        interactive: true,
        src: info.logoUrl
      }), /*#__PURE__*/jsx(SelectorLabel, {
        children: info.label
      }), /*#__PURE__*/jsx(ChevronDown, {
        strokeWidth: 3
      })]
    }), open && /*#__PURE__*/jsx(FlyoutMenu, {
      children: /*#__PURE__*/jsxs(FlyoutMenuContents, {
        children: [/*#__PURE__*/jsx(Row, {
          onSelectChain: handleChainSwitch,
          targetChain: SupportedChainId.MAINNET
        }), /*#__PURE__*/jsx(Row, {
          onSelectChain: handleChainSwitch,
          targetChain: SupportedChainId.POLYGON
        }), /*#__PURE__*/jsx(Row, {
          onSelectChain: handleChainSwitch,
          targetChain: SupportedChainId.AVALANCHE
        }), /*#__PURE__*/jsx(Row, {
          onSelectChain: handleChainSwitch,
          targetChain: SupportedChainId.SOLANA
        }), /*#__PURE__*/jsx(Row, {
          onSelectChain: handleChainSwitch,
          targetChain: SupportedChainId.OPTIMISM
        }), /*#__PURE__*/jsx(Row, {
          onSelectChain: handleChainSwitch,
          targetChain: SupportedChainId.ARBITRUM_ONE
        })]
      })
    })]
  });
}

function useSyncConvenienceFee(_ref) {
  var convenienceFee = _ref.convenienceFee,
      convenienceFeeRecipient = _ref.convenienceFeeRecipient;

  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var updateFeeOptions = useUpdateAtom(feeOptionsAtom);
  useEffect(function () {
    if (convenienceFee && convenienceFeeRecipient) {
      if (typeof convenienceFeeRecipient === 'string') {
        updateFeeOptions({
          fee: new Percent(convenienceFee, 10000),
          recipient: convenienceFeeRecipient
        });
        return;
      }

      if (chainId && convenienceFeeRecipient[chainId]) {
        updateFeeOptions({
          fee: new Percent(convenienceFee, 10000),
          recipient: convenienceFeeRecipient[chainId]
        });
        return;
      }
    }

    updateFeeOptions(undefined);
  }, [chainId, convenienceFee, convenienceFeeRecipient, updateFeeOptions]);
}

function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function useSyncPrice(_ref) {
  var price = _ref.price;
  var updateSwap = useUpdateAtom(swapAtom);
  var setCurrentPrice = useCallback(function () {
    var defaultSwapState = {
      amount: '',
      independentField: Field$1.OUTPUT
    };

    if (price) {
      defaultSwapState.amount = price.toString();
    }

    updateSwap(function (swap) {
      return _objectSpread$a(_objectSpread$a({}, swap), defaultSwapState);
    });
  }, [price, updateSwap]);
  var lastPrice = useRef(undefined);
  useLayoutEffect(function () {
    if (price && price !== lastPrice.current) {
      setCurrentPrice();
    }

    lastPrice.current = price;
  }, [price, setCurrentPrice]);
}

function useOnSupportedNetwork() {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React.chainId;

  return useMemo(function () {
    return Boolean(chainId && ALL_SUPPORTED_CHAIN_IDS.includes(chainId));
  }, [chainId]);
}

function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function useDefaultToken(defaultAddress, chainId) {
  var address = undefined;

  if (typeof defaultAddress === 'string') {
    address = defaultAddress;
  } else if (_typeof(defaultAddress) === 'object' && chainId) {
    address = defaultAddress[chainId];
  }

  var token = useToken(address, chainId);
  var onSupportedNetwork = useOnSupportedNetwork(); // Only use native currency if chain ID is in supported chains. ExtendedEther will error otherwise.

  if (chainId && address && isNativeAddress(address, chainId) && onSupportedNetwork) {
    return nativeOnChain(chainId);
  }

  return token !== null && token !== void 0 ? token : undefined;
}

function useSyncTokenDefaults(_ref) {
  var outputTokenAddress = _ref.outputTokenAddress,
      price = _ref.price,
      destinationChainId = _ref.destinationChainId;
  var updateSwap = useUpdateAtom(swapAtom);

  var _useActiveWeb3React = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React.chainId;

  var defaultInputToken = useDefaultToken('NATIVE', chainId);
  var defaultOutputToken = useDefaultToken(outputTokenAddress, destinationChainId);
  var setToDefaults = useCallback(function () {
    var _defaultSwapState;

    var defaultSwapState = (_defaultSwapState = {
      amount: ''
    }, _defineProperty(_defaultSwapState, Field$1.INPUT, defaultInputToken), _defineProperty(_defaultSwapState, Field$1.OUTPUT, defaultOutputToken), _defineProperty(_defaultSwapState, "independentField", Field$1.INPUT), _defaultSwapState);

    if (defaultOutputToken && price) {
      defaultSwapState.independentField = Field$1.OUTPUT;
      defaultSwapState.amount = price.toString();
    }

    updateSwap(function (swap) {
      return _objectSpread$9(_objectSpread$9({}, swap), defaultSwapState);
    });
  }, [defaultInputToken, defaultOutputToken, price, updateSwap]);
  var lastChainId = useRef(undefined);
  useLayoutEffect(function () {
    if (chainId && chainId !== lastChainId.current) {
      setToDefaults();
    }

    lastChainId.current = chainId;
  }, [chainId, setToDefaults]);
}

function useHasFocus(node) {
  var _node$contains, _document;

  useEffect(function () {
    if (node instanceof HTMLElement) {
      // tabIndex is required to receive blur events from non-button elements.
      node.tabIndex = node.tabIndex || -1; // Without explicitly omitting outline, Safari will now outline this node when focused.

      node.style.outline = node.style.outline || 'none';
    }
  }, [node]);

  var _useState = useState((_node$contains = node === null || node === void 0 ? void 0 : node.contains((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement)) !== null && _node$contains !== void 0 ? _node$contains : false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var onFocus = useCallback(function () {
    return setHasFocus(true);
  }, []);
  var onBlur = useCallback(function (e) {
    var _node$contains2;

    return setHasFocus((_node$contains2 = node === null || node === void 0 ? void 0 : node.contains(e.relatedTarget)) !== null && _node$contains2 !== void 0 ? _node$contains2 : false);
  }, [node]);
  useEffect(function () {
    node === null || node === void 0 ? void 0 : node.addEventListener('focusin', onFocus);
    node === null || node === void 0 ? void 0 : node.addEventListener('focusout', onBlur);
    return function () {
      node === null || node === void 0 ? void 0 : node.removeEventListener('focusin', onFocus);
      node === null || node === void 0 ? void 0 : node.removeEventListener('focusout', onBlur);
    };
  }, [node, onFocus, onBlur]);
  return hasFocus;
}

var _templateObject$o, _templateObject2$c, _templateObject3$7;

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var BoundaryContext = /*#__PURE__*/createContext(null);
var BoundaryProvider = BoundaryContext.Provider;
var PopoverContainer = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 0.5em;\n  opacity: ", ";\n  padding: 10px 12px;\n  transition: visibility 0.25s linear, opacity 0.25s linear;\n  visibility: ", ";\n  z-index: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.dialog;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.outline;
}, function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? 'visible' : 'hidden';
}, Layer.TOOLTIP);
var Reference = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  align-self: flex-start;\n  display: inline-block;\n  height: 1em;\n"])));
var Arrow = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  height: 8px;\n  width: 8px;\n  z-index: ", ";\n\n  ::before {\n    background: ", ";\n    border: 1px solid ", ";\n    content: '';\n    height: 8px;\n    position: absolute;\n    transform: rotate(45deg);\n    width: 8px;\n  }\n\n  &.arrow-top {\n    bottom: -4px;\n    ::before {\n      border-radius: 1px;\n      border-left: none;\n      border-top: none;\n    }\n  }\n\n  &.arrow-bottom {\n    top: -5px; // includes -1px from border\n    ::before {\n      border-bottom: none;\n      border-right: none;\n      border-radius: 1px;\n    }\n  }\n\n  &.arrow-left {\n    right: -4px;\n    ::before {\n      border-bottom: none;\n      border-left: none;\n      border-radius: 1px;\n    }\n  }\n\n  &.arrow-right {\n    left: -5px; // includes -1px from border\n    ::before {\n      border-radius: 1px;\n      border-right: none;\n      border-top: none;\n    }\n  }\n"])), Layer.TOOLTIP, function (_ref3) {
  var theme = _ref3.theme;
  return theme.dialog;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.outline;
});

function Popover(_ref5) {
  var _attributes$popper$da, _attributes$popper;

  var content = _ref5.content,
      show = _ref5.show,
      children = _ref5.children,
      placement = _ref5.placement,
      offset = _ref5.offset,
      contained = _ref5.contained;
  var boundary = useContext(BoundaryContext);
  var reference = useRef(null); // Use callback refs to be notified when instantiated

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popover = _useState2[0],
      setPopover = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      arrow = _useState4[0],
      setArrow = _useState4[1];

  var options = useMemo(function () {
    var modifiers = [{
      name: 'offset',
      options: {
        offset: [4, offset || 4]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrow,
        padding: 4
      }
    }];

    if (contained) {
      modifiers.push({
        name: 'preventOverflow',
        options: {
          boundary: boundary,
          padding: 8
        }
      }, {
        name: 'flip',
        options: {
          boundary: boundary,
          padding: 8
        }
      }, _objectSpread$8(_objectSpread$8({}, maxSize), {}, {
        options: {
          boundary: boundary,
          padding: 8
        }
      }), {
        name: 'applyMaxSize',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['maxSize'],
        fn: function fn(_ref6) {
          var state = _ref6.state;
          var width = state.modifiersData.maxSize.width;
          state.styles.popper = _objectSpread$8(_objectSpread$8({}, state.styles.popper), {}, {
            maxWidth: "".concat(width, "px")
          });
        }
      });
    }

    return {
      placement: placement,
      strategy: 'absolute',
      modifiers: modifiers
    };
  }, [offset, arrow, contained, placement, boundary]);

  var _usePopper = usePopper(reference.current, popover, options),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Reference, {
      ref: reference,
      children: children
    }), boundary && /*#__PURE__*/createPortal( /*#__PURE__*/jsxs(PopoverContainer, _objectSpread$8(_objectSpread$8({
      show: show,
      ref: setPopover,
      style: styles.popper
    }, attributes.popper), {}, {
      children: [content, /*#__PURE__*/jsx(Arrow, _objectSpread$8({
        className: "arrow-".concat((_attributes$popper$da = (_attributes$popper = attributes.popper) === null || _attributes$popper === void 0 ? void 0 : _attributes$popper['data-popper-placement']) !== null && _attributes$popper$da !== void 0 ? _attributes$popper$da : ''),
        ref: setArrow,
        style: styles.arrow
      }, attributes.arrow))]
    })), boundary)]
  });
}

function Wallet(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick;
  return disabled ? /*#__PURE__*/jsx(TextButton, {
    disabled: !onClick,
    onClick: onClick,
    color: "secondary",
    style: {
      filter: 'none'
    },
    children: /*#__PURE__*/jsx(Caption$1, {
      children: /*#__PURE__*/jsxs(Row$1, {
        gap: 0.5,
        children: [/*#__PURE__*/jsx(Wallet$1, {}), /*#__PURE__*/jsx(Trans, {
          id: "Connect your wallet"
        })]
      })
    })
  }) : null;
}

function safeNamehash(name) {
  if (name === undefined) return undefined;

  try {
    return namehash(name);
  } catch (error) {
    console.debug(error);
    return undefined;
  }
}
/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */


function isZero(hexNumberString) {
  return /^0x0*$/.test(hexNumberString);
}
/**
 * Does a lookup for an ENS name to find its contenthash.
 */


function useENSContentHash(ensName) {
  var _resolverAddressResul;

  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var ensNodeArgument = useMemo(function () {
    return [ensName === null ? undefined : safeNamehash(ensName)];
  }, [ensName]);
  var registrarContract = useENSRegistrarContractWithChainId(chainId, false);
  var resolverAddressResult = useSingleCallResultWithChainId(chainId, registrarContract, 'resolver', ensNodeArgument);
  var resolverAddress = (_resolverAddressResul = resolverAddressResult.result) === null || _resolverAddressResul === void 0 ? void 0 : _resolverAddressResul[0];
  var resolverContract = useENSResolverContractWithChainId(chainId, resolverAddress && isZero(resolverAddress) ? undefined : resolverAddress, false);
  var contenthash = useSingleCallResultWithChainId(chainId, resolverContract, 'contenthash', ensNodeArgument);
  return useMemo(function () {
    var _contenthash$result$, _contenthash$result;

    return {
      contenthash: (_contenthash$result$ = (_contenthash$result = contenthash.result) === null || _contenthash$result === void 0 ? void 0 : _contenthash$result[0]) !== null && _contenthash$result$ !== void 0 ? _contenthash$result$ : null,
      loading: resolverAddressResult.loading || contenthash.loading
    };
  }, [contenthash.loading, contenthash.result, resolverAddressResult.loading]);
}

function useHttpLocations(uri) {
  var ens = useMemo(function () {
    return uri ? parseENSAddress(uri) : undefined;
  }, [uri]);
  var resolvedContentHash = useENSContentHash(ens === null || ens === void 0 ? void 0 : ens.ensName);
  return useMemo(function () {
    if (ens) {
      return resolvedContentHash.contenthash ? uriToHttp(contenthashToUri(resolvedContentHash.contenthash)) : [];
    } else {
      return uri ? uriToHttp(uri) : [];
    }
  }, [ens, resolvedContentHash.contenthash, uri]);
}

var MaticLogo = "data:image/svg+xml,%3Csvg%20width%3D%221024%22%20height%3D%221024%22%20viewBox%3D%220%200%201024%201024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%22512%22%20cy%3D%22512%22%20r%3D%22512%22%20fill%3D%22%238247E5%22%2F%3E%3Cpath%20d%3D%22M681.469%20402.456C669.189%20395.312%20653.224%20395.312%20639.716%20402.456L543.928%20457.228L478.842%20492.949L383.055%20547.721C370.774%20554.865%20354.81%20554.865%20341.301%20547.721L265.162%20504.856C252.882%20497.712%20244.286%20484.614%20244.286%20470.325V385.786C244.286%20371.498%20251.654%20358.4%20265.162%20351.256L340.073%20309.581C352.353%20302.437%20368.318%20302.437%20381.827%20309.581L456.737%20351.256C469.018%20358.4%20477.614%20371.498%20477.614%20385.786V440.558L542.7%20403.646V348.874C542.7%20334.586%20535.332%20321.488%20521.824%20314.344L383.055%20235.758C370.774%20228.614%20354.81%20228.614%20341.301%20235.758L200.076%20314.344C186.567%20321.488%20179.199%20334.586%20179.199%20348.874V507.237C179.199%20521.525%20186.567%20534.623%20200.076%20541.767L341.301%20620.353C353.582%20627.498%20369.546%20627.498%20383.055%20620.353L478.842%20566.772L543.928%20529.86L639.716%20476.279C651.996%20469.135%20667.961%20469.135%20681.469%20476.279L756.38%20517.953C768.66%20525.098%20777.257%20538.195%20777.257%20552.484V637.023C777.257%20651.312%20769.888%20664.409%20756.38%20671.553L681.469%20714.419C669.189%20721.563%20653.224%20721.563%20639.716%20714.419L564.805%20672.744C552.525%20665.6%20543.928%20652.502%20543.928%20638.214V583.442L478.842%20620.353V675.125C478.842%20689.414%20486.21%20702.512%20499.719%20709.656L640.944%20788.242C653.224%20795.386%20669.189%20795.386%20682.697%20788.242L823.922%20709.656C836.203%20702.512%20844.799%20689.414%20844.799%20675.125V516.763C844.799%20502.474%20837.431%20489.377%20823.922%20482.232L681.469%20402.456Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

function chainIdToNetworkName(networkId) {
  switch (networkId) {
    case SupportedChainId.MAINNET:
      return 'ethereum';

    case SupportedChainId.ARBITRUM_ONE:
      return 'arbitrum';

    case SupportedChainId.OPTIMISM:
      return 'optimism';

    default:
      return 'ethereum';
  }
}

function getNativeLogoURI() {
  var chainId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SupportedChainId.MAINNET;

  switch (chainId) {
    case SupportedChainId.POLYGON_MUMBAI:
    case SupportedChainId.POLYGON:
      return MaticLogo;

    default:
      return EthereumLogo;
  }
}

function getTokenLogoURI(address) {
  var chainId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SupportedChainId.MAINNET;
  var networkName = chainIdToNetworkName(chainId);
  var networksWithUrls = [SupportedChainId.ARBITRUM_ONE, SupportedChainId.MAINNET, SupportedChainId.OPTIMISM];

  if (networksWithUrls.includes(chainId)) {
    return "https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/".concat(networkName, "/assets/").concat(address, "/logo.png");
  }
}

function useCurrencyLogoURIs(currency) {
  var locations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined);
  return useMemo(function () {
    var logoURIs = _toConsumableArray(locations);

    if (currency) {
      if (currency.isNative) {
        logoURIs.push(getNativeLogoURI(currency.chainId));
      } else if (currency.isToken) {
        var logoURI = getTokenLogoURI(currency.address, currency.chainId);

        if (logoURI) {
          logoURIs.push(logoURI);
        }
      }
    }

    return logoURIs;
  }, [currency, locations]);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var colors = new Map();
/**
 * Extracts the prominent color from a token.
 * NB: If cached, this function returns synchronously; using a callback allows sync or async returns.
 */

function getColorFromLogoURIs(_x) {
  return _getColorFromLogoURIs.apply(this, arguments);
}

function _getColorFromLogoURIs() {
  _getColorFromLogoURIs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logoURIs) {
    var cb,
        key,
        color,
        _iterator,
        _step,
        logoURI,
        uri,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cb = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {
              return void 0;
            };
            key = logoURIs[0];
            color = colors.get(key);

            if (color) {
              _context.next = 26;
              break;
            }

            _iterator = _createForOfIteratorHelper(logoURIs);
            _context.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }

            logoURI = _step.value;
            uri = logoURI;

            if (logoURI.startsWith('http')) {
              // Color extraction must use a CORS-compatible resource, but the resource may already be cached.
              // Adds a dummy parameter to force a different browser resource cache entry. Without this, color extraction prevents resource caching.
              uri += '?color';
            }

            _context.next = 13;
            return getColorFromUriPath(uri);

          case 13:
            color = _context.sent;

            if (!color) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("break", 18);

          case 16:
            _context.next = 7;
            break;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](5);

            _iterator.e(_context.t0);

          case 23:
            _context.prev = 23;

            _iterator.f();

            return _context.finish(23);

          case 26:
            colors.set(key, color);
            return _context.abrupt("return", cb(color));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 20, 23, 26]]);
  }));
  return _getColorFromLogoURIs.apply(this, arguments);
}

function getColorFromUriPath(_x2) {
  return _getColorFromUriPath.apply(this, arguments);
}

function _getColorFromUriPath() {
  _getColorFromUriPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(uri) {
    var _palette$Vibrant, palette;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return Vibrant.from(uri).getPalette();

          case 3:
            palette = _context2.sent;
            return _context2.abrupt("return", (_palette$Vibrant = palette.Vibrant) === null || _palette$Vibrant === void 0 ? void 0 : _palette$Vibrant.hex);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

          case 9:
            return _context2.abrupt("return");

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _getColorFromUriPath.apply(this, arguments);
}

function usePrefetchCurrencyColor(token) {
  var theme = useTheme();
  var logoURIs = useCurrencyLogoURIs(token);
  useEffect(function () {
    if (theme.tokenColorExtraction && token) {
      getColorFromLogoURIs(logoURIs);
    }
  }, [token, logoURIs, theme.tokenColorExtraction]);
}

function useCurrencyColor(token) {
  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      color = _useState2[0],
      setColor = _useState2[1];

  var theme = useTheme();
  var logoURIs = useCurrencyLogoURIs(token);
  useEffect(function () {
    var stale = false;

    if (theme.tokenColorExtraction && token) {
      getColorFromLogoURIs(logoURIs, function (color) {
        if (!stale && color) {
          setColor(color);
        }
      });
    }

    return function () {
      stale = true;
      setColor(undefined);
    };
  }, [token, logoURIs, theme.tokenColorExtraction]);
  return color;
}

function formatLocaleNumber(_ref) {
  var number = _ref.number,
      locale = _ref.locale,
      sigFigs = _ref.sigFigs,
      fixedDecimals = _ref.fixedDecimals,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  var localeArg;

  if (!locale || locale && !SUPPORTED_LOCALES.includes(locale)) {
    localeArg = DEFAULT_LOCALE;
  } else {
    localeArg = [locale, DEFAULT_LOCALE];
  }

  options.minimumFractionDigits = options.minimumFractionDigits || fixedDecimals;
  options.maximumFractionDigits = options.maximumFractionDigits || fixedDecimals; // Fixed decimals should override significant figures.

  options.maximumSignificantDigits = options.maximumSignificantDigits || fixedDecimals ? undefined : sigFigs;
  var numberString;

  if (typeof number === 'number') {
    numberString = fixedDecimals ? parseFloat(number.toFixed(fixedDecimals)) : number;
  } else {
    var baseString = parseFloat(number.toSignificant(sigFigs));
    numberString = fixedDecimals ? parseFloat(baseString.toFixed(fixedDecimals)) : baseString;
  }

  return numberString.toLocaleString(localeArg, options);
}

function formatCurrencyAmount(amount, sigFigs) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_LOCALE;
  var fixedDecimals = arguments.length > 3 ? arguments[3] : undefined;

  if (!amount) {
    return '-';
  }

  if (JSBI.equal(amount.quotient, JSBI.BigInt(0))) {
    return '0';
  }

  if (amount.divide(amount.decimalScale).lessThan(new Fraction(1, 100000))) {
    return "<".concat(formatLocaleNumber({
      number: 0.00001,
      locale: locale
    }));
  }

  return formatLocaleNumber({
    number: amount,
    locale: locale,
    sigFigs: sigFigs,
    fixedDecimals: fixedDecimals
  });
}

var MIN_NATIVE_CURRENCY_FOR_GAS = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)); // .01 ETH

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */

function maxAmountSpend(currencyAmount) {
  if (!currencyAmount) return undefined;

  if (currencyAmount.currency.isNative) {
    if (JSBI.greaterThan(currencyAmount.quotient, MIN_NATIVE_CURRENCY_FOR_GAS)) {
      return CurrencyAmount.fromRawAmount(currencyAmount.currency, JSBI.subtract(currencyAmount.quotient, MIN_NATIVE_CURRENCY_FOR_GAS));
    } else {
      return CurrencyAmount.fromRawAmount(currencyAmount.currency, JSBI.BigInt(0));
    }
  }

  return currencyAmount;
}

var _templateObject$n;

var _excluded$2 = ["token"];

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var badSrcs = new Set();

function TokenImg(_ref) {
  var _useToken;

  var token = _ref.token,
      rest = _objectWithoutProperties(_ref, _excluded$2); // Use the wrapped token info so that it includes the logoURI.


  var tokenInfo = (_useToken = useToken(token.isToken ? token.wrapped.address : undefined)) !== null && _useToken !== void 0 ? _useToken : token;
  var srcs = useCurrencyLogoURIs(tokenInfo);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      attempt = _useState2[0],
      setAttempt = _useState2[1];

  var src = useMemo(function () {
    return srcs.find(function (src) {
      return !badSrcs.has(src);
    });
  }, [attempt, srcs]);
  var onError = useCallback(function (e) {
    if (src) badSrcs.add(src);
    setAttempt(function (attempt) {
      return ++attempt;
    });
  }, [src]);
  if (!src) return /*#__PURE__*/jsx(MissingToken, _objectSpread$7({
    color: "secondary"
  }, rest));
  var alt = tokenInfo.name || tokenInfo.symbol;
  return /*#__PURE__*/jsx("img", _objectSpread$7({
    src: src,
    alt: alt,
    onError: onError
  }, rest), alt);
}

var TokenImg$1 = styled(TokenImg)(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  // radial-gradient calculates distance from the corner, not the edge: divide by sqrt(2)\n  background: radial-gradient(\n    ", " calc(100% / ", " - 1.5px),\n    ", " calc(100% / ", " - 1.5px)\n  );\n  border-radius: 100%;\n  height: ", "em;\n  width: ", "em;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.module;
}, Math.sqrt(2), function (_ref3) {
  var theme = _ref3.theme;
  return theme.outline;
}, Math.sqrt(2), function (_ref4) {
  var size = _ref4.size;
  return size || 1;
}, function (_ref5) {
  var size = _ref5.size;
  return size || 1;
});
var _excluded$1 = ["value", "onChange"],
    _excluded2 = ["value", "onChange", "enforcer", "pattern"];

var _templateObject$m, _templateObject2$b;

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Input$1 = styled.input(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  -webkit-appearance: textfield;\n  background-color: transparent;\n  border: none;\n  color: currentColor;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  margin: 0;\n  outline: none;\n  overflow: hidden;\n  padding: 0;\n  text-align: left;\n  text-overflow: ellipsis;\n  width: 100%;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :enabled {\n    transition: color 0.125s linear;\n  }\n\n  :disabled {\n    // Overrides WebKit's override of input:disabled color.\n    -webkit-text-fill-color: ", ";\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.secondary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return transparentize(1 - loadingOpacity, theme.primary);
}, function (_ref3) {
  var theme = _ref3.theme;
  return transparentize(1 - loadingOpacity, theme.primary);
});
var StringInput = /*#__PURE__*/forwardRef(function StringInput(_ref4, ref) {
  var value = _ref4.value,
      _onChange = _ref4.onChange,
      props = _objectWithoutProperties(_ref4, _excluded$1);

  return /*#__PURE__*/jsx(Input$1, _objectSpread$6({
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    } // universal input options
    ,
    inputMode: "text",
    autoComplete: "off",
    autoCorrect: "off" // text-specific options
    ,
    type: "text",
    placeholder: props.placeholder || '-',
    minLength: 1,
    spellCheck: "false",
    ref: ref
  }, props));
});
var NumericInput = /*#__PURE__*/forwardRef(function NumericInput(_ref5, ref) {
  var value = _ref5.value,
      onChange = _ref5.onChange,
      enforcer = _ref5.enforcer,
      pattern = _ref5.pattern,
      props = _objectWithoutProperties(_ref5, _excluded2);

  var validateChange = useCallback(function (event) {
    var _enforcer;

    var nextInput = (_enforcer = enforcer(event.target.value.replace(/,/g, '.'))) === null || _enforcer === void 0 ? void 0 : _enforcer.replace(/^0+$/, '0');

    if (nextInput !== undefined) {
      onChange(nextInput);
    }
  }, [enforcer, onChange]);
  return /*#__PURE__*/jsx(Input$1, _objectSpread$6({
    value: value,
    onChange: validateChange // universal input options
    ,
    inputMode: "decimal",
    autoComplete: "off",
    autoCorrect: "off" // text-specific options
    ,
    type: "text",
    pattern: pattern,
    placeholder: props.placeholder || ' ',
    minLength: 1,
    maxLength: 79,
    spellCheck: "false",
    ref: ref
  }, props));
});
var decimalRegexp = /^\d*(?:[.])?\d*$/;

var decimalEnforcer = function decimalEnforcer(nextUserInput) {
  if (nextUserInput === '') {
    return '';
  } else if (nextUserInput === '.') {
    return '0.';
  } else if (decimalRegexp.test(nextUserInput)) {
    return nextUserInput;
  }

  return null;
};

var DecimalInput = /*#__PURE__*/forwardRef(function DecimalInput(props, ref) {
  return /*#__PURE__*/jsx(NumericInput, _objectSpread$6({
    pattern: "^[0-9]*[.,]?[0-9]*$",
    enforcer: decimalEnforcer,
    ref: ref
  }, props));
});
var inputCss = css(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "em;\n  cursor: text;\n  padding: calc(0.5em - 1px);\n\n  :hover:not(:focus-within) {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  :focus-within {\n    border-color: ", ";\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.container;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.container;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.borderRadius;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.onHover(theme.container);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.onHover(theme.container);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.active;
});

function currencyId(currency) {
  if (currency.isNative) return 'ETH';
  if (currency.isToken) return currency.address;
  throw new Error('invalid currency');
}

var _templateObject$l;

var TokenButton$2 = styled(Button$1)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  border-radius: ", "em;\n  padding: 0.25em 0.75em 0.25em 0.25em;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
});

function TokenBase(_ref2) {
  var value = _ref2.value,
      _onClick = _ref2.onClick;
  return /*#__PURE__*/jsx(TokenButton$2, {
    onClick: function onClick() {
      return _onClick(value);
    },
    children: /*#__PURE__*/jsx(ButtonMedium, {
      children: /*#__PURE__*/jsxs(Row$1, {
        gap: 0.5,
        children: [/*#__PURE__*/jsx(TokenImg$1, {
          token: value,
          size: 1.5
        }), value.symbol]
      })
    })
  });
}

var _templateObject$k, _templateObject2$a, _templateObject3$6;

var transitionCss = css(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  transition: background-color 0.125s linear, border-color 0.125s linear, filter 0.125s linear, width 0.125s ease-out;\n"])));
var StyledTokenButton = styled(Button$1)(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  border-radius: ", "em;\n  padding: 0.25em;\n\n  background-color: ", ";\n\n  :enabled {\n    ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.primary;
}, function (_ref3) {
  var transition = _ref3.transition;
  return transition && transitionCss;
});
var TokenButtonRow = styled(Row$1)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  float: right;\n  height: 1.2em;\n  // max-width must have an absolute value in order to transition.\n  max-width: ", ";\n  padding-left: ", "em;\n  width: fit-content;\n  overflow: hidden;\n  transition: max-width 0.25s linear;\n  color: white;\n\n  img {\n    min-width: 1.2em;\n  }\n"])), function (_ref4) {
  var collapsed = _ref4.collapsed;
  return collapsed ? '1.2em' : '12em';
}, function (_ref5) {
  var empty = _ref5.empty;
  return empty && 0.5;
});

function TokenButton$1(_ref6) {
  var value = _ref6.value,
      collapsed = _ref6.collapsed,
      disabled = _ref6.disabled,
      onClick = _ref6.onClick;
  var buttonBackgroundColor = useMemo(function () {
    return value ? 'interactive' : 'accent';
  }, [value]);
  var contentColor = useMemo(function () {
    return value || disabled ? 'onInteractive' : 'onAccent';
  }, [value, disabled]); // Transition the button only if transitioning from a disabled state.
  // This makes initialization cleaner without adding distracting UX to normal swap flows.

  var _useState = useState(disabled),
      _useState2 = _slicedToArray(_useState, 2),
      shouldTransition = _useState2[0],
      setShouldTransition = _useState2[1];

  useEffect(function () {
    if (disabled) {
      setShouldTransition(true);
    }
  }, [disabled]); // width must have an absolute value in order to transition, so it is taken from the row ref.

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      row = _useState4[0],
      setRow = _useState4[1];

  var style = useMemo(function () {
    if (!shouldTransition) return;
    return {
      width: row ? row.clientWidth +
      /* padding= */
      8 +
      /* border= */
      2 : undefined
    };
  }, [row, shouldTransition]);
  return /*#__PURE__*/jsx(StyledTokenButton, {
    onClick: onClick,
    color: buttonBackgroundColor,
    disabled: disabled,
    style: style,
    transition: shouldTransition,
    onTransitionEnd: function onTransitionEnd() {
      return setShouldTransition(false);
    },
    children: /*#__PURE__*/jsx(ButtonLarge, {
      color: contentColor,
      children: /*#__PURE__*/jsxs(TokenButtonRow, {
        gap: 0.4,
        empty: !value,
        collapsed: collapsed // ref is used to set an absolute width, so it must be reset for each value passed.
        // To force this, value?.symbol is passed as a key.
        ,
        ref: setRow,
        children: [value ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(TokenImg$1, {
            token: value,
            size: 1.2
          }), /*#__PURE__*/jsx("div", {
            children: value.symbol
          })]
        }) : /*#__PURE__*/jsx(Trans, {
          id: "Select a token"
        }), /*#__PURE__*/jsx(ChevronDown, {
          color: contentColor,
          strokeWidth: 3
        })]
      }, value === null || value === void 0 ? void 0 : value.symbol)
    })
  });
}

function useNativeEvent(element, type, listener, options) {
  useEffect(function () {
    element === null || element === void 0 ? void 0 : element.addEventListener(type, listener, options);
    return function () {
      return element === null || element === void 0 ? void 0 : element.removeEventListener(type, listener, options);
    };
  }, [element, type, listener, options]);
}

var _templateObject$j, _templateObject2$9;

var overflowCss = css(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  overflow-y: scroll;\n"])));
/** Customizes the scrollbar for vertical overflow. */

var scrollbarCss = function scrollbarCss(padded) {
  return css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  overflow-y: scroll;\n\n  ::-webkit-scrollbar {\n    width: 1.25em;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: radial-gradient(\n        closest-corner at 0.25em 0.25em,\n        ", " 0.25em,\n        transparent 0.25em\n      ),\n      linear-gradient(\n        to bottom,\n        #ffffff00 0.25em,\n        ", " 0.25em,\n        ", " calc(100% - 0.25em),\n        #ffffff00 calc(100% - 0.25em)\n      ),\n      radial-gradient(\n        closest-corner at 0.25em calc(100% - 0.25em),\n        ", " 0.25em,\n        #ffffff00 0.25em\n      );\n    background-clip: padding-box;\n    border: none;\n    ", ": 0.75em solid transparent;\n  }\n\n  @supports not selector(::-webkit-scrollbar-thumb) {\n    scrollbar-color: ", " transparent;\n  }\n"])), function (_ref) {
    var theme = _ref.theme;
    return theme.interactive;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.interactive;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.interactive;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.interactive;
  }, padded ? 'border-right' : 'border-left', function (_ref5) {
    var theme = _ref5.theme;
    return theme.interactive;
  });
};

function useScrollbar(element) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$padded = _ref6.padded,
      padded = _ref6$padded === void 0 ? false : _ref6$padded;

  return useMemo( // NB: The css must be applied on an element's first render. WebKit will not re-apply overflow
  // properties until any transitions have ended, so waiting a frame for state would cause jank.
  function () {
    return hasOverflow(element) ? scrollbarCss(padded) : overflowCss;
  }, [element, padded]);

  function hasOverflow(element) {
    if (!element) return true;
    return element.scrollHeight > element.clientHeight;
  }
}

var _templateObject$i, _templateObject2$8, _templateObject3$5, _templateObject4$3;

var TokenButton = styled(BaseButton)(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  border-radius: 0;\n  outline: none;\n  padding: 0.5em 0.75em;\n"])));
var ITEM_SIZE = 56;
var TokenList = styled(FixedSizeList)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  ", "[data-index='", "'] {\n    background-color: ", ";\n  }\n\n  ", "\n  overscroll-behavior: none; // prevent Firefox's bouncy overscroll effect (because it does not trigger the scroll handler)\n"])), TokenButton, function (_ref) {
  var hover = _ref.hover;
  return hover;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.onHover(theme.module);
}, function (_ref3) {
  var scrollbar = _ref3.scrollbar;
  return scrollbar;
});
var OnHover = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: ", "px;\n  left: 0;\n  position: absolute;\n  top: ", "px;\n  width: 100%;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.onHover(theme.module);
}, ITEM_SIZE, function (_ref5) {
  var hover = _ref5.hover;
  return hover * ITEM_SIZE;
});
var TokenBalance = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 0.25em;\n  padding: 0.375em 0;\n"])), function (_ref6) {
  var theme = _ref6.theme,
      isLoading = _ref6.isLoading;
  return isLoading && theme.secondary;
});

function TokenOption$1(_ref7) {
  var index = _ref7.index,
      value = _ref7.value,
      style = _ref7.style;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var ref = useRef(null); // Annotate the event to be handled later instead of passing in handlers to avoid rerenders.
  // This prevents token logos from reloading and flashing on the screen.

  var onEvent = function onEvent(e) {
    var _ref$current;

    e.index = index;
    e.token = value;
    e.ref = (_ref$current = ref.current) !== null && _ref$current !== void 0 ? _ref$current : undefined;
  };

  var _useActiveWeb3React = useActiveWeb3React$1(),
      account = _useActiveWeb3React.account;

  var balance = useCurrencyBalance(account, value);
  return /*#__PURE__*/jsx(TokenButton, {
    "data-index": index,
    style: style,
    onClick: onEvent,
    onBlur: onEvent,
    onFocus: onEvent,
    onMouseMove: onEvent,
    onKeyDown: onEvent,
    ref: ref,
    children: /*#__PURE__*/jsx(Body1, {
      children: /*#__PURE__*/jsxs(Row$1, {
        children: [/*#__PURE__*/jsxs(Row$1, {
          gap: 0.5,
          children: [/*#__PURE__*/jsx(TokenImg$1, {
            token: value,
            size: 1.5
          }), /*#__PURE__*/jsxs(Column, {
            flex: true,
            gap: 0.125,
            align: "flex-start",
            children: [/*#__PURE__*/jsx(Subhead1, {
              children: value.symbol
            }), /*#__PURE__*/jsx(Caption$1, {
              color: "secondary",
              children: value.name
            })]
          })]
        }), /*#__PURE__*/jsx(TokenBalance, {
          isLoading: Boolean(account) && !balance,
          children: (balance === null || balance === void 0 ? void 0 : balance.greaterThan(0)) && formatCurrencyAmount(balance, 2, i18n.locale)
        })]
      })
    })
  });
}

var itemKey = function itemKey(index, tokens) {
  return currencyId(tokens[index]);
};

var ItemRow = /*#__PURE__*/memo(function ItemRow(_ref8) {
  var tokens = _ref8.data,
      index = _ref8.index,
      style = _ref8.style;
  return /*#__PURE__*/jsx(TokenOption$1, {
    index: index,
    value: tokens[index],
    style: style
  });
}, areEqual);
var TokenOptions = /*#__PURE__*/forwardRef(function TokenOptions(_ref9, ref) {
  var tokens = _ref9.tokens,
      onSelect = _ref9.onSelect;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState({
    index: -1
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  useEffect(function () {
    setHover(function (hover) {
      var index = hover.currency ? tokens.indexOf(hover.currency) : -1;
      return {
        index: index,
        currency: tokens[index]
      };
    });
  }, [tokens]);
  var list = useRef(null);

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      element = _useState6[0],
      setElement = _useState6[1];

  var scrollTo = useCallback(function (index) {
    var _list$current;

    if (index === undefined) return;
    (_list$current = list.current) === null || _list$current === void 0 ? void 0 : _list$current.scrollToItem(index);

    if (focused) {
      var _element$querySelecto;

      element === null || element === void 0 ? void 0 : (_element$querySelecto = element.querySelector("[data-index='".concat(index, "']"))) === null || _element$querySelecto === void 0 ? void 0 : _element$querySelecto.focus();
    }

    setHover({
      index: index,
      currency: tokens[index]
    });
  }, [element, focused, tokens]);
  var onKeyDown = useCallback(function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (e.key === 'ArrowDown' && hover.index < tokens.length - 1) {
        scrollTo(hover.index + 1);
      } else if (e.key === 'ArrowUp' && hover.index > 0) {
        scrollTo(hover.index - 1);
      } else if (e.key === 'ArrowUp' && hover.index === -1) {
        scrollTo(tokens.length - 1);
      }

      e.preventDefault();
    }

    if (e.key === 'Enter' && hover.index !== -1) {
      onSelect(tokens[hover.index]);
    }
  }, [hover.index, onSelect, scrollTo, tokens]);
  var blur = useCallback(function () {
    return setHover({
      index: -1
    });
  }, []);
  useImperativeHandle(ref, function () {
    return {
      onKeyDown: onKeyDown,
      blur: blur
    };
  }, [blur, onKeyDown]);
  var onClick = useCallback(function (_ref10) {
    var token = _ref10.token;
    return token && onSelect(token);
  }, [onSelect]);
  var onFocus = useCallback(function (_ref11) {
    var index = _ref11.index;
    setFocused(true);
    scrollTo(index);
  }, [scrollTo]);
  var onBlur = useCallback(function () {
    return setFocused(false);
  }, []);
  var onMouseMove = useCallback(function (_ref12) {
    var index = _ref12.index;
    return scrollTo(index);
  }, [scrollTo]);
  var scrollbar = useScrollbar(element, {
    padded: true
  });
  var onHover = useRef(null); // use native onscroll handler to capture Safari's bouncy overscroll effect

  useNativeEvent(element, 'scroll', useCallback(function () {
    if (element && onHover.current) {
      // must be set synchronously to avoid jank (avoiding useState)
      onHover.current.style.marginTop = "".concat(-element.scrollTop, "px");
    }
  }, [element]));
  return /*#__PURE__*/jsxs(Column, {
    align: "unset",
    grow: true,
    onKeyDown: onKeyDown,
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    onMouseMove: onMouseMove,
    style: {
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/jsx(OnHover, {
      hover: hover.index,
      ref: onHover
    }), /*#__PURE__*/jsx(AutoSizer, {
      disableWidth: true,
      children: function children(_ref13) {
        var height = _ref13.height;
        return /*#__PURE__*/jsx(TokenList, {
          hover: hover.index,
          height: height,
          width: "100%",
          itemCount: tokens.length,
          itemData: tokens,
          itemKey: itemKey,
          itemSize: ITEM_SIZE,
          className: "scrollbar",
          ref: list,
          outerRef: setElement,
          scrollbar: scrollbar,
          children: ItemRow
        });
      }
    })]
  });
});

var _templateObject$h, _templateObject2$7, _templateObject3$4, _templateObject4$2, _templateObject5$1;

var Img = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  clip-path: circle(50%);\n  height: 1.5em;\n  width: 1.5em;\n"])));

var _Symbol = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  height: 0.75em;\n  width: 7em;\n"])));

var Name = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  height: 0.5em;\n  width: 5.5em;\n"])));
var Balance$1 = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  padding: 0.375em 0;\n  width: 1.5em;\n"])));
var TokenRow = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  outline: none;\n  padding: 0.6875em 0.75em;\n\n  ", ", ", ", ", ", ", " {\n    background-color: ", ";\n    border-radius: 0.25em;\n  }\n"])), Img, _Symbol, Name, Balance$1, function (_ref) {
  var theme = _ref.theme;
  return theme.secondary;
});

function TokenOption() {
  return /*#__PURE__*/jsx(TokenRow, {
    children: /*#__PURE__*/jsx(Body1, {
      children: /*#__PURE__*/jsxs(Row$1, {
        children: [/*#__PURE__*/jsxs(Row$1, {
          gap: 0.5,
          children: [/*#__PURE__*/jsx(Img, {}), /*#__PURE__*/jsxs(Column, {
            flex: true,
            gap: 0.125,
            align: "flex-start",
            justify: "flex-center",
            children: [/*#__PURE__*/jsx(Subhead1, {
              style: {
                display: 'flex'
              },
              children: /*#__PURE__*/jsx(_Symbol, {})
            }), /*#__PURE__*/jsx(Caption$1, {
              style: {
                display: 'flex'
              },
              children: /*#__PURE__*/jsx(Name, {})
            })]
          })]
        }), /*#__PURE__*/jsx(Balance$1, {})]
      })
    })
  });
}

function TokenOptionsSkeleton() {
  return /*#__PURE__*/jsxs(Column, {
    children: [/*#__PURE__*/jsx(TokenOption, {}), /*#__PURE__*/jsx(TokenOption, {}), /*#__PURE__*/jsx(TokenOption, {}), /*#__PURE__*/jsx(TokenOption, {}), /*#__PURE__*/jsx(TokenOption, {})]
  });
}

var _templateObject$g;

var SearchInput = styled(StringInput)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  ", "\n"])), inputCss);

function usePrefetchBalances() {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      account = _useActiveWeb3React.account;

  var tokenList = useTokenList();
  var prefetchedTokenList = useRef();
  useCurrencyBalances(account, tokenList !== prefetchedTokenList.current ? tokenList : undefined);
  prefetchedTokenList.current = tokenList;
}

function useAreBalancesLoaded() {
  var _useActiveWeb3React2 = useActiveWeb3React$1(),
      account = _useActiveWeb3React2.account;

  var tokens = useTokenList();
  var native = useNativeCurrency();
  var currencies = useMemo(function () {
    return [native].concat(_toConsumableArray(tokens));
  }, [native, tokens]);
  var balances = useCurrencyBalances(account, currencies).filter(Boolean);
  return !account || currencies.length === balances.length;
}

function TokenSelectDialog(_ref) {
  var value = _ref.value,
      onSelect = _ref.onSelect,
      chainId = _ref.chainId;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  var queriedTokens = useQueryCurrencies(query, chainId);
  var tokens = useMemo(function () {
    return queriedTokens === null || queriedTokens === void 0 ? void 0 : queriedTokens.filter(function (token) {
      return token !== value;
    });
  }, [queriedTokens, value]);
  var isTokenListLoaded = useIsTokenListLoaded();
  var areBalancesLoaded = useAreBalancesLoaded();

  var _useState3 = useState(isTokenListLoaded && areBalancesLoaded),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoaded = _useState4[0],
      setIsLoaded = _useState4[1]; // Give the balance-less tokens a small block period to avoid layout thrashing from re-sorting.


  useEffect(function () {
    if (!isLoaded) {
      var timeout = setTimeout(function () {
        return setIsLoaded(true);
      }, 250);
      return function () {
        return clearTimeout(timeout);
      };
    }

    return;
  }, [isLoaded]);
  useEffect(function () {
    return setIsLoaded(Boolean(query) || isTokenListLoaded && areBalancesLoaded);
  }, [query, areBalancesLoaded, isTokenListLoaded]);
  var baseTokens = []; // TODO(zzmp): Add base tokens to token list functionality

  var input = useRef(null);
  useEffect(function () {
    var _input$current;

    return (_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.focus({
      preventScroll: true
    });
  }, [input]);

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      options = _useState6[0],
      setOptions = _useState6[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Header, {
      title: /*#__PURE__*/jsx(Trans, {
        id: "Select a token"
      })
    }), /*#__PURE__*/jsxs(Column, {
      gap: 0.75,
      children: [/*#__PURE__*/jsx(Row$1, {
        pad: 0.75,
        grow: true,
        children: /*#__PURE__*/jsx(Body1, {
          children: /*#__PURE__*/jsx(SearchInput, {
            value: query,
            onChange: setQuery,
            placeholder:
            /*i18n*/
            i18n._("Search by token name or address"),
            onKeyDown: options === null || options === void 0 ? void 0 : options.onKeyDown,
            onBlur: options === null || options === void 0 ? void 0 : options.blur,
            ref: input
          })
        })
      }), Boolean(baseTokens.length) && /*#__PURE__*/jsx(Row$1, {
        pad: 0.75,
        gap: 0.25,
        justify: "flex-start",
        flex: true,
        children: baseTokens.map(function (token) {
          return /*#__PURE__*/jsx(TokenBase, {
            value: token,
            onClick: onSelect
          }, currencyId(token));
        })
      }), /*#__PURE__*/jsx(Rule, {
        padded: true
      })]
    }), isLoaded ? tokens.length ? /*#__PURE__*/jsx(TokenOptions, {
      tokens: tokens,
      onSelect: onSelect,
      ref: setOptions
    }) : /*#__PURE__*/jsx(Column, {
      padded: true,
      children: /*#__PURE__*/jsx(Row$1, {
        justify: "center",
        children: /*#__PURE__*/jsx(Body1, {
          color: "secondary",
          children: /*#__PURE__*/jsx(Trans, {
            id: "No results found."
          })
        })
      })
    }) : /*#__PURE__*/jsx(TokenOptionsSkeleton, {})]
  });
}

var TokenSelect = /*#__PURE__*/memo(function TokenSelect(_ref2) {
  var value = _ref2.value,
      collapsed = _ref2.collapsed,
      disabled = _ref2.disabled,
      onSelect = _ref2.onSelect,
      chainId = _ref2.chainId;
  usePrefetchBalances();

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      open = _useState8[0],
      setOpen = _useState8[1];

  var onOpen = useCallback(function () {
    return setOpen(true);
  }, []);
  var selectAndClose = useCallback(function (value) {
    onSelect(value);
    setOpen(false);
  }, [onSelect, setOpen]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TokenButton$1, {
      value: value,
      collapsed: collapsed,
      disabled: disabled,
      onClick: onOpen
    }), open && /*#__PURE__*/jsx(Dialog, {
      color: "module",
      onClose: function onClose() {
        return setOpen(false);
      },
      children: /*#__PURE__*/jsx(TokenSelectDialog, {
        value: value,
        onSelect: selectAndClose,
        chainId: chainId
      })
    })]
  });
});

var _templateObject$f, _templateObject2$6;

var TokenInputRow = styled(Row$1)(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  grid-template-columns: 1fr;\n"])));
var ValueInput = styled(DecimalInput)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  color: ", ";\n  height: 1.5em;\n  margin: -0.25em 0;\n\n  :hover:not(:focus-within) {\n    color: ", ";\n  }\n\n  :hover:not(:focus-within)::placeholder {\n    color: ", ";\n  }\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.onHover(theme.primary);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.onHover(theme.secondary);
}, loadingTransitionCss); // const delayedFadeIn = keyframes`
//   0% {
//     opacity: 0;
//   }
//   25% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// `
// const MaxButton = styled(Button)`
//   animation: ${delayedFadeIn} 0.25s linear;
//   border-radius: 0.75em;
//   padding: 0.5em;
// `

function TokenInput(_ref4) {
  var currency = _ref4.currency,
      amount = _ref4.amount,
      max = _ref4.max,
      disabled = _ref4.disabled,
      onChangeInput = _ref4.onChangeInput,
      onChangeCurrency = _ref4.onChangeCurrency,
      loading = _ref4.loading,
      children = _ref4.children,
      chainId = _ref4.chainId;
  var input = useRef(null);
  var onSelect = useCallback(function (currency) {
    onChangeCurrency(currency);
    setImmediate(function () {
      var _input$current;

      return (_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.focus();
    });
  }, [onChangeCurrency]);
  var maxButton = useRef(null);
  var hasMax = useMemo(function () {
    return Boolean(max && max !== amount);
  }, [max, amount]);

  var _useState = useState(hasMax),
      _useState2 = _slicedToArray(_useState, 2),
      showMax = _useState2[0],
      setShowMax = _useState2[1];

  useEffect(function () {
    var _ref5, _input$current2;

    return setShowMax((_ref5 = hasMax && ((_input$current2 = input.current) === null || _input$current2 === void 0 ? void 0 : _input$current2.contains(document.activeElement))) !== null && _ref5 !== void 0 ? _ref5 : false);
  }, [hasMax]);
  var onBlur = useCallback(function (e) {
    var _input$current3, _maxButton$current; // Filters out clicks on input or maxButton, because onBlur fires before onClickMax.


    if (!((_input$current3 = input.current) !== null && _input$current3 !== void 0 && _input$current3.contains(e.relatedTarget)) && !((_maxButton$current = maxButton.current) !== null && _maxButton$current !== void 0 && _maxButton$current.contains(e.relatedTarget))) {
      setShowMax(false);
    }
  }, []); // const onClickMax = useCallback(() => {
  //   onChangeInput(max || '')
  //   setShowMax(false)
  //   setImmediate(() => {
  //     input.current?.focus()
  //     // Brings the start of the input into view. NB: This only works for clicks, not eg keyboard interactions.
  //     input.current?.setSelectionRange(0, null)
  //   })
  // }, [max, onChangeInput])

  return /*#__PURE__*/jsxs(Column, {
    gap: 0.25,
    children: [/*#__PURE__*/jsxs(TokenInputRow, {
      gap: 0.5,
      onBlur: onBlur,
      children: [/*#__PURE__*/jsx(H2, {
        children: /*#__PURE__*/jsx(ValueInput, {
          value: amount,
          onFocus: function onFocus() {
            return setShowMax(hasMax);
          },
          onChange: onChangeInput // disabled={disabled || !currency}
          ,
          disabled: true,
          isLoading: Boolean(loading),
          ref: input
        })
      }), /*#__PURE__*/jsx(TokenSelect, {
        value: currency,
        collapsed: showMax,
        disabled: disabled,
        onSelect: onSelect,
        chainId: chainId
      })]
    }), children]
  });
}

var _templateObject$e, _templateObject2$5, _templateObject3$3;

styled(Row$1)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  ", ";\n"])), loadingTransitionCss);
var Balance = styled(Body2)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.25s ", ";\n"])), function (_ref) {
  var focused = _ref.focused;
  return focused ? 1 : 0;
}, function (_ref2) {
  var focused = _ref2.focused;
  return focused ? 'ease-in' : 'ease-out';
});
var InputColumn = styled(Column)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  padding: 0.75em;\n  border-radius: 0px 0px 16px 16px;\n  background-color: ", ";\n  margin-bottom: 0.75rem;\n  position: relative;\n  margin: 0 0.75em 0;\n\n  ", " {\n    filter: ", ";\n    transition: filter 0.25s;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.container;
}, TokenImg$1, function (_ref4) {
  var approved = _ref4.approved;
  return approved ? undefined : 'saturate(0) opacity(0.4)';
});

function useFormattedFieldAmount(_ref5) {
  var disabled = _ref5.disabled,
      currencyAmount = _ref5.currencyAmount,
      fieldAmount = _ref5.fieldAmount;
  return useMemo(function () {
    if (disabled) {
      return '';
    }

    if (fieldAmount !== undefined) {
      return fieldAmount;
    }

    if (currencyAmount) {
      return currencyAmount.toSignificant(6);
    }

    return '';
  }, [disabled, currencyAmount, fieldAmount]);
}

function Input(_ref6) {
  var disabled = _ref6.disabled,
      focused = _ref6.focused;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var _useSwapInfo = useSwapInfo(),
      _useSwapInfo$Field$IN = _useSwapInfo[Field$1.INPUT],
      balance = _useSwapInfo$Field$IN.balance,
      totalAmountIn = _useSwapInfo$Field$IN.totalAmount,
      tradeState = _useSwapInfo.trade.state;

  var _useSwapAmount = useSwapAmount(Field$1.INPUT),
      _useSwapAmount2 = _slicedToArray(_useSwapAmount, 2),
      inputAmount = _useSwapAmount2[0],
      updateInputAmount = _useSwapAmount2[1];

  var _useSwapCurrency = useSwapCurrency(Field$1.INPUT),
      _useSwapCurrency2 = _slicedToArray(_useSwapCurrency, 2),
      inputCurrency = _useSwapCurrency2[0],
      updateInputCurrency = _useSwapCurrency2[1];

  var inputCurrencyAmount = useSwapCurrencyAmount(Field$1.INPUT); // extract eagerly in case of reversal

  usePrefetchCurrencyColor(inputCurrency);
  var isRouteLoading = disabled || tradeState === TradeState.SYNCING || tradeState === TradeState.LOADING;
  var isDependentField = !useIsSwapFieldIndependent(Field$1.INPUT);
  var isLoading = isRouteLoading && isDependentField; //TODO(ianlapham): mimic logic from app swap page

  var mockApproved = true; // account for gas needed if using max on native token

  var max = useMemo(function () {
    var maxAmount = maxAmountSpend(balance);
    return maxAmount !== null && maxAmount !== void 0 && maxAmount.greaterThan(0) ? maxAmount.toExact() : undefined;
  }, [balance]);
  var balanceColor = useMemo(function () {
    var insufficientBalance = balance && (totalAmountIn ? totalAmountIn.greaterThan(balance) : inputCurrencyAmount === null || inputCurrencyAmount === void 0 ? void 0 : inputCurrencyAmount.greaterThan(balance));
    return insufficientBalance ? 'error' : undefined;
  }, [balance, totalAmountIn, inputCurrencyAmount]);
  var amount = useFormattedFieldAmount({
    disabled: disabled,
    currencyAmount: totalAmountIn,
    fieldAmount: inputAmount
  });
  return /*#__PURE__*/jsxs(InputColumn, {
    gap: 0.85,
    approved: mockApproved,
    children: [/*#__PURE__*/jsx(TokenInput, {
      currency: inputCurrency,
      amount: amount,
      max: max,
      disabled: disabled,
      onChangeInput: updateInputAmount,
      onChangeCurrency: updateInputCurrency,
      loading: isLoading,
      children: /*#__PURE__*/jsx(Body2, {
        color: "secondary",
        userSelect: true,
        children: /*#__PURE__*/jsx(Row$1, {
          children: balance && /*#__PURE__*/jsxs(Balance, {
            color: balanceColor,
            focused: focused,
            children: ["Balance: ", /*#__PURE__*/jsx("span", {
              children: formatCurrencyAmount(balance, 4, i18n.locale)
            })]
          })
        })
      })
    }), /*#__PURE__*/jsx(Row$1, {})]
  });
}

var _excluded = ["target", "href", "rel"];

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/**
 * Outbound link
 */


function ExternalLink(_ref) {
  var _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_blank' : _ref$target,
      href = _ref.href,
      _ref$rel = _ref.rel,
      rel = _ref$rel === void 0 ? 'noopener noreferrer' : _ref$rel,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx("a", _objectSpread$5(_objectSpread$5({
    target: target,
    rel: rel,
    href: href
  }, rest), {}, {
    children: rest.children
  }));
}

var _templateObject$d;

var UniswapA = styled(ExternalLink)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n  text-decoration: none;\n\n  ", " {\n    fill: ", ";\n    height: 0.9em;\n    transition: transform 0.25s ease, fill 0.25s ease;\n    width: 0.9em;\n    will-change: transform;\n  }\n\n  :hover ", " {\n    fill: ", ";\n    transform: rotate(-15deg);\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.secondary;
}, Logo$1, function (_ref2) {
  var theme = _ref2.theme;
  return theme.secondary;
}, Logo$1, brand);
var BrandedFooter = /*#__PURE__*/memo(function BrandedFooter() {
  return /*#__PURE__*/jsx(Row$1, {
    justify: "center",
    children: /*#__PURE__*/jsx(UniswapA, {
      href: "https://brydge.network",
      children: /*#__PURE__*/jsxs(Row$1, {
        gap: 0.35,
        children: [/*#__PURE__*/jsx(Caption$1, {
          children: /*#__PURE__*/jsx(Trans, {
            id: "Powered by"
          })
        }), /*#__PURE__*/jsx(Logo$1, {}), /*#__PURE__*/jsx(Caption$1, {
          children: /*#__PURE__*/jsx(Trans, {
            id: "BRYDGE"
          })
        })]
      })
    })
  });
});

var _templateObject$c;

var colorAtom = atom(undefined);
var OutputColumn = styled(Column)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", "em;\n  padding: 1.25em;\n  padding-bottom: 0.75em;\n  position: relative;\n\n  // Set transitions to reduce color flashes when switching color/token.\n  // When color loads, transition the background so that it transitions from the empty or last state, but not _to_ the empty state.\n  transition: ", ";\n  > {\n    // When color is loading, delay the color/stroke so that it seems to transition from the last state.\n    transition: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.module;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius - 0.25;
}, function (_ref3) {
  var hasColor = _ref3.hasColor;
  return hasColor ? 'background-color 0.25s ease-out' : undefined;
}, function (_ref4) {
  var hasColor = _ref4.hasColor;
  return hasColor === null ? 'color 0.25s ease-in, stroke 0.25s ease-in' : undefined;
});

function Output(_ref5) {
  var children = _ref5.children; // const { i18n } = useLingui()
  // const {
  //   // [Field.OUTPUT]: { balance, amount: outputCurrencyAmount, usdc: outputUSDC },
  //   // trade: { state: tradeState },
  //   // impact,
  // } = useSwapInfo()

  var _useSwapCurrency = useSwapCurrency(Field$1.OUTPUT),
      _useSwapCurrency2 = _slicedToArray(_useSwapCurrency, 1),
      swapOutputCurrency //  updateSwapOutputCurrency
  = _useSwapCurrency2[0];

  var overrideColor = useAtomValue(colorAtom);
  var dynamicColor = useCurrencyColor(swapOutputCurrency);
  var color = overrideColor || dynamicColor; // different state true/null/false allow smoother color transition

  var hasColor = swapOutputCurrency ? Boolean(color) || null : false;
  return /*#__PURE__*/jsx(DynamicThemeProvider, {
    color: color,
    children: /*#__PURE__*/jsxs(OutputColumn, {
      hasColor: hasColor,
      gap: 0.75,
      children: [children, /*#__PURE__*/jsx(BrandedFooter, {})]
    })
  });
}

function useHasHover(node) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasHover = _useState2[0],
      setHasHover = _useState2[1];

  var onMouseEnter = useCallback(function () {
    return setHasHover(true);
  }, []);
  var onMouseLeave = useCallback(function (e) {
    return setHasHover(false);
  }, []);
  useEffect(function () {
    node === null || node === void 0 ? void 0 : node.addEventListener('mouseenter', onMouseEnter);
    node === null || node === void 0 ? void 0 : node.addEventListener('mouseleave', onMouseLeave);
    return function () {
      node === null || node === void 0 ? void 0 : node.removeEventListener('mouseenter', onMouseEnter);
      node === null || node === void 0 ? void 0 : node.removeEventListener('mouseleave', onMouseLeave);
    };
  }, [node, onMouseEnter, onMouseLeave]);
  return hasHover;
}

var _templateObject$b;

function useTooltip(tooltip) {
  var hover = useHasHover(tooltip);
  var focus = useHasFocus(tooltip);
  return hover || focus;
}

var IconTooltip = styled(IconButton)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  cursor: help;\n"])));

function Tooltip(_ref) {
  var _ref$icon = _ref.icon,
      Icon = _ref$icon === void 0 ? HelpCircle : _ref$icon,
      iconProps = _ref.iconProps,
      children = _ref.children,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'auto' : _ref$placement,
      offset = _ref.offset,
      contained = _ref.contained;
  var tooltip = useRef(null);
  var showTooltip = useTooltip(tooltip.current);
  return /*#__PURE__*/jsx(Popover, {
    content: children,
    show: showTooltip,
    placement: placement,
    offset: offset,
    contained: contained,
    children: /*#__PURE__*/jsx(IconTooltip, {
      icon: Icon,
      iconProps: iconProps,
      ref: tooltip
    })
  });
}

var _templateObject$a;

var optionCss = function optionCss(selected) {
  return css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: ", "em;\n  color: ", " !important;\n  display: grid;\n  grid-gap: 0.25em;\n  padding: calc(0.75em - 1px) 0.625em;\n\n  :enabled {\n    border: 1px solid ", ";\n  }\n\n  :enabled:hover {\n    border-color: ", ";\n  }\n\n  :enabled:focus-within {\n    border-color: ", ";\n  }\n"])), function (_ref) {
    var theme = _ref.theme;
    return selected ? theme.active : theme.outline;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.borderRadius * 0.75;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.primary;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return selected ? theme.active : theme.outline;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.onHover(selected ? theme.active : theme.outline);
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.active;
  });
};

function Label(_ref8) {
  var name = _ref8.name,
      tooltip = _ref8.tooltip;
  return /*#__PURE__*/jsxs(Row$1, {
    gap: 0.5,
    justify: "flex-start",
    children: [/*#__PURE__*/jsx(Subhead2, {
      children: name
    }), tooltip && /*#__PURE__*/jsx(Tooltip, {
      placement: "top",
      contained: true,
      children: /*#__PURE__*/jsx(Caption$1, {
        children: tooltip
      })
    })]
  });
}

var _templateObject$9, _templateObject2$4;

var tooltip = /*#__PURE__*/jsx(Trans, {
  id: "Your transaction will revert if the price changes unfavorably by more than this percentage."
});
var highSlippage = /*#__PURE__*/jsx(Trans, {
  id: "High slippage increases the risk of price movement"
});
var invalidSlippage = /*#__PURE__*/jsx(Trans, {
  id: "Please enter a valid slippage %"
});
var placeholder = '0.10';
var Button = styled(TextButton)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var selected = _ref.selected;
  return optionCss(selected);
});
var Custom = styled(BaseButton)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  padding: calc(0.75em - 3px) 0.625em;\n"])), function (_ref2) {
  var selected = _ref2.selected;
  return optionCss(selected);
}, inputCss);
var Option = /*#__PURE__*/forwardRef(function Option(_ref3, ref) {
  var Wrapper = _ref3.wrapper,
      children = _ref3.children,
      selected = _ref3.selected,
      onSelect = _ref3.onSelect,
      icon = _ref3.icon,
      tabIndex = _ref3.tabIndex;
  return /*#__PURE__*/jsx(Wrapper, {
    selected: selected,
    onClick: onSelect,
    ref: ref,
    tabIndex: tabIndex,
    children: /*#__PURE__*/jsxs(Row$1, {
      gap: 0.5,
      children: [children, icon ? icon : /*#__PURE__*/jsx(LargeIcon, {
        icon: selected ? Check : undefined,
        size: 1.25
      })]
    })
  });
});
var Warning = /*#__PURE__*/memo(function Warning(_ref4) {
  var state = _ref4.state,
      showTooltip = _ref4.showTooltip;
  var icon;
  var content;
  var show = showTooltip;

  switch (state) {
    case 'error':
      icon = XOctagon;
      content = invalidSlippage;
      show = true;
      break;

    case 'warning':
      icon = AlertTriangle;
      content = highSlippage;
      break;
  }

  return /*#__PURE__*/jsx(Popover, {
    content: /*#__PURE__*/jsx(Caption$1, {
      children: content
    }),
    show: show,
    placement: "top",
    offset: 16,
    contained: true,
    children: /*#__PURE__*/jsx(LargeIcon, {
      icon: icon,
      color: state,
      size: 1.25
    })
  }, state);
});

function MaxSlippageSelect() {
  var _useAtom = useAtom(autoSlippageAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      autoSlippage = _useAtom2[0],
      setAutoSlippage = _useAtom2[1];

  var _useAtom3 = useAtom(maxSlippageAtom),
      _useAtom4 = _slicedToArray(_useAtom3, 2),
      maxSlippage = _useAtom4[0],
      setMaxSlippage = _useAtom4[1];

  var maxSlippageInput = useMemo(function () {
    return (maxSlippage === null || maxSlippage === void 0 ? void 0 : maxSlippage.toString()) || '';
  }, [maxSlippage]);
  var option = useRef(null);
  var showTooltip = useTooltip(option.current);
  var input = useRef(null);
  var focus = useCallback(function () {
    var _input$current;

    return (_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.focus();
  }, [input]);

  var _useState = useState(getSlippageWarning(toPercent(maxSlippage))),
      _useState2 = _slicedToArray(_useState, 2),
      warning = _useState2[0],
      setWarning = _useState2[1];

  useEffect(function () {
    setWarning(getSlippageWarning(toPercent(maxSlippage)));
  }, [maxSlippage]);
  var onInputSelect = useCallback(function () {
    focus();
    var percent = toPercent(maxSlippage);
    var warning = getSlippageWarning(percent);
    setAutoSlippage(!percent || warning === 'error');
  }, [focus, maxSlippage, setAutoSlippage]);
  var processValue = useCallback(function (value) {
    var percent = toPercent(value);
    var warning = getSlippageWarning(percent);
    setMaxSlippage(value);
    setAutoSlippage(!percent || warning === 'error');
  }, [setAutoSlippage, setMaxSlippage]);
  return /*#__PURE__*/jsxs(Column, {
    gap: 0.75,
    children: [/*#__PURE__*/jsx(Label, {
      name: /*#__PURE__*/jsx(Trans, {
        id: "Max slippage"
      }),
      tooltip: tooltip
    }), /*#__PURE__*/jsxs(Row$1, {
      gap: 0.5,
      grow: "last",
      children: [/*#__PURE__*/jsx(Option, {
        wrapper: Button,
        selected: autoSlippage,
        onSelect: function onSelect() {
          return setAutoSlippage(true);
        },
        children: /*#__PURE__*/jsx(ButtonMedium, {
          children: /*#__PURE__*/jsx(Trans, {
            id: "Auto"
          })
        })
      }), /*#__PURE__*/jsx(Option, {
        wrapper: Custom,
        selected: !autoSlippage,
        onSelect: onInputSelect,
        icon: warning && /*#__PURE__*/jsx(Warning, {
          state: warning,
          showTooltip: showTooltip
        }),
        ref: option,
        tabIndex: -1,
        children: /*#__PURE__*/jsxs(Row$1, {
          color: warning === 'error' ? 'error' : undefined,
          children: [/*#__PURE__*/jsx(DecimalInput, {
            size: Math.max(maxSlippageInput.length, 4),
            value: maxSlippageInput,
            onChange: function onChange(input) {
              return processValue(+input);
            },
            placeholder: placeholder,
            ref: input
          }), "%"]
        })
      })]
    })]
  });
}

var _templateObject$8;

function SettingsDialog() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      boundary = _useState2[0],
      setBoundary = _useState2[1];

  var scrollbar = useScrollbar(boundary, {
    padded: true
  });
  var resetSettings = useResetAtom(settingsAtom);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Header, {
      title: /*#__PURE__*/jsx(Trans, {
        id: "Settings"
      }),
      ruled: true,
      children: /*#__PURE__*/jsx(TextButton, {
        onClick: resetSettings,
        children: /*#__PURE__*/jsx(ButtonSmall, {
          children: /*#__PURE__*/jsx(Trans, {
            id: "Reset"
          })
        })
      })
    }), /*#__PURE__*/jsx(Column, {
      gap: 1,
      style: {
        paddingTop: '1em'
      },
      ref: setBoundary,
      padded: true,
      css: scrollbar,
      children: /*#__PURE__*/jsx(BoundaryProvider, {
        value: boundary,
        children: /*#__PURE__*/jsx(MaxSlippageSelect, {})
      })
    })]
  });
}

var SettingsButton = styled(IconButton)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  ", " {\n    transform: ", ";\n    transition: ", ";\n    will-change: transform;\n  }\n"])), Settings$1, function (_ref) {
  var hover = _ref.hover;
  return hover && 'rotate(45deg)';
}, function (_ref2) {
  var hover = _ref2.hover;
  return hover && 'transform 0.25s';
});

function Settings(_ref3) {
  var disabled = _ref3.disabled;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hover = _useState6[0],
      setHover = _useState6[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(SettingsButton, {
      disabled: disabled,
      hover: hover,
      onClick: function onClick() {
        return setOpen(true);
      },
      onMouseEnter: function onMouseEnter() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      icon: Settings$1
    }), open && /*#__PURE__*/jsx(Dialog, {
      color: "module",
      onClose: function onClose() {
        return setOpen(false);
      },
      children: /*#__PURE__*/jsx(SettingsDialog, {})
    })]
  });
}

var _templateObject$7, _templateObject2$3, _templateObject3$2, _templateObject4$1, _templateObject5;

var StyledButton = styled(Button$1)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  border-radius: ", "em;\n  flex-grow: 1;\n  transition: background-color 0.25s ease-out, border-radius 0.25s ease-out, flex-grow 0.25s ease-out;\n\n  :disabled {\n    margin: -1px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius * 0.75;
});
var ActionRow = styled(Row$1)(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral([""])));
var grow = keyframes(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    width: 0;\n  }\n  to {\n    opacity: 1;\n    width: max-content;\n  }\n"])));
var actionCss = css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  padding: calc(0.25em - 1px);\n  padding-left: calc(0.75em - 1px);\n\n  ", " {\n    animation: ", " 0.25s ease-in;\n    flex-grow: 1;\n    justify-content: flex-start;\n    white-space: nowrap;\n  }\n\n  ", " {\n    border-radius: ", "em;\n    flex-grow: 0;\n    padding: 1em;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.outline;
}, ActionRow, grow, StyledButton, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
});
var Overlay = styled(Row$1)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border-radius: ", "em;\n  flex-direction: row-reverse;\n  min-height: 3.5em;\n  transition: padding 0.25s ease-out;\n\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var hasAction = _ref5.hasAction;
  return hasAction && actionCss;
});

function ActionButton(_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? 'accent' : _ref6$color,
      disabled = _ref6.disabled,
      action = _ref6.action,
      onClick = _ref6.onClick,
      children = _ref6.children;
  var textColor = useMemo(function () {
    return color === 'accent' && !disabled ? 'onAccent' : 'currentColor';
  }, [color, disabled]);
  return /*#__PURE__*/jsxs(Overlay, {
    hasAction: Boolean(action),
    flex: true,
    align: "stretch",
    children: [(action ? action.onClick : true) && /*#__PURE__*/jsx(StyledButton, {
      color: color,
      disabled: disabled,
      onClick: (action === null || action === void 0 ? void 0 : action.onClick) || onClick,
      children: /*#__PURE__*/jsx(TransitionButton, {
        buttonSize: action ? 'medium' : 'large',
        color: textColor,
        children: (action === null || action === void 0 ? void 0 : action.children) || children
      })
    }), action && /*#__PURE__*/jsxs(ActionRow, {
      gap: 0.5,
      children: [/*#__PURE__*/jsx(LargeIcon, {
        color: "currentColor",
        icon: action.icon || AlertTriangle
      }), /*#__PURE__*/jsx(Subhead2, {
        children: action === null || action === void 0 ? void 0 : action.message
      })]
    })]
  });
}

var _templateObject$6, _templateObject2$2, _templateObject3$1;

var HeaderColumn = styled(Column)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  transition: gap 0.25s;\n"])));
var ExpandoColumn = styled(Column)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  height: ", "em;\n  overflow: hidden;\n  position: relative;\n  transition: height 0.25s, padding 0.25s;\n\n  :after {\n    background: linear-gradient(transparent, ", ");\n    bottom: 0;\n    content: '';\n    height: 0.75em;\n    pointer-events: none;\n    position: absolute;\n    width: calc(100% - 1em);\n  }\n"])), function (_ref) {
  var height = _ref.height,
      open = _ref.open;
  return open ? height : 0;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.dialog;
});
var InnerColumn = styled(Column)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  height: ", "em;\n  padding: 0.5em 0;\n"])), function (_ref3) {
  var height = _ref3.height;
  return height;
});
/** A scrollable Expando with an absolute height. */

function Expando(_ref4) {
  var title = _ref4.title,
      open = _ref4.open,
      onExpand = _ref4.onExpand,
      height = _ref4.height,
      children = _ref4.children; // eslint-disable-next-line @typescript-eslint/no-unused-vars

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2);

  _useState2[0];
  var setScrollingEl = _useState2[1]; // const scrollbar = useScrollbar(scrollingEl)

  return /*#__PURE__*/jsxs(Column, {
    children: [/*#__PURE__*/jsxs(HeaderColumn, {
      gap: open ? 0.5 : 0.75,
      children: [/*#__PURE__*/jsx(Rule, {}), /*#__PURE__*/jsxs(Row$1, {
        children: [title, /*#__PURE__*/jsx(IconButton, {
          color: "secondary",
          onClick: onExpand,
          icon: Expando$1,
          iconProps: {
            open: open
          }
        })]
      }), /*#__PURE__*/jsx(Rule, {})]
    }), /*#__PURE__*/jsx(ExpandoColumn, {
      open: open,
      height: height,
      children: /*#__PURE__*/jsx(InnerColumn, {
        flex: true,
        align: "stretch",
        height: height,
        ref: setScrollingEl,
        children: children
      })
    })]
  });
}

var _templateObject$5, _templateObject2$1;

var HeaderIcon = styled(LargeIcon)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  transition: height 0.25s, width 0.25s;\n\n  svg {\n    transition: height 0.25s, width 0.25s;\n  }\n"])));

function StatusHeader(_ref) {
  var Icon = _ref.icon,
      iconColor = _ref.iconColor,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 4 : _ref$iconSize,
      children = _ref.children;
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs(Column, {
      flex: true,
      style: {
        flexGrow: 1
      },
      children: [/*#__PURE__*/jsx(HeaderIcon, {
        icon: Icon,
        color: iconColor,
        size: iconSize
      }), /*#__PURE__*/jsx(Column, {
        gap: 0.75,
        flex: true,
        style: {
          textAlign: 'center'
        },
        children: children
      })]
    })
  });
}

var ErrorHeader = styled(Column)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  transition: gap 0.25s;\n\n  div:last-child {\n    max-height: ", "em; // 3 * line-height\n    overflow-y: hidden;\n    transition: max-height 0.25s;\n  }\n"])), function (_ref2) {
  var open = _ref2.open;
  return open ? 0 : 60 / 14;
});

function ErrorDialog(_ref3) {
  var header = _ref3.header,
      error = _ref3.error,
      action = _ref3.action,
      onClick = _ref3.onClick;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onExpand = useCallback(function () {
    return setOpen(function (open) {
      return !open;
    });
  }, []);
  return /*#__PURE__*/jsxs(Column, {
    flex: true,
    padded: true,
    gap: 0.75,
    align: "stretch",
    style: {
      height: '100%'
    },
    children: [/*#__PURE__*/jsx(StatusHeader, {
      icon: AlertTriangle,
      iconColor: "error",
      iconSize: open ? 3 : 4,
      children: /*#__PURE__*/jsxs(ErrorHeader, {
        gap: open ? 0 : 0.75,
        open: open,
        children: [/*#__PURE__*/jsx(Subhead1, {
          children: /*#__PURE__*/jsx(Trans, {
            id: "Something went wrong."
          })
        }), /*#__PURE__*/jsx(Body2, {
          children: header
        })]
      })
    }), /*#__PURE__*/jsxs(Column, {
      gap: open ? 0 : 0.75,
      style: {
        transition: 'gap 0.25s'
      },
      children: [/*#__PURE__*/jsx(Expando, {
        title: /*#__PURE__*/jsx(Trans, {
          id: "Error details"
        }),
        open: open,
        onExpand: onExpand,
        height: 7.5,
        children: /*#__PURE__*/jsxs(Code, {
          userSelect: true,
          children: [error.name, error.message ? ": ".concat(error.message) : '']
        })
      }), /*#__PURE__*/jsx(ActionButton, {
        onClick: onClick,
        children: action
      })]
    })]
  });
}

var _ETHERSCAN_PREFIXES;

var ETHERSCAN_PREFIXES = (_ETHERSCAN_PREFIXES = {}, _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.MAINNET, 'https://etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.ROPSTEN, 'https://ropsten.etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.RINKEBY, 'https://rinkeby.etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.GOERLI, 'https://goerli.etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.KOVAN, 'https://kovan.etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.OPTIMISM, 'https://optimistic.etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.OPTIMISTIC_KOVAN, 'https://kovan-optimistic.etherscan.io'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.POLYGON_MUMBAI, 'https://mumbai.polygonscan.com'), _defineProperty(_ETHERSCAN_PREFIXES, SupportedChainId.POLYGON, 'https://polygonscan.com'), _ETHERSCAN_PREFIXES);
var ExplorerDataType;
/**
 * Return the explorer link for the given data and data type
 * @param chainId the ID of the chain for which to return the data
 * @param data the data to return a link for
 * @param type the type of the data
 */

(function (ExplorerDataType) {
  ExplorerDataType["TRANSACTION"] = "transaction";
  ExplorerDataType["TOKEN"] = "token";
  ExplorerDataType["ADDRESS"] = "address";
  ExplorerDataType["BLOCK"] = "block";
})(ExplorerDataType || (ExplorerDataType = {}));

function getExplorerLink(chainId, data, type) {
  var _ETHERSCAN_PREFIXES$c;

  if (chainId === SupportedChainId.ARBITRUM_ONE) {
    switch (type) {
      case ExplorerDataType.TRANSACTION:
        return "https://arbiscan.io/tx/".concat(data);

      case ExplorerDataType.ADDRESS:
      case ExplorerDataType.TOKEN:
        return "https://arbiscan.io/address/".concat(data);

      case ExplorerDataType.BLOCK:
        return "https://arbiscan.io/block/".concat(data);

      default:
        return "https://arbiscan.io/";
    }
  }

  if (chainId === SupportedChainId.ARBITRUM_RINKEBY) {
    switch (type) {
      case ExplorerDataType.TRANSACTION:
        return "https://rinkeby-explorer.arbitrum.io/tx/".concat(data);

      case ExplorerDataType.ADDRESS:
      case ExplorerDataType.TOKEN:
        return "https://rinkeby-explorer.arbitrum.io/address/".concat(data);

      case ExplorerDataType.BLOCK:
        return "https://rinkeby-explorer.arbitrum.io/block/".concat(data);

      default:
        return "https://rinkeby-explorer.arbitrum.io/";
    }
  }

  var prefix = (_ETHERSCAN_PREFIXES$c = ETHERSCAN_PREFIXES[chainId]) !== null && _ETHERSCAN_PREFIXES$c !== void 0 ? _ETHERSCAN_PREFIXES$c : 'https://etherscan.io';

  switch (type) {
    case ExplorerDataType.TRANSACTION:
      return "".concat(prefix, "/tx/").concat(data);

    case ExplorerDataType.TOKEN:
      return "".concat(prefix, "/token/").concat(data);

    case ExplorerDataType.BLOCK:
      if (chainId === SupportedChainId.OPTIMISM || chainId === SupportedChainId.OPTIMISTIC_KOVAN) {
        return "".concat(prefix, "/tx/").concat(data);
      }

      return "".concat(prefix, "/block/").concat(data);

    case ExplorerDataType.ADDRESS:
      return "".concat(prefix, "/address/").concat(data);

    default:
      return "".concat(prefix);
  }
}

var _templateObject$4;

var errorMessage = /*#__PURE__*/jsx(Trans, {
  id: "Try increasing your slippage tolerance.<0/>",
  components: {
    0: /*#__PURE__*/jsx("br", {})
  }
});
var Padding = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  padding: 32px;\n"])));

function TransactionStatus(_ref) {
  var tx = _ref.tx,
      sourceChainId = _ref.sourceChainId;
  var value = useColorModeValue(lightTheme.accent, darkTheme.accent);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Header, {
      title: /*#__PURE__*/jsx(Trans, {
        id: "Transaction Confirmation"
      }),
      ruled: true
    }), /*#__PURE__*/jsxs(AutoColumn, {
      gap: "12px",
      justify: 'center',
      children: [/*#__PURE__*/jsx(Padding, {
        children: /*#__PURE__*/jsx(ArrowUpCircle, {
          strokeWidth: 0.5,
          size: '90px'
        })
      }), /*#__PURE__*/jsx(Text, {
        fontWeight: 500,
        fontSize: 20,
        textAlign: "center",
        children: /*#__PURE__*/jsx(Trans, {
          id: "Transaction Submitted"
        })
      }), sourceChainId && tx.info.response.hash && /*#__PURE__*/jsx(Link$1, {
        href: getExplorerLink(sourceChainId, tx.info.response.hash, ExplorerDataType.TRANSACTION),
        color: value,
        isExternal: true,
        children: /*#__PURE__*/jsx(Text, {
          fontWeight: 500,
          fontSize: 14,
          textAlign: "center",
          children: /*#__PURE__*/jsx(Trans, {
            id: "View on Explorer"
          })
        })
      })]
    })]
  });
}

function TransactionStatusDialog(_ref2) {
  var _tx$receipt;

  var tx = _ref2.tx,
      sourceChainId = _ref2.sourceChainId,
      onClose = _ref2.onClose;
  return ((_tx$receipt = tx.receipt) === null || _tx$receipt === void 0 ? void 0 : _tx$receipt.status) === 0 ? /*#__PURE__*/jsx(ErrorDialog, {
    header: errorMessage,
    error: new Error('TODO'),
    action: /*#__PURE__*/jsx(Trans, {
      id: "Dismiss"
    }),
    onClick: onClose
  }) : /*#__PURE__*/jsx(TransactionStatus, {
    tx: tx,
    sourceChainId: sourceChainId,
    onClose: onClose
  });
}

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param signatureData the signature data of the permit of the input token amount, if available
 */


function useSwapCallArguments(trade, allowedSlippage, signatureData, deadline, feeOptions) {
  var _useActiveWeb3React = useActiveWeb3React(),
      account = _useActiveWeb3React.account;

  var _useJsonRPCWeb3React = useJsonRPCWeb3React(),
      chainId = _useJsonRPCWeb3React.chainId,
      library = _useJsonRPCWeb3React.library;

  deadline = BigNumber.from(Date.now() + ONE_HOUR_IN_MS);
  var recipient = POLYGON_PORTAL_ADDRESS;
  var routerContract = useV2RouterContract();
  var tradeAsV2 = useBestV2Trade(TradeType.EXACT_OUTPUT, trade ? trade.outputAmount ? trade.outputAmount : undefined : undefined, trade ? trade.inputAmount ? trade.inputAmount.currency : undefined : undefined);
  var swapCallArgs = useMemo(function () {
    if (!trade || !recipient || !library || !account || !chainId || !deadline) return [];

    if (isQuickswapTrade(trade)) {
      if (!routerContract || !tradeAsV2) return [];
      var swapMethods = [];
      swapMethods.push(Router.swapCallParameters(tradeAsV2, {
        feeOnTransfer: false,
        // ?
        allowedSlippage: allowedSlippage,
        recipient: recipient,
        deadline: deadline.toNumber()
      }));

      if (trade.tradeType === TradeType.EXACT_INPUT) {
        swapMethods.push(Router.swapCallParameters(tradeAsV2, {
          feeOnTransfer: true,
          allowedSlippage: allowedSlippage,
          recipient: recipient,
          deadline: deadline.toNumber()
        }));
      }

      return swapMethods.map(function (_ref) {
        var methodName = _ref.methodName,
            args = _ref.args,
            value = _ref.value;
        return {
          address: routerContract.address,
          calldata: routerContract.interface.encodeFunctionData(methodName, args),
          value: value
        };
      });
    } else {
      // swap options shared by v3 and v2+v3 swap routers
      var sharedSwapOptions = _objectSpread$4({
        fee: feeOptions,
        recipient: recipient,
        slippageTolerance: allowedSlippage
      }, signatureData ? {
        inputTokenPermit: 'allowed' in signatureData ? {
          expiry: signatureData.deadline,
          nonce: signatureData.nonce,
          s: signatureData.s,
          r: signatureData.r,
          v: signatureData.v
        } : {
          deadline: signatureData.deadline,
          amount: signatureData.amount,
          s: signatureData.s,
          r: signatureData.r,
          v: signatureData.v
        }
      } : {});

      var swapRouterAddress = chainId ? trade instanceof Trade$3 ? V3_ROUTER_ADDRESS[chainId] : SWAP_ROUTER_ADDRESSES[chainId] : undefined;
      if (!swapRouterAddress) return [];

      var _ref2 = trade instanceof Trade$3 ? SwapRouter.swapCallParameters(trade, _objectSpread$4(_objectSpread$4({}, sharedSwapOptions), {}, {
        deadline: deadline.toString()
      })) : SwapRouter$1.swapCallParameters(trade, _objectSpread$4(_objectSpread$4({}, sharedSwapOptions), {}, {
        deadlineOrPreviousBlockhash: deadline.toString()
      })),
          value = _ref2.value,
          calldata = _ref2.calldata;

      return [{
        address: swapRouterAddress,
        calldata: calldata,
        value: value
      }];
    }
  }, [account, allowedSlippage, chainId, deadline, feeOptions, library, recipient, routerContract, signatureData, trade, tradeAsV2]);
  return swapCallArgs;
}

var _, _3;

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var PermitType; // 20 minutes to submit after signing

(function (PermitType) {
  PermitType[PermitType["AMOUNT"] = 1] = "AMOUNT";
  PermitType[PermitType["ALLOWED"] = 2] = "ALLOWED";
})(PermitType || (PermitType = {}));

var PERMIT_VALIDITY_BUFFER = 20 * 60; // todo: read this information from extensions on token lists or elsewhere (permit registry?)

var PERMITTABLE_TOKENS = {
  1: (_ = {}, _defineProperty(_, USDC_MAINNET.address, {
    type: PermitType.AMOUNT,
    name: 'USD Coin',
    version: '2'
  }), _defineProperty(_, DAI.address, {
    type: PermitType.ALLOWED,
    name: 'Dai Stablecoin',
    version: '1'
  }), _defineProperty(_, UNI[1].address, {
    type: PermitType.AMOUNT,
    name: 'Uniswap'
  }), _),
  4: _defineProperty({
    '0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735': {
      type: PermitType.ALLOWED,
      name: 'Dai Stablecoin',
      version: '1'
    }
  }, UNI[4].address, {
    type: PermitType.AMOUNT,
    name: 'Uniswap'
  }),
  3: (_3 = {}, _defineProperty(_3, UNI[3].address, {
    type: PermitType.AMOUNT,
    name: 'Uniswap'
  }), _defineProperty(_3, '0x07865c6E87B9F70255377e024ace6630C1Eaa37F', {
    type: PermitType.AMOUNT,
    name: 'USD Coin',
    version: '2'
  }), _3),
  5: _defineProperty({}, UNI[5].address, {
    type: PermitType.AMOUNT,
    name: 'Uniswap'
  }),
  42: _defineProperty({}, UNI[42].address, {
    type: PermitType.AMOUNT,
    name: 'Uniswap'
  })
};
var UseERC20PermitState;

(function (UseERC20PermitState) {
  UseERC20PermitState[UseERC20PermitState["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
  UseERC20PermitState[UseERC20PermitState["LOADING"] = 1] = "LOADING";
  UseERC20PermitState[UseERC20PermitState["NOT_SIGNED"] = 2] = "NOT_SIGNED";
  UseERC20PermitState[UseERC20PermitState["SIGNED"] = 3] = "SIGNED";
})(UseERC20PermitState || (UseERC20PermitState = {}));

var EIP712_DOMAIN_TYPE = [{
  name: 'name',
  type: 'string'
}, {
  name: 'version',
  type: 'string'
}, {
  name: 'chainId',
  type: 'uint256'
}, {
  name: 'verifyingContract',
  type: 'address'
}];
var EIP712_DOMAIN_TYPE_NO_VERSION = [{
  name: 'name',
  type: 'string'
}, {
  name: 'chainId',
  type: 'uint256'
}, {
  name: 'verifyingContract',
  type: 'address'
}];
var EIP2612_TYPE = [{
  name: 'owner',
  type: 'address'
}, {
  name: 'spender',
  type: 'address'
}, {
  name: 'value',
  type: 'uint256'
}, {
  name: 'nonce',
  type: 'uint256'
}, {
  name: 'deadline',
  type: 'uint256'
}];
var PERMIT_ALLOWED_TYPE = [{
  name: 'holder',
  type: 'address'
}, {
  name: 'spender',
  type: 'address'
}, {
  name: 'nonce',
  type: 'uint256'
}, {
  name: 'expiry',
  type: 'uint256'
}, {
  name: 'allowed',
  type: 'bool'
}];

function useERC20Permit(currencyAmount, spender, transactionDeadline, overridePermitInfo) {
  var _currencyAmount$curre, _PERMITTABLE_TOKENS$c;

  var _useActiveWeb3React = useActiveWeb3React(),
      account = _useActiveWeb3React.account,
      chainId = _useActiveWeb3React.chainId,
      library = _useActiveWeb3React.library;

  var tokenAddress = currencyAmount !== null && currencyAmount !== void 0 && (_currencyAmount$curre = currencyAmount.currency) !== null && _currencyAmount$curre !== void 0 && _currencyAmount$curre.isToken ? currencyAmount.currency.address : undefined;
  var eip2612Contract = useEIP2612Contract(tokenAddress);
  var nonceInputs = useMemo(function () {
    return [account !== null && account !== void 0 ? account : undefined];
  }, [account]);
  var tokenNonceState = useSingleCallResultWithChainId(chainId, eip2612Contract, 'nonces', nonceInputs);
  var permitInfo = overridePermitInfo !== null && overridePermitInfo !== void 0 ? overridePermitInfo : chainId && tokenAddress ? (_PERMITTABLE_TOKENS$c = PERMITTABLE_TOKENS[chainId]) === null || _PERMITTABLE_TOKENS$c === void 0 ? void 0 : _PERMITTABLE_TOKENS$c[tokenAddress] : undefined;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      signatureData = _useState2[0],
      setSignatureData = _useState2[1];

  return useMemo(function () {
    var _tokenNonceState$resu, _tokenNonceState$resu2;

    if (!currencyAmount || !eip2612Contract || !account || !chainId || !transactionDeadline || !library || !tokenNonceState.valid || !tokenAddress || !spender || !permitInfo) {
      return {
        state: UseERC20PermitState.NOT_APPLICABLE,
        signatureData: null,
        gatherPermitSignature: null
      };
    }

    var nonceNumber = (_tokenNonceState$resu = tokenNonceState.result) === null || _tokenNonceState$resu === void 0 ? void 0 : (_tokenNonceState$resu2 = _tokenNonceState$resu[0]) === null || _tokenNonceState$resu2 === void 0 ? void 0 : _tokenNonceState$resu2.toNumber();

    if (tokenNonceState.loading || typeof nonceNumber !== 'number') {
      return {
        state: UseERC20PermitState.LOADING,
        signatureData: null,
        gatherPermitSignature: null
      };
    }

    var isSignatureDataValid = signatureData && signatureData.owner === account && signatureData.deadline >= transactionDeadline.toNumber() && signatureData.tokenAddress === tokenAddress && signatureData.nonce === nonceNumber && signatureData.spender === spender && ('allowed' in signatureData || JSBI.equal(JSBI.BigInt(signatureData.amount), currencyAmount.quotient));
    return {
      state: isSignatureDataValid ? UseERC20PermitState.SIGNED : UseERC20PermitState.NOT_SIGNED,
      signatureData: isSignatureDataValid ? signatureData : null,
      gatherPermitSignature: function () {
        var _gatherPermitSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var allowed, signatureDeadline, value, message, domain, data;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  allowed = permitInfo.type === PermitType.ALLOWED;
                  signatureDeadline = transactionDeadline.toNumber() + PERMIT_VALIDITY_BUFFER;
                  value = currencyAmount.quotient.toString();
                  message = allowed ? {
                    holder: account,
                    spender: spender,
                    allowed: allowed,
                    nonce: nonceNumber,
                    expiry: signatureDeadline
                  } : {
                    owner: account,
                    spender: spender,
                    value: value,
                    nonce: nonceNumber,
                    deadline: signatureDeadline
                  };
                  domain = permitInfo.version ? {
                    name: permitInfo.name,
                    version: permitInfo.version,
                    verifyingContract: tokenAddress,
                    chainId: chainId
                  } : {
                    name: permitInfo.name,
                    verifyingContract: tokenAddress,
                    chainId: chainId
                  };
                  data = JSON.stringify({
                    types: {
                      EIP712Domain: permitInfo.version ? EIP712_DOMAIN_TYPE : EIP712_DOMAIN_TYPE_NO_VERSION,
                      Permit: allowed ? PERMIT_ALLOWED_TYPE : EIP2612_TYPE
                    },
                    domain: domain,
                    primaryType: 'Permit',
                    message: message
                  });
                  return _context.abrupt("return", library.send('eth_signTypedData_v4', [account, data]).then(splitSignature).then(function (signature) {
                    setSignatureData(_objectSpread$3(_objectSpread$3({
                      v: signature.v,
                      r: signature.r,
                      s: signature.s,
                      deadline: signatureDeadline
                    }, allowed ? {
                      allowed: allowed
                    } : {
                      amount: value
                    }), {}, {
                      nonce: nonceNumber,
                      chainId: chainId,
                      owner: account,
                      spender: spender,
                      tokenAddress: tokenAddress,
                      permitType: permitInfo.type
                    }));
                  }));

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function gatherPermitSignature() {
          return _gatherPermitSignature.apply(this, arguments);
        }

        return gatherPermitSignature;
      }()
    };
  }, [currencyAmount, eip2612Contract, account, chainId, transactionDeadline, library, tokenNonceState.loading, tokenNonceState.valid, tokenNonceState.result, tokenAddress, spender, permitInfo, signatureData]);
}

function useERC20PermitFromTrade(trade, allowedSlippage, transactionDeadline) {
  var _useActiveWeb3React2 = useActiveWeb3React(),
      chainId = _useActiveWeb3React2.chainId;

  var swapRouterAddress = chainId ? // v2 router does not support
  trade instanceof Trade$1 ? undefined : trade instanceof Trade$3 ? V3_ROUTER_ADDRESS[chainId] : SWAP_ROUTER_ADDRESSES[chainId] : undefined;
  var amountToApprove = useMemo(function () {
    return trade ? trade.maximumAmountIn(allowedSlippage) : undefined;
  }, [trade, allowedSlippage]);
  return useERC20Permit(amountToApprove, swapRouterAddress, transactionDeadline, null);
}

function useCurrentBlockTimestampWithChainId(chainId) {
  var _useSingleCallResultW, _useSingleCallResultW2, _useSingleCallResultW3;

  var multicall = useInterfaceMulticallWithChainId(chainId);
  var resultStr = (_useSingleCallResultW = useSingleCallResultWithChainId(chainId, multicall, 'getCurrentBlockTimestamp')) === null || _useSingleCallResultW === void 0 ? void 0 : (_useSingleCallResultW2 = _useSingleCallResultW.result) === null || _useSingleCallResultW2 === void 0 ? void 0 : (_useSingleCallResultW3 = _useSingleCallResultW2[0]) === null || _useSingleCallResultW3 === void 0 ? void 0 : _useSingleCallResultW3.toString();
  return useMemo(function () {
    return typeof resultStr === 'string' ? BigNumber.from(resultStr) : undefined;
  }, [resultStr]);
}
/** Returns the default transaction TTL for the chain, in minutes. */


function useDefaultTransactionTtl() {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React.chainId;

  if (chainId && L2_CHAIN_IDS.includes(chainId)) return L2_DEADLINE_FROM_NOW / 60;
  return DEFAULT_DEADLINE_FROM_NOW / 60;
}
/** Returns the user-inputted transaction TTL, in minutes. */


function useTransactionTtl() {
  return useAtom(transactionTtlAtom);
} // combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction


function useTransactionDeadline() {
  var _useTransactionTtl = useTransactionTtl(),
      _useTransactionTtl2 = _slicedToArray(_useTransactionTtl, 1),
      ttl = _useTransactionTtl2[0];

  var defaultTtl = useDefaultTransactionTtl();
  var blockTimestamp = useCurrentBlockTimestampWithChainId();
  return useMemo(function () {
    if (!blockTimestamp) return undefined;
    return blockTimestamp.add((ttl || defaultTtl
    /* in seconds */
    ) * 60);
  }, [blockTimestamp, defaultTtl, ttl]);
}

function useTokenAllowance(token, owner, spender) {
  var contract = useTokenContract(token === null || token === void 0 ? void 0 : token.address, false);
  var inputs = useMemo(function () {
    return [owner, spender];
  }, [owner, spender]);
  var allowance = useSingleCallResultWithChainId(token === null || token === void 0 ? void 0 : token.chainId, contract, 'allowance', inputs).result;
  return useMemo(function () {
    return token && allowance ? CurrencyAmount.fromRawAmount(token, allowance.toString()) : undefined;
  }, [token, allowance]);
}
/**
 * Returns the gas value plus a margin for unexpected or variable gas costs
 * @param value the gas value to pad
 */


function calculateGasMargin(value) {
  return value.mul(120).div(100);
}

var ApprovalState;

(function (ApprovalState) {
  ApprovalState["UNKNOWN"] = "UNKNOWN";
  ApprovalState["NOT_APPROVED"] = "NOT_APPROVED";
  ApprovalState["PENDING"] = "PENDING";
  ApprovalState["APPROVED"] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));

function useApprovalStateForSpender(amountToApprove, spender, useIsPendingApproval) {
  var _amountToApprove$curr;

  var _useActiveWeb3React = useActiveWeb3React(),
      account = _useActiveWeb3React.account;

  var token = amountToApprove !== null && amountToApprove !== void 0 && (_amountToApprove$curr = amountToApprove.currency) !== null && _amountToApprove$curr !== void 0 && _amountToApprove$curr.isToken ? amountToApprove.currency : undefined;
  var currentAllowance = useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
  var pendingApproval = useIsPendingApproval(token, spender);
  return useMemo(function () {
    if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
    if (amountToApprove.currency.isNative) return ApprovalState.APPROVED; // we might not have enough data to know whether or not we need to approve

    if (!currentAllowance) return ApprovalState.UNKNOWN; // amountToApprove will be defined if currentAllowance is

    return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
  }, [amountToApprove, currentAllowance, pendingApproval, spender]);
}

function useApproval(amountToApprove, spender, useIsPendingApproval) {
  var _amountToApprove$curr2;

  var _useActiveWeb3React2 = useActiveWeb3React(),
      chainId = _useActiveWeb3React2.chainId;

  var token = amountToApprove !== null && amountToApprove !== void 0 && (_amountToApprove$curr2 = amountToApprove.currency) !== null && _amountToApprove$curr2 !== void 0 && _amountToApprove$curr2.isToken ? amountToApprove.currency : undefined; // check the current approval status

  var approvalState = useApprovalStateForSpender(amountToApprove, spender, useIsPendingApproval);
  var tokenContract = useTokenContract(token === null || token === void 0 ? void 0 : token.address);
  var approve = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var logFailure, useExact, estimatedGas;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            logFailure = function _logFailure(error) {
              console.warn("".concat((token === null || token === void 0 ? void 0 : token.symbol) || 'Token', " approval failed:"), error);
              return;
            };

            if (!(approvalState !== ApprovalState.NOT_APPROVED)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", logFailure('approve was called unnecessarily'));

          case 5:
            if (chainId) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", logFailure('no chainId'));

          case 9:
            if (token) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", logFailure('no token'));

          case 13:
            if (tokenContract) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", logFailure('tokenContract is null'));

          case 17:
            if (amountToApprove) {
              _context.next = 21;
              break;
            }

            return _context.abrupt("return", logFailure('missing amount to approve'));

          case 21:
            if (spender) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", logFailure('no spender'));

          case 23:
            useExact = false;
            _context.next = 26;
            return tokenContract.estimateGas.approve(spender, MaxUint256).catch(function () {
              // general fallback for tokens which restrict approval amounts
              useExact = true;
              return tokenContract.estimateGas.approve(spender, amountToApprove.quotient.toString());
            });

          case 26:
            estimatedGas = _context.sent;
            return _context.abrupt("return", tokenContract.approve(spender, useExact ? amountToApprove.quotient.toString() : MaxUint256, {
              gasLimit: calculateGasMargin(estimatedGas)
            }).then(function (response) {
              return {
                response: response,
                tokenAddress: token.address,
                spenderAddress: spender
              };
            }).catch(function (error) {
              logFailure(error);
              throw error;
            }));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [approvalState, token, tokenContract, amountToApprove, spender, chainId]);
  return [approvalState, approve];
}

var SwapRouterVersion;
/**
 * Returns the swap router that will result in the least amount of txs (less gas) for a given swap.
 * Heuristic:
 * - if trade contains a single v2-only trade & V2 SwapRouter is approved: use V2 SwapRouter
 * - if trade contains only v3 & V3 SwapRouter is approved: use V3 SwapRouter
 * - else: approve and use V2+V3 SwapRouter
 */

(function (SwapRouterVersion) {
  SwapRouterVersion[SwapRouterVersion["V2"] = 0] = "V2";
  SwapRouterVersion[SwapRouterVersion["V3"] = 1] = "V3";
  SwapRouterVersion[SwapRouterVersion["V2V3"] = 2] = "V2V3";
})(SwapRouterVersion || (SwapRouterVersion = {}));

function getTxOptimizedSwapRouter(_ref) {
  var onlyV2Routes = _ref.onlyV2Routes,
      onlyV3Routes = _ref.onlyV3Routes,
      tradeHasSplits = _ref.tradeHasSplits,
      approvalStates = _ref.approvalStates;
  if ([approvalStates.v2, approvalStates.v3, approvalStates.v2V3].includes(ApprovalState.PENDING)) return undefined;
  if (approvalStates.v2V3 === ApprovalState.APPROVED) return SwapRouterVersion.V2V3;
  if (approvalStates.v2 === ApprovalState.APPROVED && onlyV2Routes && !tradeHasSplits) return SwapRouterVersion.V2;
  if (approvalStates.v3 === ApprovalState.APPROVED && onlyV3Routes) return SwapRouterVersion.V3;
  return SwapRouterVersion.V2V3;
}
/** Returns approval state for all known swap routers */


function useSwapApprovalStates(trade, allowedSlippage, useIsPendingApproval, inputCurrency) {
  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var amountToApprove = useMemo(function () {
    if (!trade) return undefined;
    var maxAmountIn = trade.maximumAmountIn(allowedSlippage).asFraction;
    var amountToApprove = inputCurrency && CurrencyAmount.fromFractionalAmount(inputCurrency.currency, maxAmountIn.numerator, maxAmountIn.denominator);
    return trade.inputAmount.currency.isToken ? amountToApprove : undefined;
  }, [trade, allowedSlippage, inputCurrency]);
  var v2RouterAddress = chainId ? V2_ROUTER_ADDRESS[chainId] : undefined;
  var v3RouterAddress = chainId ? V3_ROUTER_ADDRESS[chainId] : undefined; // const swapRouterAddress = chainId ? SWAP_ROUTER_ADDRESSES[chainId] : undefined

  var portalAddress = chainId ? PORTAL_MAP[chainId] : undefined;
  var v2 = useApprovalStateForSpender(amountToApprove, v2RouterAddress, useIsPendingApproval);
  var v3 = useApprovalStateForSpender(amountToApprove, v3RouterAddress, useIsPendingApproval); //const v2V3 = useApprovalStateForSpender(amountToApprove, swapRouterAddress, useIsPendingApproval)

  var v2V3 = useApprovalStateForSpender(amountToApprove, portalAddress, useIsPendingApproval);
  return useMemo(function () {
    return {
      v2: v2,
      v3: v3,
      v2V3: v2V3
    };
  }, [v2, v2V3, v3]);
}

function useSwapRouterAddress(trade) {
  var _useActiveWeb3React2 = useActiveWeb3React(),
      chainId = _useActiveWeb3React2.chainId;

  return useMemo(function () {
    return chainId ? PORTAL_MAP[chainId] : undefined;
  }, [chainId]);
} // wraps useApproveCallback in the context of a swap


function useSwapApproval(trade, allowedSlippage, useIsPendingApproval, amountOrCurrency) {
  var amountToApprove = useMemo(function () {
    if (!amountOrCurrency) {
      return undefined;
    }

    if (amountOrCurrency && amountOrCurrency instanceof CurrencyAmount) return amountOrCurrency;

    if (trade !== null && trade !== void 0 && trade.inputAmount.currency.isNative || !trade) {
      return undefined;
    }

    var maxInput = trade.maximumAmountIn(allowedSlippage);
    return CurrencyAmount.fromFractionalAmount(amountOrCurrency, maxInput.asFraction.numerator, maxInput.asFraction.denominator);
  }, [amountOrCurrency, trade, allowedSlippage]);
  var spender = useSwapRouterAddress();
  var approval = useApproval(amountToApprove, spender, useIsPendingApproval);
  return approval;
}

function useSwapApprovalOptimizedTrade(trade, allowedSlippage, useIsPendingApproval, amountToApprove) {
  var _trade$routes$length;

  var onlyV2Routes = trade === null || trade === void 0 ? void 0 : trade.routes.every(function (route) {
    return route.protocol === Protocol.V2;
  });
  var onlyV3Routes = trade === null || trade === void 0 ? void 0 : trade.routes.every(function (route) {
    return route.protocol === Protocol.V3;
  });
  var tradeHasSplits = ((_trade$routes$length = trade === null || trade === void 0 ? void 0 : trade.routes.length) !== null && _trade$routes$length !== void 0 ? _trade$routes$length : 0) > 1;
  var approvalStates = useSwapApprovalStates(trade, allowedSlippage, useIsPendingApproval, amountToApprove);
  var optimizedSwapRouter = useMemo(function () {
    return getTxOptimizedSwapRouter({
      onlyV2Routes: onlyV2Routes,
      onlyV3Routes: onlyV3Routes,
      tradeHasSplits: tradeHasSplits,
      approvalStates: approvalStates
    });
  }, [approvalStates, tradeHasSplits, onlyV2Routes, onlyV3Routes]);
  return useMemo(function () {
    if (!trade) return undefined;

    try {
      switch (optimizedSwapRouter) {
        case SwapRouterVersion.V2V3:
          return trade;

        case SwapRouterVersion.V2:
          var pairs = trade.swaps[0].route.pools.filter(function (pool) {
            return pool instanceof Pair;
          });
          var v2Route = new Route$1(pairs, trade.inputAmount.currency, trade.outputAmount.currency);
          return new Trade$1(v2Route, trade.inputAmount, trade.tradeType);

        case SwapRouterVersion.V3:
          return Trade$3.createUncheckedTradeWithMultipleRoutes({
            routes: trade.swaps.map(function (_ref) {
              var route = _ref.route,
                  inputAmount = _ref.inputAmount,
                  outputAmount = _ref.outputAmount;
              return {
                route: new Route(route.pools.filter(function (p) {
                  return p instanceof Pool;
                }), inputAmount.currency, outputAmount.currency),
                inputAmount: inputAmount,
                outputAmount: outputAmount
              };
            }),
            tradeType: trade.tradeType
          });

        default:
          return undefined;
      }
    } catch (e) {
      // TODO(#2989): remove try-catch
      console.debug(e);
      return undefined;
    }
  }, [trade, optimizedSwapRouter]);
}

var ApproveOrPermitState;
/**
 * Returns all relevant statuses and callback functions for approvals.
 * Considers both standard approval and ERC20 permit.
 */

(function (ApproveOrPermitState) {
  ApproveOrPermitState[ApproveOrPermitState["REQUIRES_APPROVAL"] = 0] = "REQUIRES_APPROVAL";
  ApproveOrPermitState[ApproveOrPermitState["PENDING_APPROVAL"] = 1] = "PENDING_APPROVAL";
  ApproveOrPermitState[ApproveOrPermitState["REQUIRES_SIGNATURE"] = 2] = "REQUIRES_SIGNATURE";
  ApproveOrPermitState[ApproveOrPermitState["PENDING_SIGNATURE"] = 3] = "PENDING_SIGNATURE";
  ApproveOrPermitState[ApproveOrPermitState["APPROVED"] = 4] = "APPROVED";
})(ApproveOrPermitState || (ApproveOrPermitState = {}));

var useApproveOrPermit = function useApproveOrPermit(trade, allowedSlippage, useIsPendingApproval, amountOrCurrency) {
  var deadline = useTransactionDeadline(); // Check approvals on ERC20 contract based on amount.

  var _useSwapApproval = useSwapApproval(trade, allowedSlippage, useIsPendingApproval, amountOrCurrency),
      _useSwapApproval2 = _slicedToArray(_useSwapApproval, 2),
      approval = _useSwapApproval2[0],
      getApproval = _useSwapApproval2[1]; // Check status of permit and whether token supports it.


  var _useERC20PermitFromTr = useERC20PermitFromTrade(trade, allowedSlippage, deadline),
      signatureState = _useERC20PermitFromTr.state,
      signatureData = _useERC20PermitFromTr.signatureData,
      gatherPermitSignature = _useERC20PermitFromTr.gatherPermitSignature; // If permit is supported, trigger a signature, if not create approval transaction.


  var handleApproveOrPermit = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(signatureState === UseERC20PermitState.NOT_SIGNED && gatherPermitSignature)) {
              _context.next = 16;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return gatherPermitSignature();

          case 5:
            return _context.abrupt("return", _context.sent);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);

            if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) !== 4001)) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return getApproval();

          case 13:
            return _context.abrupt("return", _context.sent);

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.next = 18;
            return getApproval();

          case 18:
            return _context.abrupt("return", _context.sent);

          case 19:
            _context.next = 23;
            break;

          case 21:
            _context.prev = 21;
            _context.t1 = _context["catch"](0);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 21], [2, 8]]);
  })), [signatureState, gatherPermitSignature, getApproval]);
  var approvalState = useMemo(function () {
    if (approval === ApprovalState.PENDING) {
      return ApproveOrPermitState.PENDING_APPROVAL;
    } else if (signatureState === UseERC20PermitState.LOADING) {
      return ApproveOrPermitState.PENDING_SIGNATURE;
    } else if (approval !== ApprovalState.NOT_APPROVED || signatureState === UseERC20PermitState.SIGNED) {
      return ApproveOrPermitState.APPROVED;
    } else if (gatherPermitSignature) {
      return ApproveOrPermitState.REQUIRES_SIGNATURE;
    } else {
      return ApproveOrPermitState.REQUIRES_APPROVAL;
    }
  }, [approval, gatherPermitSignature, signatureState]);
  return {
    approvalState: approvalState,
    signatureData: signatureData,
    handleApproveOrPermit: handleApproveOrPermit
  };
};

function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _abi$f = [{
  inputs: [],
  name: "CHAIN_MANAGER",
  outputs: [{
    internalType: "contract IRootChainManager",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ERC20_PREDICATE",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "FX_ROOT",
  outputs: [{
    internalType: "contract IFxStateSender",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "WETH_ETHEREUM",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "WETH_POLYGON",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}];
var _bytecode$5 = "0x6101206040527340ec5b33f54e0e8a33a975908c5ba1c14e5bbbdf608052737ceb23fd6bc0add59e62ac25578270cff1b9f61960a05273c02aaa39b223fe8d0a0e5c4f27ead9083c756cc260c05273fe5e5d361b2ad62c541bab87c45a0b9b018389a260e05273a0c68c638235ee32657e8f720a23cec1bfc77c776101005234801561008a57600080fd5b5060805160a05160c05160e051610100516101656100cc600039600061010f0152600060c10152600060e80152600060710152600061013601526101656000f3fe608060405234801561001057600080fd5b50600436106100675760003560e01c80635e4a8013116100505780635e4a8013146100e3578063d4b07a9e1461010a578063fd5f2d831461013157600080fd5b80630e20416f1461006c57806329c9e058146100bc575b600080fd5b6100937f000000000000000000000000000000000000000000000000000000000000000081565b60405173ffffffffffffffffffffffffffffffffffffffff909116815260200160405180910390f35b6100937f000000000000000000000000000000000000000000000000000000000000000081565b6100937f000000000000000000000000000000000000000000000000000000000000000081565b6100937f000000000000000000000000000000000000000000000000000000000000000081565b6100937f00000000000000000000000000000000000000000000000000000000000000008156fea164736f6c634300080e000a";

var isSuperArgs$5 = function isSuperArgs(xs) {
  return xs.length > 1;
};

var EthereumConstants__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(EthereumConstants__factory, _ContractFactory);

  var _super = _createSuper$6(EthereumConstants__factory);

  function EthereumConstants__factory() {
    var _this;

    _classCallCheck(this, EthereumConstants__factory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isSuperArgs$5(args)) {
      _this = _super.call.apply(_super, [this].concat(args));
    } else {
      _this = _super.call(this, _abi$f, _bytecode$5, args[0]);
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(EthereumConstants__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(EthereumConstants__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(EthereumConstants__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(EthereumConstants__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(EthereumConstants__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$f);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$f, signerOrProvider);
    }
  }]);

  return EthereumConstants__factory;
}(ContractFactory);

_defineProperty(EthereumConstants__factory, "bytecode", _bytecode$5);

_defineProperty(EthereumConstants__factory, "abi", _abi$f);

function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _abi$e = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  inputs: [],
  name: "CHAIN_MANAGER",
  outputs: [{
    internalType: "contract IRootChainManager",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ERC20_PREDICATE",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "FX_ROOT",
  outputs: [{
    internalType: "contract IFxStateSender",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "WETH_ETHEREUM",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "WETH_POLYGON",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "contract IERC20",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address",
    name: "routerAddress",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "depositERC20",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "routerAddress",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "depositEther",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_polygonContract",
    type: "address"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "polygonContract",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  stateMutability: "payable",
  type: "receive"
}];
var _bytecode$4 = "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";

var isSuperArgs$4 = function isSuperArgs(xs) {
  return xs.length > 1;
};

var EthereumPortal__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(EthereumPortal__factory, _ContractFactory);

  var _super = _createSuper$5(EthereumPortal__factory);

  function EthereumPortal__factory() {
    var _this;

    _classCallCheck(this, EthereumPortal__factory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isSuperArgs$4(args)) {
      _this = _super.call.apply(_super, [this].concat(args));
    } else {
      _this = _super.call(this, _abi$e, _bytecode$4, args[0]);
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(EthereumPortal__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(EthereumPortal__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(EthereumPortal__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(EthereumPortal__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(EthereumPortal__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$e);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$e, signerOrProvider);
    }
  }]);

  return EthereumPortal__factory;
}(ContractFactory);

_defineProperty(EthereumPortal__factory, "bytecode", _bytecode$4);

_defineProperty(EthereumPortal__factory, "abi", _abi$e);

var _abi$d = [{
  inputs: [{
    internalType: "contract IERC20",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address",
    name: "routerAddress",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "depositERC20",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "routerAddress",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "depositEther",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_polygonContract",
    type: "address"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var IEthereumPortal__factory = /*#__PURE__*/function () {
  function IEthereumPortal__factory() {
    _classCallCheck(this, IEthereumPortal__factory);
  }

  _createClass(IEthereumPortal__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$d);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$d, signerOrProvider);
    }
  }]);

  return IEthereumPortal__factory;
}();

_defineProperty(IEthereumPortal__factory, "abi", _abi$d);

var _abi$c = [{
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}];

var ERC721Receiver__factory = /*#__PURE__*/function () {
  function ERC721Receiver__factory() {
    _classCallCheck(this, ERC721Receiver__factory);
  }

  _createClass(ERC721Receiver__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$c);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$c, signerOrProvider);
    }
  }]);

  return ERC721Receiver__factory;
}();

_defineProperty(ERC721Receiver__factory, "abi", _abi$c);

var _abi$b = [{
  inputs: [],
  name: "ethereumPortal",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "fxChild",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "lastStateId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "processMessageFromRoot",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var FxMessageProcessor__factory = /*#__PURE__*/function () {
  function FxMessageProcessor__factory() {
    _classCallCheck(this, FxMessageProcessor__factory);
  }

  _createClass(FxMessageProcessor__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$b);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$b, signerOrProvider);
    }
  }]);

  return FxMessageProcessor__factory;
}();

_defineProperty(FxMessageProcessor__factory, "abi", _abi$b);

var _abi$a = [{
  inputs: [],
  name: "lastStateId",
  outputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "processMessageFromRoot",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var IFxMessageProcessor__factory = /*#__PURE__*/function () {
  function IFxMessageProcessor__factory() {
    _classCallCheck(this, IFxMessageProcessor__factory);
  }

  _createClass(IFxMessageProcessor__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$a);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$a, signerOrProvider);
    }
  }]);

  return IFxMessageProcessor__factory;
}();

_defineProperty(IFxMessageProcessor__factory, "abi", _abi$a);

var _abi$9 = [{
  inputs: [{
    internalType: "address",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapERC20AndCall",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapNativeAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}];

var IPolygonPortal__factory = /*#__PURE__*/function () {
  function IPolygonPortal__factory() {
    _classCallCheck(this, IPolygonPortal__factory);
  }

  _createClass(IPolygonPortal__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$9);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$9, signerOrProvider);
    }
  }]);

  return IPolygonPortal__factory;
}();

_defineProperty(IPolygonPortal__factory, "abi", _abi$9);

function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _abi$8 = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "FX_CHILD",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ethereumPortal",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "fee",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "fxChild",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_ethereumPortal",
    type: "address"
  }, {
    internalType: "address",
    name: "_portalRouter",
    type: "address"
  }, {
    internalType: "address",
    name: "_beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "_fxChild",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_fee",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "lastStateId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "x",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "y",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "z",
    type: "uint256"
  }],
  name: "mulDiv",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "portalRouter",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "processMessageFromRoot",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapERC20AndCall",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapNativeAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  stateMutability: "payable",
  type: "receive"
}];
var _bytecode$3 = "0x6080604052600780546001600160a01b031916738397259c983751daf40400790063935a11afa28a17905534801561003657600080fd5b506000805462ff00001916905561004c33610051565b6100ae565b600080546001600160a01b0383811663010000008181026301000000600160b81b0319851617855560405193049190911692909183917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a35050565b611e85806100bd6000396000f3fe6080604052600436106101485760003560e01c80637790f9e1116100c0578063aa9a091211610074578063ddca3f4311610059578063ddca3f4314610394578063f2fde38b146103aa578063f7013ef6146103ca57600080fd5b8063aa9a091214610354578063bb9273cc1461037457600080fd5b80638456cb59116100a55780638456cb59146102fa5780638da5cb5b1461030f5780639a7c4b711461033457600080fd5b80637790f9e1146102ba57806382f9deb5146102da57600080fd5b80633f4ba83a116101175780635407ca67116100fc5780635407ca67146102585780635c975abb1461027c578063715018a6146102a557600080fd5b80633f4ba83a14610223578063450d11f01461023857600080fd5b8063150b7a02146101545780631f2bd6bc146101b65780632f56feeb146101cb57806338af3eed146101eb57600080fd5b3661014f57005b600080fd5b34801561016057600080fd5b5061018061016f3660046115cb565b630a85bd0160e11b95945050505050565b6040517fffffffff0000000000000000000000000000000000000000000000000000000090911681526020015b60405180910390f35b6101c96101c4366004611683565b6103ea565b005b3480156101d757600080fd5b506101c96101e63660046116f5565b61069f565b3480156101f757600080fd5b5060055461020b906001600160a01b031681565b6040516001600160a01b0390911681526020016101ad565b34801561022f57600080fd5b506101c961078f565b34801561024457600080fd5b5060015461020b906001600160a01b031681565b34801561026457600080fd5b5061026e60035481565b6040519081526020016101ad565b34801561028857600080fd5b5060005462010000900460ff1660405190151581526020016101ad565b3480156102b157600080fd5b506101c96107fb565b3480156102c657600080fd5b5060065461020b906001600160a01b031681565b3480156102e657600080fd5b5060075461020b906001600160a01b031681565b34801561030657600080fd5b506101c9610867565b34801561031b57600080fd5b50600054630100000090046001600160a01b031661020b565b34801561034057600080fd5b506101c961034f3660046117a6565b6108d1565b34801561036057600080fd5b5061026e61036f366004611802565b6109e9565b34801561038057600080fd5b5060025461020b906001600160a01b031681565b3480156103a057600080fd5b5061026e60045481565b3480156103b657600080fd5b506101c96103c536600461182e565b610a8a565b3480156103d657600080fd5b506101c96103e5366004611852565b610b74565b60005462010000900460ff161561043b5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b60448201526064015b60405180910390fd5b6006546001600160a01b031633146104955760405162461bcd60e51b815260206004820152601960248201527f43616e6e6f742062652063616c6c6564206469726563746c79000000000000006044820152606401610432565b476001600160a01b0386161561068d576000806104b134610ca7565b6005546040519294509092506000916001600160a01b039091169084908381818185875af1925050503d8060008114610506576040519150601f19603f3d011682016040523d82523d6000602084013e61050b565b606091505b505090508061055c5760405162461bcd60e51b815260206004820152601960248201527f42727964676520666565207061796d656e74206661696c6564000000000000006044820152606401610432565b6000808a6001600160a01b0316848b8b60405161057a9291906118b6565b60006040518083038185875af1925050503d80600081146105b7576040519150601f19603f3d011682016040523d82523d6000602084013e6105bc565b606091505b5091509150816105cf576105cf81610cd5565b60006105db47886118dc565b905060006105e982346118dc565b604051909150600090339083908381818185875af1925050503d806000811461062e576040519150601f19603f3d011682016040523d82523d6000602084013e610633565b606091505b50509050806106845760405162461bcd60e51b815260206004820152601460248201527f7265696d62757273656d656e74206661696c65640000000000000000000000006044820152606401610432565b50505050505050505b6106978383610d5a565b505050505050565b60005462010000900460ff16156106eb5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b6044820152606401610432565b6006546001600160a01b0316331480159061071157506007546001600160a01b03163314155b1561075e5760405162461bcd60e51b815260206004820152601960248201527f43616e6e6f742062652063616c6c6564206469726563746c79000000000000006044820152606401610432565b6001600160a01b0385161561077b5761077b888888888888610e8d565b6107858282610d5a565b5050505050505050565b6000546001600160a01b0363010000009091041633146107f15760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610432565b6107f96111a3565b565b6000546001600160a01b03630100000090910416331461085d5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610432565b6107f96000611247565b6000546001600160a01b0363010000009091041633146108c95760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610432565b6107f96112b9565b6001546001600160a01b031633146109515760405162461bcd60e51b815260206004820152602960248201527f4678426173654368696c6454756e6e656c3a206d73672e73656e64657220213d60448201527f2046585f4348494c4400000000000000000000000000000000000000000000006064820152608401610432565b6002546001600160a01b038481169116146109d45760405162461bcd60e51b815260206004820152602b60248201527f4678426173654368696c6454756e6e656c3a2073656e64657220213d2065746860448201527f657265756d506f7274616c0000000000000000000000000000000000000000006064820152608401610432565b60038490556109e3828261133e565b50505050565b6000806109f68386611909565b90506000610a04848761191d565b90506000610a128587611909565b90506000610a20868861191d565b905085610a2d8285611931565b610a379190611909565b610a418385611931565b610a4b8387611931565b88610a568689611931565b610a609190611931565b610a6a9190611950565b610a749190611950565b610a7e9190611950565b98975050505050505050565b6000546001600160a01b036301000000909104163314610aec5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610432565b6001600160a01b038116610b685760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f64647265737300000000000000000000000000000000000000000000000000006064820152608401610432565b610b7181611247565b50565b600054610100900460ff16610b8f5760005460ff1615610b93565b303b155b610c055760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a65640000000000000000000000000000000000006064820152608401610432565b600054610100900460ff16158015610c27576000805461ffff19166101011790555b600280546001600160a01b038089167fffffffffffffffffffffffff0000000000000000000000000000000000000000928316179092556006805488841690831617905560058054878416908316179055600180549286169290911691909117905560048290558015610697576000805461ff0019169055505050505050565b6000806000610cbb846004546103e86109e9565b90506000610cc982866118dc565b91959194509092505050565b604481511015610d275760405162461bcd60e51b815260206004820152600b60248201527f73776170206661696c65640000000000000000000000000000000000000000006044820152606401610432565b60048101905080806020019051810190610d419190611a2c565b60405162461bcd60e51b81526004016104329190611ad4565b60005b81811015610e88576000838383818110610d7957610d79611ae7565b9050602002810190610d8b9190611afd565b610d9990602081019061182e565b6001600160a01b0316848484818110610db457610db4611ae7565b9050602002810190610dc69190611afd565b610dd4906040810190611b1d565b604051610de29291906118b6565b6000604051808303816000865af19150503d8060008114610e1f576040519150601f19603f3d011682016040523d82523d6000602084013e610e24565b606091505b5050905080610e755760405162461bcd60e51b815260206004820152601360248201527f4e4654207472616e73666572206661696c6564000000000000000000000000006044820152606401610432565b5080610e8081611b64565b915050610d5d565b505050565b6040516370a0823160e01b815230600482015286906000906001600160a01b038316906370a0823190602401602060405180830381865afa158015610ed6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610efa9190611b7d565b9050600080610f0889610ca7565b60055460405163a9059cbb60e01b81526001600160a01b0391821660048201526024810184905292945090925085169063a9059cbb906044016020604051808303816000875af1158015610f60573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f849190611b96565b610fd05760405162461bcd60e51b815260206004820152601960248201527f42727964676520666565207061796d656e74206661696c6564000000000000006044820152606401610432565b610fdb8a8883611480565b600080886001600160a01b03168888604051610ff89291906118b6565b6000604051808303816000865af19150503d8060008114611035576040519150601f19603f3d011682016040523d82523d6000602084013e61103a565b606091505b50915091508161104d5761104d81610cd5565b6040516370a0823160e01b81523060048201526000906001600160a01b038816906370a0823190602401602060405180830381865afa158015611094573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110b89190611b7d565b6110c290876118dc565b905060006110d0828e6118dc565b60405163a9059cbb60e01b81526001600160a01b038e81166004830152602482018390529192509089169063a9059cbb906044016020604051808303816000875af1158015611123573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111479190611b96565b6111935760405162461bcd60e51b815260206004820152601460248201527f7265696d62757273656d656e74206661696c65640000000000000000000000006044820152606401610432565b5050505050505050505050505050565b60005462010000900460ff166111fb5760405162461bcd60e51b815260206004820152601460248201527f5061757361626c653a206e6f74207061757365640000000000000000000000006044820152606401610432565b6000805462ff0000191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b600080546001600160a01b0383811663010000008181027fffffffffffffffffff0000000000000000000000000000000000000000ffffff851617855560405193049190911692909183917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a35050565b60005462010000900460ff16156113055760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b6044820152606401610432565b6000805462ff00001916620100001790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a25861122a3390565b6000808080808061135187890189611c09565b604051632f56feeb60e01b8152959b509399509197509550935091503090632f56feeb9061138d90899089908990899089908990600401611dbb565b600060405180830381600087803b1580156113a757600080fd5b505af19250505080156113b8575060015b6107855760405163a9059cbb60e01b81526001600160a01b0385811660048301526024820187905287169063a9059cbb906044016020604051808303816000875af115801561140b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061142f9190611b96565b61147b5760405162461bcd60e51b815260206004820152600d60248201527f726566756e64206661696c6564000000000000000000000000000000000000006044820152606401610432565b610785565b604051636eb1769f60e11b81523060048201526001600160a01b03838116602483015282919085169063dd62ed3e90604401602060405180830381865afa1580156114cf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114f39190611b7d565b1015610e885760405163095ea7b360e01b81526001600160a01b038381166004830152600019602483015284169063095ea7b3906044016020604051808303816000875af1158015611549573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109e39190611b96565b6001600160a01b0381168114610b7157600080fd5b60008083601f84011261159457600080fd5b50813567ffffffffffffffff8111156115ac57600080fd5b6020830191508360208285010111156115c457600080fd5b9250929050565b6000806000806000608086880312156115e357600080fd5b85356115ee8161156d565b945060208601356115fe8161156d565b935060408601359250606086013567ffffffffffffffff81111561162157600080fd5b61162d88828901611582565b969995985093965092949392505050565b60008083601f84011261165057600080fd5b50813567ffffffffffffffff81111561166857600080fd5b6020830191508360208260051b85010111156115c457600080fd5b60008060008060006060868803121561169b57600080fd5b85356116a68161156d565b9450602086013567ffffffffffffffff808211156116c357600080fd5b6116cf89838a01611582565b909650945060408801359150808211156116e857600080fd5b5061162d8882890161163e565b60008060008060008060008060c0898b03121561171157600080fd5b883561171c8161156d565b97506020890135965060408901356117338161156d565b955060608901356117438161156d565b9450608089013567ffffffffffffffff8082111561176057600080fd5b61176c8c838d01611582565b909650945060a08b013591508082111561178557600080fd5b506117928b828c0161163e565b999c989b5096995094979396929594505050565b600080600080606085870312156117bc57600080fd5b8435935060208501356117ce8161156d565b9250604085013567ffffffffffffffff8111156117ea57600080fd5b6117f687828801611582565b95989497509550505050565b60008060006060848603121561181757600080fd5b505081359360208301359350604090920135919050565b60006020828403121561184057600080fd5b813561184b8161156d565b9392505050565b600080600080600060a0868803121561186a57600080fd5b85356118758161156d565b945060208601356118858161156d565b935060408601356118958161156d565b925060608601356118a58161156d565b949793965091946080013592915050565b8183823760009101908152919050565b634e487b7160e01b600052601160045260246000fd5b6000828210156118ee576118ee6118c6565b500390565b634e487b7160e01b600052601260045260246000fd5b600082611918576119186118f3565b500490565b60008261192c5761192c6118f3565b500690565b600081600019048311821515161561194b5761194b6118c6565b500290565b60008219821115611963576119636118c6565b500190565b634e487b7160e01b600052604160045260246000fd5b6040516060810167ffffffffffffffff811182821017156119a1576119a1611968565b60405290565b604051601f8201601f1916810167ffffffffffffffff811182821017156119d0576119d0611968565b604052919050565b600067ffffffffffffffff8211156119f2576119f2611968565b50601f01601f191660200190565b60005b83811015611a1b578181015183820152602001611a03565b838111156109e35750506000910152565b600060208284031215611a3e57600080fd5b815167ffffffffffffffff811115611a5557600080fd5b8201601f81018413611a6657600080fd5b8051611a79611a74826119d8565b6119a7565b818152856020838501011115611a8e57600080fd5b611a9f826020830160208601611a00565b95945050505050565b60008151808452611ac0816020860160208601611a00565b601f01601f19169290920160200192915050565b60208152600061184b6020830184611aa8565b634e487b7160e01b600052603260045260246000fd5b60008235605e19833603018112611b1357600080fd5b9190910192915050565b6000808335601e19843603018112611b3457600080fd5b83018035915067ffffffffffffffff821115611b4f57600080fd5b6020019150368190038213156115c457600080fd5b600060018201611b7657611b766118c6565b5060010190565b600060208284031215611b8f57600080fd5b5051919050565b600060208284031215611ba857600080fd5b8151801515811461184b57600080fd5b600082601f830112611bc957600080fd5b8135611bd7611a74826119d8565b818152846020838601011115611bec57600080fd5b816020850160208301376000918101602001919091529392505050565b60008060008060008060c08789031215611c2257600080fd5b611c2c873561156d565b8635955060208701359450611c44604088013561156d565b60408701359350611c58606088013561156d565b6060870135925067ffffffffffffffff60808801351115611c7857600080fd5b611c888860808901358901611bb8565b915067ffffffffffffffff60a08801351115611ca357600080fd5b60a0870135870188601f820112611cb957600080fd5b67ffffffffffffffff81351115611cd257611cd2611968565b611ce26020823560051b016119a7565b81358082526020808301929160051b8401018b1015611d0057600080fd5b602083015b6020843560051b850101811015611daa5767ffffffffffffffff81351115611d2c57600080fd5b803584016060818e03601f19011215611d4457600080fd5b611d4c61197e565b611d59602083013561156d565b602082013581526040820135602082015267ffffffffffffffff60608301351115611d8357600080fd5b611d968e60206060850135850101611bb8565b604082015284525060209283019201611d05565b508093505050509295509295509295565b60006001600160a01b0380891683526020888185015260408289168186015260608389168187015260c06080870152611df760c0870189611aa8565b86810360a0880152875180825284820190600581901b83018601868b0160005b83811015611e6057858303601f19018552815180518b168452898101518a850152880151888401889052611e4d88850182611aa8565b958a019593505090880190600101611e17565b5050809850505050505050505097965050505050505056fea164736f6c634300080e000a";

var isSuperArgs$3 = function isSuperArgs(xs) {
  return xs.length > 1;
};

var PolygonPortal__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(PolygonPortal__factory, _ContractFactory);

  var _super = _createSuper$4(PolygonPortal__factory);

  function PolygonPortal__factory() {
    var _this;

    _classCallCheck(this, PolygonPortal__factory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isSuperArgs$3(args)) {
      _this = _super.call.apply(_super, [this].concat(args));
    } else {
      _this = _super.call(this, _abi$8, _bytecode$3, args[0]);
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(PolygonPortal__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(PolygonPortal__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(PolygonPortal__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(PolygonPortal__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(PolygonPortal__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$8);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$8, signerOrProvider);
    }
  }]);

  return PolygonPortal__factory;
}(ContractFactory);

_defineProperty(PolygonPortal__factory, "bytecode", _bytecode$3);

_defineProperty(PolygonPortal__factory, "abi", _abi$8);

function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _abi$7 = [{
  inputs: [{
    internalType: "address",
    name: "_portal",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "Portal",
  outputs: [{
    internalType: "contract IPolygonPortal",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapERC20AndCall",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapNativeAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  stateMutability: "payable",
  type: "receive"
}];
var _bytecode$2 = "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";

var isSuperArgs$2 = function isSuperArgs(xs) {
  return xs.length > 1;
};

var PolygonRouter__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(PolygonRouter__factory, _ContractFactory);

  var _super = _createSuper$3(PolygonRouter__factory);

  function PolygonRouter__factory() {
    var _this;

    _classCallCheck(this, PolygonRouter__factory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isSuperArgs$2(args)) {
      _this = _super.call.apply(_super, [this].concat(args));
    } else {
      _this = _super.call(this, _abi$7, _bytecode$2, args[0]);
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(PolygonRouter__factory, [{
    key: "deploy",
    value: function deploy(_portal, overrides) {
      return _get(_getPrototypeOf(PolygonRouter__factory.prototype), "deploy", this).call(this, _portal, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(_portal, overrides) {
      return _get(_getPrototypeOf(PolygonRouter__factory.prototype), "getDeployTransaction", this).call(this, _portal, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(PolygonRouter__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(PolygonRouter__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$7);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$7, signerOrProvider);
    }
  }]);

  return PolygonRouter__factory;
}(ContractFactory);

_defineProperty(PolygonRouter__factory, "bytecode", _bytecode$2);

_defineProperty(PolygonRouter__factory, "abi", _abi$7);

function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _abi$6 = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "FX_CHILD",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ethereumPortal",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "fee",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "fxChild",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_ethereumPortal",
    type: "address"
  }, {
    internalType: "address",
    name: "_portalRouter",
    type: "address"
  }, {
    internalType: "address",
    name: "_beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "_fxChild",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_fee",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "lastStateId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "x",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "y",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "z",
    type: "uint256"
  }],
  name: "mulDiv",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "portalRouter",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "processMessageFromRoot",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "rawRequestData",
    type: "bytes"
  }],
  name: "processRequest",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenIn",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amountIn",
    type: "uint256"
  }, {
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapERC20AndCall",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "router",
    type: "address"
  }, {
    internalType: "bytes",
    name: "routerArguments",
    type: "bytes"
  }, {
    components: [{
      internalType: "address",
      name: "_to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "_value",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "_calldata",
      type: "bytes"
    }],
    internalType: "struct Types.ICall[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "swapNativeAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  stateMutability: "payable",
  type: "receive"
}];
var _bytecode$1 = "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";

var isSuperArgs$1 = function isSuperArgs(xs) {
  return xs.length > 1;
};

var TestPolygonPortal__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(TestPolygonPortal__factory, _ContractFactory);

  var _super = _createSuper$2(TestPolygonPortal__factory);

  function TestPolygonPortal__factory() {
    var _this;

    _classCallCheck(this, TestPolygonPortal__factory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isSuperArgs$1(args)) {
      _this = _super.call.apply(_super, [this].concat(args));
    } else {
      _this = _super.call(this, _abi$6, _bytecode$1, args[0]);
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(TestPolygonPortal__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(TestPolygonPortal__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(TestPolygonPortal__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(TestPolygonPortal__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(TestPolygonPortal__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$6);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$6, signerOrProvider);
    }
  }]);

  return TestPolygonPortal__factory;
}(ContractFactory);

_defineProperty(TestPolygonPortal__factory, "bytecode", _bytecode$1);

_defineProperty(TestPolygonPortal__factory, "abi", _abi$6);

var _abi$5 = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "rootMessageSender",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "receiver",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "NewFxMessage",
  type: "event"
}, {
  inputs: [],
  name: "fxRoot",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_data",
    type: "bytes"
  }],
  name: "onStateReceive",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_fxRoot",
    type: "address"
  }],
  name: "setFxRoot",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var FxChild__factory = /*#__PURE__*/function () {
  function FxChild__factory() {
    _classCallCheck(this, FxChild__factory);
  }

  _createClass(FxChild__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$5);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$5, signerOrProvider);
    }
  }]);

  return FxChild__factory;
}();

_defineProperty(FxChild__factory, "abi", _abi$5);

var _abi$4 = [{
  inputs: [{
    internalType: "uint256",
    name: "stateId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onStateReceive",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var IStateReceiver__factory = /*#__PURE__*/function () {
  function IStateReceiver__factory() {
    _classCallCheck(this, IStateReceiver__factory);
  }

  _createClass(IStateReceiver__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$4);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$4, signerOrProvider);
    }
  }]);

  return IStateReceiver__factory;
}();

_defineProperty(IStateReceiver__factory, "abi", _abi$4);

var _abi$3 = [{
  inputs: [{
    internalType: "address",
    name: "_receiver",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_data",
    type: "bytes"
  }],
  name: "sendMessageToChild",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var IFxStateSender__factory = /*#__PURE__*/function () {
  function IFxStateSender__factory() {
    _classCallCheck(this, IFxStateSender__factory);
  }

  _createClass(IFxStateSender__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$3);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$3, signerOrProvider);
    }
  }]);

  return IFxStateSender__factory;
}();

_defineProperty(IFxStateSender__factory, "abi", _abi$3);

var _abi$2 = [{
  inputs: [{
    internalType: "address",
    name: "user",
    type: "address"
  }],
  name: "depositEtherFor",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "user",
    type: "address"
  }, {
    internalType: "address",
    name: "rootToken",
    type: "address"
  }, {
    internalType: "bytes",
    name: "depositData",
    type: "bytes"
  }],
  name: "depositFor",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "rootToken",
    type: "address"
  }],
  name: "rootToChildToken",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];

var IRootChainManager__factory = /*#__PURE__*/function () {
  function IRootChainManager__factory() {
    _classCallCheck(this, IRootChainManager__factory);
  }

  _createClass(IRootChainManager__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$2);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$2, signerOrProvider);
    }
  }]);

  return IRootChainManager__factory;
}();

_defineProperty(IRootChainManager__factory, "abi", _abi$2);

var _abi$1 = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "spender",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "deposit",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [],
  name: "totalSupply",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  name: "withdraw",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

var IWETH__factory = /*#__PURE__*/function () {
  function IWETH__factory() {
    _classCallCheck(this, IWETH__factory);
  }

  _createClass(IWETH__factory, null, [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi$1);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi$1, signerOrProvider);
    }
  }]);

  return IWETH__factory;
}();

_defineProperty(IWETH__factory, "abi", _abi$1);

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "approved",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "ApprovalForAll",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "approve",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "getApproved",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "operator",
    type: "address"
  }],
  name: "isApprovedForAll",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "recipient",
    type: "address"
  }],
  name: "mintTo",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "safeTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_data",
    type: "bytes"
  }],
  name: "safeTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setApprovalForAll",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
var _bytecode = "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";

var isSuperArgs = function isSuperArgs(xs) {
  return xs.length > 1;
};

var MockNFT__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(MockNFT__factory, _ContractFactory);

  var _super = _createSuper$1(MockNFT__factory);

  function MockNFT__factory() {
    var _this;

    _classCallCheck(this, MockNFT__factory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isSuperArgs(args)) {
      _this = _super.call.apply(_super, [this].concat(args));
    } else {
      _this = _super.call(this, _abi, _bytecode, args[0]);
    }

    return _possibleConstructorReturn(_this);
  }

  _createClass(MockNFT__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(MockNFT__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(MockNFT__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(MockNFT__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(MockNFT__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract$1(address, _abi, signerOrProvider);
    }
  }]);

  return MockNFT__factory;
}(ContractFactory);

_defineProperty(MockNFT__factory, "bytecode", _bytecode);

_defineProperty(MockNFT__factory, "abi", _abi);

function getCurrencyAddress(currency) {
  if (currency && currency.isToken) {
    return currency.address;
  }

  return ZERO_ADDRESS;
}
/**
 * Does a lookup for an ENS name to find its address.
 */


function useENSAddressWithChainId(ensName, chainId) {
  var _resolverAddress$resu;

  var debouncedName = useDebounce(ensName, 200);
  var ensNodeArgument = useMemo(function () {
    return [debouncedName === null ? undefined : safeNamehash(debouncedName)];
  }, [debouncedName]);
  var registrarContract = useENSRegistrarContractWithChainId(chainId, false);
  var resolverAddress = useSingleCallResultWithChainId(chainId, registrarContract, 'resolver', ensNodeArgument);
  var resolverAddressResult = (_resolverAddress$resu = resolverAddress.result) === null || _resolverAddress$resu === void 0 ? void 0 : _resolverAddress$resu[0];
  var resolverContract = useENSResolverContractWithChainId(chainId, resolverAddressResult && !isZero(resolverAddressResult) ? resolverAddressResult : undefined, false);
  var addr = useSingleCallResultWithChainId(chainId, resolverContract, 'addr', ensNodeArgument);
  var changed = debouncedName !== ensName;
  return useMemo(function () {
    var _addr$result$, _addr$result;

    return {
      address: changed ? null : (_addr$result$ = (_addr$result = addr.result) === null || _addr$result === void 0 ? void 0 : _addr$result[0]) !== null && _addr$result$ !== void 0 ? _addr$result$ : null,
      loading: changed || resolverAddress.loading || addr.loading
    };
  }, [addr.loading, addr.result, changed, resolverAddress.loading]);
}

var CHAIN_DATA_ABI = [{
  inputs: [],
  name: 'latestAnswer',
  outputs: [{
    internalType: 'int256',
    name: '',
    type: 'int256'
  }],
  stateMutability: 'view',
  type: 'function'
}];
/**
 * Returns the price of 1 gas in WEI for the currently selected network using the chainlink fast gas price oracle
 */

function useGasPriceWithChainId(chainId) {
  var _useSingleCallResultW, _useSingleCallResultW2;

  var _useENSAddressWithCha = useENSAddressWithChainId('fast-gas-gwei.data.eth', chainId),
      address = _useENSAddressWithCha.address;

  var contract = useContract(address !== null && address !== void 0 ? address : undefined, CHAIN_DATA_ABI, false);
  var resultStr = (_useSingleCallResultW = useSingleCallResultWithChainId(chainId, contract, 'latestAnswer').result) === null || _useSingleCallResultW === void 0 ? void 0 : (_useSingleCallResultW2 = _useSingleCallResultW[0]) === null || _useSingleCallResultW2 === void 0 ? void 0 : _useSingleCallResultW2.toString();
  return useMemo(function () {
    return typeof resultStr === 'string' ? JSBI.BigInt(resultStr) : undefined;
  }, [resultStr]);
}

function useCalculatedGasFee(chainId, isNative) {
  //TODO DTD-274: @zachrosen hardcoded gas fee as 1 cent for polygon for now. come back and pull dynamic gas pricing upon other network additions
  var gasFee = 0.01;
  chainId = chainId ? chainId : 1; // TODO DTD-274: @greguezono add chainId check

  var tokenType = isNative ? 'NATIVE' : 'ERC20';
  var gasLimit = PORTAL_GAS_LIMIT[chainId][tokenType];

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var nativeGasPrice = useGasPriceWithChainId(chainId); // TODO DTD-274: replace this hook for something else on polygon

  var nativeCurrency = useNativeCurrency(chainId);
  var nativeTokenUSDCPrice = useUSDCPriceWithChainId(nativeCurrency, 137); //DTD-274 check this on polygon

  if (chainId === 1) {
    //get native token price in usdc
    var nativeGasCost = nativeGasPrice ? JSBI.multiply(nativeGasPrice, JSBI.BigInt(gasLimit)) : undefined;
    var dollarGasCost = nativeCurrency && nativeGasCost && nativeTokenUSDCPrice ? nativeTokenUSDCPrice.quote(CurrencyAmount.fromRawAmount(nativeCurrency, nativeGasCost)) : undefined;
    gasFee = Number(formatCurrencyAmount(dollarGasCost, 6, i18n.locale));
  }

  return gasFee;
}

function calculateBrydgeFee(brydgeFeeUSDC, i18n) {
  var formattedBrydgeFee = 0.01;

  if (isNaN(formattedBrydgeFee) || formattedBrydgeFee === 0) {
    return formattedBrydgeFee;
  }

  var brydgeFee = formatCurrencyAmount(brydgeFeeUSDC, 6, 'en', 2);
  formattedBrydgeFee = Number(brydgeFee.replace(/,/g, ''));
  return formattedBrydgeFee;
}

function calculateLpFee(lpFeeUSDC, i18n) {
  var formattedLpFee = Number(formatCurrencyAmount(lpFeeUSDC, 6, i18n.locale));
  return formattedLpFee;
}

function calculateItemPrice(outputUSDC) {
  var itemPrice = formatCurrencyAmount(outputUSDC, 6, 'en', 2);
  var formattedItemPrice = Number(itemPrice.replace(/,/g, ''));
  return formattedItemPrice;
}

function useFeeBreakdown(_ref) {
  var outputUSDC = _ref.outputUSDC;
  _ref.shownChainId;
  var isNative = _ref.isNative,
      brydgeFeeUSDC = _ref.brydgeFeeUSDC,
      lpFeeUSDC = _ref.lpFeeUSDC,
      i18n = _ref.i18n;
  _ref.isWrappingTrade;
  var itemPrice = calculateItemPrice(outputUSDC);
  var formattedBrydgeFeeUSDC = calculateBrydgeFee(brydgeFeeUSDC);
  var formattedLpFeeUSDC = calculateLpFee(lpFeeUSDC, i18n);

  var _useActiveWeb3React = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React.chainId;

  var gasFee = useCalculatedGasFee(chainId, isNative);
  var isLoading = isNaN(Number(itemPrice)) || isNaN(Number(formattedBrydgeFeeUSDC)) || isNaN(Number(formattedLpFeeUSDC)) || isNaN(Number(gasFee));
  var itemPriceUSDC = Number(itemPrice);
  var gasFeeUSDC = Number(gasFee); // @todo fix gas calculation - as is, returns Nan so it is currently hardcoded to 5 for the time being

  var totalCost = itemPriceUSDC + formattedBrydgeFeeUSDC + formattedLpFeeUSDC + gasFeeUSDC;
  return {
    itemPriceUSDC: itemPriceUSDC,
    formattedBrydgeFeeUSDC: formattedBrydgeFeeUSDC,
    formattedLpFeeUSDC: formattedLpFeeUSDC,
    gasFeeUSDC: gasFeeUSDC,
    totalCost: totalCost,
    isLoading: isLoading
  };
}
/**
 * Returns true if the trade requires a confirmation of details before we can submit it
 * @param args either a pair of V2 trades or a pair of V3 trades
 */


function tradeMeaningfullyDiffers() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var tradeA = args[0],
      tradeB = args[1];
  return tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.inputAmount.equalTo(tradeB.inputAmount) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency) || !tradeA.outputAmount.equalTo(tradeB.outputAmount);
}

function FeeComponent(_ref) {
  var itemPriceUSDC = _ref.itemPriceUSDC,
      brydgeFeeUSDC = _ref.brydgeFeeUSDC,
      lpFeeUSDC = _ref.lpFeeUSDC,
      gasFee = _ref.gasFee,
      totalCost = _ref.totalCost,
      chainId = _ref.chainId;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        justifyContent: 'space-between',
        color: 'secondary',
        fontSize: '14px',
        // position: 'absolute',
        zIndex: 99999
      },
      children: [/*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'left'
        },
        children: "Item Price"
      }), /*#__PURE__*/jsxs("div", {
        style: {
          textAlign: 'right'
        },
        children: ["$", itemPriceUSDC.toFixed(2)]
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'left'
        },
        children: "Brydge Fee"
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'right'
        },
        children: brydgeFeeUSDC.toFixed(2)
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'left'
        },
        children: "Liquidity Fee"
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'right'
        },
        children: lpFeeUSDC.toFixed(2)
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'left'
        },
        children: "Gas Fee"
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'right'
        },
        children: gasFee.toFixed(2)
      })]
    }), /*#__PURE__*/jsx("hr", {}), /*#__PURE__*/jsxs("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        justifyContent: 'space-between',
        color: 'secondary',
        fontSize: '14px',
        fontWeight: 'bold'
      },
      children: [/*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'left'
        },
        children: "Total Cost"
      }), /*#__PURE__*/jsxs("div", {
        style: {
          textAlign: 'right'
        },
        children: ["~$", totalCost.toFixed(2)]
      })]
    }), /*#__PURE__*/jsxs("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        justifyContent: 'space-between',
        color: 'grey',
        fontSize: '14px'
      },
      children: [/*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'left'
        },
        children: "Completion Time"
      }), /*#__PURE__*/jsx("div", {
        style: {
          textAlign: 'right'
        },
        children: COMPLETION_TIMES[chainId]
      })]
    })]
  });
}

function TokenValue(_ref) {
  var input = _ref.input,
      usdc = _ref.usdc,
      children = _ref.children,
      inputCurrency = _ref.inputCurrency;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  return /*#__PURE__*/jsxs(Column, {
    justify: "flex-start",
    children: [/*#__PURE__*/jsxs(Row$1, {
      gap: 0.375,
      justify: "flex-start",
      children: [/*#__PURE__*/jsx(TokenImg$1, {
        token: inputCurrency
      }), /*#__PURE__*/jsxs(Body2, {
        userSelect: true,
        children: [formatCurrencyAmount(input, 6, i18n.locale), " ", inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol]
      })]
    }), usdc && /*#__PURE__*/jsx(Caption$1, {
      color: "secondary",
      userSelect: true,
      children: /*#__PURE__*/jsxs(Row$1, {
        justify: "flex-start",
        gap: 0.25,
        children: ["$", formatCurrencyAmount(usdc, 6, 'en', 2), children]
      })
    })]
  });
}

function DisplayTitle(_ref2) {
  var title = _ref2.title; // const { i18n } = useLingui()

  return /*#__PURE__*/jsx(Column, {
    justify: "flex-start",
    children: /*#__PURE__*/jsx(Row$1, {
      gap: 0.375,
      justify: "flex-start",
      children: /*#__PURE__*/jsx(Body2, {
        userSelect: true,
        children: title
      })
    })
  });
}

function Summary(_ref3) {
  var input = _ref3.input;
  _ref3.output;
  var inputUSDC = _ref3.inputUSDC,
      impact = _ref3.impact,
      title = _ref3.title,
      inputCurrency = _ref3.inputCurrency;
  return /*#__PURE__*/jsxs(Row$1, {
    gap: impact ? 1 : 0.25,
    children: [inputCurrency && /*#__PURE__*/jsx(TokenValue, {
      input: input,
      usdc: inputUSDC,
      inputCurrency: inputCurrency
    }), /*#__PURE__*/jsx(ArrowRight, {}), /*#__PURE__*/jsx(DisplayTitle, {
      title: title
    })]
  });
}

var _templateObject$3, _templateObject2, _templateObject3, _templateObject4;

var Content = styled(Column)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral([""])));
var Heading = styled(Column)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var Footing = styled(Column)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""]))); // eslint-disable-next-line prettier/prettier

var Body = styled(Column)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: calc(100% - 2.5em);\n\n  ", ", ", " {\n    flex-grow: 1;\n    transition: flex-grow 0.25s;\n  }\n\n  ", " {\n    margin-bottom: ", ";\n    max-height: ", ";\n    opacity: ", ";\n    transition: max-height 0.25s, margin-bottom 0.25s, opacity 0.15s 0.1s;\n    visibility: ", ";\n  }\n"])), Content, Heading, Footing, function (_ref) {
  var open = _ref.open;
  return open ? '-0.75em' : undefined;
}, function (_ref2) {
  var open = _ref2.open;
  return open ? 0 : '3em';
}, function (_ref3) {
  var open = _ref3.open;
  return open ? 0 : 1;
}, function (_ref4) {
  var open = _ref4.open;
  return open ? 'hidden' : undefined;
});

function Subhead(_ref5) {
  var impact = _ref5.impact,
      slippage = _ref5.slippage;
  return /*#__PURE__*/jsxs(Row$1, {
    gap: 0.5,
    children: [impact !== null && impact !== void 0 && impact.warning || slippage.warning ? /*#__PURE__*/jsx(AlertTriangle, {
      color: (impact === null || impact === void 0 ? void 0 : impact.warning) || slippage.warning
    }) : /*#__PURE__*/jsx(Info, {
      color: "secondary"
    }), /*#__PURE__*/jsx(Subhead2, {
      color: (impact === null || impact === void 0 ? void 0 : impact.warning) || slippage.warning || 'secondary',
      children: impact !== null && impact !== void 0 && impact.warning ? /*#__PURE__*/jsx(Trans, {
        id: "High price impact"
      }) : slippage.warning ? /*#__PURE__*/jsx(Trans, {
        id: "High slippage"
      }) : /*#__PURE__*/jsx(Trans, {
        id: "Purchase details"
      })
    })]
  });
}

function Estimate(_ref6) {
  var trade = _ref6.trade,
      slippage = _ref6.slippage,
      totalAmountIn = _ref6.totalAmountIn;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var text = useMemo(function () {
    switch (trade.tradeType) {
      case TradeType.EXACT_INPUT:
        return /*#__PURE__*/jsx(Trans, {
          id: "Output is estimated. You will receive at least {0} {1} or the transaction will revert.",
          values: {
            0: formatCurrencyAmount(trade.minimumAmountOut(slippage.allowed), 6, i18n.locale),
            1: trade.outputAmount.currency.symbol
          }
        });

      case TradeType.EXACT_OUTPUT:
        return /*#__PURE__*/jsx(Trans, {
          id: "Pricing is estimated due to variable fiat and on-chain swap rates. You will send at most {0} {1} or the transaction will revert.",
          values: {
            0: formatCurrencyAmount(trade.maximumAmountIn(slippage.allowed, totalAmountIn), 6, i18n.locale),
            1: trade.inputAmount.currency.symbol
          }
        });
    }
  }, [trade, slippage.allowed, i18n.locale, totalAmountIn]);
  return /*#__PURE__*/jsx(Caption$1, {
    color: "secondary",
    children: text
  });
}

function ConfirmButton(_ref7) {
  var trade = _ref7.trade,
      highPriceImpact = _ref7.highPriceImpact,
      onConfirm = _ref7.onConfirm,
      _ref7$title = _ref7.title,
      title = _ref7$title === void 0 ? '' : _ref7$title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      ackPriceImpact = _useState2[0],
      setAckPriceImpact = _useState2[1];

  var _useState3 = useState(trade),
      _useState4 = _slicedToArray(_useState3, 2),
      ackTrade = _useState4[0],
      setAckTrade = _useState4[1];

  var doesTradeDiffer = useMemo(function () {
    return Boolean(trade && ackTrade && tradeMeaningfullyDiffers(trade, ackTrade));
  }, [ackTrade, trade]);

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isPending = _useState6[0],
      setIsPending = _useState6[1];

  var onClick = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsPending(true);
            _context.next = 3;
            return onConfirm();

          case 3:
            setIsPending(false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [onConfirm]);
  var action = useMemo(function () {
    if (isPending) {
      return {
        message: /*#__PURE__*/jsx(Trans, {
          id: "Confirm in your wallet"
        }),
        icon: Spinner
      };
    } else if (doesTradeDiffer) {
      return {
        message: /*#__PURE__*/jsx(Trans, {
          id: "Price updated"
        }),
        icon: BarChart,
        onClick: function onClick() {
          return setAckTrade(trade);
        },
        children: /*#__PURE__*/jsx(Trans, {
          id: "Accept"
        })
      };
    } else if (highPriceImpact && !ackPriceImpact) {
      return {
        message: /*#__PURE__*/jsx(Trans, {
          id: "High price impact"
        }),
        onClick: function onClick() {
          return setAckPriceImpact(true);
        },
        children: /*#__PURE__*/jsx(Trans, {
          id: "Acknowledge"
        })
      };
    }

    return;
  }, [ackPriceImpact, doesTradeDiffer, highPriceImpact, isPending, trade]);
  return /*#__PURE__*/jsx(ActionButton, {
    onClick: onClick,
    action: action,
    children: /*#__PURE__*/jsx(Trans, {
      id: "{title}",
      values: {
        title: title
      }
    })
  });
}

function SummaryDialog(_ref9) {
  var trade = _ref9.trade,
      slippage = _ref9.slippage,
      inputUSDC = _ref9.inputUSDC,
      outputUSDC = _ref9.outputUSDC,
      impact = _ref9.impact,
      onConfirm = _ref9.onConfirm,
      title = _ref9.title,
      isNative = _ref9.isNative,
      inputCurrency = _ref9.inputCurrency,
      brydgeFeeUSDC = _ref9.brydgeFeeUSDC,
      lpFeeUSDC = _ref9.lpFeeUSDC,
      totalAmountIn = _ref9.totalAmountIn;

  var _useSwapInfo = useSwapInfo(),
      outputCurrencyAmount = _useSwapInfo[Field$1.OUTPUT].amount;

  var _useLingui2 = useLingui(),
      i18n = _useLingui2.i18n;

  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var tradeOutputAmount = trade !== null && trade !== void 0 && trade.outputAmount ? trade.outputAmount : undefined;

  var _useWrapCallback = useWrapCallback(),
      wrapType = _useWrapCallback.type;

  var isWrappingTrade = wrapType !== WrapType.NONE;
  var outputAmount = isWrappingTrade && outputCurrencyAmount ? outputCurrencyAmount : tradeOutputAmount;

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      open = _useState8[0],
      setOpen = _useState8[1];

  var onExpand = useCallback(function () {
    return setOpen(function (open) {
      return !open;
    });
  }, []);
  var shownChainId = 1;

  if (chainId) {
    shownChainId = chainId;
  }

  var _useFeeBreakdown = useFeeBreakdown({
    outputUSDC: outputUSDC,
    shownChainId: shownChainId,
    isNative: isNative,
    brydgeFeeUSDC: brydgeFeeUSDC,
    lpFeeUSDC: lpFeeUSDC,
    i18n: i18n,
    isWrappingTrade: isWrappingTrade
  }),
      itemPriceUSDC = _useFeeBreakdown.itemPriceUSDC,
      formattedBrydgeFeeUSDC = _useFeeBreakdown.formattedBrydgeFeeUSDC,
      formattedLpFeeUSDC = _useFeeBreakdown.formattedLpFeeUSDC,
      gasFeeUSDC = _useFeeBreakdown.gasFeeUSDC,
      totalCost = _useFeeBreakdown.totalCost;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Header, {
      title: /*#__PURE__*/jsx(Trans, {
        id: "Purchase Summary"
      }),
      ruled: true
    }), /*#__PURE__*/jsxs(Body, {
      flex: true,
      align: "stretch",
      padded: true,
      gap: 0.75,
      open: open,
      children: [/*#__PURE__*/jsx(Heading, {
        gap: 0.75,
        flex: true,
        justify: "center",
        children: /*#__PURE__*/jsx(Summary, {
          input: totalAmountIn,
          output: outputAmount,
          inputUSDC: inputUSDC,
          impact: impact,
          title: title,
          inputCurrency: inputCurrency
        })
      }), /*#__PURE__*/jsxs(Column, {
        gap: open ? 0 : 0.75,
        style: {
          transition: 'gap 0.25s'
        },
        children: [/*#__PURE__*/jsx(Expando, {
          title: /*#__PURE__*/jsx(Subhead, {
            impact: impact,
            slippage: slippage
          }),
          open: open,
          onExpand: onExpand,
          height: 9,
          children: /*#__PURE__*/jsx(FeeComponent, {
            itemPriceUSDC: itemPriceUSDC,
            brydgeFeeUSDC: formattedBrydgeFeeUSDC,
            lpFeeUSDC: formattedLpFeeUSDC,
            gasFee: gasFeeUSDC,
            totalCost: totalCost,
            chainId: shownChainId
          })
        }), !isWrappingTrade && trade && /*#__PURE__*/jsx(Footing, {
          children: /*#__PURE__*/jsx(Estimate, {
            trade: trade,
            slippage: slippage,
            totalAmountIn: totalAmountIn
          })
        }), /*#__PURE__*/jsx(ConfirmButton, {
          trade: trade,
          highPriceImpact: (impact === null || impact === void 0 ? void 0 : impact.warning) === 'error',
          onConfirm: onConfirm,
          title: title
        })]
      })]
    })]
  });
}

var _templateObject$2;

var StyledExternalLink = styled(ExternalLink)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n"])), function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return theme[color];
});

function EtherscanLink(_ref2) {
  var data = _ref2.data,
      type = _ref2.type,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'currentColor' : _ref2$color,
      children = _ref2.children;

  var _useActiveWeb3React = useActiveWeb3React$1(),
      chainId = _useActiveWeb3React.chainId;

  var url = useMemo(function () {
    return data && getExplorerLink(chainId || SupportedChainId.MAINNET, data, type);
  }, [chainId, data, type]);
  return /*#__PURE__*/jsx(StyledExternalLink, {
    href: url,
    color: color,
    target: "_blank",
    children: /*#__PURE__*/jsxs(Row$1, {
      gap: 0.25,
      children: [children, url && /*#__PURE__*/jsx(Link, {})]
    })
  });
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function useIsPendingApproval(token, spender) {
  return Boolean(usePendingApproval(token, spender));
}

function useApprovalData(trade, slippage, currencyAmount) {
  var currency = currencyAmount === null || currencyAmount === void 0 ? void 0 : currencyAmount.currency;

  var _useApproveOrPermit = useApproveOrPermit(trade, slippage.allowed, useIsPendingApproval, currencyAmount),
      approvalState = _useApproveOrPermit.approvalState,
      signatureData = _useApproveOrPermit.signatureData,
      handleApproveOrPermit = _useApproveOrPermit.handleApproveOrPermit;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPending = _useState2[0],
      setIsPending = _useState2[1];

  var addTransaction = useAddTransaction();
  var onApprove = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var transaction;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsPending(true);
            _context.next = 3;
            return handleApproveOrPermit();

          case 3:
            transaction = _context.sent;

            if (transaction) {
              addTransaction(_objectSpread$2({
                type: TransactionType.APPROVAL
              }, transaction));
            }

            setIsPending(false);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [addTransaction, handleApproveOrPermit]); // Reset the pending state if currency changes.

  useEffect(function () {
    return setIsPending(false);
  }, [currency]);
  var approvalHash = usePendingApproval(currency !== null && currency !== void 0 && currency.isToken ? currency : undefined, useSwapRouterAddress());
  var approvalAction = useMemo(function () {
    if (!trade || !currency) return;

    switch (approvalState) {
      case ApproveOrPermitState.REQUIRES_APPROVAL:
        if (isPending) {
          return {
            message: /*#__PURE__*/jsx(Trans, {
              id: "Approve in your wallet"
            }),
            icon: Spinner
          };
        }

        return {
          message: /*#__PURE__*/jsx(Trans, {
            id: "Approve {0} first",
            values: {
              0: currency.symbol
            }
          }),
          onClick: onApprove,
          children: /*#__PURE__*/jsx(Trans, {
            id: "Approve"
          })
        };

      case ApproveOrPermitState.REQUIRES_SIGNATURE:
        if (isPending) {
          return {
            message: /*#__PURE__*/jsx(Trans, {
              id: "Allow in your wallet"
            }),
            icon: Spinner
          };
        }

        return {
          message: /*#__PURE__*/jsx(Trans, {
            id: "Allow {0} first",
            values: {
              0: currency.symbol
            }
          }),
          onClick: onApprove,
          children: /*#__PURE__*/jsx(Trans, {
            id: "Allow"
          })
        };

      case ApproveOrPermitState.PENDING_APPROVAL:
        return {
          message: /*#__PURE__*/jsx(EtherscanLink, {
            type: ExplorerDataType.TRANSACTION,
            data: approvalHash,
            children: /*#__PURE__*/jsx(Trans, {
              id: "Approval pending"
            })
          }),
          icon: Spinner
        };

      case ApproveOrPermitState.PENDING_SIGNATURE:
        return {
          message: /*#__PURE__*/jsx(Trans, {
            id: "Allowance pending"
          }),
          icon: Spinner
        };

      case ApproveOrPermitState.APPROVED:
        return;
    }
  }, [approvalHash, approvalState, currency, isPending, onApprove, trade]);
  return {
    approvalAction: approvalAction,
    signatureData: signatureData !== null && signatureData !== void 0 ? signatureData : undefined
  };
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var SwapButton = /*#__PURE__*/memo(function SwapButton(_ref) {
  var disabled = _ref.disabled,
      calls = _ref.calls;
  _ref.tokenId;
  _ref.collectionAddress;
  var title = _ref.title;

  var _useActiveWeb3React = useActiveWeb3React$1(),
      account = _useActiveWeb3React.account,
      chainId = _useActiveWeb3React.chainId,
      library = _useActiveWeb3React.library;

  var _useSwapInfo = useSwapInfo(),
      _useSwapInfo$Field$IN = _useSwapInfo[Field$1.INPUT],
      inputCurrency = _useSwapInfo$Field$IN.currency,
      inputCurrencyAmount = _useSwapInfo$Field$IN.amount,
      inputCurrencyBalance = _useSwapInfo$Field$IN.balance,
      brydgeFeeUSDC = _useSwapInfo$Field$IN.brydgeFeeUSDC,
      lpFeeUSDC = _useSwapInfo$Field$IN.lpFeeUSDC,
      totalAmountIn = _useSwapInfo$Field$IN.totalAmount,
      totalAmountInUSDC = _useSwapInfo$Field$IN.totalAmountUSDC,
      _useSwapInfo$Field$OU = _useSwapInfo[Field$1.OUTPUT],
      outputUSDC = _useSwapInfo$Field$OU.usdc,
      outputCurrency = _useSwapInfo$Field$OU.currency,
      trade = _useSwapInfo.trade,
      slippage = _useSwapInfo.slippage,
      impact = _useSwapInfo.impact,
      isSameTokenTrade = _useSwapInfo.isSameTokenTrade;

  var feeOptions = useAtomValue(feeOptionsAtom); // TODO(zzmp): Return an optimized trade directly from useSwapInfo.

  var optimizedTrade = // Use trade.trade if there is no swap optimized trade. This occurs if approvals are still pending.
  useSwapApprovalOptimizedTrade(trade.trade, slippage.allowed, useIsPendingApproval, inputCurrencyAmount) || trade.trade;
  var deadline = useTransactionDeadline();

  var _useWrapCallback = useWrapCallback(),
      wrapType = _useWrapCallback.type;

  var unmappedOutputCurrency = usePolyToEthMappedCurrency(outputCurrency, 1);
  var unmappedOutputCurrencyAmount = unmappedOutputCurrency && inputCurrencyAmount ? CurrencyAmount.fromFractionalAmount(unmappedOutputCurrency, inputCurrencyAmount.numerator, inputCurrencyAmount.denominator) : undefined; //const unmappedOutputCurrencyAmount = unmappedOutputCurrency && inputCurrencyAmount ? CurrencyAmount.fromRawAmount(unmappedOutputCurrency, inputCurrencyAmount?.toExact()) : undefined

  var _useApprovalData = useApprovalData(optimizedTrade, slippage, unmappedOutputCurrencyAmount),
      sameTokenApproval = _useApprovalData.approvalAction,
      sameTokenSignature = _useApprovalData.signatureData;

  var _useApprovalData2 = useApprovalData(optimizedTrade, slippage, inputCurrencyAmount),
      normalApproval = _useApprovalData2.approvalAction,
      normalSignature = _useApprovalData2.signatureData;

  var approvalAction = isSameTokenTrade && chainId === 1 ? sameTokenApproval : normalApproval;
  var signatureData = isSameTokenTrade && chainId === 1 ? sameTokenSignature : normalSignature;
  var swapCallArgs = useSwapCallArguments(optimizedTrade, slippage.allowed, signatureData, deadline, feeOptions);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; // Close the review modal if there is no available trade.


  useEffect(function () {
    return setOpen(function (open) {
      return trade.trade ? open : false;
    });
  }, [trade.trade]); // Close the review modal on chain change.

  useEffect(function () {
    return setOpen(false);
  }, [chainId]);
  var addTransaction = useAddTransaction();
  var setDisplayTxHash = useUpdateAtom(displayTxHashAtom); // const setOldestValidBlock = useSetOldestValidBlock()

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      setIsPending = _useState4[1]; // Reset the pending state if user updates the swap.


  useEffect(function () {
    return setIsPending(false);
  }, [inputCurrencyAmount, trade]);
  var onSwap = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var isWrap, signer, tokenIn, finalAmountInCalc, amountIn, routerAddress, routerArgumentsInitial, isUnwrap, isWrapping, routerArguments, transaction, ethereumPortal, polygonRouter;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // TODO: Fill in these frontend args
            invariant(calls && account && library); //calls.push(generateTransferCall(collectionAddress, tokenId, account)) -> Maybe put this back later

            isWrap = wrapType !== WrapType.NONE;
            _context.next = 4;
            return library.getSigner();

          case 4:
            signer = _context.sent;
            tokenIn = getCurrencyAddress(inputCurrency);
            finalAmountInCalc = totalAmountIn ? totalAmountIn.add(totalAmountIn.multiply(slippage.allowed.asFraction)) : undefined;
            amountIn = finalAmountInCalc && inputCurrency ? parseUnits(finalAmountInCalc.toFixed(), inputCurrency.decimals) : undefined;
            routerAddress = isSameTokenTrade || isWrap ? ZERO_ADDRESS : swapCallArgs[0].address;
            routerArgumentsInitial = isWrap ? ROUTER_ARGS_WRAP : isSameTokenTrade ? ZERO_ADDRESS_ENC : swapCallArgs[0].calldata;
            isUnwrap = wrapType === WrapType.UNWRAP;
            isWrapping = wrapType === WrapType.WRAP;
            routerArguments = isUnwrap ? ROUTER_ARGS_UNWRAP : isWrapping ? ROUTER_ARGS_WRAP : routerArgumentsInitial;
            _context.prev = 13;
            _context.t0 = inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.chainId;
            _context.next = _context.t0 === 1 ? 17 : _context.t0 === 137 ? 32 : 47;
            break;

          case 17:
            ethereumPortal = EthereumPortal__factory.connect(ETHEREUM_PORTAL_ADDRESS, signer);

            if (!inputCurrency.isNative) {
              _context.next = 24;
              break;
            }

            _context.next = 21;
            return ethereumPortal.depositEther(routerAddress, routerArguments, calls, {
              value: amountIn,
              gasLimit: PORTAL_GAS_LIMIT[1]['NATIVE']
            });

          case 21:
            transaction = _context.sent;
            _context.next = 31;
            break;

          case 24:
            if (!amountIn) {
              _context.next = 30;
              break;
            }

            _context.next = 27;
            return ethereumPortal.depositERC20(tokenIn, amountIn, routerAddress, routerArguments, calls, {
              gasLimit: PORTAL_GAS_LIMIT[1]['ERC20']
            });

          case 27:
            transaction = _context.sent;
            _context.next = 31;
            break;

          case 30:
            console.log('Could not find amount');

          case 31:
            return _context.abrupt("break", 47);

          case 32:
            polygonRouter = PolygonRouter__factory.connect(POLYGON_ROUTER_ADDRESS, signer);

            if (!inputCurrency.isNative) {
              _context.next = 39;
              break;
            }

            _context.next = 36;
            return polygonRouter.swapNativeAndCall(routerAddress, routerArguments, calls, {
              value: amountIn,
              gasLimit: PORTAL_GAS_LIMIT[137]['NATIVE']
            });

          case 36:
            transaction = _context.sent;
            _context.next = 46;
            break;

          case 39:
            if (!(amountIn && account)) {
              _context.next = 45;
              break;
            }

            _context.next = 42;
            return polygonRouter.swapERC20AndCall(tokenIn, amountIn, account, routerAddress, routerArguments, calls, {
              gasLimit: PORTAL_GAS_LIMIT[137]['ERC20']
            });

          case 42:
            transaction = _context.sent;
            _context.next = 46;
            break;

          case 45:
            console.log('account or amount is undefined');

          case 46:
            return _context.abrupt("break", 47);

          case 47:
            invariant(trade.trade && transaction);
            addTransaction({
              response: transaction,
              type: TransactionType.SWAP,
              tradeType: trade.trade.tradeType,
              inputCurrencyAmount: trade.trade.inputAmount,
              outputCurrencyAmount: trade.trade.outputAmount
            });
            setDisplayTxHash(transaction.hash);
            _context.next = 55;
            break;

          case 52:
            _context.prev = 52;
            _context.t1 = _context["catch"](13); // TODO(zzmp): Surface errors from swap.

            console.log(_context.t1);

          case 55:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 52]]);
  })), [calls, account, library, wrapType, inputCurrency, totalAmountIn, slippage.allowed.asFraction, isSameTokenTrade, swapCallArgs, trade.trade, addTransaction, setDisplayTxHash]);
  var disableSwap = useMemo(function () {
    return disabled || !chainId || wrapType === WrapType.NONE && !optimizedTrade || !(totalAmountIn && inputCurrencyBalance) || inputCurrencyBalance.lessThan(totalAmountIn);
  }, [disabled, wrapType, optimizedTrade, chainId, totalAmountIn, inputCurrencyBalance]);
  var actionProps = useMemo(function () {
    if (disableSwap) {
      return {
        disabled: true
      };
    } else if (wrapType === WrapType.NONE) {
      return approvalAction ? {
        action: approvalAction
      } : trade.state === TradeState.VALID ? {
        onClick: function onClick() {
          return setOpen(true);
        }
      } : {
        disabled: true
      };
    } else {
      return approvalAction ? {
        action: approvalAction
      } : {
        onClick: function onClick() {
          return setOpen(true);
        }
      };
    }
  }, [approvalAction, disableSwap, trade.state, wrapType]);
  var onClose = useCallback(function () {
    return setOpen(false);
  }, []);

  var _useTheme = useTheme(),
      tokenColorExtraction = _useTheme.tokenColorExtraction;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ActionButton, _objectSpread$1(_objectSpread$1({
      color: tokenColorExtraction ? 'interactive' : 'accent'
    }, actionProps), {}, {
      children: /*#__PURE__*/jsx(Body2, {
        children: "Review Purchase"
      })
    })), open && outputUSDC && brydgeFeeUSDC && totalAmountIn && lpFeeUSDC && (trade.trade || wrapType !== WrapType.NONE) && /*#__PURE__*/jsx(Dialog, {
      color: "dialog",
      onClose: onClose,
      children: /*#__PURE__*/jsx(SummaryDialog, {
        trade: trade.trade,
        slippage: slippage,
        inputUSDC: totalAmountInUSDC,
        outputUSDC: outputUSDC,
        impact: impact,
        onConfirm: onSwap,
        title: title,
        isNative: inputCurrency !== null && inputCurrency !== void 0 && inputCurrency.isNative ? inputCurrency.isNative : false,
        isSameTokenTrade: isSameTokenTrade,
        inputCurrency: inputCurrency,
        brydgeFeeUSDC: brydgeFeeUSDC,
        totalAmountIn: totalAmountIn,
        lpFeeUSDC: lpFeeUSDC
      })
    })]
  });
});
var toolTipIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20standalone%3D%22no%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%2020010904%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FTR%2F2001%2FREC-SVG-20010904%2FDTD%2Fsvg10.dtd%22%3E%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20version%3D%221.0%22%20width%3D%22512.000000pt%22%20height%3D%22512.000000pt%22%20viewBox%3D%220%200%20512.000000%20512.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%20fill%3D%22%238f96ac%22%3E%3Cg%20transform%3D%22translate%280.000000%2C512.000000%29%20scale%280.100000%2C-0.100000%29%22%20fill%3D%22%238f96ac%22%20stroke%3D%22none%22%3E%3Cpath%20d%3D%22M3287%205109%20c-862%20-100%20-1505%20-852%20-1464%20-1709%2021%20-419%20183%20-792%20472%20-1084%20644%20-653%201686%20-660%202334%20-16%20247%20245%20403%20542%20468%20893%2021%20115%2024%20417%205%20527%20-90%20516%20-380%20932%20-825%201188%20-286%20163%20-661%20240%20-990%20201z%20m443%20-314%20c168%20-34%20349%20-110%20500%20-210%20114%20-75%20285%20-251%20364%20-372%20156%20-239%20221%20-456%20221%20-743%200%20-119%20-5%20-189%20-18%20-250%20-59%20-284%20-179%20-506%20-381%20-705%20-201%20-199%20-415%20-313%20-696%20-372%20-118%20-24%20-382%20-24%20-500%200%20-283%2059%20-502%20178%20-705%20381%20-198%20199%20-313%20415%20-372%20696%20-24%20118%20-24%20382%200%20500%2059%20281%20174%20496%20372%20696%20225%20227%20493%20358%20815%20398%2067%208%20326%20-4%20400%20-19z%22%2F%3E%3Cpath%20d%3D%22M3398%204499%20c-60%20-31%20-78%20-78%20-78%20-201%20l0%20-103%20-52%20-24%20c-65%20-30%20-166%20-129%20-197%20-194%20-89%20-185%20-58%20-381%2084%20-522%2083%20-84%20201%20-135%20311%20-135%2080%200%20154%20-72%20154%20-150%200%20-50%20-35%20-107%20-80%20-130%20-77%20-39%20-153%20-17%20-249%2075%20-35%2033%20-74%2060%20-95%2066%20-108%2030%20-211%20-80%20-177%20-191%2016%20-55%20139%20-168%20229%20-211%20l71%20-34%200%20-103%20c1%20-125%2019%20-171%2081%20-202%2050%20-25%2090%20-25%20140%200%2062%2032%2080%2077%2080%20202%20l0%20103%2053%2024%20c64%2030%20163%20128%20196%20194%2089%20184%2058%20381%20-84%20523%20-84%2084%20-200%20134%20-312%20134%20-78%200%20-153%2074%20-153%20152%200%2075%2074%20148%20150%20148%2045%200%20104%20-27%20157%20-73%2071%20-59%20145%20-61%20208%20-6%2042%2037%2058%2088%2045%20144%20-12%2053%20-96%20132%20-189%20177%20l-70%2033%200%20103%20c-1%20125%20-19%20171%20-81%20202%20-49%2025%20-94%2025%20-142%20-1z%22%2F%3E%3Cpath%20d%3D%22M1656%202160%20c-163%20-26%20-340%20-99%20-459%20-189%20l-65%20-49%20-59%2057%20c-32%2031%20-79%2067%20-106%2080%20-98%2047%20-130%2051%20-500%2051%20-329%200%20-350%20-1%20-387%20-20%20-26%20-13%20-47%20-34%20-60%20-60%20-20%20-38%20-20%20-57%20-20%20-975%200%20-918%200%20-937%2020%20-975%2013%20-26%2034%20-47%2060%20-60%2037%20-19%2058%20-20%20379%20-20%20212%200%20360%204%20393%2011%2071%2015%20150%2055%20204%20102%20l44%2038%20162%20-40%20c198%20-50%20418%20-87%20597%20-101%2078%20-6%20464%20-10%20912%20-10%20830%200%20865%202%201019%2051%2084%2027%20201%2085%20281%20140%20120%2080%20204%20179%20571%20676%20454%20613%20426%20572%20450%20640%2091%20254%20-52%20519%20-317%20588%20-75%2019%20-145%2019%20-220%200%20-108%20-28%20-153%20-65%20-373%20-300%20-113%20-121%20-222%20-237%20-242%20-259%20l-38%20-39%20-28%2059%20c-35%2072%20-131%20172%20-197%20203%20-100%2048%20-126%2051%20-552%2051%20-508%200%20-483%20-5%20-685%20148%20-176%20134%20-370%20201%20-595%20207%20-71%202%20-157%200%20-189%20-5z%20m349%20-315%20c96%20-26%20196%20-80%20291%20-155%2049%20-38%20121%20-85%20159%20-104%20137%20-68%20144%20-69%20625%20-75%20489%20-7%20482%20-6%20520%20-81%2026%20-51%2025%20-93%20-2%20-142%20-43%20-76%20-13%20-72%20-670%20-78%20-573%20-5%20-587%20-5%20-614%20-26%20-50%20-37%20-68%20-70%20-68%20-124%200%20-54%2018%20-87%2068%20-124%2027%20-21%2039%20-21%20654%20-24%20642%20-3%20699%200%20780%2036%2084%2038%20128%2080%20468%20446%20196%20209%20370%20389%20387%20399%20120%2066%20264%20-73%20201%20-194%20-31%20-61%20-754%20-1026%20-811%20-1082%20-78%20-78%20-178%20-139%20-293%20-179%20l-95%20-33%20-860%200%20c-996%200%20-1013%201%20-1387%2091%20l-148%2036%200%20581%200%20582%2071%2060%20c136%20116%20242%20172%20379%20201%2082%2017%20263%2011%20345%20-11z%20m-1175%20-55%20c26%20-13%2047%20-34%2060%20-60%2019%20-38%2020%20-58%2020%20-675%200%20-617%20-1%20-637%20-20%20-675%20-13%20-26%20-34%20-47%20-60%20-60%20-36%20-18%20-58%20-20%20-285%20-20%20l-245%200%200%20755%200%20755%20245%200%20c227%200%20249%20-2%20285%20-20z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
/** Displays the price of a trade. If outputUSDC is included, also displays the unit price. */

function Price(_ref) {
  _ref.trade;
  var outputUSDC = _ref.outputUSDC,
      isNative = _ref.isNative,
      brydgeFeeUSDC = _ref.brydgeFeeUSDC,
      lpFeeUSDC = _ref.lpFeeUSDC,
      isWrappingTrade = _ref.isWrappingTrade;

  var _useActiveWeb3React = useActiveWeb3React(),
      chainId = _useActiveWeb3React.chainId;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var shownChainId = 1;

  if (chainId) {
    shownChainId = chainId;
  }

  var _useFeeBreakdown = useFeeBreakdown({
    outputUSDC: outputUSDC,
    shownChainId: shownChainId,
    isNative: isNative,
    brydgeFeeUSDC: brydgeFeeUSDC,
    lpFeeUSDC: lpFeeUSDC,
    i18n: i18n,
    isWrappingTrade: isWrappingTrade
  }),
      itemPriceUSDC = _useFeeBreakdown.itemPriceUSDC,
      formattedBrydgeFeeUSDC = _useFeeBreakdown.formattedBrydgeFeeUSDC,
      formattedLpFeeUSDC = _useFeeBreakdown.formattedLpFeeUSDC,
      gasFeeUSDC = _useFeeBreakdown.gasFeeUSDC,
      totalCost = _useFeeBreakdown.totalCost,
      isLoading = _useFeeBreakdown.isLoading;

  var totalFees = formattedBrydgeFeeUSDC + formattedLpFeeUSDC + gasFeeUSDC;

  if (isLoading) {
    return /*#__PURE__*/jsx(LoadingPrice, {});
  } else {
    return /*#__PURE__*/jsxs("div", {
      style: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      children: [/*#__PURE__*/jsx(Caption$1, {
        children: /*#__PURE__*/jsxs(Row$1, {
          gap: 0.25,
          children: ["Total Cost: ~$", totalCost.toFixed(2)]
        })
      }), /*#__PURE__*/jsx(Tooltip, {
        placement: "bottom",
        icon: function icon() {
          return /*#__PURE__*/jsxs("div", {
            style: {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            },
            children: [/*#__PURE__*/jsx("img", {
              src: toolTipIcon,
              style: {
                width: 30,
                height: '1rem'
              },
              alt: "fee-breakdown"
            }), "$", totalFees.toFixed(2)]
          });
        },
        children: /*#__PURE__*/jsx(FeeComponent, {
          itemPriceUSDC: itemPriceUSDC,
          brydgeFeeUSDC: formattedBrydgeFeeUSDC,
          lpFeeUSDC: formattedLpFeeUSDC,
          gasFee: gasFeeUSDC,
          totalCost: totalCost,
          chainId: shownChainId
        })
      })]
    });
  }
}

var _templateObject$1;

var Loading = styled.span(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.secondary;
}, loadingCss);

function Caption(_ref2) {
  var _ref2$icon = _ref2.icon,
      Icon = _ref2$icon === void 0 ? AlertTriangle : _ref2$icon,
      caption = _ref2.caption;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Icon, {
      color: "secondary"
    }), caption]
  });
}

function Connecting() {
  return /*#__PURE__*/jsx(Caption, {
    icon: InlineSpinner,
    caption: /*#__PURE__*/jsx(Loading, {
      children: /*#__PURE__*/jsx(Trans, {
        id: "Connecting\u2026"
      })
    })
  });
}

function ConnectWallet() {
  return /*#__PURE__*/jsx(Caption, {
    caption: /*#__PURE__*/jsx(Trans, {
      id: "Connect wallet to buy"
    })
  });
}

function UnsupportedNetwork() {
  return /*#__PURE__*/jsx(Caption, {
    caption: /*#__PURE__*/jsx(Trans, {
      id: "Unsupported network - switch to another"
    })
  });
}

function InsufficientBalance(_ref3) {
  var currency = _ref3.currency;
  return /*#__PURE__*/jsx(Caption, {
    caption: /*#__PURE__*/jsx(Trans, {
      id: "Insufficient {0} balance. Use another token.",
      values: {
        0: currency === null || currency === void 0 ? void 0 : currency.symbol
      }
    })
  });
}

function InsufficientLiquidity(_ref4) {
  var currency = _ref4.currency;
  return /*#__PURE__*/jsx(Caption, {
    caption: /*#__PURE__*/jsx(Trans, {
      id: "Insufficient liquidity for {0}. Use another token.",
      values: {
        0: currency === null || currency === void 0 ? void 0 : currency.symbol
      }
    })
  });
}

function Error$1(_ref5) {
  var currency = _ref5.currency;
  return /*#__PURE__*/jsx(Caption, {
    caption: /*#__PURE__*/jsx(Trans, {
      id: "{0} is currently unavailable. Use another token.",
      values: {
        0: currency === null || currency === void 0 ? void 0 : currency.symbol
      }
    })
  });
}

function Empty() {
  return /*#__PURE__*/jsx(Caption, {
    icon: Info,
    caption: /*#__PURE__*/jsx(Trans, {
      id: "Select chain and token"
    })
  });
}

function LoadingTrade() {
  return /*#__PURE__*/jsx(Caption, {
    icon: InlineSpinner,
    caption: /*#__PURE__*/jsx(Loading, {
      children: /*#__PURE__*/jsx(Trans, {
        id: "Fetching best price\u2026"
      })
    })
  });
}

function LoadingPrice() {
  return /*#__PURE__*/jsx(Caption, {
    icon: InlineSpinner,
    caption: /*#__PURE__*/jsx(Loading, {
      children: /*#__PURE__*/jsx(Trans, {
        id: "Calculating price in USDC\u2026"
      })
    })
  });
}

function Trade(_ref7) {
  var trade = _ref7.trade,
      outputUSDC = _ref7.outputUSDC,
      isNative = _ref7.isNative,
      brydgeFeeUSDC = _ref7.brydgeFeeUSDC,
      lpFeeUSDC = _ref7.lpFeeUSDC,
      isWrappingTrade = _ref7.isWrappingTrade;

  if (!(outputUSDC && brydgeFeeUSDC && lpFeeUSDC)) {
    return /*#__PURE__*/jsx(LoadingPrice, {});
  }

  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(Price, {
      trade: trade,
      outputUSDC: outputUSDC,
      isNative: isNative,
      brydgeFeeUSDC: brydgeFeeUSDC,
      lpFeeUSDC: lpFeeUSDC,
      isWrappingTrade: isWrappingTrade
    })
  });
}

var _templateObject;

var ToolbarRow = styled(Row$1)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0.5em 0;\n  ", "\n"])), largeIconCss);
var Toolbar = /*#__PURE__*/memo(function Toolbar(props) {
  var _useActiveWeb3React = useActiveWeb3React$1(),
      active = _useActiveWeb3React.active,
      activating = _useActiveWeb3React.activating,
      chainId = _useActiveWeb3React.chainId;

  var _useSwapInfo = useSwapInfo(),
      _useSwapInfo$Field$IN = _useSwapInfo[Field$1.INPUT],
      inputCurrency = _useSwapInfo$Field$IN.currency,
      inputBalance = _useSwapInfo$Field$IN.balance,
      brydgeFeeUSDC = _useSwapInfo$Field$IN.brydgeFeeUSDC,
      lpFeeUSDC = _useSwapInfo$Field$IN.lpFeeUSDC,
      totalAmountIn = _useSwapInfo$Field$IN.totalAmount,
      _useSwapInfo$Field$OU = _useSwapInfo[Field$1.OUTPUT],
      outputCurrency = _useSwapInfo$Field$OU.currency,
      outputUSDC = _useSwapInfo$Field$OU.usdc,
      _useSwapInfo$trade = _useSwapInfo.trade,
      trade = _useSwapInfo$trade.trade,
      state = _useSwapInfo$trade.state,
      isSameTokenTrade = _useSwapInfo.isSameTokenTrade; // const formattedUSDC = usdc ? formatCurrencyAmount(usdc, 6, 'en', 2) : '--'


  var isAmountPopulated = useIsAmountPopulated();

  var _useWrapCallback = useWrapCallback(),
      wrapType = _useWrapCallback.type;

  var isWrappingTrade = wrapType !== WrapType.NONE;
  var caption = useMemo(function () {
    if (props.isFirstLoad) {
      return /*#__PURE__*/jsx(Empty, {});
    }

    if (!active || !chainId) {
      if (activating) return /*#__PURE__*/jsx(Connecting, {});
      return /*#__PURE__*/jsx(ConnectWallet, {});
    }

    if (!ALL_SUPPORTED_CHAIN_IDS.includes(chainId)) {
      return /*#__PURE__*/jsx(UnsupportedNetwork, {});
    }

    if (inputCurrency && outputCurrency && isAmountPopulated) {
      if (state === TradeState.SYNCING || state === TradeState.LOADING) {
        return /*#__PURE__*/jsx(LoadingTrade, {});
      }

      if (inputBalance && totalAmountIn !== null && totalAmountIn !== void 0 && totalAmountIn.greaterThan(inputBalance)) {
        return /*#__PURE__*/jsx(InsufficientBalance, {
          currency: inputCurrency
        });
      }

      if (wrapType !== WrapType.NONE || isSameTokenTrade) {
        return /*#__PURE__*/jsx(Trade, {
          trade: trade,
          outputUSDC: outputUSDC,
          isNative: inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative,
          brydgeFeeUSDC: brydgeFeeUSDC,
          lpFeeUSDC: lpFeeUSDC,
          isWrappingTrade: isWrappingTrade
        });
      }

      if (state === TradeState.NO_ROUTE_FOUND || trade && !trade.swaps) {
        return /*#__PURE__*/jsx(InsufficientLiquidity, {
          currency: inputCurrency
        });
      }

      if (trade !== null && trade !== void 0 && trade.inputAmount && trade.outputAmount) {
        return /*#__PURE__*/jsx(Trade, {
          trade: trade,
          outputUSDC: outputUSDC,
          isNative: inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative,
          brydgeFeeUSDC: brydgeFeeUSDC,
          lpFeeUSDC: lpFeeUSDC,
          isWrappingTrade: isWrappingTrade
        });
      }

      if (state === TradeState.INVALID) {
        return /*#__PURE__*/jsx(Error$1, {
          currency: inputCurrency
        });
      }
    }

    return /*#__PURE__*/jsx(Empty, {});
  }, [props.isFirstLoad, active, chainId, inputCurrency, outputCurrency, isAmountPopulated, activating, state, inputBalance, totalAmountIn, wrapType, isSameTokenTrade, trade, outputUSDC, brydgeFeeUSDC, lpFeeUSDC, isWrappingTrade]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Rule, {}), /*#__PURE__*/jsx(Caption$1, {
      children: /*#__PURE__*/jsxs(ToolbarRow, {
        justify: "flex-start",
        gap: 0.5,
        iconSize: 4 / 3,
        children: [caption, ' ']
      })
    })]
  });
});

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var IntegrationError = /*#__PURE__*/function (_Error) {
  _inherits(IntegrationError, _Error);

  var _super = _createSuper(IntegrationError);

  function IntegrationError(message) {
    var _this;

    _classCallCheck(this, IntegrationError);

    _this = _super.call(this, message);
    _this.name = 'Integration Error';
    return _this;
  }

  return _createClass(IntegrationError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function isAddressOrAddressMap(addressOrMap) {
  if (_typeof(addressOrMap) === 'object') {
    return Object.values(addressOrMap).every(function (address) {
      return isAddress(address);
    });
  }

  if (typeof addressOrMap === 'string') {
    return typeof isAddress(addressOrMap) === 'string';
  }

  return false;
}

function useValidate(props) {
  var convenienceFee = props.convenienceFee,
      convenienceFeeRecipient = props.convenienceFeeRecipient;
  useEffect(function () {
    if (convenienceFee) {
      if (convenienceFee > 100 || convenienceFee < 0) {
        throw new IntegrationError("convenienceFee must be between 0 and 100 (you set it to ".concat(convenienceFee, ")."));
      }

      if (!convenienceFeeRecipient) {
        throw new IntegrationError('convenienceFeeRecipient is required when convenienceFee is set.');
      }

      if (typeof convenienceFeeRecipient === 'string') {
        if (!isAddress(convenienceFeeRecipient)) {
          throw new IntegrationError("convenienceFeeRecipient must be a valid address (you set it to ".concat(convenienceFeeRecipient, ")."));
        }
      } else if (_typeof(convenienceFeeRecipient) === 'object') {
        Object.values(convenienceFeeRecipient).forEach(function (recipient) {
          if (!isAddress(recipient)) {
            var values = Object.values(convenienceFeeRecipient).join(', ');
            throw new IntegrationError("All values in convenienceFeeRecipient object must be valid addresses (you used ".concat(values, ")."));
          }
        });
      }
    }
  }, [convenienceFee, convenienceFeeRecipient]);
  var price = props.price;
  useEffect(function () {
    // if (price && defaultInputAmount) {
    //   throw new IntegrationError('defaultInputAmount and price may not both be defined.')
    // }
    // if (defaultInputAmount && (isNaN(+defaultInputAmount) || defaultInputAmount < 0)) {
    //   throw new IntegrationError(`defaultInputAmount must be a positive number (you set it to ${defaultInputAmount})`)
    // }
    if (price && (isNaN(+price) || price < 0)) {
      throw new IntegrationError("price must be a positive number (you set it to ".concat(price, ")."));
    }
  }, [price]);
  var outputTokenAddress = props.outputTokenAddress;
  useEffect(function () {
    // if (
    //   defaultInputTokenAddress &&
    //   !isAddressOrAddressMap(defaultInputTokenAddress) &&
    //   defaultInputTokenAddress !== 'NATIVE'
    // ) {
    //   throw new IntegrationError(
    //     `defaultInputTokenAddress must be a valid address or "NATIVE" (you set it to ${defaultInputTokenAddress}).`
    //   )
    // }
    if (outputTokenAddress && !isAddressOrAddressMap(outputTokenAddress) && outputTokenAddress !== 'NATIVE') {
      throw new IntegrationError("outputTokenAddress must be a valid address or \"NATIVE\" (you set it to ".concat(outputTokenAddress, ")."));
    }
  }, [outputTokenAddress]);
}

function getTransactionFromMap(txs, hash) {
  if (hash) {
    var _tx$info, _tx$info2;

    var tx = txs[hash];

    if ((tx === null || tx === void 0 ? void 0 : (_tx$info = tx.info) === null || _tx$info === void 0 ? void 0 : _tx$info.type) === TransactionType.SWAP) {
      return tx;
    }

    if ((tx === null || tx === void 0 ? void 0 : (_tx$info2 = tx.info) === null || _tx$info2 === void 0 ? void 0 : _tx$info2.type) === TransactionType.WRAP) {
      return tx;
    }
  }

  return;
}

var FirstLoadContext = /*#__PURE__*/createContext(null);

function Swap(props) {
  useValidate(props);
  useSyncConvenienceFee(props);
  useSyncTokenDefaults(props);
  useSyncPrice(props);

  var _useActiveWeb3React = useActiveWeb3React$1(),
      active = _useActiveWeb3React.active,
      chainId = _useActiveWeb3React.chainId,
      account = _useActiveWeb3React.account;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      wrapper = _useState2[0],
      setWrapper = _useState2[1];

  var _useAtom = useAtom(displayTxHashAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      displayTxHash = _useAtom2[0],
      setDisplayTxHash = _useAtom2[1];

  var pendingTxs = usePendingTransactions();
  var displayTx = getTransactionFromMap(pendingTxs, displayTxHash);
  var onSupportedNetwork = useOnSupportedNetwork();
  var isDisabled = !(active && onSupportedNetwork);
  var focused = useHasFocus(wrapper);

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isFirstLoad = _useState4[0],
      setIsFirstLoad = _useState4[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Header$1, {
      title: props.title,
      children: [active && /*#__PURE__*/jsx(Wallet, {
        disabled: !account && props.onConnectWallet !== undefined,
        onClick: props.onConnectWallet
      }), /*#__PURE__*/jsx(Settings, {
        disabled: isDisabled
      })]
    }), /*#__PURE__*/jsx("div", {
      ref: setWrapper,
      children: /*#__PURE__*/jsx(BoundaryProvider, {
        value: wrapper,
        children: /*#__PURE__*/jsx(SwapInfoProvider, {
          disabled: isDisabled,
          children: /*#__PURE__*/jsxs(FirstLoadContext.Provider, {
            value: setIsFirstLoad,
            children: [/*#__PURE__*/jsx(NetworkSelector, {}), /*#__PURE__*/jsx(Input, {
              disabled: isDisabled || isFirstLoad,
              focused: focused
            }), /*#__PURE__*/jsxs(Output, {
              disabled: isDisabled,
              focused: focused,
              destinationChainId: props.destinationChainId,
              children: [/*#__PURE__*/jsx(Toolbar, {
                isFirstLoad: isFirstLoad
              }), /*#__PURE__*/jsx(SwapButton, {
                disabled: isFirstLoad,
                calls: props.calls,
                collectionAddress: props.collectionAddress,
                tokenId: props.tokenId,
                title: props.title
              })]
            })]
          })
        })
      })
    }), displayTx && /*#__PURE__*/jsx(Dialog, {
      color: "dialog",
      onClose: function onClose() {
        return setDisplayTxHash();
      },
      children: chainId && /*#__PURE__*/jsx(TransactionStatusDialog, {
        tx: displayTx,
        sourceChainId: chainId,
        onClose: function onClose() {
          return setDisplayTxHash();
        }
      })
    })]
  });
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function BrydgeWidget(props) {
  return /*#__PURE__*/jsx(Widget, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/jsx(Swap, _objectSpread({}, props))
  }));
}

export { BrydgeWidget, SUPPORTED_LOCALES, darkTheme, lightTheme };